webpackJsonp([114276838955818,60335399758886],{

/***/ 110:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Holzauge Fotografie"}},"editorial":{"edges":[{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMFAgT/xAAWAQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhADEAAAAWtjdLnRNI//xAAaEAEBAAIDAAAAAAAAAAAAAAACAQADEiIx/9oACAEBAAEFAtN6sVHYXXrx3lF7/8QAFREBAQAAAAAAAAAAAAAAAAAAABL/2gAIAQMBAT8BtT//xAAWEQEBAQAAAAAAAAAAAAAAAAAAERL/2gAIAQIBAT8Byj//xAAaEAACAgMAAAAAAAAAAAAAAAAAEQExECGB/9oACAEBAAY/AtWKVJa6Xn//xAAaEAEBAQEBAQEAAAAAAAAAAAABEQAhMWFx/9oACAEBAAE/IWriCe+4lE/Z3KEXwDWQqDZmE4TvMlavd//aAAwDAQACAAMAAAAQyO//xAAWEQEBAQAAAAAAAAAAAAAAAAARACH/2gAIAQMBAT8QAWtv/8QAFxEAAwEAAAAAAAAAAAAAAAAAABEhMf/aAAgBAgEBPxB9Jh//xAAdEAEBAAIBBQAAAAAAAAAAAAABEQAhQTFRcYHR/9oACAEBAAE/EBxoFxpGe/maFFaBA4POEsniAxkQQOFxexbplXrcf0pq98//2Q==","aspectRatio":1.4992503748125936,"src":"/static/01.5-35ec780543b82d5e6ec9df587d0cd0f2-79b28.jpg","srcSet":"/static/01.5-35ec780543b82d5e6ec9df587d0cd0f2-3d830.jpg 300w,\n/static/01.5-35ec780543b82d5e6ec9df587d0cd0f2-2ab78.jpg 600w,\n/static/01.5-35ec780543b82d5e6ec9df587d0cd0f2-79b28.jpg 1000w","srcWebp":"/static/01.5-35ec780543b82d5e6ec9df587d0cd0f2-161ff.webp","srcSetWebp":"/static/01.5-35ec780543b82d5e6ec9df587d0cd0f2-9fc06.webp 300w,\n/static/01.5-35ec780543b82d5e6ec9df587d0cd0f2-36f59.webp 600w,\n/static/01.5-35ec780543b82d5e6ec9df587d0cd0f2-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABmxumHqCjPPyd5rYgE//EABwQAAMAAwEBAQAAAAAAAAAAAAECAwAREgQTIv/aAAgBAQABBQJvHUEwcL57MspEoi0M6sy7Gkx6ftWTnnvPiMCHX//EABYRAQEBAAAAAAAAAAAAAAAAABARIf/aAAgBAwEBPwGYU//EABYRAQEBAAAAAAAAAAAAAAAAABARIf/aAAgBAgEBPwG6Q//EAB4QAAICAgIDAAAAAAAAAAAAAAABESECIhBhEjOR/9oACAEBAAY/Atdl0TQlnH0ix+UR2epM3IrPHllM/8QAHRABAAMAAwADAAAAAAAAAAAAAQARITFBYVFx0f/aAAgBAQABPyGtA+ZQ0+XVzQuYXXIbyp5gFd0DZz1EapYbA9BB9la+lf2HFGes2t4lAqMI21Y9T//aAAwDAQACAAMAAAAQUBBP/8QAGBEAAgMAAAAAAAAAAAAAAAAAABEQIUH/2gAIAQMBAT8Q0LGSj//EABcRAQEBAQAAAAAAAAAAAAAAABEAIRD/2gAIAQIBAT8QGLILz//EAB0QAQACAgMBAQAAAAAAAAAAAAEAESExQVFhgaH/2gAIAQEAAT8Qa4eQhfxYrgVV8vncJxXqK6Xctu6Usb8lIzbRIy9HOSUKkiVQNgWewrvBkJ1riFU4NHdHRsfGBrqLEF/YM0KFAzChmeYb2ZY1P//Z","aspectRatio":0.6666666666666666,"src":"/static/01-fc5ed43a1e2f56bc2a36c99c49c40de0-79b28.jpg","srcSet":"/static/01-fc5ed43a1e2f56bc2a36c99c49c40de0-3d830.jpg 300w,\n/static/01-fc5ed43a1e2f56bc2a36c99c49c40de0-2ab78.jpg 600w,\n/static/01-fc5ed43a1e2f56bc2a36c99c49c40de0-79b28.jpg 1000w","srcWebp":"/static/01-fc5ed43a1e2f56bc2a36c99c49c40de0-161ff.webp","srcSetWebp":"/static/01-fc5ed43a1e2f56bc2a36c99c49c40de0-9fc06.webp 300w,\n/static/01-fc5ed43a1e2f56bc2a36c99c49c40de0-36f59.webp 600w,\n/static/01-fc5ed43a1e2f56bc2a36c99c49c40de0-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUBAwQG/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABY1CM6EkMiZ1WbjEH/8QAHBABAAEFAQEAAAAAAAAAAAAAAQIAAwQREhAT/9oACAEBAAEFAiBXZ9OSsiWrN3pqJqOTFuEIyDofEGBqJ//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB4QAAIBBAMBAAAAAAAAAAAAAAABEQISUYEhIjFB/9oACAEBAAY/Aix6PBx9NCTwWrEirqXWUcM0KlqSEoP/xAAfEAEAAwACAQUAAAAAAAAAAAABABEhMVEQQWFxoeH/2gAIAQEAAT8hFtEEyUmj28BrinF9TlWYCr9Iiy0FsBVFa3MHVLeaX8nMBOyLY/IgugB9TKQ6J//aAAwDAQACAAMAAAAQIMIA/8QAFREBAQAAAAAAAAAAAAAAAAAAESD/2gAIAQMBAT8QY//EABURAQEAAAAAAAAAAAAAAAAAABEg/9oACAECAQE/ECP/xAAdEAEAAgMAAwEAAAAAAAAAAAABABEhMUFRYYHR/9oACAEBAAE/EFqXeVlHGh0F2GPrfIPEga4d/n2OlGAg6cA95j+TCbWsxSAa5C01R7zcJlcUyQWHdoDvPIljGf3IvjA5Cl+RiIB7mmif/9k=","aspectRatio":0.6666666666666666,"src":"/static/03-eaac0042291b2b420ef95bc43ea8af75-79b28.jpg","srcSet":"/static/03-eaac0042291b2b420ef95bc43ea8af75-3d830.jpg 300w,\n/static/03-eaac0042291b2b420ef95bc43ea8af75-2ab78.jpg 600w,\n/static/03-eaac0042291b2b420ef95bc43ea8af75-79b28.jpg 1000w","srcWebp":"/static/03-eaac0042291b2b420ef95bc43ea8af75-161ff.webp","srcSetWebp":"/static/03-eaac0042291b2b420ef95bc43ea8af75-9fc06.webp 300w,\n/static/03-eaac0042291b2b420ef95bc43ea8af75-36f59.webp 600w,\n/static/03-eaac0042291b2b420ef95bc43ea8af75-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHOZFKkiP/EABoQAAICAwAAAAAAAAAAAAAAAAABEBESISL/2gAIAQEAAQUC5FQ8B6E4/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGhAAAgIDAAAAAAAAAAAAAAAAADEBICFBkf/aAAgBAQAGPwLZlCntP//EABoQAAMBAQEBAAAAAAAAAAAAAAABESFBMVH/2gAIAQEAAT8hVrdnw2uYyPjxCYiHKQ//2gAMAwEAAgADAAAAEDD/AP/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABwQAQEAAgIDAAAAAAAAAAAAAAERADEhQYGxwf/aAAgBAQABPxA9kkJJevGC4IQ3D3lABTcHzCEku1blPIDsce5pz//Z","aspectRatio":1.4992503748125936,"src":"/static/12-156-7180a95405b6890ade4ac752cb702f57-79b28.jpg","srcSet":"/static/12-156-7180a95405b6890ade4ac752cb702f57-3d830.jpg 300w,\n/static/12-156-7180a95405b6890ade4ac752cb702f57-2ab78.jpg 600w,\n/static/12-156-7180a95405b6890ade4ac752cb702f57-79b28.jpg 1000w","srcWebp":"/static/12-156-7180a95405b6890ade4ac752cb702f57-161ff.webp","srcSetWebp":"/static/12-156-7180a95405b6890ade4ac752cb702f57-9fc06.webp 300w,\n/static/12-156-7180a95405b6890ade4ac752cb702f57-36f59.webp 600w,\n/static/12-156-7180a95405b6890ade4ac752cb702f57-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGgAAAgIDAAAAAAAAAAAAAAAAAAQBBQIDBv/EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAABuktSeFIkm955hZMAE//EABwQAAIDAAMBAAAAAAAAAAAAAAECAAMSBBAhMf/aAAgBAQABBQIN5yLRlfItwEusViply5oB63tW+z//xAAVEQEBAAAAAAAAAAAAAAAAAAARIP/aAAgBAwEBPwEj/8QAFREBAQAAAAAAAAAAAAAAAAAAESD/2gAIAQIBAT8BY//EABwQAAMAAgMBAAAAAAAAAAAAAAABERAhAjFRQf/aAAgBAQAGPwIfB/RkfhoY244O4knu+yLrH//EAB0QAQACAgIDAAAAAAAAAAAAAAEAESExQXEQUZH/2gAIAQEAAT8hsGvsGJpuJoDmULZBxMTLW19w603MVEdVL7dvFWGvMtLBDUDP/9oADAMBAAIAAwAAABD87YH/xAAXEQEBAQEAAAAAAAAAAAAAAAABABAR/9oACAEDAQE/ECDDzP/EABcRAQEBAQAAAAAAAAAAAAAAAAERABD/2gAIAQIBAT8QVnSk5//EAB4QAQEAAgICAwAAAAAAAAAAAAERACExQVFxYYGR/9oACAEBAAE/EARySxw5E0B2WmRxTz9GW1qWy6G794+mvoHwDDI8m79GX5RClOQ8nM1rEat7+0wXcwUVu0cgi3snOPibpa/uSM//2Q==","aspectRatio":0.66711140760507,"src":"/static/12-216-eb14fd7b532dd679bc0b7217aa0e0945-79b28.jpg","srcSet":"/static/12-216-eb14fd7b532dd679bc0b7217aa0e0945-3d830.jpg 300w,\n/static/12-216-eb14fd7b532dd679bc0b7217aa0e0945-2ab78.jpg 600w,\n/static/12-216-eb14fd7b532dd679bc0b7217aa0e0945-79b28.jpg 1000w","srcWebp":"/static/12-216-eb14fd7b532dd679bc0b7217aa0e0945-161ff.webp","srcSetWebp":"/static/12-216-eb14fd7b532dd679bc0b7217aa0e0945-9fc06.webp 300w,\n/static/12-216-eb14fd7b532dd679bc0b7217aa0e0945-36f59.webp 600w,\n/static/12-216-eb14fd7b532dd679bc0b7217aa0e0945-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQAD/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAABHeCeKQs5D//EABoQAAIDAQEAAAAAAAAAAAAAAAECAAMSIjH/2gAIAQEAAQUCHtXC7ChRKTqtJ//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/ASf/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPwFn/8QAGxAAAgIDAQAAAAAAAAAAAAAAAAERIRASMUH/2gAIAQEABj8CI1uOinCbHfp//8QAHBAAAwACAwEAAAAAAAAAAAAAAAERQWEhMVFx/9oACAEBAAE/IehCrmsmglvxSlZ92XeC5TPA/9oADAMBAAIAAwAAABBw7//EABYRAQEBAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPxA6T//EABYRAAMAAAAAAAAAAAAAAAAAAAABIf/aAAgBAgEBPxBqKn//xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhMUFRkYH/2gAIAQEAAT8QN9hqG2zdIUJyr8jtNp0XHkAI6MRbOuAHADb1grgCLcHBP//Z","aspectRatio":1.4992503748125936,"src":"/static/12-263-190b9b6eb3099eebe49f0b2d01d0108d-79b28.jpg","srcSet":"/static/12-263-190b9b6eb3099eebe49f0b2d01d0108d-3d830.jpg 300w,\n/static/12-263-190b9b6eb3099eebe49f0b2d01d0108d-2ab78.jpg 600w,\n/static/12-263-190b9b6eb3099eebe49f0b2d01d0108d-79b28.jpg 1000w","srcWebp":"/static/12-263-190b9b6eb3099eebe49f0b2d01d0108d-161ff.webp","srcSetWebp":"/static/12-263-190b9b6eb3099eebe49f0b2d01d0108d-9fc06.webp 300w,\n/static/12-263-190b9b6eb3099eebe49f0b2d01d0108d-36f59.webp 600w,\n/static/12-263-190b9b6eb3099eebe49f0b2d01d0108d-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgUD/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAbSvxjaMUBN9CnBMT//EABwQAQADAAIDAAAAAAAAAAAAAAIAAQMEEhAjM//aAAgBAQABBQJgGifT0ubuzqeQzL0U5P0nQzc+f//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwEj/8QAHRAAAgIBBQAAAAAAAAAAAAAAAAEQESECEkFhcf/aAAgBAQAGPwJVls9hujo4HGdTs3T/AP/EABwQAAIDAQEBAQAAAAAAAAAAAAERACExURCx0f/aAAgBAQABPyEXvyc7HuNb7CRUcgTBdXByBFsIyNfiWN5QEEuo5BuH3//aAAwDAQACAAMAAAAQfw49/8QAGBEAAgMAAAAAAAAAAAAAAAAAAREAECH/2gAIAQMBAT8QQWRm/wD/xAAZEQABBQAAAAAAAAAAAAAAAAAAARAhMXH/2gAIAQIBAT8QpTTQf//EAB4QAQACAgMAAwAAAAAAAAAAAAEAESExQVGRELHw/9oACAEBAAE/EATsy+FNiEo4QVtdCBI0OZkWQzsdkwSqQjluW4Yfvcrb2rfpMv3DTwIL01C0lKHmvi3t9n//2Q==","aspectRatio":0.6666666666666666,"src":"/static/12-264-7291e84ed7e062ad4d1ac0e6f0167fd2-79b28.jpg","srcSet":"/static/12-264-7291e84ed7e062ad4d1ac0e6f0167fd2-3d830.jpg 300w,\n/static/12-264-7291e84ed7e062ad4d1ac0e6f0167fd2-2ab78.jpg 600w,\n/static/12-264-7291e84ed7e062ad4d1ac0e6f0167fd2-79b28.jpg 1000w","srcWebp":"/static/12-264-7291e84ed7e062ad4d1ac0e6f0167fd2-161ff.webp","srcSetWebp":"/static/12-264-7291e84ed7e062ad4d1ac0e6f0167fd2-9fc06.webp 300w,\n/static/12-264-7291e84ed7e062ad4d1ac0e6f0167fd2-36f59.webp 600w,\n/static/12-264-7291e84ed7e062ad4d1ac0e6f0167fd2-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAwX/xAAXAQEBAQEAAAAAAAAAAAAAAAABAgAD/9oADAMBAAIQAxAAAAHnVK5WBQDytcWvncQhv//EABsQAAICAwEAAAAAAAAAAAAAAAECABIDBDEh/9oACAEBAAEFAl1XMXVrOTHmLvnYoWNivhZi7WqB0mFp/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEREP/aAAgBAwEBPwGbWf/EABcRAAMBAAAAAAAAAAAAAAAAAAABERD/2gAIAQIBAT8BuxH/xAAeEAACAgAHAAAAAAAAAAAAAAAAAQIhEBEgIjFRcf/aAAgBAQAGPwLr0uaMnHgUY0JlYbhVo//EABsQAAIDAQEBAAAAAAAAAAAAAAERACExQXFh/9oACAEBAAE/IR7Kk8TgqoS6zpYg4gJ6dgUNNEE7DusOOaRUEOgM5FAsw4viUD5Ux8n/2gAMAwEAAgADAAAAENPG/wD/xAAZEQADAAMAAAAAAAAAAAAAAAAAAREQITH/2gAIAQMBAT8QiVCV2V8xf//EABgRAQEBAQEAAAAAAAAAAAAAAAEAESEx/9oACAECAQE/ENbjLnID2Z//xAAeEAEBAAEEAwEAAAAAAAAAAAABEQAxQWFxIVGBof/aAAgBAQABPxAO1tlpjqNWQ9fuKirUXTi5UsRSp72xJkxTcs0HpF5cz9yrbDRNo4U7gAi5yRKFRYPrFspWmKe2q60xfBHpn//Z","aspectRatio":0.6720430107526881,"src":"/static/12-265-f51fd2782ea1c9dcb12a70892f592200-79b28.jpg","srcSet":"/static/12-265-f51fd2782ea1c9dcb12a70892f592200-3d830.jpg 300w,\n/static/12-265-f51fd2782ea1c9dcb12a70892f592200-2ab78.jpg 600w,\n/static/12-265-f51fd2782ea1c9dcb12a70892f592200-79b28.jpg 1000w","srcWebp":"/static/12-265-f51fd2782ea1c9dcb12a70892f592200-161ff.webp","srcSetWebp":"/static/12-265-f51fd2782ea1c9dcb12a70892f592200-9fc06.webp 300w,\n/static/12-265-f51fd2782ea1c9dcb12a70892f592200-36f59.webp 600w,\n/static/12-265-f51fd2782ea1c9dcb12a70892f592200-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMFBP/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAZq9SCiND//EABsQAAIBBQAAAAAAAAAAAAAAAAACMgEREjND/9oACAEBAAEFAulzIaL66R//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAYEAEAAwEAAAAAAAAAAAAAAAAAAQIxEf/aAAgBAQAGPwKZ13GrKIf/xAAbEAACAgMBAAAAAAAAAAAAAAAAAREhMWFxUf/aAAgBAQABPyFtJlQVx6SmlnjR0HhyyU3ItxP/2gAMAwEAAgADAAAAEBPP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBAAAgIDAQEAAAAAAAAAAAAAAREAITFBcWHw/9oACAEBAAE/EHQflrxyGrQwAKBaEqgxBZNReMCH1CYDUSeNCW7+kz//2Q==","aspectRatio":1.5037593984962405,"src":"/static/12-271-8a3fc304b8daa53c759623211949628c-79b28.jpg","srcSet":"/static/12-271-8a3fc304b8daa53c759623211949628c-3d830.jpg 300w,\n/static/12-271-8a3fc304b8daa53c759623211949628c-2ab78.jpg 600w,\n/static/12-271-8a3fc304b8daa53c759623211949628c-79b28.jpg 1000w","srcWebp":"/static/12-271-8a3fc304b8daa53c759623211949628c-161ff.webp","srcSetWebp":"/static/12-271-8a3fc304b8daa53c759623211949628c-9fc06.webp 300w,\n/static/12-271-8a3fc304b8daa53c759623211949628c-36f59.webp 600w,\n/static/12-271-8a3fc304b8daa53c759623211949628c-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAAF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAHMUV4nlVn/xAAbEAACAQUAAAAAAAAAAAAAAAABAgMEESIyM//aAAgBAQABBQJC13VgUR5BF0mONNp//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHBAAAgICAwAAAAAAAAAAAAAAAAECERIxQVFx/9oACAEBAAY/AqUtknllS5LVCK7H6f/EAB0QAAICAQUAAAAAAAAAAAAAAAABITERQVFhkfD/2gAIAQEAAT8hwbSpYpKoqU5GJ18GpH7CSeyPrSP/2gAMAwEAAgADAAAAEKA//8QAFhEAAwAAAAAAAAAAAAAAAAAAEBEh/9oACAEDAQE/EFB//8QAFxEBAAMAAAAAAAAAAAAAAAAAARARIf/aAAgBAgEBPxBdqP/EABwQAQEAAwADAQAAAAAAAAAAAAERACExQYGxwf/aAAgBAQABPxBSjRtpiVnmroIHO4fYFBJuD+4BkpeesRNVAHkA/cc5ysP/2Q==","aspectRatio":1.4992503748125936,"src":"/static/12-28-ac63b950e6d841470ad46d27fe99b0a1-79b28.jpg","srcSet":"/static/12-28-ac63b950e6d841470ad46d27fe99b0a1-3d830.jpg 300w,\n/static/12-28-ac63b950e6d841470ad46d27fe99b0a1-2ab78.jpg 600w,\n/static/12-28-ac63b950e6d841470ad46d27fe99b0a1-79b28.jpg 1000w","srcWebp":"/static/12-28-ac63b950e6d841470ad46d27fe99b0a1-161ff.webp","srcSetWebp":"/static/12-28-ac63b950e6d841470ad46d27fe99b0a1-9fc06.webp 300w,\n/static/12-28-ac63b950e6d841470ad46d27fe99b0a1-36f59.webp 600w,\n/static/12-28-ac63b950e6d841470ad46d27fe99b0a1-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQAE/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAABMcKaC02WZ//EABsQAAEEAwAAAAAAAAAAAAAAAAIABBMyAxES/9oACAEBAAEFAgvxpxiq3uBKSNf/xAAWEQEBAQAAAAAAAAAAAAAAAAAAESH/2gAIAQMBAT8BmI//xAAWEQEBAQAAAAAAAAAAAAAAAAABECH/2gAIAQIBAT8BXZ//xAAcEAACAQUBAAAAAAAAAAAAAAAAARECAxASMYH/2gAIAQEABj8CRbaWIjpT6awf/8QAHhABAAICAQUAAAAAAAAAAAAAAQARITFRQWFxkaH/2gAIAQEAAT8hN6d9YEFBEa8QfcZmCco9CuXpg8Fu7P/aAAwDAQACAAMAAAAQ18//xAAXEQADAQAAAAAAAAAAAAAAAAAAAREh/9oACAEDAQE/EFWBtT//xAAXEQADAQAAAAAAAAAAAAAAAAAAASER/9oACAECAQE/EMaE4f/EABsQAAMBAQEBAQAAAAAAAAAAAAERIQAxcVHB/9oACAEBAAE/EBiGF6QxGBeMbryLBC/PwNByKOaQgxHgYF5o4EVl3//Z","aspectRatio":1.4992503748125936,"src":"/static/12-300-28a12cebb6b91986320a29446179e982-79b28.jpg","srcSet":"/static/12-300-28a12cebb6b91986320a29446179e982-3d830.jpg 300w,\n/static/12-300-28a12cebb6b91986320a29446179e982-2ab78.jpg 600w,\n/static/12-300-28a12cebb6b91986320a29446179e982-79b28.jpg 1000w","srcWebp":"/static/12-300-28a12cebb6b91986320a29446179e982-161ff.webp","srcSetWebp":"/static/12-300-28a12cebb6b91986320a29446179e982-9fc06.webp 300w,\n/static/12-300-28a12cebb6b91986320a29446179e982-36f59.webp 600w,\n/static/12-300-28a12cebb6b91986320a29446179e982-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAAF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAABWsRgtGPM/wD/xAAbEAACAwADAAAAAAAAAAAAAAABAgADEhETI//aAAgBAQABBQKhyJ2ejWnSseDYYBpf/8QAFhEBAQEAAAAAAAAAAAAAAAAAAhAR/9oACAEDAQE/ASdn/8QAFhEBAQEAAAAAAAAAAAAAAAAAAhAS/9oACAECAQE/AW8z/8QAGhAAAgIDAAAAAAAAAAAAAAAAASEAEQIQQf/aAAgBAQAGPwK8rYlciY2ChP/EABoQAQADAQEBAAAAAAAAAAAAAAEAESExUWH/2gAIAQEAAT8hJ0F0HoBSWlfBIQ8v7OyMTocqf//aAAwDAQACAAMAAAAQVP8A/8QAFhEBAQEAAAAAAAAAAAAAAAAAAREA/9oACAEDAQE/EKWuSb//xAAYEQADAQEAAAAAAAAAAAAAAAAAAREhMf/aAAgBAgEBPxDBF0Tqp//EAB4QAQEAAgEFAQAAAAAAAAAAAAERACExQVFhcZGh/9oACAEBAAE/EAmlDXUefHP5jK5oVj3rk7NYkj9yD2BKF6e8o12+feN7NobXvzn/2Q==","aspectRatio":1.5267175572519085,"src":"/static/15-394d0ebc8cd23178ad61d6c573f67834-79b28.jpg","srcSet":"/static/15-394d0ebc8cd23178ad61d6c573f67834-3d830.jpg 300w,\n/static/15-394d0ebc8cd23178ad61d6c573f67834-2ab78.jpg 600w,\n/static/15-394d0ebc8cd23178ad61d6c573f67834-79b28.jpg 1000w","srcWebp":"/static/15-394d0ebc8cd23178ad61d6c573f67834-161ff.webp","srcSetWebp":"/static/15-394d0ebc8cd23178ad61d6c573f67834-9fc06.webp 300w,\n/static/15-394d0ebc8cd23178ad61d6c573f67834-36f59.webp 600w,\n/static/15-394d0ebc8cd23178ad61d6c573f67834-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFBv/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAYrN1QmGgD//xAAaEAADAQADAAAAAAAAAAAAAAABAgMAERIT/9oACAEBAAEFAjycTPpObMohPSiBfyTf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGhAAAwADAQAAAAAAAAAAAAAAAAERAiExMv/aAAgBAQAGPwKs1iqVOHhGSe0cP//EABwQAAICAgMAAAAAAAAAAAAAAAERACEQYTFRcf/aAAgBAQABPyFqw7MUMIid9x2YPBKJ50RuI4Xyf//aAAwDAQACAAMAAAAQEw//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAdEAEAAgICAwAAAAAAAAAAAAABABEhMUFhcYGh/9oACAEBAAE/EHYUuoEzJBE6bdOKlHZRQpKe3yRZAtAhpx7mWGd0kPk//9k=","aspectRatio":1.4992503748125936,"src":"/static/19-fa944233fa6e1d127e858c3f16445d06-79b28.jpg","srcSet":"/static/19-fa944233fa6e1d127e858c3f16445d06-3d830.jpg 300w,\n/static/19-fa944233fa6e1d127e858c3f16445d06-2ab78.jpg 600w,\n/static/19-fa944233fa6e1d127e858c3f16445d06-79b28.jpg 1000w","srcWebp":"/static/19-fa944233fa6e1d127e858c3f16445d06-161ff.webp","srcSetWebp":"/static/19-fa944233fa6e1d127e858c3f16445d06-9fc06.webp 300w,\n/static/19-fa944233fa6e1d127e858c3f16445d06-36f59.webp 600w,\n/static/19-fa944233fa6e1d127e858c3f16445d06-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAABAv/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAd6QEJBj/8QAGRAAAgMBAAAAAAAAAAAAAAAAAQIAAxIE/9oACAEBAAEFAuSrQC4m0MBxR1MQhn//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAbEAABBAMAAAAAAAAAAAAAAAAAAQISIRBBsf/aAAgBAQAGPwKY5XdLQSOmlY//xAAbEAACAgMBAAAAAAAAAAAAAAAAARFRITFhQf/aAAgBAQABPyGZe4XbIMx0shstxvjHaTIeYDaP/9oADAMBAAIAAwAAABDQD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EAB0QAQADAAIDAQAAAAAAAAAAAAEAESExUUGBobH/2gAIAQEAAT8QQAoq93Vp/IoTy8pTwM3KmF5XsiAsIvbV1+ylJo1d73FHHJfU/9k=","aspectRatio":1.4992503748125936,"src":"/static/20.5-9ed32a4b7b548a81e6f2fcf7c3811c67-79b28.jpg","srcSet":"/static/20.5-9ed32a4b7b548a81e6f2fcf7c3811c67-3d830.jpg 300w,\n/static/20.5-9ed32a4b7b548a81e6f2fcf7c3811c67-2ab78.jpg 600w,\n/static/20.5-9ed32a4b7b548a81e6f2fcf7c3811c67-79b28.jpg 1000w","srcWebp":"/static/20.5-9ed32a4b7b548a81e6f2fcf7c3811c67-161ff.webp","srcSetWebp":"/static/20.5-9ed32a4b7b548a81e6f2fcf7c3811c67-9fc06.webp 300w,\n/static/20.5-9ed32a4b7b548a81e6f2fcf7c3811c67-36f59.webp 600w,\n/static/20.5-9ed32a4b7b548a81e6f2fcf7c3811c67-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFBv/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAGmumRVMzQH/8QAGxAAAgIDAQAAAAAAAAAAAAAAAgMAARETFCP/2gAIAQEAAQUCNlEpTtYdIRR+bTuEV5//xAAWEQADAAAAAAAAAAAAAAAAAAABEFH/2gAIAQMBAT8BMX//xAAXEQEAAwAAAAAAAAAAAAAAAAAAARFh/9oACAECAQE/AdXL/8QAHRAAAgEEAwAAAAAAAAAAAAAAAAECEBESQWGBkf/aAAgBAQAGPwJ4t9FpqRvwfAlT/8QAGRABAAMBAQAAAAAAAAAAAAAAAQARMUEh/9oACAEBAAE/IfdQm8Tl5jXInySUBVIAvc2L1P/aAAwDAQACAAMAAAAQ3+//xAAYEQACAwAAAAAAAAAAAAAAAAAAAREhMf/aAAgBAwEBPxBIwUf/xAAXEQADAQAAAAAAAAAAAAAAAAAAAREx/9oACAECAQE/EFlMuf/EABkQAQEBAQEBAAAAAAAAAAAAAAERADEhUf/aAAgBAQABPxCVSM6ZHjKnZX1vc8X1LhPYLj1i3H70S1057kKu7//Z","aspectRatio":1.4992503748125936,"src":"/static/20.6-783302bf947824c789a2437a4c0039d7-79b28.jpg","srcSet":"/static/20.6-783302bf947824c789a2437a4c0039d7-3d830.jpg 300w,\n/static/20.6-783302bf947824c789a2437a4c0039d7-2ab78.jpg 600w,\n/static/20.6-783302bf947824c789a2437a4c0039d7-79b28.jpg 1000w","srcWebp":"/static/20.6-783302bf947824c789a2437a4c0039d7-161ff.webp","srcSetWebp":"/static/20.6-783302bf947824c789a2437a4c0039d7-9fc06.webp 300w,\n/static/20.6-783302bf947824c789a2437a4c0039d7-36f59.webp 600w,\n/static/20.6-783302bf947824c789a2437a4c0039d7-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMCBAX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHOlYSOHB//xAAbEAACAgMBAAAAAAAAAAAAAAABAgMyABITIv/aAAgBAQABBQLVsKeRAWQUNombn//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABwQAAMAAQUAAAAAAAAAAAAAAAABAhIRITFBUf/aAAgBAQAGPwLohy9fUyWsODIhi3P/xAAbEAACAwEBAQAAAAAAAAAAAAABEQAhMUFhcf/aAAgBAQABPyG9Lag9EC4DB2Ax5sYlX4ofsNQEKoBCp//aAAwDAQACAAMAAAAQ88//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAdEAEAAgICAwAAAAAAAAAAAAABABEhMUFhUXGB/9oACAEBAAE/EEaOQ3hqHsNlMEX89Q5qzDXbLfMd6Fo9leY1XGVXZAPsQWif/9k=","aspectRatio":1.4992503748125936,"src":"/static/20-35645c8d096195a0951d5c3f068058f4-79b28.jpg","srcSet":"/static/20-35645c8d096195a0951d5c3f068058f4-3d830.jpg 300w,\n/static/20-35645c8d096195a0951d5c3f068058f4-2ab78.jpg 600w,\n/static/20-35645c8d096195a0951d5c3f068058f4-79b28.jpg 1000w","srcWebp":"/static/20-35645c8d096195a0951d5c3f068058f4-161ff.webp","srcSetWebp":"/static/20-35645c8d096195a0951d5c3f068058f4-9fc06.webp 300w,\n/static/20-35645c8d096195a0951d5c3f068058f4-36f59.webp 600w,\n/static/20-35645c8d096195a0951d5c3f068058f4-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAwADAAAAAAAAAAAAAAAAAAMEAQIF/8QAFwEAAwEAAAAAAAAAAAAAAAAAAQIDAP/aAAwDAQACEAMQAAABw2GuVIjUYdFBHllGhP8A/8QAHBAAAgIDAQEAAAAAAAAAAAAAAQIDEQAEEhMh/9oACAEBAAEFAmQKpHIcN1sWHj6EDym0p82pPl5GaMjSevDZ/8QAFxEAAwEAAAAAAAAAAAAAAAAAABAREv/aAAgBAwEBPwGlWT//xAAXEQEBAQEAAAAAAAAAAAAAAAAAARES/9oACAECAQE/AeWJWv/EACMQAAIBAgQHAAAAAAAAAAAAAAABAhExAxIhIxAiMkFRYaH/2gAIAQEABj8C+1NuXOPbb9mVWY3XvcpF6IcMSSfgjhxtHg8uh1a0uXR//8QAHBAAAgMBAAMAAAAAAAAAAAAAASEAETFBUWGR/9oACAEBAAE/IXQ3QZwSpd0sEKNr42FZqXfiCWWH2gbpQUP3eLlGHd7FURWqUMyKk0S9khn/2gAMAwEAAgADAAAAEDjAwf/EABgRAAMBAQAAAAAAAAAAAAAAAAABESFB/9oACAEDAQE/EF2QRPUUf//EABcRAAMBAAAAAAAAAAAAAAAAAAAQETH/2gAIAQIBAT8Q1Ckyf//EAB8QAQEAAgICAwEAAAAAAAAAAAERACExQWFxgZGh0f/aAAgBAQABPxBquFQkRCy761kkCngDmvTiWQ1y+2BHGtFEvDq/GHyWIZ1NXcwQAlPbzvFiZktnzOKYBFLVXLr8v3hGop3cJojaKI9Ry4gEMCuyklxTUOVX+Z//2Q==","aspectRatio":0.6666666666666666,"src":"/static/21.5-0bd0698f132daa0fc3d4a1a5e35c31b6-79b28.jpg","srcSet":"/static/21.5-0bd0698f132daa0fc3d4a1a5e35c31b6-3d830.jpg 300w,\n/static/21.5-0bd0698f132daa0fc3d4a1a5e35c31b6-2ab78.jpg 600w,\n/static/21.5-0bd0698f132daa0fc3d4a1a5e35c31b6-79b28.jpg 1000w","srcWebp":"/static/21.5-0bd0698f132daa0fc3d4a1a5e35c31b6-161ff.webp","srcSetWebp":"/static/21.5-0bd0698f132daa0fc3d4a1a5e35c31b6-9fc06.webp 300w,\n/static/21.5-0bd0698f132daa0fc3d4a1a5e35c31b6-36f59.webp 600w,\n/static/21.5-0bd0698f132daa0fc3d4a1a5e35c31b6-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwQA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABoCowtdj/xAAaEAADAAMBAAAAAAAAAAAAAAABAgMABBIR/9oACAEBAAEFAurBTWvRTYxwXCzVW9z/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAeEAABBAEFAAAAAAAAAAAAAAABAAIREiEQMkFRkf/aAAgBAQAGPwKXOAjlNZbLuluPqItiFYDOn//EABgQAQEBAQEAAAAAAAAAAAAAAAERADFh/9oACAEBAAE/IWGTpZhL4VqNEih8Bi4QQs81u//aAAwDAQACAAMAAAAQ0M//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAeEAACAgICAwAAAAAAAAAAAAABEQAhMVFBYZGhwf/aAAgBAQABPxAjAZkP2plhUwkIN2IdXB1iCDkgXsnXVSs1YQlIfPMJj+z/2Q==","aspectRatio":1.4992503748125936,"src":"/static/21-a82f1b00c3e39c2df5ffc8954a4e71fc-79b28.jpg","srcSet":"/static/21-a82f1b00c3e39c2df5ffc8954a4e71fc-3d830.jpg 300w,\n/static/21-a82f1b00c3e39c2df5ffc8954a4e71fc-2ab78.jpg 600w,\n/static/21-a82f1b00c3e39c2df5ffc8954a4e71fc-79b28.jpg 1000w","srcWebp":"/static/21-a82f1b00c3e39c2df5ffc8954a4e71fc-161ff.webp","srcSetWebp":"/static/21-a82f1b00c3e39c2df5ffc8954a4e71fc-9fc06.webp 300w,\n/static/21-a82f1b00c3e39c2df5ffc8954a4e71fc-36f59.webp 600w,\n/static/21-a82f1b00c3e39c2df5ffc8954a4e71fc-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}}]},"freiearbeiten":null,"brotundspiele":{"edges":[{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAECAwQF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABwaKJkzMCSrIncD//xAAbEAADAQEAAwAAAAAAAAAAAAAAAQISAxETIf/aAAgBAQABBQL2PWmbZMqRs0Ni+jtiWzy+lcucTH//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAbEAABBQEBAAAAAAAAAAAAAAAAAQIRITEgwf/aAAgBAQAGPwIvrayShzlxLgawRPD/xAAdEAACAgMBAQEAAAAAAAAAAAABEQAhUWGBQdHw/9oACAEBAAE/IWCQGY8W4IjE2BgQIoJodDlJOKllo7fEe8gYimpHv5y0ALQ7AEeylz//2gAMAwEAAgADAAAAECDPPP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB0QAQACAgMBAQAAAAAAAAAAAAEAESFBMWGRUbH/2gAIAQEAAT8QAvHIP7C8vYLKQ9KQpVv5ZgKHREI23tUqsclfL17AEtf2XBjxzqyIAk1Aq9+vcu/SK2Tg6PUojIYKCxrRiAxbLYKvnM//2Q==","aspectRatio":0.66711140760507,"src":"/static/1-22d64630055e57daedcf0bd22519e0a5-79b28.jpg","srcSet":"/static/1-22d64630055e57daedcf0bd22519e0a5-3d830.jpg 300w,\n/static/1-22d64630055e57daedcf0bd22519e0a5-2ab78.jpg 600w,\n/static/1-22d64630055e57daedcf0bd22519e0a5-79b28.jpg 1000w","srcWebp":"/static/1-22d64630055e57daedcf0bd22519e0a5-161ff.webp","srcSetWebp":"/static/1-22d64630055e57daedcf0bd22519e0a5-9fc06.webp 300w,\n/static/1-22d64630055e57daedcf0bd22519e0a5-36f59.webp 600w,\n/static/1-22d64630055e57daedcf0bd22519e0a5-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQCAwUG/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABSzewzzNGwmlCsdAP/8QAHhAAAwACAgMBAAAAAAAAAAAAAQIDERIABBMxMkH/2gAIAQEAAQUCbqEoRjkEDJPHj7MJlYJqlK68apIjnWnv9l8//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHBAAAQQDAQAAAAAAAAAAAAAAEAIRMYEAARIh/9oACAEBAAY/Aukiw6fFZOpNhh//xAAcEAEAAgMBAQEAAAAAAAAAAAABABEhMWFBgeH/2gAIAQEAAT8hSP7VOIipKYgUjk22Rs+TQ4hKMhUxb+zjuTJh3Z8JTT6YQd7uf//aAAwDAQACAAMAAAAQoAE8/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAIRABAQACAQIHAAAAAAAAAAAAAREAIUFRcTFhgaGxwdH/2gAIAQEAAT8QAhRpgTiK/OJ3AxHKDkR7GQRUQQ07m8KEEFk8649MYQVOrrRkauDB0eLLzR0CYyMrV7wyMdFZ12/uC2FOws+s3BU1j5Gf/9k=","aspectRatio":0.66711140760507,"src":"/static/10-5eb3076108eec274752a5a3742a37ffe-79b28.jpg","srcSet":"/static/10-5eb3076108eec274752a5a3742a37ffe-3d830.jpg 300w,\n/static/10-5eb3076108eec274752a5a3742a37ffe-2ab78.jpg 600w,\n/static/10-5eb3076108eec274752a5a3742a37ffe-79b28.jpg 1000w","srcWebp":"/static/10-5eb3076108eec274752a5a3742a37ffe-161ff.webp","srcSetWebp":"/static/10-5eb3076108eec274752a5a3742a37ffe-9fc06.webp 300w,\n/static/10-5eb3076108eec274752a5a3742a37ffe-36f59.webp 600w,\n/static/10-5eb3076108eec274752a5a3742a37ffe-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAQP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFxWbWJ5QCJRT6mi4f/xAAdEAACAQQDAAAAAAAAAAAAAAABAgADERIUBCIj/9oACAEBAAEFAjVQRuUltloignUAGospoWLoQvaZWmfnmZ//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAfEAACAAUFAAAAAAAAAAAAAAAAAQIhMTJBEBFxgZH/2gAIAQEABj8CqjL4JQInkqYJsuZe/TZHen//xAAhEAEAAgEDBAMAAAAAAAAAAAABABEhEDFBUWFxgZHB0f/aAAgBAQABPyGmaMZtnKL0wIGVW8QNttRE77RHn4v7B1gQAjm2XTPQb94tBov/2gAMAwEAAgADAAAAEBMIMP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB8QAAIDAAICAwAAAAAAAAAAAAERACExUYFBcZGhwf/aAAgBAQABPxAY3J0OBcVCksXVyYNhBxkXBybARn24tiqiy/FKP5DQPgqytjy1oUo7Fve7KDyQGnKX2FjXqHyo9T//2Q==","aspectRatio":0.66711140760507,"src":"/static/11-575eda4c0db594fd802018fc7aa8662b-79b28.jpg","srcSet":"/static/11-575eda4c0db594fd802018fc7aa8662b-3d830.jpg 300w,\n/static/11-575eda4c0db594fd802018fc7aa8662b-2ab78.jpg 600w,\n/static/11-575eda4c0db594fd802018fc7aa8662b-79b28.jpg 1000w","srcWebp":"/static/11-575eda4c0db594fd802018fc7aa8662b-161ff.webp","srcSetWebp":"/static/11-575eda4c0db594fd802018fc7aa8662b-9fc06.webp 300w,\n/static/11-575eda4c0db594fd802018fc7aa8662b-36f59.webp 600w,\n/static/11-575eda4c0db594fd802018fc7aa8662b-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAUBAgP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGNlFh0JQ//xAAbEAACAwADAAAAAAAAAAAAAAABAgADEhEUIf/aAAgBAQABBQJWHC2YnYSVksNelwJ//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGxAAAgIDAQAAAAAAAAAAAAAAAAEhMgIRUWH/2gAIAQEABj8CLbXpUlxwfETgmf/EABwQAQACAwADAAAAAAAAAAAAAAEAESExQXGBof/aAAgBAQABPyF1BfUfRhzL7Ho18yzLRqnZlhoKCUpgt6n/2gAMAwEAAgADAAAAEEMP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHxABAQABAwUBAAAAAAAAAAAAAREAITFxQVFhgbHR/9oACAEBAAE/ECcjmz8xSIms0eDce8M84C4rBNRInVyzAYHsd8o46qX4c//Z","aspectRatio":1.4992503748125936,"src":"/static/12-d1c35f50187fecfc6a6e013491788197-79b28.jpg","srcSet":"/static/12-d1c35f50187fecfc6a6e013491788197-3d830.jpg 300w,\n/static/12-d1c35f50187fecfc6a6e013491788197-2ab78.jpg 600w,\n/static/12-d1c35f50187fecfc6a6e013491788197-79b28.jpg 1000w","srcWebp":"/static/12-d1c35f50187fecfc6a6e013491788197-161ff.webp","srcSetWebp":"/static/12-d1c35f50187fecfc6a6e013491788197-9fc06.webp 300w,\n/static/12-d1c35f50187fecfc6a6e013491788197-36f59.webp 600w,\n/static/12-d1c35f50187fecfc6a6e013491788197-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwAB/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABDCYOyP/EABoQAAICAwAAAAAAAAAAAAAAAAADAhMBEDL/2gAIAQEAAQUCvZIy2ZcwXzr/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAbEAABBAMAAAAAAAAAAAAAAAAAAQISICExQf/aAAgBAQAGPwLMVNNOU//EABoQAQEAAgMAAAAAAAAAAAAAAAEAESExcYH/2gAIAQEAAT8hwNOyVvbA8B8nGb//2gAMAwEAAgADAAAAENDP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHRABAAICAgMAAAAAAAAAAAAAAQAxESFBkVGB0f/aAAgBAQABPxAM0my2HuXSXKGzuCYO8A+xsqt4hEcg+po0dT//2Q==","aspectRatio":1.7761989342806395,"src":"/static/13-06ef1feab827a698627066442e720913-79b28.jpg","srcSet":"/static/13-06ef1feab827a698627066442e720913-3d830.jpg 300w,\n/static/13-06ef1feab827a698627066442e720913-2ab78.jpg 600w,\n/static/13-06ef1feab827a698627066442e720913-79b28.jpg 1000w","srcWebp":"/static/13-06ef1feab827a698627066442e720913-161ff.webp","srcSetWebp":"/static/13-06ef1feab827a698627066442e720913-9fc06.webp 300w,\n/static/13-06ef1feab827a698627066442e720913-36f59.webp 600w,\n/static/13-06ef1feab827a698627066442e720913-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMBAgT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHI4WXJD//EABoQAAIDAQEAAAAAAAAAAAAAAAABAgMRISL/2gAIAQEAAQUCUurGYXxRT6Ez/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGBABAQADAAAAAAAAAAAAAAAAIQABEHH/2gAIAQEABj8CSYg1nt//xAAbEAEAAwADAQAAAAAAAAAAAAABABEhQVFhMf/aAAgBAQABPyHUC3Mor9S/oiFTY08m4OPD1K6dR//aAAwDAQACAAMAAAAQg8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAeEAEAAgIBBQAAAAAAAAAAAAABABEhYTFRcYGRsf/aAAgBAQABPxBGqLYqr359TCkDmzLHEhQuxnLwgZ2O06pADyr+ajWC7CxSf//Z","aspectRatio":1.4992503748125936,"src":"/static/14-2a0d25f6b0a1b82da16a291e630f2914-79b28.jpg","srcSet":"/static/14-2a0d25f6b0a1b82da16a291e630f2914-3d830.jpg 300w,\n/static/14-2a0d25f6b0a1b82da16a291e630f2914-2ab78.jpg 600w,\n/static/14-2a0d25f6b0a1b82da16a291e630f2914-79b28.jpg 1000w","srcWebp":"/static/14-2a0d25f6b0a1b82da16a291e630f2914-161ff.webp","srcSetWebp":"/static/14-2a0d25f6b0a1b82da16a291e630f2914-9fc06.webp 300w,\n/static/14-2a0d25f6b0a1b82da16a291e630f2914-36f59.webp 600w,\n/static/14-2a0d25f6b0a1b82da16a291e630f2914-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIEA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAZ9ncnNgV22JS4P/xAAdEAACAgIDAQAAAAAAAAAAAAAAAQISAxEQExQh/9oACAEBAAEFAopxLTZ17NfGuLwL7LIhhgRx42/PA//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB0QAAICAQUAAAAAAAAAAAAAAAABEDERAhIhMlH/2gAIAQEABj8CwjwqFHZFlmdiONCKR//EACAQAAICAAYDAAAAAAAAAAAAAAABESEQMUFRYYFxkaH/2gAIAQEAAT8hV6GwkJrYNHm2lvAh6ELx0TKMwg9pWRw/ZdeV8H2bQ53Jf//aAAwDAQACAAMAAAAQkMsw/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHhABAAMAAgMBAQAAAAAAAAAAAQARIUFhMVGxceH/2gAIAQEAAT8QYIDtUcMvQ4XaqPO/kuBM0xapAA8Hr+QqjDB1HAaoUFGiUHpDYKV71wvuPFT1BfOTB0HWylFTLT5cHslvBD7P/9k=","aspectRatio":0.66711140760507,"src":"/static/15-9b7060c92370ebde42093138cc916374-79b28.jpg","srcSet":"/static/15-9b7060c92370ebde42093138cc916374-3d830.jpg 300w,\n/static/15-9b7060c92370ebde42093138cc916374-2ab78.jpg 600w,\n/static/15-9b7060c92370ebde42093138cc916374-79b28.jpg 1000w","srcWebp":"/static/15-9b7060c92370ebde42093138cc916374-161ff.webp","srcSetWebp":"/static/15-9b7060c92370ebde42093138cc916374-9fc06.webp 300w,\n/static/15-9b7060c92370ebde42093138cc916374-36f59.webp 600w,\n/static/15-9b7060c92370ebde42093138cc916374-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwAE/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABNsaCWGP/xAAaEAADAQADAAAAAAAAAAAAAAABAhEDAAQT/9oACAEBAAEFAlmznJIOwoCPB6cY0//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABsQAAIDAAMAAAAAAAAAAAAAAAERABIhEDFx/9oACAEBAAY/ArEZMBfsVEuep//EABsQAQEBAAIDAAAAAAAAAAAAAAERADFBUWGh/9oACAEBAAE/IbvDcjLiv1l0IekhoAGrx9xVTv/aAAwDAQACAAMAAAAQcw//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAeEAEAAgIBBQAAAAAAAAAAAAABABEhMYFBUWGR0f/aAAgBAQABPxDM9ibldOSNqAWGrnEuchRXny1uKYgGhSNe/vFbC91+z//Z","aspectRatio":1.4992503748125936,"src":"/static/16-cabad5b8f8427281eba87344641614a1-79b28.jpg","srcSet":"/static/16-cabad5b8f8427281eba87344641614a1-3d830.jpg 300w,\n/static/16-cabad5b8f8427281eba87344641614a1-2ab78.jpg 600w,\n/static/16-cabad5b8f8427281eba87344641614a1-79b28.jpg 1000w","srcWebp":"/static/16-cabad5b8f8427281eba87344641614a1-161ff.webp","srcSetWebp":"/static/16-cabad5b8f8427281eba87344641614a1-9fc06.webp 300w,\n/static/16-cabad5b8f8427281eba87344641614a1-36f59.webp 600w,\n/static/16-cabad5b8f8427281eba87344641614a1-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAZnVYTDA/8QAGxAAAgIDAQAAAAAAAAAAAAAAAAIBAxMUITH/2gAIAQEAAQUCWlmNZTFWR0b2T//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABkQAAIDAQAAAAAAAAAAAAAAAAABEBExIf/aAAgBAQAGPwLEdZkVH//EABoQAAMBAQEBAAAAAAAAAAAAAAABETFxQYH/2gAIAQEAAT8h1ujI+3FCWJ9RDYVoWmf/2gAMAwEAAgADAAAAECDP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHhABAAIBBAMAAAAAAAAAAAAAAQARITFRYZFxwdH/2gAIAQEAAT8QyAzh73hqqmaqTS1/KxAGilifIRm+upgbHG0//9k=","aspectRatio":1.4992503748125936,"src":"/static/17-a6eecc1faf94f6d7351c1755ef6ab4c7-79b28.jpg","srcSet":"/static/17-a6eecc1faf94f6d7351c1755ef6ab4c7-3d830.jpg 300w,\n/static/17-a6eecc1faf94f6d7351c1755ef6ab4c7-2ab78.jpg 600w,\n/static/17-a6eecc1faf94f6d7351c1755ef6ab4c7-79b28.jpg 1000w","srcWebp":"/static/17-a6eecc1faf94f6d7351c1755ef6ab4c7-161ff.webp","srcSetWebp":"/static/17-a6eecc1faf94f6d7351c1755ef6ab4c7-9fc06.webp 300w,\n/static/17-a6eecc1faf94f6d7351c1755ef6ab4c7-36f59.webp 600w,\n/static/17-a6eecc1faf94f6d7351c1755ef6ab4c7-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAwADAAAAAAAAAAAAAAAAAAIFAQME/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB0UOELZJCXkYUcP/EAB4QAAEDBAMAAAAAAAAAAAAAAAABAhIDERMUEDEy/9oACAEBAAEFAqXro16RmYZ223CyEUI8SUkf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHRAAAQIHAAAAAAAAAAAAAAAAAAFBEBEgMTKR4f/aAAgBAQAGPwIkhgg2jg8bUf/EAB0QAQACAQUBAAAAAAAAAAAAAAEAESExQVFhcZH/2gAIAQEAAT8hrZ2MEUVBwYIrrf5K8Rxtz3Bhr8RuyrOplOcvMYXn/9oADAMBAAIAAwAAABCAyTz/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAdEAEBAAICAwEAAAAAAAAAAAABEQAhMWFBUZHR/9oACAEBAAE/ELUlvA7evmIdxCdxyvORVwApF+ZxDDuD2/MZiANDRkwSON808Dtcdgvv1+4PXy9ZdIzCNtR9dYRLn//Z","aspectRatio":0.66711140760507,"src":"/static/18-8463d835554771e7d897fb5c325e9fb6-79b28.jpg","srcSet":"/static/18-8463d835554771e7d897fb5c325e9fb6-3d830.jpg 300w,\n/static/18-8463d835554771e7d897fb5c325e9fb6-2ab78.jpg 600w,\n/static/18-8463d835554771e7d897fb5c325e9fb6-79b28.jpg 1000w","srcWebp":"/static/18-8463d835554771e7d897fb5c325e9fb6-161ff.webp","srcSetWebp":"/static/18-8463d835554771e7d897fb5c325e9fb6-9fc06.webp 300w,\n/static/18-8463d835554771e7d897fb5c325e9fb6-36f59.webp 600w,\n/static/18-8463d835554771e7d897fb5c325e9fb6-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAcPleSlQf//EABkQAAMBAQEAAAAAAAAAAAAAAAABAgMQEf/aAAgBAQABBQKckPNUPKvZYuf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAWEAADAAAAAAAAAAAAAAAAAAAAIHH/2gAIAQEABj8CIv8A/8QAGxABAAIDAQEAAAAAAAAAAAAAAQAxESFxQVH/2gAIAQEAAT8hXaHIO+ZYIdF8iYuJ3u4r9n//2gAMAwEAAgADAAAAELAP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBABAQEAAQUAAAAAAAAAAAAAAREAITFBUZHR/9oACAEBAAE/EEBM8ThojRg7Q+uHhF4QOOUwFVyrzr+r3v/Z","aspectRatio":1.7761989342806395,"src":"/static/19-4f32d51076982b8a66cf666bebe74d4c-79b28.jpg","srcSet":"/static/19-4f32d51076982b8a66cf666bebe74d4c-3d830.jpg 300w,\n/static/19-4f32d51076982b8a66cf666bebe74d4c-2ab78.jpg 600w,\n/static/19-4f32d51076982b8a66cf666bebe74d4c-79b28.jpg 1000w","srcWebp":"/static/19-4f32d51076982b8a66cf666bebe74d4c-161ff.webp","srcSetWebp":"/static/19-4f32d51076982b8a66cf666bebe74d4c-9fc06.webp 300w,\n/static/19-4f32d51076982b8a66cf666bebe74d4c-36f59.webp 600w,\n/static/19-4f32d51076982b8a66cf666bebe74d4c-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAVdo7BQJQf/EABsQAAICAwEAAAAAAAAAAAAAAAABAhQDBBAR/9oACAEBAAEFAlsssSLcuYV7I//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABkQAAIDAQAAAAAAAAAAAAAAAAAQAREyQv/aAAgBAQAGPwI0cqbX/8QAGhAAAgMBAQAAAAAAAAAAAAAAAREAITFRcf/aAAgBAQABPyFy6PYTBV9gQNRk6YASyE1tbP/aAAwDAQACAAMAAAAQA8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAcEAEAAwACAwAAAAAAAAAAAAABABEhMUFRgcH/2gAIAQEAAT8QK0nSLIdoCcj7CkIBym+9iQEQ8sPWipqVDaCRFoT/2Q==","aspectRatio":1.7761989342806395,"src":"/static/2-9305740130eb626b5d440fa34f407f00-79b28.jpg","srcSet":"/static/2-9305740130eb626b5d440fa34f407f00-3d830.jpg 300w,\n/static/2-9305740130eb626b5d440fa34f407f00-2ab78.jpg 600w,\n/static/2-9305740130eb626b5d440fa34f407f00-79b28.jpg 1000w","srcWebp":"/static/2-9305740130eb626b5d440fa34f407f00-161ff.webp","srcSetWebp":"/static/2-9305740130eb626b5d440fa34f407f00-9fc06.webp 300w,\n/static/2-9305740130eb626b5d440fa34f407f00-36f59.webp 600w,\n/static/2-9305740130eb626b5d440fa34f407f00-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMBAgT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHGxDShIf/EABsQAAIBBQAAAAAAAAAAAAAAAAABAgMREiEz/9oACAEBAAEFAkxjyOdWWpXZ/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHBAAAQMFAAAAAAAAAAAAAAAAAQACEBEhMUFR/9oACAEBAAY/Aq6VnQ5owgOiP//EABoQAAMBAQEBAAAAAAAAAAAAAAABESExYUH/2gAIAQEAAT8hVFVfKU43I31UnRcx+iTHlF4Jn0//2gAMAwEAAgADAAAAEMDP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBABAAICAwEAAAAAAAAAAAAAAREhADFBUYGx/9oACAEBAAE/EAGlIao9PT9wHTGmzOHqNhvGWJ0V8gm8Zn3O28QvOSFPTP/Z","aspectRatio":1.4992503748125936,"src":"/static/3-e096cb77b0fa8fe108ed1a988b583564-79b28.jpg","srcSet":"/static/3-e096cb77b0fa8fe108ed1a988b583564-3d830.jpg 300w,\n/static/3-e096cb77b0fa8fe108ed1a988b583564-2ab78.jpg 600w,\n/static/3-e096cb77b0fa8fe108ed1a988b583564-79b28.jpg 1000w","srcWebp":"/static/3-e096cb77b0fa8fe108ed1a988b583564-161ff.webp","srcSetWebp":"/static/3-e096cb77b0fa8fe108ed1a988b583564-9fc06.webp 300w,\n/static/3-e096cb77b0fa8fe108ed1a988b583564-36f59.webp 600w,\n/static/3-e096cb77b0fa8fe108ed1a988b583564-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQBAgP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGa5tCAB//EABsQAAICAwEAAAAAAAAAAAAAAAECAAMEERIh/9oACAEBAAEFAmyHeeCOR1W062GrG//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABwQAAIBBQEAAAAAAAAAAAAAAAABIhARITFSgf/aAAgBAQAGPwLlEkyN16aMqn//xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhUUFhcZH/2gAIAQEAAT8hx58Ze4dReAPEq4LtlHDS4t1if//aAAwDAQACAAMAAAAQQ8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAbEAEAAgMBAQAAAAAAAAAAAAABABEhMUFRcf/aAAgBAQABPxBBu6AVfrA42Bd1zGzTdKTj2DkYtZk0xksfCf/Z","aspectRatio":1.4992503748125936,"src":"/static/4-6cc1724c0f9685c3df26a2b400c5ef31-79b28.jpg","srcSet":"/static/4-6cc1724c0f9685c3df26a2b400c5ef31-3d830.jpg 300w,\n/static/4-6cc1724c0f9685c3df26a2b400c5ef31-2ab78.jpg 600w,\n/static/4-6cc1724c0f9685c3df26a2b400c5ef31-79b28.jpg 1000w","srcWebp":"/static/4-6cc1724c0f9685c3df26a2b400c5ef31-161ff.webp","srcSetWebp":"/static/4-6cc1724c0f9685c3df26a2b400c5ef31-9fc06.webp 300w,\n/static/4-6cc1724c0f9685c3df26a2b400c5ef31-36f59.webp 600w,\n/static/4-6cc1724c0f9685c3df26a2b400c5ef31-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIFBP/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAVeKxuJof//EABoQAQABBQAAAAAAAAAAAAAAAAERAgQQExT/2gAIAQEAAQUC3q9FUNwyZ//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABUQAQEAAAAAAAAAAAAAAAAAACAh/9oACAEBAAY/Aqv/xAAbEAADAAMBAQAAAAAAAAAAAAAAAREhMVFBcf/aAAgBAQABPyFYRX2DRKs5BfDB9M82x7P/2gAMAwEAAgADAAAAEDMP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHhABAAIBBAMAAAAAAAAAAAAAAQARITFBYZGBscH/2gAIAQEAAT8QONLiiephzpu1FwHhp8l0PYxXxN2Hl3P/2Q==","aspectRatio":1.7761989342806395,"src":"/static/5-88d41e01e26e281c4b4c8a298a332488-79b28.jpg","srcSet":"/static/5-88d41e01e26e281c4b4c8a298a332488-3d830.jpg 300w,\n/static/5-88d41e01e26e281c4b4c8a298a332488-2ab78.jpg 600w,\n/static/5-88d41e01e26e281c4b4c8a298a332488-79b28.jpg 1000w","srcWebp":"/static/5-88d41e01e26e281c4b4c8a298a332488-161ff.webp","srcSetWebp":"/static/5-88d41e01e26e281c4b4c8a298a332488-9fc06.webp 300w,\n/static/5-88d41e01e26e281c4b4c8a298a332488-36f59.webp 600w,\n/static/5-88d41e01e26e281c4b4c8a298a332488-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGgAAAQUBAAAAAAAAAAAAAAAAAAECAwQFBv/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAdHK3eYGihbqVphRgf/EABwQAAICAwEBAAAAAAAAAAAAAAIDAAEREiExQf/aAAgBAQABBQIx2pjQBlO1mcx68xaOWcYfBuV2fb9//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAIBAAAgAEBwAAAAAAAAAAAAAAAAECERIhECAxMmGRof/aAAgBAQAGPwKUTtwUtbSzZIqXpeXZrkSw/8QAHRABAQEBAAIDAQAAAAAAAAAAAREAITFBUWGBsf/aAAgBAQABPyFKEvtedLU9OevWOidbkFX91Ytq1fcr5vc+XeOfegNT91C5AmHmNz//2gAMAwEAAgADAAAAEDPGPP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EACAQAQEAAgICAgMAAAAAAAAAAAERADEhcUFRYcGRofH/2gAIAQEAAT8QGIIuaPT5mtY7oiAoVz+mCpkKl5/GHb45n3zl6TaJsN77xOhNHoYYN17y5tkdd7/mNEKiUej7uVE/EyoYrlxkb1n/2Q==","aspectRatio":0.66711140760507,"src":"/static/6-51cb12efabefd289ef8395a13b6adcc0-79b28.jpg","srcSet":"/static/6-51cb12efabefd289ef8395a13b6adcc0-3d830.jpg 300w,\n/static/6-51cb12efabefd289ef8395a13b6adcc0-2ab78.jpg 600w,\n/static/6-51cb12efabefd289ef8395a13b6adcc0-79b28.jpg 1000w","srcWebp":"/static/6-51cb12efabefd289ef8395a13b6adcc0-161ff.webp","srcSetWebp":"/static/6-51cb12efabefd289ef8395a13b6adcc0-9fc06.webp 300w,\n/static/6-51cb12efabefd289ef8395a13b6adcc0-36f59.webp 600w,\n/static/6-51cb12efabefd289ef8395a13b6adcc0-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAYBAwX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGjRXoGYXw//8QAHRAAAQQCAwAAAAAAAAAAAAAAAAECBBMDERIxMv/aAAgBAQABBQLDIrElNU3yH+uixyH/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAABAwUAAAAAAAAAAAAAAAAAAQIREBIhMZH/2gAIAQEABj8CgyhNre12f//EABsQAQADAQADAAAAAAAAAAAAAAEAESFRMXGh/9oACAEBAAE/IU8RXGdF95Cq2k/QuCrGoYhz/9oADAMBAAIAAwAAABAAD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EAB4QAAICAgIDAAAAAAAAAAAAAAERACExUUFhcaGx/9oACAEBAAE/EAtrFppauot+hAnUdE9KGhXCXZl5vCCEQGJ//9k=","aspectRatio":1.7761989342806395,"src":"/static/7-2ba02bc3cda7e527cf0236674c798efc-79b28.jpg","srcSet":"/static/7-2ba02bc3cda7e527cf0236674c798efc-3d830.jpg 300w,\n/static/7-2ba02bc3cda7e527cf0236674c798efc-2ab78.jpg 600w,\n/static/7-2ba02bc3cda7e527cf0236674c798efc-79b28.jpg 1000w","srcWebp":"/static/7-2ba02bc3cda7e527cf0236674c798efc-161ff.webp","srcSetWebp":"/static/7-2ba02bc3cda7e527cf0236674c798efc-9fc06.webp 300w,\n/static/7-2ba02bc3cda7e527cf0236674c798efc-36f59.webp 600w,\n/static/7-2ba02bc3cda7e527cf0236674c798efc-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB2nmXHBIP/8QAGxAAAgIDAQAAAAAAAAAAAAAAAAECEhEhMUH/2gAIAQEAAQUCXLIa3KWT25//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAaEAEAAQUAAAAAAAAAAAAAAAAAARARITKB/9oACAEBAAY/AnKTbCGr/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFBUeH/2gAIAQEAAT8hQaYliGOpYtSmA2rsFHWwdeyp9T//2gAMAwEAAgADAAAAEGDP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBABAQADAQADAAAAAAAAAAAAAREAITFBYXHw/9oACAEBAAE/EL5gFWc/XCAei+HuPwYyZtFY00JB184gDYBSJz6xckO7Vvd5/9k=","aspectRatio":1.4992503748125936,"src":"/static/8-75462aec2e28e4d138b3c375497dabe8-79b28.jpg","srcSet":"/static/8-75462aec2e28e4d138b3c375497dabe8-3d830.jpg 300w,\n/static/8-75462aec2e28e4d138b3c375497dabe8-2ab78.jpg 600w,\n/static/8-75462aec2e28e4d138b3c375497dabe8-79b28.jpg 1000w","srcWebp":"/static/8-75462aec2e28e4d138b3c375497dabe8-161ff.webp","srcSetWebp":"/static/8-75462aec2e28e4d138b3c375497dabe8-9fc06.webp 300w,\n/static/8-75462aec2e28e4d138b3c375497dabe8-36f59.webp 600w,\n/static/8-75462aec2e28e4d138b3c375497dabe8-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAUCAwT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFTK5iYhiH/xAAbEAACAgMBAAAAAAAAAAAAAAAAAQISAwQRIf/aAAgBAQABBQKpRsWr5yuSCUTp/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGRAAAgMBAAAAAAAAAAAAAAAAAAIBECFR/9oACAEBAAY/Aq1hY6ZX/8QAHBAAAgMAAwEAAAAAAAAAAAAAAREAITEQUXGh/9oACAEBAAE/IcsZ8jyAfkOcR6gQzTG4Fpt8P//aAAwDAQACAAMAAAAQ48//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAeEAEAAgIBBQAAAAAAAAAAAAABABExQSFhgaHB0f/aAAgBAQABPxCwKOpbXc9wASloy3XyAFH0LqKtt4ZWPnG4PORNnPME6n//2Q==","aspectRatio":1.4992503748125936,"src":"/static/9-4a95d5ae042e2d156efc90c964710cfb-79b28.jpg","srcSet":"/static/9-4a95d5ae042e2d156efc90c964710cfb-3d830.jpg 300w,\n/static/9-4a95d5ae042e2d156efc90c964710cfb-2ab78.jpg 600w,\n/static/9-4a95d5ae042e2d156efc90c964710cfb-79b28.jpg 1000w","srcWebp":"/static/9-4a95d5ae042e2d156efc90c964710cfb-161ff.webp","srcSetWebp":"/static/9-4a95d5ae042e2d156efc90c964710cfb-9fc06.webp 300w,\n/static/9-4a95d5ae042e2d156efc90c964710cfb-36f59.webp 600w,\n/static/9-4a95d5ae042e2d156efc90c964710cfb-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}}]},"offseason":{"edges":[{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQABAAIDAAAAAAAAAAAAAAAAAAMEAQIF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB66XBGkBU1LqiP//EABcQAQEBAQAAAAAAAAAAAAAAAAAREiD/2gAIAQEAAQUCiJxVVttt/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAFBABAAAAAAAAAAAAAAAAAAAAMP/aAAgBAQAGPwJP/8QAFxABAQEBAAAAAAAAAAAAAAAAEQAQIP/aAAgBAQABPyHQRHAUpX//2gAMAwEAAgADAAAAENDNDP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EABsQAAICAwEAAAAAAAAAAAAAAAARYXEBECBR/9oACAEBAAE/ENFeIggkGZh3pcf/2Q==","aspectRatio":0.66711140760507,"src":"/static/timmendorf-1-von-1-10-e4280fb9df8a59995dfdc84370dab38d-79b28.jpg","srcSet":"/static/timmendorf-1-von-1-10-e4280fb9df8a59995dfdc84370dab38d-3d830.jpg 300w,\n/static/timmendorf-1-von-1-10-e4280fb9df8a59995dfdc84370dab38d-2ab78.jpg 600w,\n/static/timmendorf-1-von-1-10-e4280fb9df8a59995dfdc84370dab38d-79b28.jpg 1000w","srcWebp":"/static/timmendorf-1-von-1-10-e4280fb9df8a59995dfdc84370dab38d-161ff.webp","srcSetWebp":"/static/timmendorf-1-von-1-10-e4280fb9df8a59995dfdc84370dab38d-9fc06.webp 300w,\n/static/timmendorf-1-von-1-10-e4280fb9df8a59995dfdc84370dab38d-36f59.webp 600w,\n/static/timmendorf-1-von-1-10-e4280fb9df8a59995dfdc84370dab38d-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFAf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAaTU3CkLB//EABgQAAMBAQAAAAAAAAAAAAAAAAADEgEC/9oACAEBAAEFAlrJJK2Vt6vej//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABcQAAMBAAAAAAAAAAAAAAAAAAACEDH/2gAIAQEABj8CrGz/xAAYEAEBAAMAAAAAAAAAAAAAAAABABEhUf/aAAgBAQABPyEAgTMTC6OzAKZFv//aAAwDAQACAAMAAAAQEA//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAbEAEAAwADAQAAAAAAAAAAAAABABEhMUFRkf/aAAgBAQABPxAdZBVhCXiIQFqbeQPAji51Frb9Z//Z","aspectRatio":1.4992503748125936,"src":"/static/timmendorf-1-von-1-12-308c375e0d46f37dd96bf52ab747bf1e-79b28.jpg","srcSet":"/static/timmendorf-1-von-1-12-308c375e0d46f37dd96bf52ab747bf1e-3d830.jpg 300w,\n/static/timmendorf-1-von-1-12-308c375e0d46f37dd96bf52ab747bf1e-2ab78.jpg 600w,\n/static/timmendorf-1-von-1-12-308c375e0d46f37dd96bf52ab747bf1e-79b28.jpg 1000w","srcWebp":"/static/timmendorf-1-von-1-12-308c375e0d46f37dd96bf52ab747bf1e-161ff.webp","srcSetWebp":"/static/timmendorf-1-von-1-12-308c375e0d46f37dd96bf52ab747bf1e-9fc06.webp 300w,\n/static/timmendorf-1-von-1-12-308c375e0d46f37dd96bf52ab747bf1e-36f59.webp 600w,\n/static/timmendorf-1-von-1-12-308c375e0d46f37dd96bf52ab747bf1e-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEBQH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHXeVikzQl66k4of//EABwQAAICAwEBAAAAAAAAAAAAAAECAAMRExQEEv/aAAgBAQABBQICYgE6apvXHbUDssWL6flbLVdiiwjM1gz/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAgEAACAQEJAAAAAAAAAAAAAAAAAREhAhASIjFhkaGx/9oACAEBAAY/ArmPMT4OvQ04cis4XTcmOTQiEUP/xAAcEAEAAgMAAwAAAAAAAAAAAAABABEhMUFhcZH/2gAIAQEAAT8hphAX7TkDUEZbOUWURQ3KMh7sxQArEWxnXEoY+swXsTb18z//2gAMAwEAAgADAAAAEFDGPP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EACAQAQEAAwACAQUAAAAAAAAAAAERACExQYFxUWGRoeH/2gAIAQEAAT8Q+iwMNA7TfgwdFDKOn3w95vobVQPjzj0RgUJqbuIRBS6qS/iYCA2SWj7YEY6FBXb5wlSSn7HuG+BYmpL3+ZanLk7H14z/2Q==","aspectRatio":0.66711140760507,"src":"/static/timmendorf-1-von-1-13-9c9570aa39fa97a88dbe2d8abc5d9fa3-79b28.jpg","srcSet":"/static/timmendorf-1-von-1-13-9c9570aa39fa97a88dbe2d8abc5d9fa3-3d830.jpg 300w,\n/static/timmendorf-1-von-1-13-9c9570aa39fa97a88dbe2d8abc5d9fa3-2ab78.jpg 600w,\n/static/timmendorf-1-von-1-13-9c9570aa39fa97a88dbe2d8abc5d9fa3-79b28.jpg 1000w","srcWebp":"/static/timmendorf-1-von-1-13-9c9570aa39fa97a88dbe2d8abc5d9fa3-161ff.webp","srcSetWebp":"/static/timmendorf-1-von-1-13-9c9570aa39fa97a88dbe2d8abc5d9fa3-9fc06.webp 300w,\n/static/timmendorf-1-von-1-13-9c9570aa39fa97a88dbe2d8abc5d9fa3-36f59.webp 600w,\n/static/timmendorf-1-von-1-13-9c9570aa39fa97a88dbe2d8abc5d9fa3-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAEDBQL/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHWVQiWDMtTkRMP/8QAGhAAAgMBAQAAAAAAAAAAAAAAAAECERIQIP/aAAgBAQABBQKijPhznS0jTLHz/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGxAAAQQDAAAAAAAAAAAAAAAAAQACESAhIlH/2gAIAQEABj8Cto1xnpWZNf/EABoQAAIDAQEAAAAAAAAAAAAAAAABEBEhMXH/2gAIAQEAAT8hhoZGDN+6TCrpx7SPT//aAAwDAQACAAMAAAAQUMYw/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHhABAAICAgMBAAAAAAAAAAAAAQARITFBYRBRgaH/2gAIAQEAAT8Qo8RDxG7UO0x4FAywQB18z+RovLauuNEQdQ2Mm4nPo7gFbP/Z","aspectRatio":0.66711140760507,"src":"/static/timmendorf-1-von-1-15-8da99cc0d6854269f81abfcf3323ac03-79b28.jpg","srcSet":"/static/timmendorf-1-von-1-15-8da99cc0d6854269f81abfcf3323ac03-3d830.jpg 300w,\n/static/timmendorf-1-von-1-15-8da99cc0d6854269f81abfcf3323ac03-2ab78.jpg 600w,\n/static/timmendorf-1-von-1-15-8da99cc0d6854269f81abfcf3323ac03-79b28.jpg 1000w","srcWebp":"/static/timmendorf-1-von-1-15-8da99cc0d6854269f81abfcf3323ac03-161ff.webp","srcSetWebp":"/static/timmendorf-1-von-1-15-8da99cc0d6854269f81abfcf3323ac03-9fc06.webp 300w,\n/static/timmendorf-1-von-1-15-8da99cc0d6854269f81abfcf3323ac03-36f59.webp 600w,\n/static/timmendorf-1-von-1-15-8da99cc0d6854269f81abfcf3323ac03-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMGAQX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAH2FBJUR7mBpmZH/8QAGxAAAgIDAQAAAAAAAAAAAAAAAAECEQMSEyD/2gAIAQEAAQUCoorx0N0dELLM7THnmz//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAZEAACAwEAAAAAAAAAAAAAAAAAEQEwMTL/2gAIAQEABj8Cp6kbNP/EABwQAAMAAgMBAAAAAAAAAAAAAAABESFhECBx0f/aAAgBAQABPyHoIQaJWbfFtS9EKwyZRt8H/9oADAMBAAIAAwAAABCDBjD/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAaEAEBAQEBAQEAAAAAAAAAAAABEQAxIVEQ/9oACAEBAAE/EMj5q+YP0AuCejwwl8YFtN5C0cFHAhTvc+PTsWnJqyCeTP/Z","aspectRatio":0.66711140760507,"src":"/static/timmendorf-1-von-1-18-0682b7a66a5a9bdb647f72f9be693886-79b28.jpg","srcSet":"/static/timmendorf-1-von-1-18-0682b7a66a5a9bdb647f72f9be693886-3d830.jpg 300w,\n/static/timmendorf-1-von-1-18-0682b7a66a5a9bdb647f72f9be693886-2ab78.jpg 600w,\n/static/timmendorf-1-von-1-18-0682b7a66a5a9bdb647f72f9be693886-79b28.jpg 1000w","srcWebp":"/static/timmendorf-1-von-1-18-0682b7a66a5a9bdb647f72f9be693886-161ff.webp","srcSetWebp":"/static/timmendorf-1-von-1-18-0682b7a66a5a9bdb647f72f9be693886-9fc06.webp 300w,\n/static/timmendorf-1-von-1-18-0682b7a66a5a9bdb647f72f9be693886-36f59.webp 600w,\n/static/timmendorf-1-von-1-18-0682b7a66a5a9bdb647f72f9be693886-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAwADAAAAAAAAAAAAAAAAAAMGAQIF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB7YwFDQVmf1KImg//xAAbEAABBQEBAAAAAAAAAAAAAAAAAQIREhMUIP/aAAgBAQABBQKCCPF0LFkNlN3HQ4//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAUEAEAAAAAAAAAAAAAAAAAAAAw/9oACAEBAAY/Ak//xAAYEAADAQEAAAAAAAAAAAAAAAAAAREQIP/aAAgBAQABPyGeynKYwdT/2gAMAwEAAgADAAAAEMMNPP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EABsQAAMAAgMAAAAAAAAAAAAAAAABEUFhMaGx/9oACAEBAAE/EIYIWB6kIQTXE6bTcJOWtZK+ehKL4f/Z","aspectRatio":0.66711140760507,"src":"/static/timmendorf-1-von-1-21-fea1619d50aae011c258a3d5a0fd0fbd-79b28.jpg","srcSet":"/static/timmendorf-1-von-1-21-fea1619d50aae011c258a3d5a0fd0fbd-3d830.jpg 300w,\n/static/timmendorf-1-von-1-21-fea1619d50aae011c258a3d5a0fd0fbd-2ab78.jpg 600w,\n/static/timmendorf-1-von-1-21-fea1619d50aae011c258a3d5a0fd0fbd-79b28.jpg 1000w","srcWebp":"/static/timmendorf-1-von-1-21-fea1619d50aae011c258a3d5a0fd0fbd-161ff.webp","srcSetWebp":"/static/timmendorf-1-von-1-21-fea1619d50aae011c258a3d5a0fd0fbd-9fc06.webp 300w,\n/static/timmendorf-1-von-1-21-fea1619d50aae011c258a3d5a0fd0fbd-36f59.webp 600w,\n/static/timmendorf-1-von-1-21-fea1619d50aae011c258a3d5a0fd0fbd-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQAD/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABXi8RiAj/xAAZEAEAAwEBAAAAAAAAAAAAAAACAAESEyH/2gAIAQEAAQUCTyehnQwnVo2LD8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAaEAACAgMAAAAAAAAAAAAAAAABAgAQMTJB/9oACAEBAAY/Aix5M0ykzav/xAAaEAADAQADAAAAAAAAAAAAAAAAASERMXGB/9oACAEBAAE/IULETTRKKbVPfBz1i5JXSVqGvrD/2gAMAwEAAgADAAAAEDDP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGhABAAMBAQEAAAAAAAAAAAAAAQARIUExof/aAAgBAQABPxBnF5BBAYBDuygUToiR+RywFp0eVc2OjFnldlFT04Z//9k=","aspectRatio":1.4992503748125936,"src":"/static/timmendorf-1-von-1-26-37d8e92b0969e043ec44434851f27d95-79b28.jpg","srcSet":"/static/timmendorf-1-von-1-26-37d8e92b0969e043ec44434851f27d95-3d830.jpg 300w,\n/static/timmendorf-1-von-1-26-37d8e92b0969e043ec44434851f27d95-2ab78.jpg 600w,\n/static/timmendorf-1-von-1-26-37d8e92b0969e043ec44434851f27d95-79b28.jpg 1000w","srcWebp":"/static/timmendorf-1-von-1-26-37d8e92b0969e043ec44434851f27d95-161ff.webp","srcSetWebp":"/static/timmendorf-1-von-1-26-37d8e92b0969e043ec44434851f27d95-9fc06.webp 300w,\n/static/timmendorf-1-von-1-26-37d8e92b0969e043ec44434851f27d95-36f59.webp 600w,\n/static/timmendorf-1-von-1-26-37d8e92b0969e043ec44434851f27d95-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUBAgME/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABtk5qKBwGU8eIyF4f/8QAGhAAAgMBAQAAAAAAAAAAAAAAAQMAAhESE//aAAgBAQABBQJqOSF6SrDcdALAmZPQZ7CFwEoo0swXyq+J/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHhAAAgIBBQEAAAAAAAAAAAAAAAERIQISIDFBYaH/2gAIAQEABj8CnrZ6WpJs5LY8k1LLWJGr4f/EABsQAQEBAAMBAQAAAAAAAAAAAAERACExUWHx/9oACAEBAAE/IWnat0xngzRjzEZ5C93G6fhv1GdmEpRiSGREL4ughzsI43//2gAMAwEAAgADAAAAELMJDP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB0QAQEBAQEAAgMAAAAAAAAAAAERACFRMUFhcYH/2gAIAQEAAT8QM1Wi8R8yRauWdR+cfpLNWi+HzWkUNr7xcFfhpgw6BPDcOFKQHn7uT4BDpbeOXh8LWfxJlUBsDRDnd//Z","aspectRatio":0.66711140760507,"src":"/static/timmendorf-1-von-1-31-5c14d2db18c85962c8aa0edb780cc0fd-79b28.jpg","srcSet":"/static/timmendorf-1-von-1-31-5c14d2db18c85962c8aa0edb780cc0fd-3d830.jpg 300w,\n/static/timmendorf-1-von-1-31-5c14d2db18c85962c8aa0edb780cc0fd-2ab78.jpg 600w,\n/static/timmendorf-1-von-1-31-5c14d2db18c85962c8aa0edb780cc0fd-79b28.jpg 1000w","srcWebp":"/static/timmendorf-1-von-1-31-5c14d2db18c85962c8aa0edb780cc0fd-161ff.webp","srcSetWebp":"/static/timmendorf-1-von-1-31-5c14d2db18c85962c8aa0edb780cc0fd-9fc06.webp 300w,\n/static/timmendorf-1-von-1-31-5c14d2db18c85962c8aa0edb780cc0fd-36f59.webp 600w,\n/static/timmendorf-1-von-1-31-5c14d2db18c85962c8aa0edb780cc0fd-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgUD/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB1puEgGG6j3FhQP/EABsQAAICAwEAAAAAAAAAAAAAAAECABIDBBEg/9oACAEBAAEFAudATnkOcwsyxt1gyKFlpkrb/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHRAAAQQCAwAAAAAAAAAAAAAAAAECESEQEiAxYf/aAAgBAQAGPwLlO7k8kpagppSY6P/EAB0QAQACAgIDAAAAAAAAAAAAAAEAESFBEGExUYH/2gAIAQEAAT8hupNjhCZNy+ogbfnCgI7ltuPDB2wf2Txl2cf/2gAMAwEAAgADAAAAEIAOMP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB8QAQADAAIBBQAAAAAAAAAAAAEAESExUUFhcYGR0f/aAAgBAQABPxDYqXhlYdN3A7lC+GvEFS7Rd5f2lpfYSCviFmMrdOm/sx33HZ+pdgHl6xRSs6ljz14J/9k=","aspectRatio":0.66711140760507,"src":"/static/timmendorf-1-von-1-33-fbc2dd746174ab2e045cdb9b99b4ccea-79b28.jpg","srcSet":"/static/timmendorf-1-von-1-33-fbc2dd746174ab2e045cdb9b99b4ccea-3d830.jpg 300w,\n/static/timmendorf-1-von-1-33-fbc2dd746174ab2e045cdb9b99b4ccea-2ab78.jpg 600w,\n/static/timmendorf-1-von-1-33-fbc2dd746174ab2e045cdb9b99b4ccea-79b28.jpg 1000w","srcWebp":"/static/timmendorf-1-von-1-33-fbc2dd746174ab2e045cdb9b99b4ccea-161ff.webp","srcSetWebp":"/static/timmendorf-1-von-1-33-fbc2dd746174ab2e045cdb9b99b4ccea-9fc06.webp 300w,\n/static/timmendorf-1-von-1-33-fbc2dd746174ab2e045cdb9b99b4ccea-36f59.webp 600w,\n/static/timmendorf-1-von-1-33-fbc2dd746174ab2e045cdb9b99b4ccea-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGgAAAgMBAQAAAAAAAAAAAAAAAAQBAgMFBv/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAeraNRcYDzjM6gUD/8QAGxAAAwEBAAMAAAAAAAAAAAAAAAECERIEEBP/2gAIAQEAAQUCtacj0m1S9T4y35UjLJZ0dH//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAdEAACAgEFAAAAAAAAAAAAAAABAgAQESAhIzEz/9oACAEBAAY/Aq6mxBvKsQYOd57No//EABwQAAMBAAIDAAAAAAAAAAAAAAABESExYRBx8f/aAAgBAQABPyGP2LG8mmOymW9PxUKQQ8aYk+Tb0fORAoZ//9oADAMBAAIAAwAAABDwDgz/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAdEAEAAgIDAQEAAAAAAAAAAAABABEhMUFhcVHB/9oACAEBAAE/EKABbeTfJTu8QaQ+jB4Y0JMKoXEqxmB7IBtVh6zLqIu13bx9hScPf+RdL3OZtxi4g6Z//9k=","aspectRatio":0.66711140760507,"src":"/static/timmendorf-1-von-1-47-9f8774c88c1ee11433c317fce1187b42-79b28.jpg","srcSet":"/static/timmendorf-1-von-1-47-9f8774c88c1ee11433c317fce1187b42-3d830.jpg 300w,\n/static/timmendorf-1-von-1-47-9f8774c88c1ee11433c317fce1187b42-2ab78.jpg 600w,\n/static/timmendorf-1-von-1-47-9f8774c88c1ee11433c317fce1187b42-79b28.jpg 1000w","srcWebp":"/static/timmendorf-1-von-1-47-9f8774c88c1ee11433c317fce1187b42-161ff.webp","srcSetWebp":"/static/timmendorf-1-von-1-47-9f8774c88c1ee11433c317fce1187b42-9fc06.webp 300w,\n/static/timmendorf-1-von-1-47-9f8774c88c1ee11433c317fce1187b42-36f59.webp 600w,\n/static/timmendorf-1-von-1-47-9f8774c88c1ee11433c317fce1187b42-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAQADBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAe9mIRH/xAAZEAACAwEAAAAAAAAAAAAAAAAAAQIQERL/2gAIAQEAAQUCH1SkaN4f/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFxABAAMAAAAAAAAAAAAAAAAAACAygf/aAAgBAQAGPwJq0P/EABkQAAIDAQAAAAAAAAAAAAAAAAARAUGBMf/aAAgBAQABPyHSVVTCW+xlEhhI/9oADAMBAAIAAwAAABCTD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EAB4QAQACAgEFAAAAAAAAAAAAAAEAESFBYTFRcYGh/9oACAEBAAE/EFdfELVxZV67/MIyN4COCge7iLTm4PUObn//2Q==","aspectRatio":1.4992503748125936,"src":"/static/timmendorf-1-von-1-8-88ffa280758ede37ce57941cbd51874b-79b28.jpg","srcSet":"/static/timmendorf-1-von-1-8-88ffa280758ede37ce57941cbd51874b-3d830.jpg 300w,\n/static/timmendorf-1-von-1-8-88ffa280758ede37ce57941cbd51874b-2ab78.jpg 600w,\n/static/timmendorf-1-von-1-8-88ffa280758ede37ce57941cbd51874b-79b28.jpg 1000w","srcWebp":"/static/timmendorf-1-von-1-8-88ffa280758ede37ce57941cbd51874b-161ff.webp","srcSetWebp":"/static/timmendorf-1-von-1-8-88ffa280758ede37ce57941cbd51874b-9fc06.webp 300w,\n/static/timmendorf-1-von-1-8-88ffa280758ede37ce57941cbd51874b-36f59.webp 600w,\n/static/timmendorf-1-von-1-8-88ffa280758ede37ce57941cbd51874b-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}}]},"humanstudies":{"edges":[{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAUDBP/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAeijHrGgP//EABsQAQACAgMAAAAAAAAAAAAAAAEDEQACBBAS/9oACAEBAAEFAjyzjfXHoh0tM//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EAB0QAAAFBQAAAAAAAAAAAAAAAAECEBEhABIiQYH/2gAIAQEABj8CxgpJ6twg+6cU/8QAGhAAAgMBAQAAAAAAAAAAAAAAAREAEFFBMf/aAAgBAQABPyFGAADLsKMeUJmwGxGVvmV//9oADAMBAAIAAwAAABDgz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EAB4QAAICAgIDAAAAAAAAAAAAAAERADEhUUFxEGHR/9oACAEBAAE/EOP27RafGAz2YAbmo0/fXhgOTkoEd7WoYC2gAh9RT//Z","aspectRatio":1.4992503748125936,"src":"/static/10-ade99f5e7b33b8ae685f61c4891ec0a2-79b28.jpg","srcSet":"/static/10-ade99f5e7b33b8ae685f61c4891ec0a2-3d830.jpg 300w,\n/static/10-ade99f5e7b33b8ae685f61c4891ec0a2-2ab78.jpg 600w,\n/static/10-ade99f5e7b33b8ae685f61c4891ec0a2-79b28.jpg 1000w","srcWebp":"/static/10-ade99f5e7b33b8ae685f61c4891ec0a2-161ff.webp","srcSetWebp":"/static/10-ade99f5e7b33b8ae685f61c4891ec0a2-9fc06.webp 300w,\n/static/10-ade99f5e7b33b8ae685f61c4891ec0a2-36f59.webp 600w,\n/static/10-ade99f5e7b33b8ae685f61c4891ec0a2-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAdB6KRpKH//EABsQAAIBBQAAAAAAAAAAAAAAAAECAAMQERIT/9oACAEBAAEFAgWiNtbmHIRREqHH/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHBAAAAYDAAAAAAAAAAAAAAAAAAECAxAhQVFh/9oACAEBAAY/AqbUNHF46KSUf//EAB4QAAICAAcAAAAAAAAAAAAAAAERACEQQWFxocHR/9oACAEBAAE/IVOh7FkQgohvDNK1ILQGwhN0bI5n/9oADAMBAAIAAwAAABBzD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EAB4QAQACAgEFAAAAAAAAAAAAAAEAIRExYRBBcaHB/9oACAEBAAE/EKxr2VJBoNzBW4SuhSmhWz3qGBfATKyhmeEfJ//Z","aspectRatio":1.4992503748125936,"src":"/static/11-e5a83e64b72a2e1ea9db5fd539e907e0-79b28.jpg","srcSet":"/static/11-e5a83e64b72a2e1ea9db5fd539e907e0-3d830.jpg 300w,\n/static/11-e5a83e64b72a2e1ea9db5fd539e907e0-2ab78.jpg 600w,\n/static/11-e5a83e64b72a2e1ea9db5fd539e907e0-79b28.jpg 1000w","srcWebp":"/static/11-e5a83e64b72a2e1ea9db5fd539e907e0-161ff.webp","srcSetWebp":"/static/11-e5a83e64b72a2e1ea9db5fd539e907e0-9fc06.webp 300w,\n/static/11-e5a83e64b72a2e1ea9db5fd539e907e0-36f59.webp 600w,\n/static/11-e5a83e64b72a2e1ea9db5fd539e907e0-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUBAgQG/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABeUtgGRnCcTUOeGYf/8QAHRAAAgEEAwAAAAAAAAAAAAAAAgMBABAREwQSMf/aAAgBAQABBQKinFi8gtyEM2pYBFAAanNkuOyzc9v/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAgEAACAQQBBQAAAAAAAAAAAAABAgAQESFBAxIiMWGB/9oACAEBAAY/AoDT3qcq7EVp2sPonW9rNg2jKvg5FdT/xAAgEAACAQMEAwAAAAAAAAAAAAABEQAQIVExQWGRcaGx/9oACAEBAAE/IZwRrul6Ar7RcsOQxuPczCr+YqAcMgAArhlsYyt3dQgEIxKX21Ic/9oADAMBAAIAAwAAABDgzjD/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAfEAEAAQQCAwEAAAAAAAAAAAABEQAhMUFRcRBhkYH/2gAIAQEAAT8QiLO6Au3lPwP2KCiqZLt4XKhfCmymx2BPyi3GHqM1F0bjHpIR90nqR5jmnLh7ndBBKgGDT6PhkAjkaQ7EESyS5r//2Q==","aspectRatio":0.6666666666666666,"src":"/static/12-72b55ee71764b308e2b65d8bc3219f11-79b28.jpg","srcSet":"/static/12-72b55ee71764b308e2b65d8bc3219f11-3d830.jpg 300w,\n/static/12-72b55ee71764b308e2b65d8bc3219f11-2ab78.jpg 600w,\n/static/12-72b55ee71764b308e2b65d8bc3219f11-79b28.jpg 1000w","srcWebp":"/static/12-72b55ee71764b308e2b65d8bc3219f11-161ff.webp","srcSetWebp":"/static/12-72b55ee71764b308e2b65d8bc3219f11-9fc06.webp 300w,\n/static/12-72b55ee71764b308e2b65d8bc3219f11-36f59.webp 600w,\n/static/12-72b55ee71764b308e2b65d8bc3219f11-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAwADAAAAAAAAAAAAAAAAAAMEAQIF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB6bBJUJDDZ9xpKH//xAAcEAACAgIDAAAAAAAAAAAAAAABAgASAxATIkH/2gAIAQEAAQUC8TsukYInMghFooAhAmM2QGPmo/8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHRAAAgIDAAMAAAAAAAAAAAAAAAECERAxURIyYf/aAAgBAQAGPwIT7mEX7VoqUlF8ZV40eXSH0aP/xAAeEAEAAgMAAgMAAAAAAAAAAAABABEhMUFRYXGBkf/aAAgBAQABPyGqUQPxcqBHrrQcstU50pmNYdxNLt2+YpyH6jg+8fHI1N9H8mObn//aAAwDAQACAAMAAAAQkwow/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAIRABAQABAwMFAAAAAAAAAAAAAREAITFxUaGxQYGRwfD/2gAIAQEAAT8QLAagvbNkAR7mGKUeMqyAAUm2hZzi8goxnz5wlpJqpQ65RD6ib8sLLs0UPnJg2wDaoP3XFbwXvPrEScIjyGf/2Q==","aspectRatio":0.6666666666666666,"src":"/static/13-e6fbbe48e326a3b88b305984bd4fb0ab-79b28.jpg","srcSet":"/static/13-e6fbbe48e326a3b88b305984bd4fb0ab-3d830.jpg 300w,\n/static/13-e6fbbe48e326a3b88b305984bd4fb0ab-2ab78.jpg 600w,\n/static/13-e6fbbe48e326a3b88b305984bd4fb0ab-79b28.jpg 1000w","srcWebp":"/static/13-e6fbbe48e326a3b88b305984bd4fb0ab-161ff.webp","srcSetWebp":"/static/13-e6fbbe48e326a3b88b305984bd4fb0ab-9fc06.webp 300w,\n/static/13-e6fbbe48e326a3b88b305984bd4fb0ab-36f59.webp 600w,\n/static/13-e6fbbe48e326a3b88b305984bd4fb0ab-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB70RU1AFabqDosH//xAAdEAACAgEFAAAAAAAAAAAAAAABAgADEhEUISIz/9oACAEBAAEFAoORGOkq85ccRQSKu0sGVdAbborOv//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EACEQAAIAAwkAAAAAAAAAAAAAAAABAiExEBESEyAiMlFx/9oACAEBAAY/AtCsTfGjEpsoiJPoh3XeGLMimf/EAB8QAQACAgICAwAAAAAAAAAAAAEAESExEEFRYXGBkf/aAAgBAQABPyGOl4w11dMV8BbGfre4JhRdfPmCzIerg6kx1eCsMv7CdcyDGp//2gAMAwEAAgADAAAAEMDLMP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EACAQAQACAgIBBQAAAAAAAAAAAAEAESExYZFBEFFxgcH/2gAIAQEAAT8QKupymSoF9gOEWh7qX/5OlPQqth9sXRrtgkSWm8trEsCfK/kPu3CfUct8eFoUtbTyg+rHheNz/9k=","aspectRatio":0.6666666666666666,"src":"/static/14-89f114950c8a72b348d38e2b7fdfb52d-79b28.jpg","srcSet":"/static/14-89f114950c8a72b348d38e2b7fdfb52d-3d830.jpg 300w,\n/static/14-89f114950c8a72b348d38e2b7fdfb52d-2ab78.jpg 600w,\n/static/14-89f114950c8a72b348d38e2b7fdfb52d-79b28.jpg 1000w","srcWebp":"/static/14-89f114950c8a72b348d38e2b7fdfb52d-161ff.webp","srcSetWebp":"/static/14-89f114950c8a72b348d38e2b7fdfb52d-9fc06.webp 300w,\n/static/14-89f114950c8a72b348d38e2b7fdfb52d-36f59.webp 600w,\n/static/14-89f114950c8a72b348d38e2b7fdfb52d-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAIBAwQF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB7qpBYVgmF3NQgf/EABsQAAIDAAMAAAAAAAAAAAAAAAERAAIDEBIT/9oACAEBAAEFAuezjCBYCqM7egmtlljUUyn/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAeEAACAQMFAAAAAAAAAAAAAAAAAQIQESEgMUJx0f/aAAgBAQAGPwLRcuY2RGPFZl5SXQkqf//EABsQAAMBAAMBAAAAAAAAAAAAAAABESExUWEQ/9oACAEBAAE/IS/EjRbOfDbcW1nUKNDgHLeCvbeijGx1rV+sp//aAAwDAQACAAMAAAAQcAoM/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHxABAAICAgIDAAAAAAAAAAAAAREhADFBURBhcaGx/9oACAEBAAE/EFxExN4uMb1GaXXzgawMkdAo/mKSkWCLDifeBxDUGiN4IdDuCH2l9Vz4C8uTXcRhC8E5QlfD/9k=","aspectRatio":0.6666666666666666,"src":"/static/2-2634905cc02b6f41960f5032ee12933e-79b28.jpg","srcSet":"/static/2-2634905cc02b6f41960f5032ee12933e-3d830.jpg 300w,\n/static/2-2634905cc02b6f41960f5032ee12933e-2ab78.jpg 600w,\n/static/2-2634905cc02b6f41960f5032ee12933e-79b28.jpg 1000w","srcWebp":"/static/2-2634905cc02b6f41960f5032ee12933e-161ff.webp","srcSetWebp":"/static/2-2634905cc02b6f41960f5032ee12933e-9fc06.webp 300w,\n/static/2-2634905cc02b6f41960f5032ee12933e-36f59.webp 600w,\n/static/2-2634905cc02b6f41960f5032ee12933e-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAUCBAb/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFqI9ATKgf/xAAYEAADAQEAAAAAAAAAAAAAAAABAgMAEf/aAAgBAQABBQI1ChadwbuBNMqBBTpb/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHhAAAgEDBQAAAAAAAAAAAAAAAAFxAhEhAxASMTL/2gAIAQEABj8CV+3knZVN51KuMFkemoP/xAAbEAEAAgMBAQAAAAAAAAAAAAABAEERITFRgf/aAAgBAQABPyHgHm8JruM9AUQxR9naDB8wBstW4c4q4j//2gAMAwEAAgADAAAAEMAP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBABAQACAwEBAAAAAAAAAAAAAREAITFBUZHw/9oACAEBAAE/ELikrm9WveCduIjcnQPTbrft3lKqWJDPmaHY0ocsO1GXovuWy2Ngriv7WAgQNENKXP/Z","aspectRatio":1.4992503748125936,"src":"/static/4-eb1e5fbe858232fcf837ce86fa0c1812-79b28.jpg","srcSet":"/static/4-eb1e5fbe858232fcf837ce86fa0c1812-3d830.jpg 300w,\n/static/4-eb1e5fbe858232fcf837ce86fa0c1812-2ab78.jpg 600w,\n/static/4-eb1e5fbe858232fcf837ce86fa0c1812-79b28.jpg 1000w","srcWebp":"/static/4-eb1e5fbe858232fcf837ce86fa0c1812-161ff.webp","srcSetWebp":"/static/4-eb1e5fbe858232fcf837ce86fa0c1812-9fc06.webp 300w,\n/static/4-eb1e5fbe858232fcf837ce86fa0c1812-36f59.webp 600w,\n/static/4-eb1e5fbe858232fcf837ce86fa0c1812-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUBAgME/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABdzSTM3Bb2INB+Jw//8QAHRAAAgICAwEAAAAAAAAAAAAAAQIAAxARBBITIf/aAAgBAQABBQLDN1Kn4p3g7FtbhiXEsvDz3icrQ//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB4QAAIBBAMBAAAAAAAAAAAAAAABQQIQESExYYGR/9oACAEBAAY/ArcG4HZZ2qt+lVqcpp9OBqXJhL6f/8QAHRAAAgMAAgMAAAAAAAAAAAAAAREAITEQcUFR8P/aAAgBAQABPyHikY9Sy2kYwmCKGNDwD0PhCBmUdgJTm4wGYCuzL6Ca7HvU/9oADAMBAAIAAwAAABCjAwD/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAdEAEBAAIDAAMAAAAAAAAAAAABEQAhMUFRcZHB/9oACAEBAAE/EAyYZO4o4FkVnXzv6jkJVCXulxLyGIqFpg1B31NDXWDRUKRg0cmUY3FmLtUrTB4X8yWDJUFWD8e4dSTuFPPWf//Z","aspectRatio":0.6666666666666666,"src":"/static/5-86e6fe3b390e762e69a3fa6b124da267-79b28.jpg","srcSet":"/static/5-86e6fe3b390e762e69a3fa6b124da267-3d830.jpg 300w,\n/static/5-86e6fe3b390e762e69a3fa6b124da267-2ab78.jpg 600w,\n/static/5-86e6fe3b390e762e69a3fa6b124da267-79b28.jpg 1000w","srcWebp":"/static/5-86e6fe3b390e762e69a3fa6b124da267-161ff.webp","srcSetWebp":"/static/5-86e6fe3b390e762e69a3fa6b124da267-9fc06.webp 300w,\n/static/5-86e6fe3b390e762e69a3fa6b124da267-36f59.webp 600w,\n/static/5-86e6fe3b390e762e69a3fa6b124da267-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMFBAL/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGunbIKYwF4kvKJyH//xAAeEAABBAIDAQAAAAAAAAAAAAADAAECBBETEiEjMf/aAAgBAQABBQKxDmGsbYJ5Sz9Q/M7dKOFZb0QCvrt9DX//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAgEAABBAIBBQAAAAAAAAAAAAABAAIQEQMhIjFBUoGC/9oACAEBAAY/AnBb6ri24yY/psaNrG8djRhvpWPIR//EAB0QAQACAgMBAQAAAAAAAAAAAAEAESExQXGREGH/2gAIAQEAAT8ho/dWdxDdJ7MQAObgmjAa0YClEWFnO2V7oOp+CR1h+zH3XRBefZ//2gAMAwEAAgADAAAAEHDAMP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EACIQAAICAAYCAwAAAAAAAAAAAAERACExQVFhgbFxoZHh8P/aAAgBAQABPxAw8z4qx1FDlY7BT86/cZ0kJLcGMRGxcK4ut0JxHtcQIcARsaokZ118SknJDXvuYwIjchzEAPi/zl0EMGdKEaKHNEJ//9k=","aspectRatio":0.6666666666666666,"src":"/static/7-795b1475ed7c2627493e4cfc414390dd-79b28.jpg","srcSet":"/static/7-795b1475ed7c2627493e4cfc414390dd-3d830.jpg 300w,\n/static/7-795b1475ed7c2627493e4cfc414390dd-2ab78.jpg 600w,\n/static/7-795b1475ed7c2627493e4cfc414390dd-79b28.jpg 1000w","srcWebp":"/static/7-795b1475ed7c2627493e4cfc414390dd-161ff.webp","srcSetWebp":"/static/7-795b1475ed7c2627493e4cfc414390dd-9fc06.webp 300w,\n/static/7-795b1475ed7c2627493e4cfc414390dd-36f59.webp 600w,\n/static/7-795b1475ed7c2627493e4cfc414390dd-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQCAwUB/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB159rLSQIsZbA0Lh//8QAHRAAAgIBBQAAAAAAAAAAAAAAAQIDERIAEyAjMv/aAAgBAQABBQKuCHI6D1H5VpcTuULzSBur/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHxAAAQMDBQAAAAAAAAAAAAAAAAECESFBUQMQIDFh/9oACAEBAAY/AuCrbpNmxgS0EQRk1G+COdVXVP/EAB4QAQADAAEFAQAAAAAAAAAAAAEAESFREDFBYZFx/9oACAEBAAE/ISAlQ7ROSfDoCnr+r8RTDRGepkkwFMpv8Ng2HWw8S8zRH//aAAwDAQACAAMAAAAQ0wwM/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHhABAAICAgMBAAAAAAAAAAAAAQARMUEhkRBhgcH/2gAIAQEAAT8QqgDXgSlBjBHHxb7DJ+t9Sos24F3QZNe9xKKYtkXHPZNUW1NeoBeKiaxPqvcW/bZtxX51KAbiuuUDon//2Q==","aspectRatio":0.6666666666666666,"src":"/static/8-20301098f034f12e520f36fc4bb8efcd-79b28.jpg","srcSet":"/static/8-20301098f034f12e520f36fc4bb8efcd-3d830.jpg 300w,\n/static/8-20301098f034f12e520f36fc4bb8efcd-2ab78.jpg 600w,\n/static/8-20301098f034f12e520f36fc4bb8efcd-79b28.jpg 1000w","srcWebp":"/static/8-20301098f034f12e520f36fc4bb8efcd-161ff.webp","srcSetWebp":"/static/8-20301098f034f12e520f36fc4bb8efcd-9fc06.webp 300w,\n/static/8-20301098f034f12e520f36fc4bb8efcd-36f59.webp 600w,\n/static/8-20301098f034f12e520f36fc4bb8efcd-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDAQX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHvSqg5of/EABkQAQEAAwEAAAAAAAAAAAAAAAEAEiEiMf/aAAgBAQABBQJsmPHcnN//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAXEAADAQAAAAAAAAAAAAAAAAAAEBEx/9oACAEBAAY/AiSPV//EAB0QAQACAgIDAAAAAAAAAAAAAAEAESFBEDFhcYH/2gAIAQEAAT8hVHS+orsO3UNDt8sFKz8ZUssZ4//aAAwDAQACAAMAAAAQsM//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAbEAEAAgMBAQAAAAAAAAAAAAABABEhUWFxof/aAAgBAQABPxBGRuqX9mGLADx17yEIavV7BtI6gxkCIpdOTMGwdz//2Q==","aspectRatio":1.4992503748125936,"src":"/static/9-b92bf97aee3159cc47032d21b6e23c79-79b28.jpg","srcSet":"/static/9-b92bf97aee3159cc47032d21b6e23c79-3d830.jpg 300w,\n/static/9-b92bf97aee3159cc47032d21b6e23c79-2ab78.jpg 600w,\n/static/9-b92bf97aee3159cc47032d21b6e23c79-79b28.jpg 1000w","srcWebp":"/static/9-b92bf97aee3159cc47032d21b6e23c79-161ff.webp","srcSetWebp":"/static/9-b92bf97aee3159cc47032d21b6e23c79-9fc06.webp 300w,\n/static/9-b92bf97aee3159cc47032d21b6e23c79-36f59.webp 600w,\n/static/9-b92bf97aee3159cc47032d21b6e23c79-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}}]},"hafengefluester":{"edges":[{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAACA//EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAFfQrE52qhsE8S26P/EAB0QAAIBBQEBAAAAAAAAAAAAAAECAwAREiEyECL/2gAIAQEAAQUCTa2HimymwX5FLydxdVG5VoDlE8T5f//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EACEQAAEDAwQDAAAAAAAAAAAAAAABAhEhMUEQEiJRI2Fx/9oACAEBAAY/AkVb/DNPWjZFjo5OGlCUGRFWlsnjftTqD//EAB4QAQACAwACAwAAAAAAAAAAAAEAESFBUTFxYYHh/9oACAEBAAE/Ia23DAQELeCy8Jo9clwyPyXvx49zVS8mR5ynzqC5LzPBitEQTrCwJ2ahk0KR9kIqXz5Z/9oADAMBAAIAAwAAABATJgH/xAAXEQEAAwAAAAAAAAAAAAAAAAABABAR/9oACAEDAQE/EEmX/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEREP/aAAgBAgEBPxBOlyn/xAAeEAEAAgICAwEAAAAAAAAAAAABESEAMUFhUXHRkf/aAAgBAQABPxBWfFmgO44+ZJVRBAGk9ddYUElAigVx1jQuqblhtWSalzEW4oAQ7MR6rWANBAUJeTV44WbcrfkyFQEEfHVZBWEMqVrHYhwNSb/bzw8EoPOf/9k=","aspectRatio":0.66711140760507,"src":"/static/01-22e0bb3742f1c855dec2fbb89367c2a2-79b28.jpg","srcSet":"/static/01-22e0bb3742f1c855dec2fbb89367c2a2-3d830.jpg 300w,\n/static/01-22e0bb3742f1c855dec2fbb89367c2a2-2ab78.jpg 600w,\n/static/01-22e0bb3742f1c855dec2fbb89367c2a2-79b28.jpg 1000w","srcWebp":"/static/01-22e0bb3742f1c855dec2fbb89367c2a2-161ff.webp","srcSetWebp":"/static/01-22e0bb3742f1c855dec2fbb89367c2a2-9fc06.webp 300w,\n/static/01-22e0bb3742f1c855dec2fbb89367c2a2-36f59.webp 600w,\n/static/01-22e0bb3742f1c855dec2fbb89367c2a2-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAHoMJTDhAiObauWxgJ//8QAHhAAAgEDBQAAAAAAAAAAAAAAAQIAAxASESExMkP/2gAIAQEAAQUC9LO2lQNi0rbt2gciNOEfFT//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAVEQEBAAAAAAAAAAAAAAAAAAABIP/aAAgBAgEBPwEj/8QAHxAAAQMDBQAAAAAAAAAAAAAAAQAQIQIRUTFBUnGB/9oACAEBAAY/AvHneEcXantTGVqwHIqxF1//xAAfEAACAgIBBQAAAAAAAAAAAAABEQAhMXEQQVFhgcH/2gAIAQEAAT8hw5wPqMcBEBQoPeLnUFnUYMDANPAXFAuAyReYj9whhdeoGHwrU//aAAwDAQACAAMAAAAQQ/8Awf/EABcRAQEBAQAAAAAAAAAAAAAAAAEAEBH/2gAIAQMBAT8Q5jJf/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAEQESH/2gAIAQIBAT8QaNLP/8QAHhABAQADAAIDAQAAAAAAAAAAAREAITFBcYGRwaH/2gAIAQEAAT8QUs6D6xbiPpy4LBVla7wMdWSLcN/zAgnHZihtFIULiHC5F0IgNfn7yMgOC8TF0F0/m8iYFT5pv5gjQAxkGo/Tn//Z","aspectRatio":0.66711140760507,"src":"/static/02-23d74a9ba19e2366fd83be01bf7887ed-79b28.jpg","srcSet":"/static/02-23d74a9ba19e2366fd83be01bf7887ed-3d830.jpg 300w,\n/static/02-23d74a9ba19e2366fd83be01bf7887ed-2ab78.jpg 600w,\n/static/02-23d74a9ba19e2366fd83be01bf7887ed-79b28.jpg 1000w","srcWebp":"/static/02-23d74a9ba19e2366fd83be01bf7887ed-161ff.webp","srcSetWebp":"/static/02-23d74a9ba19e2366fd83be01bf7887ed-9fc06.webp 300w,\n/static/02-23d74a9ba19e2366fd83be01bf7887ed-36f59.webp 600w,\n/static/02-23d74a9ba19e2366fd83be01bf7887ed-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMBBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAACAf/aAAwDAQACEAMQAAABswtCO+Ab/8QAGxAAAgIDAQAAAAAAAAAAAAAAAQIDBAASMiP/2gAIAQEAAQUCtD0mAxOL7amZyrpx/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHBAAAQQDAQAAAAAAAAAAAAAAAAECUXEDESFh/9oACAEBAAY/AkoZqBKOQYvWjaP/xAAaEAACAwEBAAAAAAAAAAAAAAAAARExoSFB/9oACAEBAAE/IZuYpHmjCHJdhAdJkxD/2gAMAwEAAgADAAAAEFs//8QAFhEAAwAAAAAAAAAAAAAAAAAAARBB/9oACAEDAQE/EDV//8QAFhEBAQEAAAAAAAAAAAAAAAAAARAx/9oACAECAQE/EDCf/8QAGxABAQACAwEAAAAAAAAAAAAAAREAUSExsfD/2gAIAQEAAT8QJymDoGcu8p5MrA+58TWLsiII9VcAExQMrvHU34Z//9k=","aspectRatio":1.4992503748125936,"src":"/static/03-afe4a2fa1a4695bca7cdf0d044b02558-79b28.jpg","srcSet":"/static/03-afe4a2fa1a4695bca7cdf0d044b02558-3d830.jpg 300w,\n/static/03-afe4a2fa1a4695bca7cdf0d044b02558-2ab78.jpg 600w,\n/static/03-afe4a2fa1a4695bca7cdf0d044b02558-79b28.jpg 1000w","srcWebp":"/static/03-afe4a2fa1a4695bca7cdf0d044b02558-161ff.webp","srcSetWebp":"/static/03-afe4a2fa1a4695bca7cdf0d044b02558-9fc06.webp 300w,\n/static/03-afe4a2fa1a4695bca7cdf0d044b02558-36f59.webp 600w,\n/static/03-afe4a2fa1a4695bca7cdf0d044b02558-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAgb/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAa43O1mctE59mKVpAP/EABwQAAICAgMAAAAAAAAAAAAAAAECAAMRIxITIf/aAAgBAQABBQIITLK/KK9NFu0uMJidvB1FrRUwILmWB1Yf/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8BKf/EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/ASH/xAAgEAACAgEDBQAAAAAAAAAAAAAAAREhAgMSURAiMUFS/9oACAEBAAY/Au2hp3lyKVYsTUv2OIiR7EfKPL6ck7T/xAAdEAEAAwACAwEAAAAAAAAAAAABABEhMVEQQWGx/9oACAEBAAE/IcNW7hmqCAJm4OZuaqm1nBGL9JmahDYCHrJW2HYkxL/tzK4hO4++DH//2gAMAwEAAgADAAAAECP38v/EABcRAAMBAAAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8QQ40//8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAREP/aAAgBAgEBPxBdY4y//8QAHxABAQACAQUBAQAAAAAAAAAAAREAMSFBUZGhwWGB/9oACAEBAAE/EK4F0+mH0cMlwhX+5AQUBbGuPaqlNIcT8xRKd/0p9xiikA1oxKJ0PBR43v3jao9s8D9yek7RJ6wCEh74RuezbzhxoXuGf//Z","aspectRatio":0.66711140760507,"src":"/static/04.5-6363bd67fb5e8b553e238ac7ead24d6b-79b28.jpg","srcSet":"/static/04.5-6363bd67fb5e8b553e238ac7ead24d6b-3d830.jpg 300w,\n/static/04.5-6363bd67fb5e8b553e238ac7ead24d6b-2ab78.jpg 600w,\n/static/04.5-6363bd67fb5e8b553e238ac7ead24d6b-79b28.jpg 1000w","srcWebp":"/static/04.5-6363bd67fb5e8b553e238ac7ead24d6b-161ff.webp","srcSetWebp":"/static/04.5-6363bd67fb5e8b553e238ac7ead24d6b-9fc06.webp 300w,\n/static/04.5-6363bd67fb5e8b553e238ac7ead24d6b-36f59.webp 600w,\n/static/04.5-6363bd67fb5e8b553e238ac7ead24d6b-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQAE/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABkwWgOwx//8QAGRAAAwEBAQAAAAAAAAAAAAAAAgMEAAES/9oACAEBAAEFAprc2kFidZ9KJftr1cJW/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHRAAAQIHAAAAAAAAAAAAAAAAAAIRAxASITFBYf/aAAgBAQAGPwKmIO7mS+hXJf/EABsQAQADAQADAAAAAAAAAAAAAAEAESExQVGB/9oACAEBAAE/IdBLPDO3DwImc/ISW4uXNiLJvuf/2gAMAwEAAgADAAAAELDP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGxABAAIDAQEAAAAAAAAAAAAAAQAhETFBUaH/2gAIAQEAAT8QwZAICNSkXcHMBJHkWfFVN/YjISQHnNwLY6n/2Q==","aspectRatio":1.4992503748125936,"src":"/static/04-8bdf4311135a42c7f159756b8dc701da-79b28.jpg","srcSet":"/static/04-8bdf4311135a42c7f159756b8dc701da-3d830.jpg 300w,\n/static/04-8bdf4311135a42c7f159756b8dc701da-2ab78.jpg 600w,\n/static/04-8bdf4311135a42c7f159756b8dc701da-79b28.jpg 1000w","srcWebp":"/static/04-8bdf4311135a42c7f159756b8dc701da-161ff.webp","srcSetWebp":"/static/04-8bdf4311135a42c7f159756b8dc701da-9fc06.webp 300w,\n/static/04-8bdf4311135a42c7f159756b8dc701da-36f59.webp 600w,\n/static/04-8bdf4311135a42c7f159756b8dc701da-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDBAX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFbTQUqEs0Q2HND/8QAGxABAAMBAAMAAAAAAAAAAAAAAQACEQMSISL/2gAIAQEAAQUCRUastWuuSq79S/VrKYWbctXX1PLJ/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHhAAAgMAAQUAAAAAAAAAAAAAAAECESEQEjEyQVH/2gAIAQEABj8CWVQ+uRkXR7HUUvh5RNLcnptvjtx//8QAHRAAAwACAgMAAAAAAAAAAAAAAAERIUFRkWFxgf/aAAgBAQABPyFgwCGmLSwO5z0Zfn2PwgXZH0gY5JlRNCkN5kxGQszsaof/2gAMAwEAAgADAAAAECPODP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EACAQAQEAAgIBBQEAAAAAAAAAAAERACExQWFRgZGh8PH/2gAIAQEAAT8QmRrVb9GBkqRZfjeL2QI2684ZKD3yuEaGKUFMC5z0/nDLDpBYTFJoHhXu4tRGik/W4bAnQDkFtV0nj2xGi5n/2Q==","aspectRatio":0.66711140760507,"src":"/static/05.5-cd9d1c89bda923b3605eacbe14afd074-79b28.jpg","srcSet":"/static/05.5-cd9d1c89bda923b3605eacbe14afd074-3d830.jpg 300w,\n/static/05.5-cd9d1c89bda923b3605eacbe14afd074-2ab78.jpg 600w,\n/static/05.5-cd9d1c89bda923b3605eacbe14afd074-79b28.jpg 1000w","srcWebp":"/static/05.5-cd9d1c89bda923b3605eacbe14afd074-161ff.webp","srcSetWebp":"/static/05.5-cd9d1c89bda923b3605eacbe14afd074-9fc06.webp 300w,\n/static/05.5-cd9d1c89bda923b3605eacbe14afd074-36f59.webp 600w,\n/static/05.5-cd9d1c89bda923b3605eacbe14afd074-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAQL/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABWoTH7jDoH//EABkQAAMBAQEAAAAAAAAAAAAAAAIDEQEAE//aAAgBAQABBQJCmTxKDRxAXJwjM//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABsQAAMAAgMAAAAAAAAAAAAAAAABERChITFx/9oACAEBAAY/AuGp6WojeyvHej//xAAcEAACAgIDAAAAAAAAAAAAAAAAARFhMUGBocH/2gAIAQEAAT8hYnTsPmDInUCC5LY7DfQP/9oADAMBAAIAAwAAABC0L//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAwEBPxBNf//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPxBcf//EABsQAQACAwEBAAAAAAAAAAAAAAEAESExQYHB/9oACAEBAAE/EDGZFhE04j0acUrgOeywFR4vsLMUFHMR1aYKNVoNnsqIG3YLP//Z","aspectRatio":1.4992503748125936,"src":"/static/05-9308184b2076113e8acb347c54a5d99b-79b28.jpg","srcSet":"/static/05-9308184b2076113e8acb347c54a5d99b-3d830.jpg 300w,\n/static/05-9308184b2076113e8acb347c54a5d99b-2ab78.jpg 600w,\n/static/05-9308184b2076113e8acb347c54a5d99b-79b28.jpg 1000w","srcWebp":"/static/05-9308184b2076113e8acb347c54a5d99b-161ff.webp","srcSetWebp":"/static/05-9308184b2076113e8acb347c54a5d99b-9fc06.webp 300w,\n/static/05-9308184b2076113e8acb347c54a5d99b-36f59.webp 600w,\n/static/05-9308184b2076113e8acb347c54a5d99b-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAwAEBf/EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAABTF0UcnNVgXmbtFJD/8QAHBAAAgIDAQEAAAAAAAAAAAAAAgMAAQQREhMj/9oACAEBAAEFAm4gbPFYESvkGN+hOoqpoaG+5xU8Qm4B9Vuf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHhAAAQQBBQAAAAAAAAAAAAAAAAEQITECESAyQVH/2gAIAQEABj8C7k9RkqjVYOSE5NWz/8QAHxAAAgICAQUAAAAAAAAAAAAAAREAITFRQRBhcYGR/9oACAEBAAE/IQ0BoyeIpWQcuVp3L1gtu8SRAR7hlPpMYj0oThFnyYXYwGxDWZHR/9oADAMBAAIAAwAAABDf/k7/xAAXEQADAQAAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/ELrP/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEQEf/aAAgBAgEBPxC4j//EAB0QAQADAQACAwAAAAAAAAAAAAEAESExQVFxseH/2gAIAQEAAT8QQGYCDBYQgAaChnk7Ly61rsN0wscPhAmOyt0s3mQq0bhUj9UBZ8xagvSwY36L+QjceiRW+o1xl/U//9k=","aspectRatio":0.66711140760507,"src":"/static/06-5afa3f0a4c902e9b9dac176a97c5c1bf-79b28.jpg","srcSet":"/static/06-5afa3f0a4c902e9b9dac176a97c5c1bf-3d830.jpg 300w,\n/static/06-5afa3f0a4c902e9b9dac176a97c5c1bf-2ab78.jpg 600w,\n/static/06-5afa3f0a4c902e9b9dac176a97c5c1bf-79b28.jpg 1000w","srcWebp":"/static/06-5afa3f0a4c902e9b9dac176a97c5c1bf-161ff.webp","srcSetWebp":"/static/06-5afa3f0a4c902e9b9dac176a97c5c1bf-9fc06.webp 300w,\n/static/06-5afa3f0a4c902e9b9dac176a97c5c1bf-36f59.webp 600w,\n/static/06-5afa3f0a4c902e9b9dac176a97c5c1bf-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDBAH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABsqWjEawhyMjWOH//xAAaEAADAQEBAQAAAAAAAAAAAAAAAQIRIQMS/9oACAEBAAEFAvO6L+kOO9E1jTNOyKnKt4TbblLP/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAIBAAAgIBAwUAAAAAAAAAAAAAAAECESExUYEQEmGRof/aAAgBAQAGPwKu0qU87QRo/VlKT4iKEefBUHSRT+6GMMo3MN9P/8QAHxAAAgIDAAIDAAAAAAAAAAAAAREAITFBYVFxodHw/9oACAEBAAE/IcAIeS3AsJPUEcTMdqn2THq3QfMCyew/LgRTpRDbWiVOKfdJXArsITQDwYpCjpcyIZ7P/9oADAMBAAIAAwAAABBL5bH/xAAWEQADAAAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8QcP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB8QAQACAQQDAQAAAAAAAAAAAAERIQAxQVFhgZHB8P/aAAgBAQABPxCZHpSTdIGsYsW6KZzKUdriQpsao4VbzFZBRWlRjbh6xeWUzrkSo/nnNmBA7ms9zXjANQSvtnQLhZqLIWLMTG+r6w2VNyTW+e8ZJC34O2OipVA+MKJuZZ//2Q==","aspectRatio":0.66711140760507,"src":"/static/07-6e2a9f2c5d761699a2f8138f50afb018-79b28.jpg","srcSet":"/static/07-6e2a9f2c5d761699a2f8138f50afb018-3d830.jpg 300w,\n/static/07-6e2a9f2c5d761699a2f8138f50afb018-2ab78.jpg 600w,\n/static/07-6e2a9f2c5d761699a2f8138f50afb018-79b28.jpg 1000w","srcWebp":"/static/07-6e2a9f2c5d761699a2f8138f50afb018-161ff.webp","srcSetWebp":"/static/07-6e2a9f2c5d761699a2f8138f50afb018-9fc06.webp 300w,\n/static/07-6e2a9f2c5d761699a2f8138f50afb018-36f59.webp 600w,\n/static/07-6e2a9f2c5d761699a2f8138f50afb018-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIEBf/EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAABT0acw1J//8QAGxAAAgMAAwAAAAAAAAAAAAAAAAIBAxIEEyP/2gAIAQEAAQUC9jdhQzYjjxB0laYX/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8Bh//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABsQAAIBBQAAAAAAAAAAAAAAAAABMREhMkKh/9oACAEBAAY/AsumxdNkklD/xAAdEAACAgIDAQAAAAAAAAAAAAAAEQExIUFRYXGh/9oACAEBAAE/IWjefBlv7Le3ZAKJ6NufRcnk/9oADAMBAAIAAwAAABC4D//EABURAQEAAAAAAAAAAAAAAAAAAAAB/9oACAEDAQE/ECR//8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQIBAT8Qqv/EAB0QAAICAgMBAAAAAAAAAAAAAAERACExQVGB0XH/2gAIAQEAAT8QJnYG/wCwBLorxCCvNkDVCsQARAljjG4RZi6PouYNVdgUtDyf/9k=","aspectRatio":1.4992503748125936,"src":"/static/08-7ffad18ec63b2479461306abc710abdb-79b28.jpg","srcSet":"/static/08-7ffad18ec63b2479461306abc710abdb-3d830.jpg 300w,\n/static/08-7ffad18ec63b2479461306abc710abdb-2ab78.jpg 600w,\n/static/08-7ffad18ec63b2479461306abc710abdb-79b28.jpg 1000w","srcWebp":"/static/08-7ffad18ec63b2479461306abc710abdb-161ff.webp","srcSetWebp":"/static/08-7ffad18ec63b2479461306abc710abdb-9fc06.webp 300w,\n/static/08-7ffad18ec63b2479461306abc710abdb-36f59.webp 600w,\n/static/08-7ffad18ec63b2479461306abc710abdb-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAEDBAX/xAAUAQEAAAAAAAAAAAAAAAAAAAAC/9oADAMBAAIQAxAAAAHQpTY74wL/xAAcEAABBAMBAAAAAAAAAAAAAAADAAECBBESIjT/2gAIAQEAAQUCLDeABSYmVYfmt6F//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGxAAAQQDAAAAAAAAAAAAAAAAAgABEBEDIWH/2gAIAQEABj8CCkJ6qMbcQx//xAAbEAACAgMBAAAAAAAAAAAAAAABEQAhEFGxMf/aAAgBAQABPyEleELdahaGrxwpHajcnTzH/9oADAMBAAIAAwAAABBQ7//EABYRAAMAAAAAAAAAAAAAAAAAAAEQMf/aAAgBAwEBPxAVf//EABYRAAMAAAAAAAAAAAAAAAAAAAEQMf/aAAgBAgEBPxAxf//EABoQAQACAwEAAAAAAAAAAAAAAAEAESExgUH/2gAIAQEAAT8Qzfc7cVDhwSi7pNQKlLjyJTVTbkcFCuoan//Z","aspectRatio":1.4992503748125936,"src":"/static/09-7cd46e08163088eb9bc1eb9edf78dfa7-79b28.jpg","srcSet":"/static/09-7cd46e08163088eb9bc1eb9edf78dfa7-3d830.jpg 300w,\n/static/09-7cd46e08163088eb9bc1eb9edf78dfa7-2ab78.jpg 600w,\n/static/09-7cd46e08163088eb9bc1eb9edf78dfa7-79b28.jpg 1000w","srcWebp":"/static/09-7cd46e08163088eb9bc1eb9edf78dfa7-161ff.webp","srcSetWebp":"/static/09-7cd46e08163088eb9bc1eb9edf78dfa7-9fc06.webp 300w,\n/static/09-7cd46e08163088eb9bc1eb9edf78dfa7-36f59.webp 600w,\n/static/09-7cd46e08163088eb9bc1eb9edf78dfa7-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAIBAwQF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAHqtjHMFg2FmRLCsn//xAAbEAACAwEBAQAAAAAAAAAAAAAAAQIDEhEQE//aAAgBAQABBQJS4WWZTstNom1xU1TSqSPnHxvhpmj/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAdEAACAgEFAAAAAAAAAAAAAAAAAQIxECBBcYHh/9oACAEBAAY/AhNHht08KUr5LKK0f//EAB0QAQACAQUBAAAAAAAAAAAAAAEAETEQIVFhcaH/2gAIAQEAAT8h94sYyNy1lgQact/hHNuqmZgHCe4lNZV3E6aqvwT/2gAMAwEAAgADAAAAEDzUzv/EABcRAAMBAAAAAAAAAAAAAAAAAAABERD/2gAIAQMBAT8QpHv/xAAXEQEBAQEAAAAAAAAAAAAAAAAAEQEh/9oACAECAQE/EJ1cRH//xAAgEAEBAAIBAwUAAAAAAAAAAAABEQAhQTFRsXGBkaHR/9oACAEBAAE/EO/FOn16MzeSZXiZsIXYFk9nGB60h0F8MViAURw3RvVcDi4A1ulmcw4qvGCpXhNg5B0rkN35Ll/2c//Z","aspectRatio":0.66711140760507,"src":"/static/10.5-6bfd3f2bb8b65be462162bd83bbf6e75-79b28.jpg","srcSet":"/static/10.5-6bfd3f2bb8b65be462162bd83bbf6e75-3d830.jpg 300w,\n/static/10.5-6bfd3f2bb8b65be462162bd83bbf6e75-2ab78.jpg 600w,\n/static/10.5-6bfd3f2bb8b65be462162bd83bbf6e75-79b28.jpg 1000w","srcWebp":"/static/10.5-6bfd3f2bb8b65be462162bd83bbf6e75-161ff.webp","srcSetWebp":"/static/10.5-6bfd3f2bb8b65be462162bd83bbf6e75-9fc06.webp 300w,\n/static/10.5-6bfd3f2bb8b65be462162bd83bbf6e75-36f59.webp 600w,\n/static/10.5-6bfd3f2bb8b65be462162bd83bbf6e75-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIDBQT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHousEUhSwxtsAf/8QAHBAAAgICAwAAAAAAAAAAAAAAAAECEgMRExQg/9oACAEBAAEFArTZHevFixY7DOdks0m//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHhAAAAQHAAAAAAAAAAAAAAAAAAERIQIQIjAxYZH/2gAIAQEABj8CaHoqRdWMSY0H/8QAHRAAAgEEAwAAAAAAAAAAAAAAAAERICExUWFxkf/aAAgBAQABPyFYelu0TObgIoSESJajLsSN+kkYh//aAAwDAQACAAMAAAAQUwQw/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHhABAAICAgMBAAAAAAAAAAAAAQARITFRcUFhkaH/2gAIAQEAAT8Q6/Vw7rf5MQRW1A+MZElkUnKnsjyRuBiMPhBjDcbhPpCrn//Z","aspectRatio":0.66711140760507,"src":"/static/10-ee2d0fe3aed4362a4f0992ca2a1a8271-79b28.jpg","srcSet":"/static/10-ee2d0fe3aed4362a4f0992ca2a1a8271-3d830.jpg 300w,\n/static/10-ee2d0fe3aed4362a4f0992ca2a1a8271-2ab78.jpg 600w,\n/static/10-ee2d0fe3aed4362a4f0992ca2a1a8271-79b28.jpg 1000w","srcWebp":"/static/10-ee2d0fe3aed4362a4f0992ca2a1a8271-161ff.webp","srcSetWebp":"/static/10-ee2d0fe3aed4362a4f0992ca2a1a8271-9fc06.webp 300w,\n/static/10-ee2d0fe3aed4362a4f0992ca2a1a8271-36f59.webp 600w,\n/static/10-ee2d0fe3aed4362a4f0992ca2a1a8271-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}}]},"portrait":{"edges":[{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQCBQYD/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAIB/9oADAMBAAIQAxAAAAFebis3UkhmgpNHliwOBlf/xAAeEAACAQQDAQAAAAAAAAAAAAABAgMABBEhEhMUI//aAAgBAQABBQKHBMq5txVzhI04+Zhu5jLLDL1FoNzH4vpvSa//xAAZEQACAwEAAAAAAAAAAAAAAAAAAQIQEUH/2gAIAQMBAT8Biq4aj//EABgRAAIDAAAAAAAAAAAAAAAAAAABEBFB/9oACAECAQE/AW40pn//xAAcEAABBAMBAAAAAAAAAAAAAAABABARIQISQTL/2gAIAQEABj8CkighnNm2gIdbbsWtSJBYt5X/xAAcEAADAQADAQEAAAAAAAAAAAAAAREhMUFRwYH/2gAIAQEAAT8hs4mlO10PnJVWk34cznW6+CDweEfwDYD3dFsur0/diFn2ZL6P/9oADAMBAAIAAwAAABDQ4LD/xAAZEQACAwEAAAAAAAAAAAAAAAAAARARITH/2gAIAQMBAT8QwKE+of/EABgRAAMBAQAAAAAAAAAAAAAAAAABERAx/9oACAECAQE/EKMo1xh//8QAHRABAQADAAMBAQAAAAAAAAAAAREAITFBYYFR4f/aAAgBAQABPxBUDZHj+ZpQMFg9gHIZBDG8cgvQeMRXddgPQPmQ4haGDaKAeInPdxKuynldKZbQlBeTHEm/hqYCpHQcCJOia/nP/9k=","aspectRatio":0.6666666666666666,"src":"/static/01.5-97fa75ee6dcfa1de33560fc5954fd381-79b28.jpg","srcSet":"/static/01.5-97fa75ee6dcfa1de33560fc5954fd381-3d830.jpg 300w,\n/static/01.5-97fa75ee6dcfa1de33560fc5954fd381-2ab78.jpg 600w,\n/static/01.5-97fa75ee6dcfa1de33560fc5954fd381-79b28.jpg 1000w","srcWebp":"/static/01.5-97fa75ee6dcfa1de33560fc5954fd381-161ff.webp","srcSetWebp":"/static/01.5-97fa75ee6dcfa1de33560fc5954fd381-9fc06.webp 300w,\n/static/01.5-97fa75ee6dcfa1de33560fc5954fd381-36f59.webp 600w,\n/static/01.5-97fa75ee6dcfa1de33560fc5954fd381-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIBBf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAGMmpeaKP/EABoQAAIDAQEAAAAAAAAAAAAAAAECAAMRMRP/2gAIAQEAAQUCsdTLK18z122O2g9//8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQMBAT8BJ//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/AWf/xAAZEAABBQAAAAAAAAAAAAAAAAAAAREgYfH/2gAIAQEABj8CZNLj/8QAGBABAQEBAQAAAAAAAAAAAAAAAREAMVH/2gAIAQEAAT8hBjBV8w10l7umUA6jTu7b/9oADAMBAAIAAwAAABCrz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QH//EABYRAAMAAAAAAAAAAAAAAAAAAAABIf/aAAgBAgEBPxB7BH//xAAcEAEBAQABBQAAAAAAAAAAAAABEQAhEEFRcYH/2gAIAQEAAT8QTVwIQGT331KDl/BDGF4Zg0GOoxqeem//2Q==","aspectRatio":1.4992503748125936,"src":"/static/01-2d35fecf06701f320a93992fbfd3324c-79b28.jpg","srcSet":"/static/01-2d35fecf06701f320a93992fbfd3324c-3d830.jpg 300w,\n/static/01-2d35fecf06701f320a93992fbfd3324c-2ab78.jpg 600w,\n/static/01-2d35fecf06701f320a93992fbfd3324c-79b28.jpg 1000w","srcWebp":"/static/01-2d35fecf06701f320a93992fbfd3324c-161ff.webp","srcSetWebp":"/static/01-2d35fecf06701f320a93992fbfd3324c-9fc06.webp 300w,\n/static/01-2d35fecf06701f320a93992fbfd3324c-36f59.webp 600w,\n/static/01-2d35fecf06701f320a93992fbfd3324c-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUCBAYD/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABd45/nzgWQuLdEoAgH//EABwQAAMAAgMBAAAAAAAAAAAAAAECAwASBBExMv/aAAgBAQABBQJ/iy6vlORqHpsxRc1auMpUjyS9RqRYHP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB0QAAICAQUAAAAAAAAAAAAAAAABEBEhAhJCYXH/2gAIAQEABj8CZUOi2jkVpyNOO3k31TF4f//EAB0QAAMAAgIDAAAAAAAAAAAAAAABETFxIUEQUWH/2gAIAQEAAT8h6cx2qMbVnyeKZNDWIRutFPCDQcG2Zm0PVvohXDTNoM4Kswf/2gAMAwEAAgADAAAAEDPLDP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB0QAQEAAgMBAQEAAAAAAAAAAAERADEhQWGBcaH/2gAIAQEAAT8QpJUosB7O8oqFLs+Z9/uOeWIFscbnELt7T3lxVHEGIYcAZXhvVuHVHiDjrRYtfMBHKBb1xPzJBYTlRmQfRSHmf//Z","aspectRatio":0.66711140760507,"src":"/static/02-587604f192e4308e0fcf085e712b9d93-79b28.jpg","srcSet":"/static/02-587604f192e4308e0fcf085e712b9d93-3d830.jpg 300w,\n/static/02-587604f192e4308e0fcf085e712b9d93-2ab78.jpg 600w,\n/static/02-587604f192e4308e0fcf085e712b9d93-79b28.jpg 1000w","srcWebp":"/static/02-587604f192e4308e0fcf085e712b9d93-161ff.webp","srcSetWebp":"/static/02-587604f192e4308e0fcf085e712b9d93-9fc06.webp 300w,\n/static/02-587604f192e4308e0fcf085e712b9d93-36f59.webp 600w,\n/static/02-587604f192e4308e0fcf085e712b9d93-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAAF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAcZBdGUcWT//xAAaEAACAgMAAAAAAAAAAAAAAAABAgADEBEh/9oACAEBAAEFAjqXIiQMRK+lxj//xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPwEn/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGhAAAgIDAAAAAAAAAAAAAAAAABABEQIhUf/aAAgBAQAGPwIxrhqVS//EABwQAQADAAIDAAAAAAAAAAAAAAEAESEQMVFxwf/aAAgBAQABPyF9O1iNd3rb2GYB6IMfOQwVtn14/9oADAMBAAIAAwAAABAnL//EABYRAQEBAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPxAaT//EABYRAAMAAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPxBuEP/EAB4QAQACAgEFAAAAAAAAAAAAAAEAESFRQRAxcaGx/9oACAEBAAE/EFKwYVs8RKUWNQy5lBuF0J9IYrkW1b3mBogu1yeun//Z","aspectRatio":1.4992503748125936,"src":"/static/03-c6ad6f55212241c9e2f08d2a5f30689e-79b28.jpg","srcSet":"/static/03-c6ad6f55212241c9e2f08d2a5f30689e-3d830.jpg 300w,\n/static/03-c6ad6f55212241c9e2f08d2a5f30689e-2ab78.jpg 600w,\n/static/03-c6ad6f55212241c9e2f08d2a5f30689e-79b28.jpg 1000w","srcWebp":"/static/03-c6ad6f55212241c9e2f08d2a5f30689e-161ff.webp","srcSetWebp":"/static/03-c6ad6f55212241c9e2f08d2a5f30689e-9fc06.webp 300w,\n/static/03-c6ad6f55212241c9e2f08d2a5f30689e-36f59.webp 600w,\n/static/03-c6ad6f55212241c9e2f08d2a5f30689e-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIEBQED/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQD/2gAMAwEAAhADEAAAAc/2qXBqhOQ0M+iYv//EAB0QAAIBBAMAAAAAAAAAAAAAAAECAAMREiEEEzH/2gAIAQEAAQUCS2cFQiHT12DOygFvQTGBLLS7OO2mytP/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAdEAACAQUBAQAAAAAAAAAAAAAAATECEBEhQTKh/9oACAEBAAY/Amm9DTyifhrgqlFVokxzIxb8xf8A/8QAHBABAAIDAQEBAAAAAAAAAAAAAQARIUFhMVHB/9oACAEBAAE/ISC5te+SwLzv8mGMNWGKhGcmBz5Z+cmAbicLbZ3LBd9KigG4zHNN+fIWt0zlc//aAAwDAQACAAMAAAAQwMUP/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERMRD/2gAIAQMBAT8QWcj0h//EABkRAAMAAwAAAAAAAAAAAAAAAAABERAhQf/aAAgBAgEBPxBreLwp/8QAHRABAQACAwEBAQAAAAAAAAAAAREAITFRYUGBof/aAAgBAQABPxBgUKTvyeRe8txbrqAEDN0MEUphXgABUy8q9O0blG4KDSeVDm5PbgrE01J/MWYglCeE8wOrTv1eLiGEcHS3QbPtfuzrELF+HGNU3O1uf//Z","aspectRatio":0.66711140760507,"src":"/static/04-a74ff5e86930b91fee27d28624a619ec-79b28.jpg","srcSet":"/static/04-a74ff5e86930b91fee27d28624a619ec-3d830.jpg 300w,\n/static/04-a74ff5e86930b91fee27d28624a619ec-2ab78.jpg 600w,\n/static/04-a74ff5e86930b91fee27d28624a619ec-79b28.jpg 1000w","srcWebp":"/static/04-a74ff5e86930b91fee27d28624a619ec-161ff.webp","srcSetWebp":"/static/04-a74ff5e86930b91fee27d28624a619ec-9fc06.webp 300w,\n/static/04-a74ff5e86930b91fee27d28624a619ec-36f59.webp 600w,\n/static/04-a74ff5e86930b91fee27d28624a619ec-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAgX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAAB3Yuia5w0P//EABkQAAMBAQEAAAAAAAAAAAAAAAABAwIhEf/aAAgBAQABBQKUzcueIi+6bYz/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAXEAADAQAAAAAAAAAAAAAAAAABECAh/9oACAEBAAY/Aloj/8QAGxABAAICAwAAAAAAAAAAAAAAAQARITFBUaH/2gAIAQEAAT8hvckS2jjUQU8JgQxOmNuf/9oADAMBAAIAAwAAABDwz//EABYRAQEBAAAAAAAAAAAAAAAAAAARAf/aAAgBAwEBPxC6r//EABYRAQEBAAAAAAAAAAAAAAAAAAARAf/aAAgBAgEBPxCYj//EABoQAQACAwEAAAAAAAAAAAAAAAEAESExQXH/2gAIAQEAAT8QIumAIJiitBqMyseWiWgS1gHDyIzq/J//2Q==","aspectRatio":1.4992503748125936,"src":"/static/05-5b671b657d9861b49d8ae8bdb912f9be-79b28.jpg","srcSet":"/static/05-5b671b657d9861b49d8ae8bdb912f9be-3d830.jpg 300w,\n/static/05-5b671b657d9861b49d8ae8bdb912f9be-2ab78.jpg 600w,\n/static/05-5b671b657d9861b49d8ae8bdb912f9be-79b28.jpg 1000w","srcWebp":"/static/05-5b671b657d9861b49d8ae8bdb912f9be-161ff.webp","srcSetWebp":"/static/05-5b671b657d9861b49d8ae8bdb912f9be-9fc06.webp 300w,\n/static/05-5b671b657d9861b49d8ae8bdb912f9be-36f59.webp 600w,\n/static/05-5b671b657d9861b49d8ae8bdb912f9be-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUBAwQC/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABRRLgUlwUvkO06NQf/8QAHRAAAQQCAwAAAAAAAAAAAAAAAQACAxEhMQQTIv/aAAgBAQABBQLYohUmmnTRd0YGNri5ZMKlDqDPEQjBH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB4QAAEDBAMAAAAAAAAAAAAAAAABAiEQEUGRAzGh/9oACAEBAAY/AiaSI7jxTrQng4sXyokbP//EABwQAQADAQADAQAAAAAAAAAAAAEAESExQVFhgf/aAAgBAQABPyFwfPI8hIYIZOi9g9MOe5glBad3F7ub5QCHLiiP2WrVX35E6i1r7T//2gAMAwEAAgADAAAAEDDPPP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EABwQAQEAAwEBAQEAAAAAAAAAAAERACExQVGRwf/aAAgBAQABPxApW+mSdpyncs30wnIhH3Ghqlekep+cyJvQwJONEUj446H0oaC9wD4LA8u/7g8hapNuJIxU62v3jfmUnRsVenef/9k=","aspectRatio":0.66711140760507,"src":"/static/06-38cb17ab8852a3e0f321db2c4a72f57a-79b28.jpg","srcSet":"/static/06-38cb17ab8852a3e0f321db2c4a72f57a-3d830.jpg 300w,\n/static/06-38cb17ab8852a3e0f321db2c4a72f57a-2ab78.jpg 600w,\n/static/06-38cb17ab8852a3e0f321db2c4a72f57a-79b28.jpg 1000w","srcWebp":"/static/06-38cb17ab8852a3e0f321db2c4a72f57a-161ff.webp","srcSetWebp":"/static/06-38cb17ab8852a3e0f321db2c4a72f57a-9fc06.webp 300w,\n/static/06-38cb17ab8852a3e0f321db2c4a72f57a-36f59.webp 600w,\n/static/06-38cb17ab8852a3e0f321db2c4a72f57a-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGgAAAgIDAAAAAAAAAAAAAAAAAAQBBQIDBv/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABskNiGNLGYXPPO19gQR//xAAcEAACAgIDAAAAAAAAAAAAAAACAwABESEEEiL/2gAIAQEAAQUCq8zlNxAzOxBGsoyUWmtCkDcqe2pLUG9f/8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQMBAT8BCE//xAAVEQEBAAAAAAAAAAAAAAAAAAARIP/aAAgBAgEBPwFj/8QAHxAAAgICAQUAAAAAAAAAAAAAAAECESExEBJBQlFx/9oACAEBAAY/Als6fFjr2ZWDQ/pNwlrsPi5tUsFLXH//xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhQTFRYbH/2gAIAQEAAT8hqC+Bw1EbW/pKzVGU+JG5eiwbe/IGiLsbuz9lgnVzi13KS8gUMxjb8tyiP//aAAwDAQACAAMAAAAQyAlC/8QAFxEBAAMAAAAAAAAAAAAAAAAAAAEQIf/aAAgBAwEBPxAQxX//xAAXEQEBAQEAAAAAAAAAAAAAAAABABEh/9oACAECAQE/EHEvZ6ZN/8QAHxABAQACAgIDAQAAAAAAAAAAAREAITFRQWFxgaHR/9oACAEBAAE/EJCAEEXBijRQG2B54/MnJ2+PRiocqfoOseb4KMew/uCeit38GCGJIoVYTp7NaxXO6H2YkgUrIuSjJt8AYO/Y5OXBvOf/2Q==","aspectRatio":0.66711140760507,"src":"/static/07-c2acc6b189886a39cef31d80921b3749-79b28.jpg","srcSet":"/static/07-c2acc6b189886a39cef31d80921b3749-3d830.jpg 300w,\n/static/07-c2acc6b189886a39cef31d80921b3749-2ab78.jpg 600w,\n/static/07-c2acc6b189886a39cef31d80921b3749-79b28.jpg 1000w","srcWebp":"/static/07-c2acc6b189886a39cef31d80921b3749-161ff.webp","srcSetWebp":"/static/07-c2acc6b189886a39cef31d80921b3749-9fc06.webp 300w,\n/static/07-c2acc6b189886a39cef31d80921b3749-36f59.webp 600w,\n/static/07-c2acc6b189886a39cef31d80921b3749-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUBAwQC/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABcVdKB2Kw3YJVlBoD/8QAHRAAAgICAwEAAAAAAAAAAAAAAQIAAwQREhMhMf/aAAgBAQABBQL5Es5TybmQ3XZVkDgCkJQPaR25CaheJUpH/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHRAAAQQCAwAAAAAAAAAAAAAAAAECESEQQTEyUf/aAAgBAQAGPwI8xQ3e8diXKktHqziSWUWhMH//xAAeEAEAAwACAgMAAAAAAAAAAAABABEhMUFRcWGRof/aAAgBAQABPyFwv5CDdRT27nfLXbDoctHFMHRa2O4BCFycviPY2khM0+8+oV17Z8nPM//aAAwDAQACAAMAAAAQoA0M/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHhABAAICAgMBAAAAAAAAAAAAAQARITFBkVFhccH/2gAIAQEAAT8QA4ZBabZalzm8Hq4GKLZsdx4wNHzG6IlXQQKEaKPl9wIJCwUkwJnhKl1/wSwWr93qWMHg1nMuATeavx3LC9wLsXqMltgWxP/Z","aspectRatio":0.66711140760507,"src":"/static/08-530e63fbc45718161c425ac891fcb10a-79b28.jpg","srcSet":"/static/08-530e63fbc45718161c425ac891fcb10a-3d830.jpg 300w,\n/static/08-530e63fbc45718161c425ac891fcb10a-2ab78.jpg 600w,\n/static/08-530e63fbc45718161c425ac891fcb10a-79b28.jpg 1000w","srcWebp":"/static/08-530e63fbc45718161c425ac891fcb10a-161ff.webp","srcSetWebp":"/static/08-530e63fbc45718161c425ac891fcb10a-9fc06.webp 300w,\n/static/08-530e63fbc45718161c425ac891fcb10a-36f59.webp 600w,\n/static/08-530e63fbc45718161c425ac891fcb10a-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQAD/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAABJdGfDCtZD//EABsQAAEEAwAAAAAAAAAAAAAAAAIAAQMzBCEy/9oACAEBAAEFAlADMM1kfYbWXf8A/8QAFREBAQAAAAAAAAAAAAAAAAAAAhD/2gAIAQMBAT8BM//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/AVn/xAAZEAACAwEAAAAAAAAAAAAAAAAAAQIQURL/2gAIAQEABj8COZbSI6hn/8QAGhAAAwEBAQEAAAAAAAAAAAAAAAERITFBof/aAAgBAQABPyFdIi1xzosZGjfZrC0zP1J/D//aAAwDAQACAAMAAAAQUy//xAAXEQADAQAAAAAAAAAAAAAAAAAAAREh/9oACAEDAQE/EExkh//EABcRAAMBAAAAAAAAAAAAAAAAAAABESH/2gAIAQIBAT8Qk4LUf//EAB0QAQEAAQQDAAAAAAAAAAAAAAERACExUXFBgcH/2gAIAQEAAT8QNIFVmKj2FhiKtm23vORgB7wgnn5h+MFeqJJiqAVu0Z//2Q==","aspectRatio":1.4992503748125936,"src":"/static/09-fc69a21f9e1b0735554040c0f9ecd832-79b28.jpg","srcSet":"/static/09-fc69a21f9e1b0735554040c0f9ecd832-3d830.jpg 300w,\n/static/09-fc69a21f9e1b0735554040c0f9ecd832-2ab78.jpg 600w,\n/static/09-fc69a21f9e1b0735554040c0f9ecd832-79b28.jpg 1000w","srcWebp":"/static/09-fc69a21f9e1b0735554040c0f9ecd832-161ff.webp","srcSetWebp":"/static/09-fc69a21f9e1b0735554040c0f9ecd832-9fc06.webp 300w,\n/static/09-fc69a21f9e1b0735554040c0f9ecd832-36f59.webp 600w,\n/static/09-fc69a21f9e1b0735554040c0f9ecd832-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQCAwUB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAWqeKmqZAQSarspIEf/EABwQAAEFAQEBAAAAAAAAAAAAAAEAAgMEEhMRFP/aAAgBAQABBQKKExhkj+3zlC+MvsNKF6UCxBzbhZATpC9H0rS//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFREBAQAAAAAAAAAAAAAAAAAAESD/2gAIAQIBAT8BI//EAB0QAAICAwADAAAAAAAAAAAAAAABESEQEjECQXH/2gAIAQEABj8Cnpo7TOoceFG6ps9P6KIs7i8//8QAGhABAQEBAQEBAAAAAAAAAAAAAREAIUExYf/aAAgBAQABPyFhBZxHmmNVImLvCuDAB8Lu6puzx05f3G4EPQa/RvgXeEYe5dlzDv/aAAwDAQACAAMAAAAQQNh//8QAGBEBAQADAAAAAAAAAAAAAAAAEQABECH/2gAIAQMBAT8QwF2DX//EABYRAQEBAAAAAAAAAAAAAAAAAAEQIf/aAAgBAgEBPxCByf/EAB0QAQADAAIDAQAAAAAAAAAAAAEAESExQVFhcaH/2gAIAQEAAT8QUFtbr4liACwGZ1LTWsAFqOGKBSn3BcBgtDx64mWW8ov4kaxvNKZ3v2NZQXoJ3AwWgtA7ojSG3lioUPtJ/9k=","aspectRatio":0.66711140760507,"src":"/static/10-09704929e472b7d218e67bcfd63c77f3-79b28.jpg","srcSet":"/static/10-09704929e472b7d218e67bcfd63c77f3-3d830.jpg 300w,\n/static/10-09704929e472b7d218e67bcfd63c77f3-2ab78.jpg 600w,\n/static/10-09704929e472b7d218e67bcfd63c77f3-79b28.jpg 1000w","srcWebp":"/static/10-09704929e472b7d218e67bcfd63c77f3-161ff.webp","srcSetWebp":"/static/10-09704929e472b7d218e67bcfd63c77f3-9fc06.webp 300w,\n/static/10-09704929e472b7d218e67bcfd63c77f3-36f59.webp 600w,\n/static/10-09704929e472b7d218e67bcfd63c77f3-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAcYRvL1RQP/EABoQAQEAAgMAAAAAAAAAAAAAAAIBAAMREiH/2gAIAQEAAQUCUMztrDSuK25p4qV9/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGhAAAwEAAwAAAAAAAAAAAAAAAAERIRBCYf/aAAgBAQAGPwKkTya/TqazVeP/xAAbEAEAAgMBAQAAAAAAAAAAAAABACERMXFBUf/aAAgBAQABPyFmprB2bCjogCVp8hhZAjBT2PH/2gAMAwEAAgADAAAAEFPP/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERIf/aAAgBAwEBPxBPCH//xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPxCH/8QAHBAAAgIDAQEAAAAAAAAAAAAAAREAMSFBYVHw/9oACAEBAAE/ECDpgQbAJiFWCwlFfDkFFPjmNy40JhOGFkXC76n/2Q==","aspectRatio":1.4992503748125936,"src":"/static/11-0041e50095cc0a33ead112daeb044b83-79b28.jpg","srcSet":"/static/11-0041e50095cc0a33ead112daeb044b83-3d830.jpg 300w,\n/static/11-0041e50095cc0a33ead112daeb044b83-2ab78.jpg 600w,\n/static/11-0041e50095cc0a33ead112daeb044b83-79b28.jpg 1000w","srcWebp":"/static/11-0041e50095cc0a33ead112daeb044b83-161ff.webp","srcSetWebp":"/static/11-0041e50095cc0a33ead112daeb044b83-9fc06.webp 300w,\n/static/11-0041e50095cc0a33ead112daeb044b83-36f59.webp 600w,\n/static/11-0041e50095cc0a33ead112daeb044b83-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAEDBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABz35koYiv/8QAHBAAAgICAwAAAAAAAAAAAAAAAQIAAxESITEy/9oACAEBAAEFAtcI6JVD3b7JJjcT/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGxABAAICAwAAAAAAAAAAAAAAAQAREFEhQWH/2gAIAQEABj8CNBCuzFanLcPSf//EABoQAQADAQEBAAAAAAAAAAAAAAEAETEhQVH/2gAIAQEAAT8h1efTE1y5XsPUatNgAlbdQovyB19J/9oADAMBAAIAAwAAABBfz//EABYRAQEBAAAAAAAAAAAAAAAAAAEAMf/aAAgBAwEBPxDBGb//xAAWEQEBAQAAAAAAAAAAAAAAAAARECH/2gAIAQIBAT8QHZ//xAAbEAEBAAIDAQAAAAAAAAAAAAABEQAxIVGh8P/aAAgBAQABPxCKcOvJiuUBUKbpuP3ORO6XNFMBolnuFPbQsdGCoqDp3n//2Q==","aspectRatio":1.4992503748125936,"src":"/static/12-3fd57a461e01a6e824966bbeba7d29dc-79b28.jpg","srcSet":"/static/12-3fd57a461e01a6e824966bbeba7d29dc-3d830.jpg 300w,\n/static/12-3fd57a461e01a6e824966bbeba7d29dc-2ab78.jpg 600w,\n/static/12-3fd57a461e01a6e824966bbeba7d29dc-79b28.jpg 1000w","srcWebp":"/static/12-3fd57a461e01a6e824966bbeba7d29dc-161ff.webp","srcSetWebp":"/static/12-3fd57a461e01a6e824966bbeba7d29dc-9fc06.webp 300w,\n/static/12-3fd57a461e01a6e824966bbeba7d29dc-36f59.webp 600w,\n/static/12-3fd57a461e01a6e824966bbeba7d29dc-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQCAwb/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAG2KSRsBMP/xAAbEAACAgMBAAAAAAAAAAAAAAABAgADBBETJP/aAAgBAQABBQLYSXXcijB0AbIijcw28/8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHBAAAwABBQAAAAAAAAAAAAAAAAECESEiMkFx/9oACAEBAAY/AtwqnGoqXZbquKyeCP/EABkQAQADAQEAAAAAAAAAAAAAAAEAETFBIf/aAAgBAQABPyHZxFtN4MSZri5a+ZA2AFcHhGb+KT//2gAMAwEAAgADAAAAELMP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGxAAAgMBAQEAAAAAAAAAAAAAAREAIWExQYH/2gAIAQEAAT8QRFQuQYc5QjEkev6bhSGszJxfgAsZyNKLTPSYhAoMDn//2Q==","aspectRatio":1.5015015015015014,"src":"/static/13-354098002d08e57d5a81efe6ee6ba750-79b28.jpg","srcSet":"/static/13-354098002d08e57d5a81efe6ee6ba750-3d830.jpg 300w,\n/static/13-354098002d08e57d5a81efe6ee6ba750-2ab78.jpg 600w,\n/static/13-354098002d08e57d5a81efe6ee6ba750-79b28.jpg 1000w","srcWebp":"/static/13-354098002d08e57d5a81efe6ee6ba750-161ff.webp","srcSetWebp":"/static/13-354098002d08e57d5a81efe6ee6ba750-9fc06.webp 300w,\n/static/13-354098002d08e57d5a81efe6ee6ba750-36f59.webp 600w,\n/static/13-354098002d08e57d5a81efe6ee6ba750-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAgX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFN3JcQDg22G0tJQ//EABwQAAICAgMAAAAAAAAAAAAAAAECAxETIQASI//aAAgBAQABBQLdsnjXGkYiORqC9gAxaFRlOO8rVAaVn3//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAeEAACAgICAwAAAAAAAAAAAAAAEQECEDEhMkFRYf/aAAgBAQAGPwKlffkspx8JrOpgbLRWvB1a2pNITz//xAAdEAADAAICAwAAAAAAAAAAAAAAAREhQTFRYXGh/9oACAEBAAE/IYnCSZiinYS74HkIzbw0i5MkQmKui7S36ENLuEKsR4jrvGKc4ZOPh//aAAwDAQACAAMAAAAQMMg8/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHRABAAICAwEBAAAAAAAAAAAAAQARITFBUWFxgf/aAAgBAQABPxAvpqAwJwcQOtw4WcN2dSukQiImgLij4S6y00vvsu3RsLHcGQ6p1cXcWgLOBvfyOLY3iV+SuB2Zma1QvPkZSlu8J//Z","aspectRatio":0.6666666666666666,"src":"/static/14-b13ff992297d5934857a64cb700f7e76-79b28.jpg","srcSet":"/static/14-b13ff992297d5934857a64cb700f7e76-3d830.jpg 300w,\n/static/14-b13ff992297d5934857a64cb700f7e76-2ab78.jpg 600w,\n/static/14-b13ff992297d5934857a64cb700f7e76-79b28.jpg 1000w","srcWebp":"/static/14-b13ff992297d5934857a64cb700f7e76-161ff.webp","srcSetWebp":"/static/14-b13ff992297d5934857a64cb700f7e76-9fc06.webp 300w,\n/static/14-b13ff992297d5934857a64cb700f7e76-36f59.webp 600w,\n/static/14-b13ff992297d5934857a64cb700f7e76-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAgP/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAABTx1dGCOCLv05wyxoj//EAB0QAQACAgIDAAAAAAAAAAAAAAIBAwARBBMUITH/2gAIAQEAAQUCUerAicbJU6vs7BCkziM1cTeeJEVXJaPz/8QAFhEAAwAAAAAAAAAAAAAAAAAAASAx/9oACAEDAQE/ARE//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAIhAAAgEDAgcAAAAAAAAAAAAAAQIAEBEhAyIjQUJhYpKh/9oACAEBAAY/AoGI7UGLxV6VyY3CVhfEJM8nNCu0mHSb5OXrP//EAB4QAQADAAICAwAAAAAAAAAAAAEAESExURBBYZHh/9oACAEBAAE/ISoVqYxwFV4W5acnUe/o/KNTeanMlHtbNHwb+CW7hUCfbZBu7x0iCifRP//aAAwDAQACAAMAAAAQIMy//8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERIf/aAAgBAwEBPxBExBSGn//EABgRAQEAAwAAAAAAAAAAAAAAAAEAEBEh/9oACAECAQE/EFRt45f/xAAhEAEBAAEEAAcAAAAAAAAAAAABEQAhMUFhEIGRobHR8P/aAAgBAQABPxAGtphuftMA0ZlIiHgI7HpAPy9ZqFEdqTjpTfIeDkxWgBsfeS0TQhsXDg0UY7JQX0zvY9g9CC+TxhkUxMVI8ly3VGWvu5//2Q==","aspectRatio":0.66711140760507,"src":"/static/15-582bdaf7afc339c718c0c413823e5d0b-79b28.jpg","srcSet":"/static/15-582bdaf7afc339c718c0c413823e5d0b-3d830.jpg 300w,\n/static/15-582bdaf7afc339c718c0c413823e5d0b-2ab78.jpg 600w,\n/static/15-582bdaf7afc339c718c0c413823e5d0b-79b28.jpg 1000w","srcWebp":"/static/15-582bdaf7afc339c718c0c413823e5d0b-161ff.webp","srcSetWebp":"/static/15-582bdaf7afc339c718c0c413823e5d0b-9fc06.webp 300w,\n/static/15-582bdaf7afc339c718c0c413823e5d0b-36f59.webp 600w,\n/static/15-582bdaf7afc339c718c0c413823e5d0b-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQCAwb/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFN+LRnC4P/xAAaEAACAwEBAAAAAAAAAAAAAAACAwABEQQh/9oACAEBAAEFAufSNoDc2cg4sh8dVC3/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAaEAACAwEBAAAAAAAAAAAAAAABEQACECEy/9oACAEBAAY/Aj0pdiqvLyxywE//xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhQTFRYaH/2gAIAQEAAT8h1kWo8w8XwH2KdsINytQDHqmCBReCf//aAAwDAQACAAMAAAAQo8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAcEAEBAAIDAQEAAAAAAAAAAAABEQAhMUFRccH/2gAIAQEAAT8QNpWlojgcZoF0AaiKe1xLflzikO34AL+4JoLVDZ58w2w0HVBmf//Z","aspectRatio":1.4992503748125936,"src":"/static/16-fac023196a4f68aca5d2b7cb16ae0cb5-79b28.jpg","srcSet":"/static/16-fac023196a4f68aca5d2b7cb16ae0cb5-3d830.jpg 300w,\n/static/16-fac023196a4f68aca5d2b7cb16ae0cb5-2ab78.jpg 600w,\n/static/16-fac023196a4f68aca5d2b7cb16ae0cb5-79b28.jpg 1000w","srcWebp":"/static/16-fac023196a4f68aca5d2b7cb16ae0cb5-161ff.webp","srcSetWebp":"/static/16-fac023196a4f68aca5d2b7cb16ae0cb5-9fc06.webp 300w,\n/static/16-fac023196a4f68aca5d2b7cb16ae0cb5-36f59.webp 600w,\n/static/16-fac023196a4f68aca5d2b7cb16ae0cb5-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUCAwYE/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAG5nnu7NYlgII3oa04vD//EABwQAAMAAwADAAAAAAAAAAAAAAECAwAEESIjMf/aAAgBAQABBQJfHaDdBGXqybCbXty0TSyKZN1mwlAnzEsSv//EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAwEBPwF0/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAEQERL/2gAIAQIBAT8BqEZP/8QAHRAAAQQCAwAAAAAAAAAAAAAAAQACESEQQRIzYv/aAAgBAQAGPwInyqvBioQY0S3BfPEHakOYQNyrRkdjdYtf/8QAHhAAAwACAgMBAAAAAAAAAAAAAAERITFBUWGhwdH/2gAIAQEAAT8hVMtL8GYgUeVDruKFbEcr5HljxUtuDjud0Xo3YfkW70oLps2h8IP/2gAMAwEAAgADAAAAEI/1vv/EABYRAQEBAAAAAAAAAAAAAAAAABEBEP/aAAgBAwEBPxBhlM//xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQUf/aAAgBAgEBPxCrjMfJ/8QAIBABAQACAQMFAAAAAAAAAAAAAREAIVExQXFhgaGxwf/aAAgBAQABPxDUgh+MNNixjJjukuLcb3dHIhR84s4IWt9zjxjKdPR1h6biJBA3vnDMJP34d5Uk5AB2g/uFhh1nXyeY+2O1BR47mFkFNWi6M//Z","aspectRatio":0.66711140760507,"src":"/static/17-3e16faef945c6cddf137e115eb6e9657-79b28.jpg","srcSet":"/static/17-3e16faef945c6cddf137e115eb6e9657-3d830.jpg 300w,\n/static/17-3e16faef945c6cddf137e115eb6e9657-2ab78.jpg 600w,\n/static/17-3e16faef945c6cddf137e115eb6e9657-79b28.jpg 1000w","srcWebp":"/static/17-3e16faef945c6cddf137e115eb6e9657-161ff.webp","srcSetWebp":"/static/17-3e16faef945c6cddf137e115eb6e9657-9fc06.webp 300w,\n/static/17-3e16faef945c6cddf137e115eb6e9657-36f59.webp 600w,\n/static/17-3e16faef945c6cddf137e115eb6e9657-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQCAwX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFF/JuJiYf/xAAbEAADAAIDAAAAAAAAAAAAAAABAgMEEwARIf/aAAgBAQABBQLF6N7qoLD1H10ynLU2Nz//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAdEAACAgEFAAAAAAAAAAAAAAAAAQIRECExQXGx/9oACAEBAAY/AlG9PRUorrCkuBG5/8QAGhAAAwADAQAAAAAAAAAAAAAAAAERITGRUf/aAAgBAQABPyF2JK9XBZyoY3l4NTdtF0xFcEpkf//aAAwDAQACAAMAAAAQEM//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAeEAEAAgICAwEAAAAAAAAAAAABABEhMVFhQXHB8f/aAAgBAQABPxBpxqHAtiO5pddqitNkXsXQfsDVZJ4PJMCMJ7fkRDQcz//Z","aspectRatio":1.4992503748125936,"src":"/static/18-365b2b47674cda025ac9d1b665777325-79b28.jpg","srcSet":"/static/18-365b2b47674cda025ac9d1b665777325-3d830.jpg 300w,\n/static/18-365b2b47674cda025ac9d1b665777325-2ab78.jpg 600w,\n/static/18-365b2b47674cda025ac9d1b665777325-79b28.jpg 1000w","srcWebp":"/static/18-365b2b47674cda025ac9d1b665777325-161ff.webp","srcSetWebp":"/static/18-365b2b47674cda025ac9d1b665777325-9fc06.webp 300w,\n/static/18-365b2b47674cda025ac9d1b665777325-36f59.webp 600w,\n/static/18-365b2b47674cda025ac9d1b665777325-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAAD/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAQLI+UFhJ//EABsQAAEEAwAAAAAAAAAAAAAAAAIAAQMiESMz/9oACAEBAAEFAgMsyVj1oGvLwX//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAABAwUAAAAAAAAAAAAAAAABABARAhIygZH/2gAIAQEABj8CAugKaQYKxPW23//EABoQAAMBAQEBAAAAAAAAAAAAAAABESFBMVH/2gAIAQEAAT8h2UzMHUUya4ywrTsCkmWDaXwP0//aAAwDAQACAAMAAAAQJy//xAAWEQEBAQAAAAAAAAAAAAAAAAABECH/2gAIAQMBAT8QDGf/xAAXEQEBAQEAAAAAAAAAAAAAAAABABEh/9oACAECAQE/EF6WX//EABwQAQADAAIDAAAAAAAAAAAAAAEAESExYVGBof/aAAgBAQABPxDZ4aBnyCHILUVKeHqWIZhSkvoj26FL8k4NRj6anJP/2Q==","aspectRatio":1.4992503748125936,"src":"/static/20-c5d8d5d4d79f2e55234f4492a7c71109-79b28.jpg","srcSet":"/static/20-c5d8d5d4d79f2e55234f4492a7c71109-3d830.jpg 300w,\n/static/20-c5d8d5d4d79f2e55234f4492a7c71109-2ab78.jpg 600w,\n/static/20-c5d8d5d4d79f2e55234f4492a7c71109-79b28.jpg 1000w","srcWebp":"/static/20-c5d8d5d4d79f2e55234f4492a7c71109-161ff.webp","srcSetWebp":"/static/20-c5d8d5d4d79f2e55234f4492a7c71109-9fc06.webp 300w,\n/static/20-c5d8d5d4d79f2e55234f4492a7c71109-36f59.webp 600w,\n/static/20-c5d8d5d4d79f2e55234f4492a7c71109-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFA//EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAABkuL0BQMSn6MOpomGQX//xAAcEAADAAMAAwAAAAAAAAAAAAABAgMAERMEMkH/2gAIAQEAAQUC+hNTEncR31dWMc8XS4WYrYjpNiGnXH9//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAIBAAAgIBAwUAAAAAAAAAAAAAAREAAhIQISIxQVFhcf/aAAgBAQAGPwLjM0X7gIqxK4wioWJ3+aPv4jAVoUIx10K2E//EABwQAQADAAMBAQAAAAAAAAAAAAEAESExQVFxYf/aAAgBAQABPyGqAudya92/ECn6ELYWjc0JhDjD+MYKpo12YG6LvkonFz9jKnHce1qIVFjh5P/aAAwDAQACAAMAAAAQG+08/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERIRD/2gAIAQMBAT8QUhTFr5//xAAXEQEBAQEAAAAAAAAAAAAAAAABIQAQ/9oACAECAQE/EEddWHP/xAAfEAEBAAMAAgIDAAAAAAAAAAABEQAhMUFRYXGBoeH/2gAIAQEAAT8QpTdDGxN472EoFE2ztO3IRxCVdvd9/mDHOQ8TzidknNKz763KtkPpysjQ/B6xRyFRauj7zXkaJ8+X71+MNEFg7AYx1urX5yscXrHrP//Z","aspectRatio":0.66711140760507,"src":"/static/21-51a78d0c6796c92d3fdd4188380d7521-79b28.jpg","srcSet":"/static/21-51a78d0c6796c92d3fdd4188380d7521-3d830.jpg 300w,\n/static/21-51a78d0c6796c92d3fdd4188380d7521-2ab78.jpg 600w,\n/static/21-51a78d0c6796c92d3fdd4188380d7521-79b28.jpg 1000w","srcWebp":"/static/21-51a78d0c6796c92d3fdd4188380d7521-161ff.webp","srcSetWebp":"/static/21-51a78d0c6796c92d3fdd4188380d7521-9fc06.webp 300w,\n/static/21-51a78d0c6796c92d3fdd4188380d7521-36f59.webp 600w,\n/static/21-51a78d0c6796c92d3fdd4188380d7521-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}}]},"reportage":{"edges":[{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAVXQvMEQf//EABoQAAMBAAMAAAAAAAAAAAAAAAECAxEEEhT/2gAIAQEAAQUClM6hwLyegnU0bzBlWIcf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHhAAAQMEAwAAAAAAAAAAAAAAAAEREgIhMUFCUXH/2gAIAQEABj8CWrjj00+xrEcR6JLUo6qf/8QAGRABAQEBAQEAAAAAAAAAAAAAAREAMSFx/9oACAEBAAE/IQHfDT1w0DrPV+5YDqy81WJInLj52ATWCu//2gAMAwEAAgADAAAAEJAP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGxABAAIDAQEAAAAAAAAAAAAAAREhADFBUaH/2gAIAQEAAT8QLI3YKqCRq2K8MjhVYBRSJoLCPMahSkorebwqFyqRI3z3ncdqBKNDe3vzJT2hBFQZ/9k=","aspectRatio":1.4992503748125936,"src":"/static/01-1518ad646734bc05ea332bfeb7ec92e1-79b28.jpg","srcSet":"/static/01-1518ad646734bc05ea332bfeb7ec92e1-3d830.jpg 300w,\n/static/01-1518ad646734bc05ea332bfeb7ec92e1-2ab78.jpg 600w,\n/static/01-1518ad646734bc05ea332bfeb7ec92e1-79b28.jpg 1000w","srcWebp":"/static/01-1518ad646734bc05ea332bfeb7ec92e1-161ff.webp","srcSetWebp":"/static/01-1518ad646734bc05ea332bfeb7ec92e1-9fc06.webp 300w,\n/static/01-1518ad646734bc05ea332bfeb7ec92e1-36f59.webp 600w,\n/static/01-1518ad646734bc05ea332bfeb7ec92e1-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAU2Jug8Sw//EABoQAAMAAwEAAAAAAAAAAAAAAAABAgMREhP/2gAIAQEAAQUClvu3UndCtyejHkrf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHRAAAgIBBQAAAAAAAAAAAAAAAAERIQITMVFxkf/aAAgBAQAGPwLBqux6bm/GUk+XIiDc/8QAGxABAAMAAwEAAAAAAAAAAAAAAQARITFRYaH/2gAIAQEAAT8hWQWKXp3HUJRjyE++lNh9Nq+Y25AdfYtK5//aAAwDAQACAAMAAAAQcw//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAdEAEBAAMAAgMAAAAAAAAAAAABEQAhMUFRYYHw/9oACAEBAAE/ECRgn0a2D4NZZIhZQ4Xpvzm+JEo1NdfeGcAgDdPTIgRaiOli/uYhgr7z/9k=","aspectRatio":1.4992503748125936,"src":"/static/02-e16664602f6c3e07329efc1acc2f0467-79b28.jpg","srcSet":"/static/02-e16664602f6c3e07329efc1acc2f0467-3d830.jpg 300w,\n/static/02-e16664602f6c3e07329efc1acc2f0467-2ab78.jpg 600w,\n/static/02-e16664602f6c3e07329efc1acc2f0467-79b28.jpg 1000w","srcWebp":"/static/02-e16664602f6c3e07329efc1acc2f0467-161ff.webp","srcSetWebp":"/static/02-e16664602f6c3e07329efc1acc2f0467-9fc06.webp 300w,\n/static/02-e16664602f6c3e07329efc1acc2f0467-36f59.webp 600w,\n/static/02-e16664602f6c3e07329efc1acc2f0467-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAUBAwT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHRCOwaCkP/xAAbEAACAgMBAAAAAAAAAAAAAAABAgMSABETFP/aAAgBAQABBQK6lvQNK6VWQpnQkNIbf//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABwQAAMAAQUAAAAAAAAAAAAAAAABEQIQEiExQf/aAAgBAQAGPwJbJYeZIVRwdaf/xAAbEAACAwADAAAAAAAAAAAAAAAAAREhMVFhsf/aAAgBAQABPyFQRyGTtoVR4dLMnBs3t6NxTZomrP/aAAwDAQACAAMAAAAQMM//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAcEAEBAAMAAwEAAAAAAAAAAAABEQAhMVFhgdH/2gAIAQEAAT8QXGBItJJsOOQIINMkCoe97iIIk6SLzIJA7TuVcVoiUvH1+Ztnh81n/9k=","aspectRatio":1.4992503748125936,"src":"/static/03-ee00dd97eebdf0c8fed93fcc9c5be475-79b28.jpg","srcSet":"/static/03-ee00dd97eebdf0c8fed93fcc9c5be475-3d830.jpg 300w,\n/static/03-ee00dd97eebdf0c8fed93fcc9c5be475-2ab78.jpg 600w,\n/static/03-ee00dd97eebdf0c8fed93fcc9c5be475-79b28.jpg 1000w","srcWebp":"/static/03-ee00dd97eebdf0c8fed93fcc9c5be475-161ff.webp","srcSetWebp":"/static/03-ee00dd97eebdf0c8fed93fcc9c5be475-9fc06.webp 300w,\n/static/03-ee00dd97eebdf0c8fed93fcc9c5be475-36f59.webp 600w,\n/static/03-ee00dd97eebdf0c8fed93fcc9c5be475-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMFAgb/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFuZyiuc+H/xAAaEAACAwEBAAAAAAAAAAAAAAAAAQIDEhET/9oACAEBAAEFAlcidqz6wrNDlwbP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHBAAAgICAwAAAAAAAAAAAAAAAQIAERASISJB/9oACAEBAAY/AizCnnZ9gRzUpAKhTyGsf//EABsQAAMBAAMBAAAAAAAAAAAAAAABESExQVFh/9oACAEBAAE/IVqHE0l2WFEl4CV2uqjf4B9s02vun//aAAwDAQACAAMAAAAQoA//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAcEAEBAAIDAQEAAAAAAAAAAAABEQAhMUFhcVH/2gAIAQEAAT8QMGgv1FJ8NHy41yAI3e/JOMCcsSlvZb+YypsI+znCamgQdPsxt20Vn//Z","aspectRatio":1.5527950310559007,"src":"/static/04-0ccd932ddefbcae3d194fd662031f7cf-79b28.jpg","srcSet":"/static/04-0ccd932ddefbcae3d194fd662031f7cf-3d830.jpg 300w,\n/static/04-0ccd932ddefbcae3d194fd662031f7cf-2ab78.jpg 600w,\n/static/04-0ccd932ddefbcae3d194fd662031f7cf-79b28.jpg 1000w","srcWebp":"/static/04-0ccd932ddefbcae3d194fd662031f7cf-161ff.webp","srcSetWebp":"/static/04-0ccd932ddefbcae3d194fd662031f7cf-9fc06.webp 300w,\n/static/04-0ccd932ddefbcae3d194fd662031f7cf-36f59.webp 600w,\n/static/04-0ccd932ddefbcae3d194fd662031f7cf-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAXV4LSoxg//EABkQAAIDAQAAAAAAAAAAAAAAAAACAQMREv/aAAgBAQABBQKhcGyDkryUe7Imxj//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAACAgIDAAAAAAAAAAAAAAABEQAhAhASQZH/2gAIAQEABj8CRI117HkHcPEKoHdT/8QAHBAAAgICAwAAAAAAAAAAAAAAAREAIUFhUZGh/9oACAEBAAE/IbAxb6lIUWIoK9wHDwbUNdWTgljaT//aAAwDAQACAAMAAAAQs8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAdEAEAAgICAwAAAAAAAAAAAAABESEAMUGRUYGh/9oACAEBAAE/ECUxtAUG094FSdEGGQbcXkB5LTpxIiYiaWos4rUe8j4gxIt1Zr5hEZgiijxn/9k=","aspectRatio":1.4992503748125936,"src":"/static/05-c522ae71a45c2ab82d5a6b0c4440123a-79b28.jpg","srcSet":"/static/05-c522ae71a45c2ab82d5a6b0c4440123a-3d830.jpg 300w,\n/static/05-c522ae71a45c2ab82d5a6b0c4440123a-2ab78.jpg 600w,\n/static/05-c522ae71a45c2ab82d5a6b0c4440123a-79b28.jpg 1000w","srcWebp":"/static/05-c522ae71a45c2ab82d5a6b0c4440123a-161ff.webp","srcSetWebp":"/static/05-c522ae71a45c2ab82d5a6b0c4440123a-9fc06.webp 300w,\n/static/05-c522ae71a45c2ab82d5a6b0c4440123a-36f59.webp 600w,\n/static/05-c522ae71a45c2ab82d5a6b0c4440123a-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUBAgME/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABvCjQ7BUH/8QAGxAAAgIDAQAAAAAAAAAAAAAAAQIAEQMEEhP/2gAIAQEAAQUC9uo+djG2DaWZkHMLG//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EAB4QAAICAAcAAAAAAAAAAAAAAAERADEQMkFCUWGR/9oACAEBAAY/AluVwqhzMg8hD0i6w//EABsQAQADAAMBAAAAAAAAAAAAAAEAESExQVGh/9oACAEBAAE/ITCgDQjlN6YwhwFFHqdWRjLwPsAtn//aAAwDAQACAAMAAAAQs8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAcEAEAAwACAwAAAAAAAAAAAAABABEhMUFRYYH/2gAIAQEAAT8QtlTJL+F43K5eiLDsSPh4nJza3NvJRJEDYF6meuYBSRTffKAFufM//9k=","aspectRatio":1.4992503748125936,"src":"/static/06-88e36dcaf94d3d295685d6454ae463a8-79b28.jpg","srcSet":"/static/06-88e36dcaf94d3d295685d6454ae463a8-3d830.jpg 300w,\n/static/06-88e36dcaf94d3d295685d6454ae463a8-2ab78.jpg 600w,\n/static/06-88e36dcaf94d3d295685d6454ae463a8-79b28.jpg 1000w","srcWebp":"/static/06-88e36dcaf94d3d295685d6454ae463a8-161ff.webp","srcSetWebp":"/static/06-88e36dcaf94d3d295685d6454ae463a8-9fc06.webp 300w,\n/static/06-88e36dcaf94d3d295685d6454ae463a8-36f59.webp 600w,\n/static/06-88e36dcaf94d3d295685d6454ae463a8-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAdiZINEB/8QAHBAAAQQDAQAAAAAAAAAAAAAAAgADERIBBCEi/9oACAEBAAEFAnqRYRTkEtjqdGuZ8//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABwQAAICAgMAAAAAAAAAAAAAAAABAhEQEkFhcf/aAAgBAQAGPwKO77HXiFXCojiJ/8QAHRAAAQQCAwAAAAAAAAAAAAAAAQARITFBUXHB0f/aAAgBAQABPyFgBJYhoMn1ZggszaAmKRtQ8fFmHQKLXZX/2gAMAwEAAgADAAAAEOPP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBABAAMBAAMBAAAAAAAAAAAAAREhMQBBYZGh/9oACAEBAAE/EHR1IMASfc6S0202GU+jxxs5G4aFuuCmYUCxpFP149gsPEQpwsF59unf/9k=","aspectRatio":1.4992503748125936,"src":"/static/07-0f0baa7ba76653f0bc840e6dd3f86ac9-79b28.jpg","srcSet":"/static/07-0f0baa7ba76653f0bc840e6dd3f86ac9-3d830.jpg 300w,\n/static/07-0f0baa7ba76653f0bc840e6dd3f86ac9-2ab78.jpg 600w,\n/static/07-0f0baa7ba76653f0bc840e6dd3f86ac9-79b28.jpg 1000w","srcWebp":"/static/07-0f0baa7ba76653f0bc840e6dd3f86ac9-161ff.webp","srcSetWebp":"/static/07-0f0baa7ba76653f0bc840e6dd3f86ac9-9fc06.webp 300w,\n/static/07-0f0baa7ba76653f0bc840e6dd3f86ac9-36f59.webp 600w,\n/static/07-0f0baa7ba76653f0bc840e6dd3f86ac9-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAQL/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAF3ido6RQ//xAAaEAACAwEBAAAAAAAAAAAAAAABAgADERIT/9oACAEBAAEFAvVdN4mo8vOJ3zWbjP/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EAB0QAAICAQUAAAAAAAAAAAAAAAABAhEyIUFRkZL/2gAIAQEABj8CXLGXp2KiTUVluYQ8n//EAB0QAQACAgIDAAAAAAAAAAAAAAEAESFBMVFhcYH/2gAIAQEAAT8hRDCt+idNevP2AM7PMY6p7IlR4lC9S9F//9oADAMBAAIAAwAAABATz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EAB0QAQEAAgMAAwAAAAAAAAAAAAERACExQVFhkaH/2gAIAQEAAT8QBYiSN6Lr51muQ7AXSDiPv8wxOBCNM4yR7FSU8maFFYRWsPbm1DoPDP/Z","aspectRatio":1.4992503748125936,"src":"/static/08-6168bd01dec098e6da4b77402875f51e-79b28.jpg","srcSet":"/static/08-6168bd01dec098e6da4b77402875f51e-3d830.jpg 300w,\n/static/08-6168bd01dec098e6da4b77402875f51e-2ab78.jpg 600w,\n/static/08-6168bd01dec098e6da4b77402875f51e-79b28.jpg 1000w","srcWebp":"/static/08-6168bd01dec098e6da4b77402875f51e-161ff.webp","srcSetWebp":"/static/08-6168bd01dec098e6da4b77402875f51e-9fc06.webp 300w,\n/static/08-6168bd01dec098e6da4b77402875f51e-36f59.webp 600w,\n/static/08-6168bd01dec098e6da4b77402875f51e-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAVKEJ80Ew//EABoQAQADAAMAAAAAAAAAAAAAAAEAAgMREiL/2gAIAQEAAQUCzvUu9eDbMMz1dWOdZ//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABwQAAICAgMAAAAAAAAAAAAAAAABAiEQERIxYf/aAAgBAQAGPwJM5apF6ZD2Q76x/8QAGhABAQEAAwEAAAAAAAAAAAAAAREAITFxgf/aAAgBAQABPyH4p91hSDyac9E7wIOJkQCTUSb/2gAMAwEAAgADAAAAEKAP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHRAAAgIBBQAAAAAAAAAAAAAAAREAIUExUXGBsf/aAAgBAQABPxBI2jgi1RjES2YHiUGREG12uOcKBwGIyXKDSeiEARQVP//Z","aspectRatio":1.4992503748125936,"src":"/static/09-41f71a6dd190d2833d6d48e5c3b0d20b-79b28.jpg","srcSet":"/static/09-41f71a6dd190d2833d6d48e5c3b0d20b-3d830.jpg 300w,\n/static/09-41f71a6dd190d2833d6d48e5c3b0d20b-2ab78.jpg 600w,\n/static/09-41f71a6dd190d2833d6d48e5c3b0d20b-79b28.jpg 1000w","srcWebp":"/static/09-41f71a6dd190d2833d6d48e5c3b0d20b-161ff.webp","srcSetWebp":"/static/09-41f71a6dd190d2833d6d48e5c3b0d20b-9fc06.webp 300w,\n/static/09-41f71a6dd190d2833d6d48e5c3b0d20b-36f59.webp 600w,\n/static/09-41f71a6dd190d2833d6d48e5c3b0d20b-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIFAf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAceA5ZIwf//EABgQAQEBAQEAAAAAAAAAAAAAAAEDEgAC/9oACAEBAAEFApWM+rglRNPaV2nf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGxAAAQQDAAAAAAAAAAAAAAAAABARIYEBMWH/2gAIAQEABj8CuDXR4tHyn//EABsQAQACAwEBAAAAAAAAAAAAAAEAIRExQWFR/9oACAEBAAE/IbRHjqYKqh9QMt/u56cxDcitwchrM//aAAwDAQACAAMAAAAQU8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAeEAEAAgICAwEAAAAAAAAAAAABABEhMUFRcYGhsf/aAAgBAQABPxC0PKOBlu/dsVBUgI4HXF38iZCl0n4m8X5OOoBVYsu8RdDJRRif/9k=","aspectRatio":1.4992503748125936,"src":"/static/10-52c081f6c6a93ea9b9fdf3347df8bd24-79b28.jpg","srcSet":"/static/10-52c081f6c6a93ea9b9fdf3347df8bd24-3d830.jpg 300w,\n/static/10-52c081f6c6a93ea9b9fdf3347df8bd24-2ab78.jpg 600w,\n/static/10-52c081f6c6a93ea9b9fdf3347df8bd24-79b28.jpg 1000w","srcWebp":"/static/10-52c081f6c6a93ea9b9fdf3347df8bd24-161ff.webp","srcSetWebp":"/static/10-52c081f6c6a93ea9b9fdf3347df8bd24-9fc06.webp 300w,\n/static/10-52c081f6c6a93ea9b9fdf3347df8bd24-36f59.webp 600w,\n/static/10-52c081f6c6a93ea9b9fdf3347df8bd24-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMBAgT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAG6YSZxQf/EABsQAAIDAAMAAAAAAAAAAAAAAAECAAMSESEi/9oACAEBAAEFAiNVNwa8ERHM14du/wD/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAbEAABBAMAAAAAAAAAAAAAAAABAAIQETFBcf/aAAgBAQAGPwIboJtnMHibH//EABsQAQADAQEBAQAAAAAAAAAAAAEAESExgVGR/9oACAEBAAE/IVX9fJRCx18lCs/Y8NoKMnCl4d8lgzhP/9oADAMBAAIAAwAAABADz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABwQAQEAAwADAQAAAAAAAAAAAAERACExQVFhwf/aAAgBAQABPxABvCCqCuI2p9Pr8yQgdTTZXeU5CChI54xNRacPDAJFvvP/2Q==","aspectRatio":1.4992503748125936,"src":"/static/11-b3335780914ac0701ac6d2feee507067-79b28.jpg","srcSet":"/static/11-b3335780914ac0701ac6d2feee507067-3d830.jpg 300w,\n/static/11-b3335780914ac0701ac6d2feee507067-2ab78.jpg 600w,\n/static/11-b3335780914ac0701ac6d2feee507067-79b28.jpg 1000w","srcWebp":"/static/11-b3335780914ac0701ac6d2feee507067-161ff.webp","srcSetWebp":"/static/11-b3335780914ac0701ac6d2feee507067-9fc06.webp 300w,\n/static/11-b3335780914ac0701ac6d2feee507067-36f59.webp 600w,\n/static/11-b3335780914ac0701ac6d2feee507067-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQBA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAY+uidSP/8QAGxAAAQUBAQAAAAAAAAAAAAAAAQIDEhMjABH/2gAIAQEAAQUCCjTe4S8NIY1+LgV9/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHhAAAgEDBQAAAAAAAAAAAAAAAAERAhIhMUFhcZH/2gAIAQEABj8Co7LZ8M7lK5G09GTdB//EABoQAQADAQEBAAAAAAAAAAAAAAEAESExQYH/2gAIAQEAAT8h4zCsXUrsNcmp06sgN3uJVOlSsfNU/9oADAMBAAIAAwAAABDzz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABwQAQEAAgMBAQAAAAAAAAAAAAERACExUWGxwf/aAAgBAQABPxDXogzSnP3LtAPBHX7lh0BAxJitEUUAXAzBAtumG8ShlOF+9+5//9k=","aspectRatio":1.4992503748125936,"src":"/static/12-a1073011403bd3429e7056a49654ba05-79b28.jpg","srcSet":"/static/12-a1073011403bd3429e7056a49654ba05-3d830.jpg 300w,\n/static/12-a1073011403bd3429e7056a49654ba05-2ab78.jpg 600w,\n/static/12-a1073011403bd3429e7056a49654ba05-79b28.jpg 1000w","srcWebp":"/static/12-a1073011403bd3429e7056a49654ba05-161ff.webp","srcSetWebp":"/static/12-a1073011403bd3429e7056a49654ba05-9fc06.webp 300w,\n/static/12-a1073011403bd3429e7056a49654ba05-36f59.webp 600w,\n/static/12-a1073011403bd3429e7056a49654ba05-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMFAQT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFbJWneTw//xAAbEAADAAIDAAAAAAAAAAAAAAABAhEDEgATIv/aAAgBAQABBQLFJszc8kBtMnaaztf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAZEAADAQEBAAAAAAAAAAAAAAAAARFBITH/2gAIAQEABj8Crw8UK0OGHHEf/8QAGhAAAgMBAQAAAAAAAAAAAAAAAREAITFBUf/aAAgBAQABPyEgFCveQeihhKhAtoDyHFXO3FsmzI1ZwAn/2gAMAwEAAgADAAAAEDDP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGxABAAMBAQEBAAAAAAAAAAAAAQARIVExYcH/2gAIAQEAAT8QcVYvYab/ACMinaEmzbLv5ADcgKwgc04HHYGAKNgGO8lGNZ4gn//Z","aspectRatio":1.4992503748125936,"src":"/static/13-b391bfb7495dd53dbf33867eb1302e98-79b28.jpg","srcSet":"/static/13-b391bfb7495dd53dbf33867eb1302e98-3d830.jpg 300w,\n/static/13-b391bfb7495dd53dbf33867eb1302e98-2ab78.jpg 600w,\n/static/13-b391bfb7495dd53dbf33867eb1302e98-79b28.jpg 1000w","srcWebp":"/static/13-b391bfb7495dd53dbf33867eb1302e98-161ff.webp","srcSetWebp":"/static/13-b391bfb7495dd53dbf33867eb1302e98-9fc06.webp 300w,\n/static/13-b391bfb7495dd53dbf33867eb1302e98-36f59.webp 600w,\n/static/13-b391bfb7495dd53dbf33867eb1302e98-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQCAwYF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABh1su8PmaDUrzuFSwP//EABwQAAICAgMAAAAAAAAAAAAAAAECAxEEEwASIf/aAAgBAQABBQLHpINidd9kXpQL04uPGY2jByziRWj88st7/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHhAAAQQCAwEAAAAAAAAAAAAAAQACEUEQEiEiMWL/2gAIAQEABj8CDnWUBNLqVP0nAGCRjWOPVrWsq8TeP//EAB4QAAICAgIDAAAAAAAAAAAAAAABESExQWFxkaHB/9oACAEBAAE/IZRJ83wSYO2Y5mBOBIZOqXwTqQVsbxZsMfkKb1qGM9hkFKew7Zn/2gAMAwEAAgADAAAAEBAAAP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB0QAQACAgMBAQAAAAAAAAAAAAEAESFBMVFxYYH/2gAIAQEAAT8QHBxDOk4Dbf2Oi3EtgG3qAFrzzs/IKktGilvl4g7lNtdPnOI+xxLJJurfDqZptAxbpFuGpSdHGVwnzDC3yyu9dXC4BP/Z","aspectRatio":0.6666666666666666,"src":"/static/14-4d370240408d64eb61abc1c6da6ab111-79b28.jpg","srcSet":"/static/14-4d370240408d64eb61abc1c6da6ab111-3d830.jpg 300w,\n/static/14-4d370240408d64eb61abc1c6da6ab111-2ab78.jpg 600w,\n/static/14-4d370240408d64eb61abc1c6da6ab111-79b28.jpg 1000w","srcWebp":"/static/14-4d370240408d64eb61abc1c6da6ab111-161ff.webp","srcSetWebp":"/static/14-4d370240408d64eb61abc1c6da6ab111-9fc06.webp 300w,\n/static/14-4d370240408d64eb61abc1c6da6ab111-36f59.webp 600w,\n/static/14-4d370240408d64eb61abc1c6da6ab111-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}}]},"travel":{"edges":[{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAABAAFAgP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHO0TtCyIJeXBoQI//EABwQAAICAwEBAAAAAAAAAAAAAAECAAMREyESIv/aAAgBAQABBQJx2hc1mjvjZEr1x2AYEEM+Yv0Kxk3xQDP/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAdEAACAgIDAQAAAAAAAAAAAAAAAQIRIVEQMUFh/9oACAEBAAY/Alo34YdIpYrZgzE6cnfUSPjLlNJ/eFx//8QAGxABAAMBAQEBAAAAAAAAAAAAAQARITFBUXH/2gAIAQEAAT8hbev2yw0xTy5U7vgXkFoFTjsLXR5eLK0dxH6gwSowetjNlrVAqsIWqW6j37P/2gAMAwEAAgADAAAAEDDLDP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB8QAQACAgIDAQEAAAAAAAAAAAEAESExQWFRcaGBkf/aAAgBAQABPxCyHFXAKw3CdHlNF9fZnGnDU6Q4VDNmHHk8xxastrL/AHH8l4ohm1v6QUREpRAN+Rv3FBpgbve+++5UiioG0NPqbSrURqH8RxACFUooaJ//2Q==","aspectRatio":0.6662225183211192,"src":"/static/01-a7f69344b45c3301226423b8f2199a3a-79b28.jpg","srcSet":"/static/01-a7f69344b45c3301226423b8f2199a3a-3d830.jpg 300w,\n/static/01-a7f69344b45c3301226423b8f2199a3a-2ab78.jpg 600w,\n/static/01-a7f69344b45c3301226423b8f2199a3a-79b28.jpg 1000w","srcWebp":"/static/01-a7f69344b45c3301226423b8f2199a3a-161ff.webp","srcSetWebp":"/static/01-a7f69344b45c3301226423b8f2199a3a-9fc06.webp 300w,\n/static/01-a7f69344b45c3301226423b8f2199a3a-36f59.webp 600w,\n/static/01-a7f69344b45c3301226423b8f2199a3a-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAgP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGFVRokcdDffexIYD//xAAaEAACAwEBAAAAAAAAAAAAAAABAgADExEi/9oACAEBAAEFAlUsz1nBhw1+AjSxQzChippaZkQVLM1mSz//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAeEAACAQQDAQAAAAAAAAAAAAAAAQIREjEyECJRgf/aAAgBAQAGPwJJZZFR4ufwtrX0qWku2TY1NUYR/8QAHhAAAgEFAAMAAAAAAAAAAAAAAREAITFBUXEQYYH/2gAIAQEAAT8hAkyIQ4I0icYhigp+oBsRNN+wqKwAq1GkvktR3UbJBNtV0RmyFfgb/9oADAMBAAIAAwAAABAwwDz/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAgEAEBAAIBBAMBAAAAAAAAAAABEQAhUTFBYaFxgdGR/9oACAEBAAE/ENSoDlwYKOyA7lvkzQ2dap/TJorGoDewer5y+UJFQQIczFiGkESnL5yRDuxsum/Uw9kBYOoH5hw33S4V9H5f3D6/dcG6+7P/2Q==","aspectRatio":0.6666666666666666,"src":"/static/02-ed37825d7cfb6509921bcaad8bee46d7-79b28.jpg","srcSet":"/static/02-ed37825d7cfb6509921bcaad8bee46d7-3d830.jpg 300w,\n/static/02-ed37825d7cfb6509921bcaad8bee46d7-2ab78.jpg 600w,\n/static/02-ed37825d7cfb6509921bcaad8bee46d7-79b28.jpg 1000w","srcWebp":"/static/02-ed37825d7cfb6509921bcaad8bee46d7-161ff.webp","srcSetWebp":"/static/02-ed37825d7cfb6509921bcaad8bee46d7-9fc06.webp 300w,\n/static/02-ed37825d7cfb6509921bcaad8bee46d7-36f59.webp 600w,\n/static/02-ed37825d7cfb6509921bcaad8bee46d7-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAwH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGl4emQgcbWglNg/8QAHRAAAgICAwEAAAAAAAAAAAAAAQIAAxITBBEhIv/aAAgBAQABBQJO1bkH0/ZrxVLTBbrDCWq2LVO7UJlLwXVdhH//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAeEAACAwACAwEAAAAAAAAAAAAAAQIRIRJxMUFSkf/aAAgBAQAGPwJYK3hdSfQ/rs5ysUaZhcvHo5RWMU3pVmTX4f/EAB0QAQACAwEAAwAAAAAAAAAAAAEAESExQWGBsdH/2gAIAQEAAT8hRx5GY6m83HINIXkvFGOzlLkwHIA+L+/yFA6GHI8s6G5nf5TQYiLUNVP/2gAMAwEAAgADAAAAEDMJAP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB4QAQEAAgMAAwEAAAAAAAAAAAERACExQVFhcaGR/9oACAEBAAE/EDXBRE47f0x3VBqddv8AZm0cJoECdvtwiGo4fePjCiXByVdcCavesYXtODR3f3GYmtj9wT3Tj5ybV0LXaTrJo8MBdHrjSsLoVpr6MYbmanmOxq0LIzW+M//Z","aspectRatio":0.6666666666666666,"src":"/static/04-e14fbe6359180fa6003140d932f7e31c-79b28.jpg","srcSet":"/static/04-e14fbe6359180fa6003140d932f7e31c-3d830.jpg 300w,\n/static/04-e14fbe6359180fa6003140d932f7e31c-2ab78.jpg 600w,\n/static/04-e14fbe6359180fa6003140d932f7e31c-79b28.jpg 1000w","srcWebp":"/static/04-e14fbe6359180fa6003140d932f7e31c-161ff.webp","srcSetWebp":"/static/04-e14fbe6359180fa6003140d932f7e31c-9fc06.webp 300w,\n/static/04-e14fbe6359180fa6003140d932f7e31c-36f59.webp 600w,\n/static/04-e14fbe6359180fa6003140d932f7e31c-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAgX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHDeTQMJQ//xAAbEAEAAgIDAAAAAAAAAAAAAAABAAIDERITIf/aAAgBAQABBQKkWL6ZkN8jstP/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAbEAACAQUAAAAAAAAAAAAAAAAAATERIWFx4f/aAAgBAQAGPwLJDOEItVPZLP/EAB4QAQABAwUBAAAAAAAAAAAAAAEAESExQVFxgZHh/9oACAEBAAE/IQUKgaLE3k6giE9gI1L4SZvBWR+hP//aAAwDAQACAAMAAAAQ0A//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAdEAACAgMBAQEAAAAAAAAAAAABEQAhMUFhkXHx/9oACAEBAAE/ECWZODvoubOP+onAjVlexF8Nwuh4i0D3ucOIEQFIKgv0T//Z","aspectRatio":1.4992503748125936,"src":"/static/05-4a8f58d0a2f842c96f9144a3d487aebe-79b28.jpg","srcSet":"/static/05-4a8f58d0a2f842c96f9144a3d487aebe-3d830.jpg 300w,\n/static/05-4a8f58d0a2f842c96f9144a3d487aebe-2ab78.jpg 600w,\n/static/05-4a8f58d0a2f842c96f9144a3d487aebe-79b28.jpg 1000w","srcWebp":"/static/05-4a8f58d0a2f842c96f9144a3d487aebe-161ff.webp","srcSetWebp":"/static/05-4a8f58d0a2f842c96f9144a3d487aebe-9fc06.webp 300w,\n/static/05-4a8f58d0a2f842c96f9144a3d487aebe-36f59.webp 600w,\n/static/05-4a8f58d0a2f842c96f9144a3d487aebe-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQCAwX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFK2DJnjIf/xAAZEAEAAwEBAAAAAAAAAAAAAAABAAIDESH/2gAIAQEAAQUCzLJansz2SV6w0ef/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAACAQUBAAAAAAAAAAAAAAAAASECETEyQVH/2gAIAQEABj8C8NrEISyiueHD/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFBYXH/2gAIAQEAAT8hGc13Uv1YdMxtXJLaCzIyrem5Rr5AgRV5P//aAAwDAQACAAMAAAAQI8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAbEAEBAAIDAQAAAAAAAAAAAAABEQAhMUGBUf/aAAgBAQABPxCZKnAJt37McLUetR2z0wxkjFqR+Yc8YVpy2SNIHfQujHNIlcf/2Q==","aspectRatio":1.4992503748125936,"src":"/static/07-abcd5d2c8ce291f7880764af09312069-79b28.jpg","srcSet":"/static/07-abcd5d2c8ce291f7880764af09312069-3d830.jpg 300w,\n/static/07-abcd5d2c8ce291f7880764af09312069-2ab78.jpg 600w,\n/static/07-abcd5d2c8ce291f7880764af09312069-79b28.jpg 1000w","srcWebp":"/static/07-abcd5d2c8ce291f7880764af09312069-161ff.webp","srcSetWebp":"/static/07-abcd5d2c8ce291f7880764af09312069-9fc06.webp 300w,\n/static/07-abcd5d2c8ce291f7880764af09312069-36f59.webp 600w,\n/static/07-abcd5d2c8ce291f7880764af09312069-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAUCAwT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGnQmkOBIH/xAAaEAADAAMBAAAAAAAAAAAAAAABAgMREhMh/9oACAEBAAEFAttWm/MrM4LHr6lKMSf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAbEAACAwADAAAAAAAAAAAAAAAAMQERIRIiQf/aAAgBAQAGPwLhdaONWnarJGh+H//EABsQAQACAwEBAAAAAAAAAAAAAAEAESExQVFx/9oACAEBAAE/IQENDKuvIz6WoySa/wDBGMS6zzkLFO8yDb4T/9oADAMBAAIAAwAAABDzD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABwQAQACAwADAAAAAAAAAAAAAAEAESExQXGR8P/aAAgBAQABPxA2AUuHLZ0GGCIhyGAUPnUq6SzXydhJV0gvQgZYgtG76RnawMNcn//Z","aspectRatio":1.4992503748125936,"src":"/static/08-5e36242702ffe7ffbfe82678c7e56320-79b28.jpg","srcSet":"/static/08-5e36242702ffe7ffbfe82678c7e56320-3d830.jpg 300w,\n/static/08-5e36242702ffe7ffbfe82678c7e56320-2ab78.jpg 600w,\n/static/08-5e36242702ffe7ffbfe82678c7e56320-79b28.jpg 1000w","srcWebp":"/static/08-5e36242702ffe7ffbfe82678c7e56320-161ff.webp","srcSetWebp":"/static/08-5e36242702ffe7ffbfe82678c7e56320-9fc06.webp 300w,\n/static/08-5e36242702ffe7ffbfe82678c7e56320-36f59.webp 600w,\n/static/08-5e36242702ffe7ffbfe82678c7e56320-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAQX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFtEdQ4cHBo3TpE4f/EABsQAAIDAQEBAAAAAAAAAAAAAAABAgMREhMi/9oACAEBAAEFAoiRhGaKrOkjkrjOJB/O2sTt32sP/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHRAAAgICAwEAAAAAAAAAAAAAAAECESExEiAiMv/aAAgBAQAGPwLs1CDd6bPkyqM8KL8mon//xAAdEAADAAICAwAAAAAAAAAAAAAAAREhQRBRMYGR/9oACAEBAAE/IcuTFXoS5vEYlRTWuC8kSs71kZsOiJ+gqJbSwdH2Z//aAAwDAQACAAMAAAAQQAA8/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHRABAAMBAAMBAQAAAAAAAAAAAQARITFBUZFhcf/aAAgBAQABPxDgEs9fICvEOrK0vqEaWAKeeOwBSknWP4lcwt/tQomVERq+2PAYsL3NocieSsGBUwt7Adniqyjyc/DexMDGbfb5P//Z","aspectRatio":0.6666666666666666,"src":"/static/09-18f5b0a3f634886e82b3bd2abe6cec72-79b28.jpg","srcSet":"/static/09-18f5b0a3f634886e82b3bd2abe6cec72-3d830.jpg 300w,\n/static/09-18f5b0a3f634886e82b3bd2abe6cec72-2ab78.jpg 600w,\n/static/09-18f5b0a3f634886e82b3bd2abe6cec72-79b28.jpg 1000w","srcWebp":"/static/09-18f5b0a3f634886e82b3bd2abe6cec72-161ff.webp","srcSetWebp":"/static/09-18f5b0a3f634886e82b3bd2abe6cec72-9fc06.webp 300w,\n/static/09-18f5b0a3f634886e82b3bd2abe6cec72-36f59.webp 600w,\n/static/09-18f5b0a3f634886e82b3bd2abe6cec72-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAQUAAAAAAAAAAAAAAAAAAAECAwQF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQIA/9oADAMBAAIQAxAAAAHdbCmzCuIFXSilIij/xAAdEAACAgEFAAAAAAAAAAAAAAABAgADEhEhIiMx/9oACAEBAAEFAo50HsFk2Ys7KUPVYMjlKW4gjEz/xAAXEQEAAwAAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/AWJr/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEQ/9oACAECAQE/AVTP/8QAHRAAAQQCAwAAAAAAAAAAAAAAAAECEBExURIhcf/aAAgBAQAGPwKL3FqcawM8G9IuoaYj/8QAHBAAAgMBAQEBAAAAAAAAAAAAAAERITFBYVGR/9oACAEBAAE/IUjGt/DKhiSi2/w4JQmlJYzjCdE3RMX5VLg8S78HQcgjQ11R/9oADAMBAAIAAwAAABCDEAz/xAAWEQADAAAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8QZD//xAAYEQEBAAMAAAAAAAAAAAAAAAABABARIf/aAAgBAgEBPxBcOjTDf//EAB4QAQADAAICAwAAAAAAAAAAAAEAESExQVFhcZGh/9oACAEBAAE/EMppA00hlRbOlFPmYFCtZT6jyOsMtvl/I8FIBVzjzBBGHsZLfuaAFm299dSgBoNQpcpGwJoxW6N6j+TmXzLLWD0T/9k=","aspectRatio":0.6666666666666666,"src":"/static/10-1e4acd45dd677996a3cba09329d9e0e1-79b28.jpg","srcSet":"/static/10-1e4acd45dd677996a3cba09329d9e0e1-3d830.jpg 300w,\n/static/10-1e4acd45dd677996a3cba09329d9e0e1-2ab78.jpg 600w,\n/static/10-1e4acd45dd677996a3cba09329d9e0e1-79b28.jpg 1000w","srcWebp":"/static/10-1e4acd45dd677996a3cba09329d9e0e1-161ff.webp","srcSetWebp":"/static/10-1e4acd45dd677996a3cba09329d9e0e1-9fc06.webp 300w,\n/static/10-1e4acd45dd677996a3cba09329d9e0e1-36f59.webp 600w,\n/static/10-1e4acd45dd677996a3cba09329d9e0e1-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQCBQb/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAF2OfeLAWD/xAAbEAACAgMBAAAAAAAAAAAAAAACAwABERIUBP/aAAgBAQABBQIfRsPQWewagliJdZGxVbf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAABBAMBAAAAAAAAAAAAAAAAAQIRITFBobH/2gAIAQEABj8ClsGC+CKhDt0V4f/EABoQAAMBAAMAAAAAAAAAAAAAAAABETEhQWH/2gAIAQEAAT8h0hNhggwLWG5D8ZAlqmnB7kSU7Rn/2gAMAwEAAgADAAAAEDDP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBABAAMAAgMAAAAAAAAAAAAAAQARITGRUWFx/9oACAEBAAE/EERAFiy9M31PSbFai7nh8hVhltohJD2Cc5fMBtWYp3P/2Q==","aspectRatio":1.4992503748125936,"src":"/static/burg-1-von-1-24-a9422c5397880cfec81969b5729af190-79b28.jpg","srcSet":"/static/burg-1-von-1-24-a9422c5397880cfec81969b5729af190-3d830.jpg 300w,\n/static/burg-1-von-1-24-a9422c5397880cfec81969b5729af190-2ab78.jpg 600w,\n/static/burg-1-von-1-24-a9422c5397880cfec81969b5729af190-79b28.jpg 1000w","srcWebp":"/static/burg-1-von-1-24-a9422c5397880cfec81969b5729af190-161ff.webp","srcSetWebp":"/static/burg-1-von-1-24-a9422c5397880cfec81969b5729af190-9fc06.webp 300w,\n/static/burg-1-von-1-24-a9422c5397880cfec81969b5729af190-36f59.webp 600w,\n/static/burg-1-von-1-24-a9422c5397880cfec81969b5729af190-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB6N05NRUP/8QAGRAAAgMBAAAAAAAAAAAAAAAAAAECEhMD/9oACAEBAAEFAl2NTeZYsxzkf//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABkQAAIDAQAAAAAAAAAAAAAAAAABEDEyM//aAAgBAQAGPwLDMM5ObP/EABoQAAIDAQEAAAAAAAAAAAAAAAABESGRMdH/2gAIAQEAAT8hbcjOPEcgJ3HdKOvRN0+I/9oADAMBAAIAAwAAABAQD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EAB8QAQACAgEFAQAAAAAAAAAAAAEAETFBIWGhscHR8P/aAAgBAQABPxBOieErEEsL4d5ZUJ1T7AMCmlxKmLuLfSUAR+NT/9k=","aspectRatio":1.4992503748125936,"src":"/static/burg-1-von-1-26-04f2d23dc14439e1e16c8632a5f72dc0-79b28.jpg","srcSet":"/static/burg-1-von-1-26-04f2d23dc14439e1e16c8632a5f72dc0-3d830.jpg 300w,\n/static/burg-1-von-1-26-04f2d23dc14439e1e16c8632a5f72dc0-2ab78.jpg 600w,\n/static/burg-1-von-1-26-04f2d23dc14439e1e16c8632a5f72dc0-79b28.jpg 1000w","srcWebp":"/static/burg-1-von-1-26-04f2d23dc14439e1e16c8632a5f72dc0-161ff.webp","srcSetWebp":"/static/burg-1-von-1-26-04f2d23dc14439e1e16c8632a5f72dc0-9fc06.webp 300w,\n/static/burg-1-von-1-26-04f2d23dc14439e1e16c8632a5f72dc0-36f59.webp 600w,\n/static/burg-1-von-1-26-04f2d23dc14439e1e16c8632a5f72dc0-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGgAAAgMBAQAAAAAAAAAAAAAAAAQCAwUBBv/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAdzuauPnngrZTmRKA//EABwQAAIDAAMBAAAAAAAAAAAAAAABAgMRBBASIf/aAAgBAQABBQLp2VbHkpl97Y2hM+OvNIuOSacPR//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABwQAAEFAAMAAAAAAAAAAAAAAAEAAhARIVGBof/aAAgBAQAGPwKNcFqoYJ1wHCtaPU0C+4//xAAcEAACAgMBAQAAAAAAAAAAAAAAAREhMVGhELH/2gAIAQEAAT8hXk8kmqFjhEdFuU6SBsZFAf0JvFA2NqxiJSKVZ//aAAwDAQACAAMAAAAQMMAw/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAIBABAAMAAgAHAAAAAAAAAAAAAQARITFhQVFxgZGx4f/aAAgBAQABPxAgUR2CZ0oeoQWODX0JbJENePugmYQN3JZmQDLtbWoOTDzi3Q73+RxZA1U+FVHT1dg4azPSFILHbU//2Q==","aspectRatio":0.6666666666666666,"src":"/static/burg-1-von-1-33-6664ac4ecabdc6533ae85f832880fc0a-79b28.jpg","srcSet":"/static/burg-1-von-1-33-6664ac4ecabdc6533ae85f832880fc0a-3d830.jpg 300w,\n/static/burg-1-von-1-33-6664ac4ecabdc6533ae85f832880fc0a-2ab78.jpg 600w,\n/static/burg-1-von-1-33-6664ac4ecabdc6533ae85f832880fc0a-79b28.jpg 1000w","srcWebp":"/static/burg-1-von-1-33-6664ac4ecabdc6533ae85f832880fc0a-161ff.webp","srcSetWebp":"/static/burg-1-von-1-33-6664ac4ecabdc6533ae85f832880fc0a-9fc06.webp 300w,\n/static/burg-1-von-1-33-6664ac4ecabdc6533ae85f832880fc0a-36f59.webp 600w,\n/static/burg-1-von-1-33-6664ac4ecabdc6533ae85f832880fc0a-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMBBAX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHKFtKZIf/EABoQAAICAwAAAAAAAAAAAAAAAAECAAMEEBL/2gAIAQEAAQUCqVwWLGuJZzHyC2v/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAdEAABBAIDAAAAAAAAAAAAAAACAAERIRASMnGB/9oACAEBAAY/AhcSjalcQNY4i/aoRHzH/8QAHBABAAICAwEAAAAAAAAAAAAAAQARMVEQIXGx/9oACAEBAAE/IRAYjf2Fg2NDha4OkCrzoW3uf//aAAwDAQACAAMAAAAQA8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAaEAEAAwADAAAAAAAAAAAAAAABABFBcZGh/9oACAEBAAE/EFvDegSCSWhBB0oiVsZTkWNeygw1JV5YqNldn//Z","aspectRatio":1.4992503748125936,"src":"/static/burg-1-von-1-38-0626713a8f643a1ff9f1cac7ee1e7bb7-79b28.jpg","srcSet":"/static/burg-1-von-1-38-0626713a8f643a1ff9f1cac7ee1e7bb7-3d830.jpg 300w,\n/static/burg-1-von-1-38-0626713a8f643a1ff9f1cac7ee1e7bb7-2ab78.jpg 600w,\n/static/burg-1-von-1-38-0626713a8f643a1ff9f1cac7ee1e7bb7-79b28.jpg 1000w","srcWebp":"/static/burg-1-von-1-38-0626713a8f643a1ff9f1cac7ee1e7bb7-161ff.webp","srcSetWebp":"/static/burg-1-von-1-38-0626713a8f643a1ff9f1cac7ee1e7bb7-9fc06.webp 300w,\n/static/burg-1-von-1-38-0626713a8f643a1ff9f1cac7ee1e7bb7-36f59.webp 600w,\n/static/burg-1-von-1-38-0626713a8f643a1ff9f1cac7ee1e7bb7-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAQL/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGBTMIzQ7W2giLg/8QAGhAAAwEBAQEAAAAAAAAAAAAAAAERAgMQEv/aAAgBAQABBQLhnMdYznlTXNEMSeKSpH0f/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHxAAAgEEAgMAAAAAAAAAAAAAAAECEBIhMREiQVGB/9oACAEBAAY/Arnocl5MnEnb9MTibH7roXVU/8QAHBABAAICAwEAAAAAAAAAAAAAAQARITFBUXGB/9oACAEBAAE/IakeQ+xP8KC3a5pSe+XkOApruo56QXHzMVKhNm0B0yRn/9oADAMBAAIAAwAAABBTBgD/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAfEAEBAAMAAQUBAAAAAAAAAAABEQAhMXFBUWGB4fH/2gAIAQEAAT8QcmiiMBE36aXFEFpUFj+TEVafXPe/4qPBRzDWvZr+sn0eLjbKLFgat+c2FmjWKvX6c5kdbXNRtbZvAuhDxn//2Q==","aspectRatio":0.6666666666666666,"src":"/static/burg-1-von-1-65-741d2bddcc369418ab4441a61632278e-79b28.jpg","srcSet":"/static/burg-1-von-1-65-741d2bddcc369418ab4441a61632278e-3d830.jpg 300w,\n/static/burg-1-von-1-65-741d2bddcc369418ab4441a61632278e-2ab78.jpg 600w,\n/static/burg-1-von-1-65-741d2bddcc369418ab4441a61632278e-79b28.jpg 1000w","srcWebp":"/static/burg-1-von-1-65-741d2bddcc369418ab4441a61632278e-161ff.webp","srcSetWebp":"/static/burg-1-von-1-65-741d2bddcc369418ab4441a61632278e-9fc06.webp 300w,\n/static/burg-1-von-1-65-741d2bddcc369418ab4441a61632278e-36f59.webp 600w,\n/static/burg-1-von-1-65-741d2bddcc369418ab4441a61632278e-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwAB/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABNMQCKP/EABkQAAMAAwAAAAAAAAAAAAAAAAECAwARFP/aAAgBAQABBQLnhiSUjnlkyaGh2j6Vv//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EAB0QAAICAQUAAAAAAAAAAAAAAAABAhEhAxIzUWH/2gAIAQEABj8Ct6pbk44rKOZCt9i8juKo/8QAGhAAAwEBAQEAAAAAAAAAAAAAAREhAEExYf/aAAgBAQABPyGSJnN01sA81ySVl0ZwAZZd1oEmJpwiPp3/2gAMAwEAAgADAAAAECMP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHhABAQACAQUBAAAAAAAAAAAAAREAMSFBYYGRofD/2gAIAQEAAT8QHbIpoKhqeMsEQiINR/ayDqYMH0YNTMiCJTmdsJ8wA9lk+ZQhAnMl6az/2Q==","aspectRatio":1.4992503748125936,"src":"/static/burg-1-von-1-69-b161ba5e894d4812dd957e2f6768f09d-79b28.jpg","srcSet":"/static/burg-1-von-1-69-b161ba5e894d4812dd957e2f6768f09d-3d830.jpg 300w,\n/static/burg-1-von-1-69-b161ba5e894d4812dd957e2f6768f09d-2ab78.jpg 600w,\n/static/burg-1-von-1-69-b161ba5e894d4812dd957e2f6768f09d-79b28.jpg 1000w","srcWebp":"/static/burg-1-von-1-69-b161ba5e894d4812dd957e2f6768f09d-161ff.webp","srcSetWebp":"/static/burg-1-von-1-69-b161ba5e894d4812dd957e2f6768f09d-9fc06.webp 300w,\n/static/burg-1-von-1-69-b161ba5e894d4812dd957e2f6768f09d-36f59.webp 600w,\n/static/burg-1-von-1-69-b161ba5e894d4812dd957e2f6768f09d-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAIEBQED/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABylrUlEDRn4pOeof/xAAbEAEAAgMBAQAAAAAAAAAAAAACAQMAEiETIv/aAAgBAQABBQKY+AdptMw69VhpkW2LZVICn1TyeTkDGe//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAcEAACAgMBAQAAAAAAAAAAAAAAARExAhIyQSD/2gAIAQEABj8C2NfWQN58UKebkkTtmSpPz5//xAAbEAADAQADAQAAAAAAAAAAAAAAAREhMUFRgf/aAAgBAQABPyF01U/OiWnIpo1tsHRUoxex3VGF4iGNowTXRsU8LEhXIiazM8EWuv6NeT//2gAMAwEAAgADAAAAELDBAP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB4QAQADAAEFAQAAAAAAAAAAAAEAESExQVFhcYHx/9oACAEBAAE/EH62RFtKLXsxKOiJxzVe9h7WwsbT2mrV5wbL5FmhzL+8fY7uXbiYOqRZZfiEBaCn9XiaCPWyJAAKGhHXk52LGiq6z//Z","aspectRatio":0.6666666666666666,"src":"/static/burg-1-von-1-75-2e49e7f5aca5e724a015ba9264c53ff8-79b28.jpg","srcSet":"/static/burg-1-von-1-75-2e49e7f5aca5e724a015ba9264c53ff8-3d830.jpg 300w,\n/static/burg-1-von-1-75-2e49e7f5aca5e724a015ba9264c53ff8-2ab78.jpg 600w,\n/static/burg-1-von-1-75-2e49e7f5aca5e724a015ba9264c53ff8-79b28.jpg 1000w","srcWebp":"/static/burg-1-von-1-75-2e49e7f5aca5e724a015ba9264c53ff8-161ff.webp","srcSetWebp":"/static/burg-1-von-1-75-2e49e7f5aca5e724a015ba9264c53ff8-9fc06.webp 300w,\n/static/burg-1-von-1-75-2e49e7f5aca5e724a015ba9264c53ff8-36f59.webp 600w,\n/static/burg-1-von-1-75-2e49e7f5aca5e724a015ba9264c53ff8-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAACA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAASYIgNco/8QAGhABAQACAwAAAAAAAAAAAAAAAQIDEhETIv/aAAgBAQABBQKYnTplLkK3UjN4Xl//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAADAAEFAAAAAAAAAAAAAAAAARECEkFRkaH/2gAIAQEABj8Cb34G34RMlfZpWGJT/8QAGxABAAMBAQEBAAAAAAAAAAAAAQARIUFRMWH/2gAIAQEAAT8hyQ3QuwtQq5zN0w9yJ6/S03F4k+pcZF3yf//aAAwDAQACAAMAAAAQwM//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAdEAEAAwACAwEAAAAAAAAAAAABABEhcYExQVGR/9oACAEBAAE/EKUQO2wfGbvQRwd37iQADdL4j8BfiHMuGACl7XUoYFWgo/J//9k=","aspectRatio":1.4992503748125936,"src":"/static/f-l-1-von-1-26-1a13c34f90a2781621bcd98d91e7f025-79b28.jpg","srcSet":"/static/f-l-1-von-1-26-1a13c34f90a2781621bcd98d91e7f025-3d830.jpg 300w,\n/static/f-l-1-von-1-26-1a13c34f90a2781621bcd98d91e7f025-2ab78.jpg 600w,\n/static/f-l-1-von-1-26-1a13c34f90a2781621bcd98d91e7f025-79b28.jpg 1000w","srcWebp":"/static/f-l-1-von-1-26-1a13c34f90a2781621bcd98d91e7f025-161ff.webp","srcSetWebp":"/static/f-l-1-von-1-26-1a13c34f90a2781621bcd98d91e7f025-9fc06.webp 300w,\n/static/f-l-1-von-1-26-1a13c34f90a2781621bcd98d91e7f025-36f59.webp 600w,\n/static/f-l-1-von-1-26-1a13c34f90a2781621bcd98d91e7f025-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAAD/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABFuBhhNj/xAAaEAABBQEAAAAAAAAAAAAAAAACAAEDBBET/9oACAEBAAEFAoyxHsiaHWGwYqOx0MrhM/8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHRAAAQQCAwAAAAAAAAAAAAAAAAERITECkSJhof/aAAgBAQAGPwKMvBHSui2IbRyTSsUf/8QAGxABAAICAwAAAAAAAAAAAAAAAQARIVExQaH/2gAIAQEAAT8hQbG0e0r5dMKpSKlpJxqTZO9vCMPc/9oADAMBAAIAAwAAABCwz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EAB0QAQACAwADAQAAAAAAAAAAAAERIQAxQWFxobH/2gAIAQEAAT8QZMrQC3Ss7xgwCd6LydLG/JgYe7GfmCLUjlPGsK6g1N/zP//Z","aspectRatio":1.4992503748125936,"src":"/static/f-l-1-von-1-27-3786a8a7104e2e70ee363e5a68badae1-79b28.jpg","srcSet":"/static/f-l-1-von-1-27-3786a8a7104e2e70ee363e5a68badae1-3d830.jpg 300w,\n/static/f-l-1-von-1-27-3786a8a7104e2e70ee363e5a68badae1-2ab78.jpg 600w,\n/static/f-l-1-von-1-27-3786a8a7104e2e70ee363e5a68badae1-79b28.jpg 1000w","srcWebp":"/static/f-l-1-von-1-27-3786a8a7104e2e70ee363e5a68badae1-161ff.webp","srcSetWebp":"/static/f-l-1-von-1-27-3786a8a7104e2e70ee363e5a68badae1-9fc06.webp 300w,\n/static/f-l-1-von-1-27-3786a8a7104e2e70ee363e5a68badae1-36f59.webp 600w,\n/static/f-l-1-von-1-27-3786a8a7104e2e70ee363e5a68badae1-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}}]},"wedding":{"edges":[{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAUBAwT/xAAWAQEBAQAAAAAAAAAAAAAAAAADAAH/2gAMAwEAAhADEAAAAWmShiahBZ//xAAbEAACAwADAAAAAAAAAAAAAAAAEgECAwQRIv/aAAgBAQABBQKL++Rk2imMsTbsY//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/AQn/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPwFZ/8QAGRAAAwADAAAAAAAAAAAAAAAAABARARJR/9oACAEBAAY/AtS9VML/xAAaEAEAAwADAAAAAAAAAAAAAAABABEhMVGR/9oACAEBAAE/IRBTK1lL6SgAcBE2xJcT1GP/2gAMAwEAAgADAAAAEDMf/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERQf/aAAgBAwEBPxBGEZ//xAAXEQEAAwAAAAAAAAAAAAAAAAAAASFB/9oACAECAQE/EJNU/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARITFBcf/aAAgBAQABPxAHDtCzLMAIhegAS3Sxa+rrEIGWPsYeT//Z","aspectRatio":1.4992503748125936,"src":"/static/1-82dde6eacdd07c2680bcc91d6c4337a6-79b28.jpg","srcSet":"/static/1-82dde6eacdd07c2680bcc91d6c4337a6-3d830.jpg 300w,\n/static/1-82dde6eacdd07c2680bcc91d6c4337a6-2ab78.jpg 600w,\n/static/1-82dde6eacdd07c2680bcc91d6c4337a6-79b28.jpg 1000w","srcWebp":"/static/1-82dde6eacdd07c2680bcc91d6c4337a6-161ff.webp","srcSetWebp":"/static/1-82dde6eacdd07c2680bcc91d6c4337a6-9fc06.webp 300w,\n/static/1-82dde6eacdd07c2680bcc91d6c4337a6-36f59.webp 600w,\n/static/1-82dde6eacdd07c2680bcc91d6c4337a6-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBf/EABcBAAMBAAAAAAAAAAAAAAAAAAECAwT/2gAMAwEAAhADEAAAAdaaRz0BhD//xAAbEAACAgMBAAAAAAAAAAAAAAABAgAhERITMf/aAAgBAQABBQJUwD7x2iCkNGf/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPwEn/8QAFhEBAQEAAAAAAAAAAAAAAAAAABIh/9oACAECAQE/AaxT/8QAHBAAAQMFAAAAAAAAAAAAAAAAAAEhMRAREkGR/9oACAEBAAY/ApFxcurG+0g//8QAGhABAAIDAQAAAAAAAAAAAAAAAQARITFBkf/aAAgBAQABPyHufI7BWCCN63gSjbSFC9MDELmzP//aAAwDAQACAAMAAAAQB/8A/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARIf/aAAgBAwEBPxAOydv/xAAXEQEBAQEAAAAAAAAAAAAAAAABABEh/9oACAECAQE/EAvUocv/xAAcEAEAAwADAQEAAAAAAAAAAAABABEhMUGRYbH/2gAIAQEAAT8Q7qz4iC29bnkEckiUesCwdMWsyUtF1Bwd/suhUc2z/9k=","aspectRatio":1.4992503748125936,"src":"/static/10-3c37c7ffbad69861f0ca7236e374fc58-79b28.jpg","srcSet":"/static/10-3c37c7ffbad69861f0ca7236e374fc58-3d830.jpg 300w,\n/static/10-3c37c7ffbad69861f0ca7236e374fc58-2ab78.jpg 600w,\n/static/10-3c37c7ffbad69861f0ca7236e374fc58-79b28.jpg 1000w","srcWebp":"/static/10-3c37c7ffbad69861f0ca7236e374fc58-161ff.webp","srcSetWebp":"/static/10-3c37c7ffbad69861f0ca7236e374fc58-9fc06.webp 300w,\n/static/10-3c37c7ffbad69861f0ca7236e374fc58-36f59.webp 600w,\n/static/10-3c37c7ffbad69861f0ca7236e374fc58-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwQA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAbkhomnwZP/EABsQAAIBBQAAAAAAAAAAAAAAAAECAwAQEyEy/9oACAEBAAEFAl0AwsshxR8V/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGRAAAwADAAAAAAAAAAAAAAAAABAhUYGR/9oACAEBAAY/Ar0yRaX/xAAaEAEBAQADAQAAAAAAAAAAAAABEQAhMUFR/9oACAEBAAE/IT2ineUg5TzxlD7olnM6UFXf/9oADAMBAAIAAwAAABC87//EABcRAAMBAAAAAAAAAAAAAAAAAAABESH/2gAIAQMBAT8Qqa0h/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERIf/aAAgBAgEBPxBKPCn/xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhMUFRYXH/2gAIAQEAAT8QSpwAHD0xmLKlekKNPECiNFZCrfstVdMvwm8BL3P/2Q==","aspectRatio":1.4992503748125936,"src":"/static/12-26-7dec8d21abe75c21fbc01c82b4c2cb70-79b28.jpg","srcSet":"/static/12-26-7dec8d21abe75c21fbc01c82b4c2cb70-3d830.jpg 300w,\n/static/12-26-7dec8d21abe75c21fbc01c82b4c2cb70-2ab78.jpg 600w,\n/static/12-26-7dec8d21abe75c21fbc01c82b4c2cb70-79b28.jpg 1000w","srcWebp":"/static/12-26-7dec8d21abe75c21fbc01c82b4c2cb70-161ff.webp","srcSetWebp":"/static/12-26-7dec8d21abe75c21fbc01c82b4c2cb70-9fc06.webp 300w,\n/static/12-26-7dec8d21abe75c21fbc01c82b4c2cb70-36f59.webp 600w,\n/static/12-26-7dec8d21abe75c21fbc01c82b4c2cb70-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAABA//EABYBAQEBAAAAAAAAAAAAAAAAAAABA//aAAwDAQACEAMQAAAB1h0Z01zj/8QAGRAAAwEBAQAAAAAAAAAAAAAAAQIRAAMh/9oACAEBAAEFAkEUpAZuQzC5+Xv/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAWEQEBAQAAAAAAAAAAAAAAAAAAARL/2gAIAQIBAT8BjL//xAAdEAABAwUBAAAAAAAAAAAAAAAAAQIRECExQmFx/9oACAEBAAY/AsIvpMMNaL0s4//EABsQAQADAAMBAAAAAAAAAAAAAAEAESExQVGR/9oACAEBAAE/ISEtQNIK5sjDx8wXXaclLT6Op3QPJ//aAAwDAQACAAMAAAAQXN//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPxBX/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERUf/aAAgBAgEBPxBKqytP/8QAHRABAAICAwEBAAAAAAAAAAAAAQARITFBUWGBof/aAAgBAQABPxBq6y8tx8ioIA9477lNUxhprzyUOMCOk5hIa9lz+R6qIvC6/Z//2Q==","aspectRatio":1.4992503748125936,"src":"/static/12-27-7737167c0e225886a64cf858a9c10ce7-79b28.jpg","srcSet":"/static/12-27-7737167c0e225886a64cf858a9c10ce7-3d830.jpg 300w,\n/static/12-27-7737167c0e225886a64cf858a9c10ce7-2ab78.jpg 600w,\n/static/12-27-7737167c0e225886a64cf858a9c10ce7-79b28.jpg 1000w","srcWebp":"/static/12-27-7737167c0e225886a64cf858a9c10ce7-161ff.webp","srcSetWebp":"/static/12-27-7737167c0e225886a64cf858a9c10ce7-9fc06.webp 300w,\n/static/12-27-7737167c0e225886a64cf858a9c10ce7-36f59.webp 600w,\n/static/12-27-7737167c0e225886a64cf858a9c10ce7-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMFBAb/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGYvoUmIqBI6GDtN4kP/8QAHBAAAgIDAQEAAAAAAAAAAAAAAgMAAQQSExAh/9oACAEBAAEFAiCx8HFYQi7eyQNmYuskXfWbVEP4zJfrF/R//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAIBAAAQIFBQAAAAAAAAAAAAAAAQARAhASIWEiMTJBUf/aAAgBAQAGPwIuDIRBrpqWUJs3Y9WillCMysCuAOUKRuHl/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFBEKH/2gAIAQEAAT8hSAqd147BBdLHtoVuEqoyGo+wbKTuuuxrmDpAsIDpDDsbtmYOEweT/9oADAMBAAIAAwAAABADAQz/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAgEAEBAAIBAwUAAAAAAAAAAAABEQAhMVFhwRBBcYGR/9oACAEBAAE/EAoDCnP30moAUJ86y2cVoZ9e5hzLIKpbpODtj1lAFK47cg04GAgIGwNJ4whSkhRwSGK2DOmXJCaXo+cNBw092c5//9k=","aspectRatio":0.6666666666666666,"src":"/static/12-35-5ca8871817569cf2b265d8c4db01f0b6-79b28.jpg","srcSet":"/static/12-35-5ca8871817569cf2b265d8c4db01f0b6-3d830.jpg 300w,\n/static/12-35-5ca8871817569cf2b265d8c4db01f0b6-2ab78.jpg 600w,\n/static/12-35-5ca8871817569cf2b265d8c4db01f0b6-79b28.jpg 1000w","srcWebp":"/static/12-35-5ca8871817569cf2b265d8c4db01f0b6-161ff.webp","srcSetWebp":"/static/12-35-5ca8871817569cf2b265d8c4db01f0b6-9fc06.webp 300w,\n/static/12-35-5ca8871817569cf2b265d8c4db01f0b6-36f59.webp 600w,\n/static/12-35-5ca8871817569cf2b265d8c4db01f0b6-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAAF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAHNcZ2aWHH/xAAZEAADAAMAAAAAAAAAAAAAAAABAgMAEjL/2gAIAQEAAQUCCljSBWaW1Ee7VKvn/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQIBAT8BR//EABsQAAIBBQAAAAAAAAAAAAAAAAABEQIQMVFx/9oACAEBAAY/AoROiBdHSsNW/8QAGRABAAMBAQAAAAAAAAAAAAAAAQAhMRFB/9oACAEBAAE/ITAdXIJq7eQWB6sdMF4WGLeT/9oADAMBAAIAAwAAABBjD//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/EFf/xAAWEQEBAQAAAAAAAAAAAAAAAAARARD/2gAIAQIBAT8QG5//xAAcEAEAAgIDAQAAAAAAAAAAAAABACERQTFRYYH/2gAIAQEAAT8Q0gwzzDxXyrW68YBEElG30luMmG7JgWTkLa7h8CfZ/9k=","aspectRatio":1.4992503748125936,"src":"/static/12-36-b12df7f9cd99b0ce80ee28ad39c50fed-79b28.jpg","srcSet":"/static/12-36-b12df7f9cd99b0ce80ee28ad39c50fed-3d830.jpg 300w,\n/static/12-36-b12df7f9cd99b0ce80ee28ad39c50fed-2ab78.jpg 600w,\n/static/12-36-b12df7f9cd99b0ce80ee28ad39c50fed-79b28.jpg 1000w","srcWebp":"/static/12-36-b12df7f9cd99b0ce80ee28ad39c50fed-161ff.webp","srcSetWebp":"/static/12-36-b12df7f9cd99b0ce80ee28ad39c50fed-9fc06.webp 300w,\n/static/12-36-b12df7f9cd99b0ce80ee28ad39c50fed-36f59.webp 600w,\n/static/12-36-b12df7f9cd99b0ce80ee28ad39c50fed-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAf/EABYBAQEBAAAAAAAAAAAAAAAAAAECA//aAAwDAQACEAMQAAABe1dGbCYS/wD/xAAaEAADAQADAAAAAAAAAAAAAAABAgMSESIx/9oACAEBAAEFAo5Zn9ZADDqusyavJ//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/AUf/xAAWEQEBAQAAAAAAAAAAAAAAAAAAESH/2gAIAQIBAT8BjX//xAAeEAABAwQDAAAAAAAAAAAAAAABACExAgMQEhFBcf/aAAgBAQAGPwK3oXAdlvT2FPPqYKIx/8QAHBAAAgIDAQEAAAAAAAAAAAAAAREAITFBUYGR/9oACAEBAAE/IcaaDiEEuCBUNwnZ2hDBRNhfsIxEez//2gAMAwEAAgADAAAAEAwv/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8Qg//EABYRAAMAAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPxCGij//xAAeEAEAAgEEAwAAAAAAAAAAAAABACERMVFxkUGh8P/aAAgBAQABPxBrCoVmm/JNWD5dDp9xCorwlV1FqBKDOfcaE7ppdRDwhWf/2Q==","aspectRatio":1.4992503748125936,"src":"/static/12-16704c45cd17af58baf25e3355cbba04-79b28.jpg","srcSet":"/static/12-16704c45cd17af58baf25e3355cbba04-3d830.jpg 300w,\n/static/12-16704c45cd17af58baf25e3355cbba04-2ab78.jpg 600w,\n/static/12-16704c45cd17af58baf25e3355cbba04-79b28.jpg 1000w","srcWebp":"/static/12-16704c45cd17af58baf25e3355cbba04-161ff.webp","srcSetWebp":"/static/12-16704c45cd17af58baf25e3355cbba04-9fc06.webp 300w,\n/static/12-16704c45cd17af58baf25e3355cbba04-36f59.webp 600w,\n/static/12-16704c45cd17af58baf25e3355cbba04-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAYE/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABxU8dRGgH/8QAGhAAAwADAQAAAAAAAAAAAAAAAQIDABEiMv/aAAgBAQABBQKTBSG3lPWJLRqev//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABwQAAEEAwEAAAAAAAAAAAAAAAECEBEhABJBcf/aAAgBAQAGPwJN+4II1LhE1xv/xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhQRAxUWH/2gAIAQEAAT8hvMGdIKSQw33MxjXvB31DfxueE6n/2gAMAwEAAgADAAAAEEPP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBAAAgIDAQEAAAAAAAAAAAAAAREAITFBUXGR/9oACAEBAAE/EE9LsWr3UpSgcmlDJhsvGzMQmC0bB1fOxCCgMif/2Q==","aspectRatio":1.4992503748125936,"src":"/static/163-67fe557e2daf310f96d389425c18cde6-79b28.jpg","srcSet":"/static/163-67fe557e2daf310f96d389425c18cde6-3d830.jpg 300w,\n/static/163-67fe557e2daf310f96d389425c18cde6-2ab78.jpg 600w,\n/static/163-67fe557e2daf310f96d389425c18cde6-79b28.jpg 1000w","srcWebp":"/static/163-67fe557e2daf310f96d389425c18cde6-161ff.webp","srcSetWebp":"/static/163-67fe557e2daf310f96d389425c18cde6-9fc06.webp 300w,\n/static/163-67fe557e2daf310f96d389425c18cde6-36f59.webp 600w,\n/static/163-67fe557e2daf310f96d389425c18cde6-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAapTOZhw/8QAGhAAAgMBAQAAAAAAAAAAAAAAAgMAAQQRIv/aAAgBAQABBQJefseNMqsZlM7DOKv0byov/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGBAAAwEBAAAAAAAAAAAAAAAAAAEhEQL/2gAIAQEABj8CkSJWoanyLWdbSH//xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhQTFRYYH/2gAIAQEAAT8hsWHWixQHT2HYC+44Lyd2Dz9iwWPZ/9oADAMBAAIAAwAAABCDz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EACAQAQACAQIHAAAAAAAAAAAAAAEAESExwUFRYXGBkbH/2gAIAQEAAT8QJQkUtVrIdLlsWwKK/XKK8qFNUrxGRpR7xvE4ostWqbSroO6f/9k=","aspectRatio":1.4992503748125936,"src":"/static/2.0-d8ae8583e0e2e9fd84f0bb2481a7ea39-79b28.jpg","srcSet":"/static/2.0-d8ae8583e0e2e9fd84f0bb2481a7ea39-3d830.jpg 300w,\n/static/2.0-d8ae8583e0e2e9fd84f0bb2481a7ea39-2ab78.jpg 600w,\n/static/2.0-d8ae8583e0e2e9fd84f0bb2481a7ea39-79b28.jpg 1000w","srcWebp":"/static/2.0-d8ae8583e0e2e9fd84f0bb2481a7ea39-161ff.webp","srcSetWebp":"/static/2.0-d8ae8583e0e2e9fd84f0bb2481a7ea39-9fc06.webp 300w,\n/static/2.0-d8ae8583e0e2e9fd84f0bb2481a7ea39-36f59.webp 600w,\n/static/2.0-d8ae8583e0e2e9fd84f0bb2481a7ea39-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAQL/xAAVAQEBAAAAAAAAAAAAAAAAAAABA//aAAwDAQACEAMQAAABa2NdnRc5E//EABsQAQEAAQUAAAAAAAAAAAAAAAIDAQAEERMh/9oACAEBAAEFAgiaufqhzmbXYc63F2Kf/8QAFxEBAAMAAAAAAAAAAAAAAAAAAAEhUf/aAAgBAwEBPwGNW//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/AWf/xAAbEAABBQEBAAAAAAAAAAAAAAAAAQIRITFRcf/aAAgBAQAGPwJK09KGrwlSGxh//8QAGxAAAgIDAQAAAAAAAAAAAAAAAREAMSFBYaH/2gAIAQEAAT8hWJIfeQhWiW5nadjwL0hCshIuUqJYn//aAAwDAQACAAMAAAAQjB//xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAIAQMBAT8QQaIZ/8QAFhEBAQEAAAAAAAAAAAAAAAAAAREA/9oACAECAQE/EBYOhv/EABoQAQACAwEAAAAAAAAAAAAAAAEAESExQWH/2gAIAQEAAT8QPbjSi17By9sPUyCL25yigeoJini6F7L+ZS3JgMKbG5//2Q==","aspectRatio":1.4992503748125936,"src":"/static/2.1-321a4aa952ae6d8511ad539b8d5092aa-79b28.jpg","srcSet":"/static/2.1-321a4aa952ae6d8511ad539b8d5092aa-3d830.jpg 300w,\n/static/2.1-321a4aa952ae6d8511ad539b8d5092aa-2ab78.jpg 600w,\n/static/2.1-321a4aa952ae6d8511ad539b8d5092aa-79b28.jpg 1000w","srcWebp":"/static/2.1-321a4aa952ae6d8511ad539b8d5092aa-161ff.webp","srcSetWebp":"/static/2.1-321a4aa952ae6d8511ad539b8d5092aa-9fc06.webp 300w,\n/static/2.1-321a4aa952ae6d8511ad539b8d5092aa-36f59.webp 600w,\n/static/2.1-321a4aa952ae6d8511ad539b8d5092aa-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAYE/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAcdPG0UaQf/EABsQAAICAwEAAAAAAAAAAAAAAAEDAAIREiIx/9oACAEBAAEFAlXFSLZjPYtWpaev/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHBAAAQMFAAAAAAAAAAAAAAAAAQIQIQAREkFx/9oACAEBAAY/Akz2gQRiXCLxpv/EABwQAQACAgMBAAAAAAAAAAAAAAEAESExEEFRYf/aAAgBAQABPyG4wZ6QWgDDe5mcde8BZUN/E8Jqf//aAAwDAQACAAMAAAAQHD//xAAVEQEBAAAAAAAAAAAAAAAAAAAxEP/aAAgBAwEBPxBZ/8QAFREBAQAAAAAAAAAAAAAAAAAAEDH/2gAIAQIBAT8Qh//EABsQAAIDAQEBAAAAAAAAAAAAAAERACExQYGh/9oACAEBAAE/EEZLsXC5fJSCw6cUJ42X6MyFoWiYR0Dx7CBBQGif/9k=","aspectRatio":1.4992503748125936,"src":"/static/3-bc462779ad3be3c0b8634f091c3a11e3-79b28.jpg","srcSet":"/static/3-bc462779ad3be3c0b8634f091c3a11e3-3d830.jpg 300w,\n/static/3-bc462779ad3be3c0b8634f091c3a11e3-2ab78.jpg 600w,\n/static/3-bc462779ad3be3c0b8634f091c3a11e3-79b28.jpg 1000w","srcWebp":"/static/3-bc462779ad3be3c0b8634f091c3a11e3-161ff.webp","srcSetWebp":"/static/3-bc462779ad3be3c0b8634f091c3a11e3-9fc06.webp 300w,\n/static/3-bc462779ad3be3c0b8634f091c3a11e3-36f59.webp 600w,\n/static/3-bc462779ad3be3c0b8634f091c3a11e3-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFA//EABYBAQEBAAAAAAAAAAAAAAAAAAIBA//aAAwDAQACEAMQAAABbwdWzWBmM3ZT8s2cUCT/xAAeEAACAgICAwAAAAAAAAAAAAACAwABERIEEyEjMf/aAAgBAQABBQKwJhswmDoyEPs5A+O3E+U1dlDzRbRjtTC26//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAwEBPwFqxj//xAAZEQEAAgMAAAAAAAAAAAAAAAAAARMCETH/2gAIAQIBAT8BVoy1xY//xAAhEAACAQIGAwAAAAAAAAAAAAAAARESMgIQISIxURNhkf/aAAgBAQAGPwLc1p2WpuSrx/CUtOyqovj1GW58M4eWNNSmXn//xAAdEAEAAgMBAAMAAAAAAAAAAAABABEhMUFhUYGR/9oACAEBAAE/IQtA5Obqbp4bkYqo34iJwXDDRqTONwroZ+EjoiGz6CoKlByaHkCtbm5R4fk//9oADAMBAAIAAwAAABAc27L/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREhUf/aAAgBAwEBPxBJJUnhgQf/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREhYf/aAAgBAgEBPxDpT2jcBy9P/8QAHxABAQACAgMAAwAAAAAAAAAAAREAITFBUWFxgZHB/9oACAEBAAE/EKBlWmgsOJ4wPfJULOnoy9sYiRfh3jfAVbYTYnv+ZYk1AEjh514x+wIqh7fOBrcuVL1NUbo/Pzi7slDs8nrInuq8ZBhMPQyEOuTWFGQECGH6z//Z","aspectRatio":0.6666666666666666,"src":"/static/4-1fb98e01db0a28d7ca97c9020d6b046c-79b28.jpg","srcSet":"/static/4-1fb98e01db0a28d7ca97c9020d6b046c-3d830.jpg 300w,\n/static/4-1fb98e01db0a28d7ca97c9020d6b046c-2ab78.jpg 600w,\n/static/4-1fb98e01db0a28d7ca97c9020d6b046c-79b28.jpg 1000w","srcWebp":"/static/4-1fb98e01db0a28d7ca97c9020d6b046c-161ff.webp","srcSetWebp":"/static/4-1fb98e01db0a28d7ca97c9020d6b046c-9fc06.webp 300w,\n/static/4-1fb98e01db0a28d7ca97c9020d6b046c-36f59.webp 600w,\n/static/4-1fb98e01db0a28d7ca97c9020d6b046c-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAUCAwT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAA//aAAwDAQACEAMQAAABnYoaztjAP//EABsQAQEAAQUAAAAAAAAAAAAAAAIBEQADISIx/9oACAEBAAEFAj4MxUqU8ak67hyv/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAISAf/aAAgBAwEBPwFVojT/xAAWEQADAAAAAAAAAAAAAAAAAAAAARH/2gAIAQIBAT8BbhT/xAAcEAACAQUBAAAAAAAAAAAAAAAAARECEBMhMZH/2gAIAQEABj8CcVJyY3xo3Htls6z/xAAaEAEAAwEBAQAAAAAAAAAAAAABABEhQTFh/9oACAEBAAE/IV6aRRgc2psexANv2kyvs3LXUS1af//aAAwDAQACAAMAAAAQ6C//xAAXEQEBAQEAAAAAAAAAAAAAAAABABFB/9oACAEDAQE/EF6knL//xAAXEQEAAwAAAAAAAAAAAAAAAAAAARFR/9oACAECAQE/EMCLP//EABsQAQADAQEBAQAAAAAAAAAAAAEAETEhQVFh/9oACAEBAAE/EGpOYqq9zIPUuxuxfHzJzZPqLPhEoFs7E/DjfSJGieqz/9k=","aspectRatio":1.4992503748125936,"src":"/static/48-5d5822a91011bcdecb134e3d893dded3-79b28.jpg","srcSet":"/static/48-5d5822a91011bcdecb134e3d893dded3-3d830.jpg 300w,\n/static/48-5d5822a91011bcdecb134e3d893dded3-2ab78.jpg 600w,\n/static/48-5d5822a91011bcdecb134e3d893dded3-79b28.jpg 1000w","srcWebp":"/static/48-5d5822a91011bcdecb134e3d893dded3-161ff.webp","srcSetWebp":"/static/48-5d5822a91011bcdecb134e3d893dded3-9fc06.webp 300w,\n/static/48-5d5822a91011bcdecb134e3d893dded3-36f59.webp 600w,\n/static/48-5d5822a91011bcdecb134e3d893dded3-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQCAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAACAAP/2gAMAwEAAhADEAAAAdSlJnFzEwX/xAAZEAACAwEAAAAAAAAAAAAAAAABAgMRIxL/2gAIAQEAAQUCdgAsQtu7lOiNmzG//8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8BR//EABgRAAIDAAAAAAAAAAAAAAAAAAACERIh/9oACAECAQE/AZwsx//EABsQAAIBBQAAAAAAAAAAAAAAAAABMRASITNh/9oACAEBAAY/AsuYL4ZsYlyv/8QAGxAAAwADAQEAAAAAAAAAAAAAAAERITFRQXH/2gAIAQEAAT8hR0m+hByRrhyvwa0sXYmkUxTmH//aAAwDAQACAAMAAAAQX9//xAAXEQEAAwAAAAAAAAAAAAAAAAAAESEx/9oACAEDAQE/ENpB/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERYf/aAAgBAgEBPxBxRof/xAAdEAEAAgMAAwEAAAAAAAAAAAABABEhMUFRYYGx/9oACAEBAAE/EChMQytjluRQilNksSGeID8ji3e9kB54jCCiVaV9T4/pP//Z","aspectRatio":1.4992503748125936,"src":"/static/5-9010dd29dc79bf6eb6c10b031714fae7-79b28.jpg","srcSet":"/static/5-9010dd29dc79bf6eb6c10b031714fae7-3d830.jpg 300w,\n/static/5-9010dd29dc79bf6eb6c10b031714fae7-2ab78.jpg 600w,\n/static/5-9010dd29dc79bf6eb6c10b031714fae7-79b28.jpg 1000w","srcWebp":"/static/5-9010dd29dc79bf6eb6c10b031714fae7-161ff.webp","srcSetWebp":"/static/5-9010dd29dc79bf6eb6c10b031714fae7-9fc06.webp 300w,\n/static/5-9010dd29dc79bf6eb6c10b031714fae7-36f59.webp 600w,\n/static/5-9010dd29dc79bf6eb6c10b031714fae7-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMFAgT/xAAUAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHCLM4UnaD/AP/EABsQAAEEAwAAAAAAAAAAAAAAAAIBAxITAAQz/9oACAEBAAEFAqIm+xTlaEOzxB+YjFE//8QAFhEBAQEAAAAAAAAAAAAAAAAAABES/9oACAEDAQE/AYy//8QAFhEBAQEAAAAAAAAAAAAAAAAAABES/9oACAECAQE/Aa0//8QAHBAAAgICAwAAAAAAAAAAAAAAAQIAIQNhERIx/9oACAEBAAY/Amxmt6nvIMU6ncUVuFWUGUs//8QAHhABAAICAQUAAAAAAAAAAAAAAQARIVExQWFxkaH/2gAIAQEAAT8htgZMeaIrAqjZAEPaFunDNfI4nde8QSg1c//aAAwDAQACAAMAAAAQqA//xAAXEQEBAQEAAAAAAAAAAAAAAAABABEh/9oACAEDAQE/EAPIeX//xAAWEQEBAQAAAAAAAAAAAAAAAAABACH/2gAIAQIBAT8QUbJW/8QAHxABAQACAgEFAAAAAAAAAAAAAREAITFBcVFhgZGh/9oACAEBAAE/ECTBmNGKPnUz2hGCcx9fJlIDya5rgQa9A0dO3TfzLN3pIfDpzSj7DZ95/9k=","aspectRatio":1.4992503748125936,"src":"/static/6-ba926d1b30045fa287cdd593e68fc741-79b28.jpg","srcSet":"/static/6-ba926d1b30045fa287cdd593e68fc741-3d830.jpg 300w,\n/static/6-ba926d1b30045fa287cdd593e68fc741-2ab78.jpg 600w,\n/static/6-ba926d1b30045fa287cdd593e68fc741-79b28.jpg 1000w","srcWebp":"/static/6-ba926d1b30045fa287cdd593e68fc741-161ff.webp","srcSetWebp":"/static/6-ba926d1b30045fa287cdd593e68fc741-9fc06.webp 300w,\n/static/6-ba926d1b30045fa287cdd593e68fc741-36f59.webp 600w,\n/static/6-ba926d1b30045fa287cdd593e68fc741-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABQAEA//EABYBAQEBAAAAAAAAAAAAAAAAAAIBAP/aAAwDAQACEAMQAAAB6pDNlZ7TUhpCai2Yi0//xAAeEAACAgEFAQAAAAAAAAAAAAACAwABEwQQESEjMf/aAAgBAQABBQJbWZj7grGJPifdtGyggF6RabOju6POc//EABcRAAMBAAAAAAAAAAAAAAAAAAABERD/2gAIAQMBAT8BayEP/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEQEf/aAAgBAgEBPwGNmn//xAAfEAACAgEEAwAAAAAAAAAAAAABEQACMRASIXEiQWH/2gAIAQEABj8CVujWKYfc3VBss/NTUlOGoPiuNGDM8z1P/8QAHRAAAwACAgMAAAAAAAAAAAAAAAERITFBUXGBof/aAAgBAQABPyF9bXYX1Cbk5NiKzk5D2XdHgaXscGyJMqyKA80FhOFeUJslV1gjhtvR/9oADAMBAAIAAwAAABAEFs3/xAAXEQEBAQEAAAAAAAAAAAAAAAABABEQ/9oACAEDAQE/EAEyWNc//8QAGBEBAQADAAAAAAAAAAAAAAAAAQAQESH/2gAIAQIBAT8QFTsWjH//xAAhEAEAAgEEAQUAAAAAAAAAAAABABEhMUFRccFhgZHh8P/aAAgBAQABPxBr8mEg8h5gWKFqta7EX0pXRbx4iZPNrH5v4ggnIBIFXU1hT6izZ9oFQ49Meg7kSqlNPwjNColB2o7mvHy/ef/Z","aspectRatio":0.6666666666666666,"src":"/static/7-801fbf2e8bf8ec41742674c4b81e06c1-79b28.jpg","srcSet":"/static/7-801fbf2e8bf8ec41742674c4b81e06c1-3d830.jpg 300w,\n/static/7-801fbf2e8bf8ec41742674c4b81e06c1-2ab78.jpg 600w,\n/static/7-801fbf2e8bf8ec41742674c4b81e06c1-79b28.jpg 1000w","srcWebp":"/static/7-801fbf2e8bf8ec41742674c4b81e06c1-161ff.webp","srcSetWebp":"/static/7-801fbf2e8bf8ec41742674c4b81e06c1-9fc06.webp 300w,\n/static/7-801fbf2e8bf8ec41742674c4b81e06c1-36f59.webp 600w,\n/static/7-801fbf2e8bf8ec41742674c4b81e06c1-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAgP/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAgP/2gAMAwEAAhADEAAAAbSK/bOtE0P/xAAYEAADAQEAAAAAAAAAAAAAAAACAxEBEv/aAAgBAQABBQLsZc0yYmsyALqtnJl//8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/AZGP/8QAFhEBAQEAAAAAAAAAAAAAAAAAEQEQ/9oACAECAQE/AVjn/8QAGxABAAICAwAAAAAAAAAAAAAAAQACESExUnH/2gAIAQEABj8C5lrDsm748mTsMEqEy1n/xAAbEAACAwEBAQAAAAAAAAAAAAAAAREhMUFRYf/aAAgBAQABPyFX8YfUyjTQG8CU9GJLlHiHhqVWn//aAAwDAQACAAMAAAAQKy//xAAWEQEBAQAAAAAAAAAAAAAAAAARAAH/2gAIAQMBAT8QTSd//8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAECAQE/EM6oS//EABwQAQEAAwEAAwAAAAAAAAAAAAERACFRMWGx8P/aAAgBAQABPxBx0VCkr4E7kBrBqUQ0/HcSFEDSH1jqxM7C256WnhpTmI3i3EU/Of/Z","aspectRatio":1.4992503748125936,"src":"/static/8-1d783bc68555cb2816acfa50f1a5469a-79b28.jpg","srcSet":"/static/8-1d783bc68555cb2816acfa50f1a5469a-3d830.jpg 300w,\n/static/8-1d783bc68555cb2816acfa50f1a5469a-2ab78.jpg 600w,\n/static/8-1d783bc68555cb2816acfa50f1a5469a-79b28.jpg 1000w","srcWebp":"/static/8-1d783bc68555cb2816acfa50f1a5469a-161ff.webp","srcSetWebp":"/static/8-1d783bc68555cb2816acfa50f1a5469a-9fc06.webp 300w,\n/static/8-1d783bc68555cb2816acfa50f1a5469a-36f59.webp 600w,\n/static/8-1d783bc68555cb2816acfa50f1a5469a-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIEAf/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABrR48VDQ//8QAGRAAAwEBAQAAAAAAAAAAAAAAAAIDAQQi/9oACAEBAAEFAkiVxaGcjMQozkd9vZsb/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/AQ0n/8QAGhAAAgMBAQAAAAAAAAAAAAAAAAECESEQUf/aAAgBAQAGPwLxDrWi04msnz//xAAbEAEAAgMBAQAAAAAAAAAAAAABABEhMUFxgf/aAAgBAQABPyEVsEOQKwDWoFgPZTEtxlO/YsDU/9oADAMBAAIAAwAAABCTL//EABcRAQEBAQAAAAAAAAAAAAAAAAEAESH/2gAIAQMBAT8QeIWX/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAECAQE/EDVY2//EAB4QAQADAAEFAQAAAAAAAAAAAAEAESExQVFhkaHw/9oACAEBAAE/EKy3KXVrj3NQCQ1d/Yg0CU6JYQjRnnIhzY65fwip477P/9k=","aspectRatio":1.4992503748125936,"src":"/static/9-742368d41ae050298fd91ede4c56dcf8-79b28.jpg","srcSet":"/static/9-742368d41ae050298fd91ede4c56dcf8-3d830.jpg 300w,\n/static/9-742368d41ae050298fd91ede4c56dcf8-2ab78.jpg 600w,\n/static/9-742368d41ae050298fd91ede4c56dcf8-79b28.jpg 1000w","srcWebp":"/static/9-742368d41ae050298fd91ede4c56dcf8-161ff.webp","srcSetWebp":"/static/9-742368d41ae050298fd91ede4c56dcf8-9fc06.webp 300w,\n/static/9-742368d41ae050298fd91ede4c56dcf8-36f59.webp 600w,\n/static/9-742368d41ae050298fd91ede4c56dcf8-161ff.webp 1000w","sizes":"(max-width: 1000px) 100vw, 1000px"}}}}]},"logo":{"childImageSharp":{"sizes":{"aspectRatio":1,"src":"/static/logo-9ab595ca0079aa39bd21b6940e0cce38-7be90.png","srcSet":"/static/logo-9ab595ca0079aa39bd21b6940e0cce38-7b359.png 200w,\n/static/logo-9ab595ca0079aa39bd21b6940e0cce38-1e9c1.png 400w,\n/static/logo-9ab595ca0079aa39bd21b6940e0cce38-7be90.png 800w,\n/static/logo-9ab595ca0079aa39bd21b6940e0cce38-df521.png 1000w","srcWebp":"/static/logo-9ab595ca0079aa39bd21b6940e0cce38-454e9.webp","srcSetWebp":"/static/logo-9ab595ca0079aa39bd21b6940e0cce38-1ae35.webp 200w,\n/static/logo-9ab595ca0079aa39bd21b6940e0cce38-dae30.webp 400w,\n/static/logo-9ab595ca0079aa39bd21b6940e0cce38-454e9.webp 800w,\n/static/logo-9ab595ca0079aa39bd21b6940e0cce38-55d53.webp 1000w","sizes":"(max-width: 800px) 100vw, 800px"}}},"logotext":{"childImageSharp":{"sizes":{"aspectRatio":2,"src":"/static/logo-text-5a30e35649f9d785ef0ac83e938ef018-7844b.png","srcSet":"/static/logo-text-5a30e35649f9d785ef0ac83e938ef018-85d22.png 200w,\n/static/logo-text-5a30e35649f9d785ef0ac83e938ef018-7f268.png 400w,\n/static/logo-text-5a30e35649f9d785ef0ac83e938ef018-7844b.png 500w","srcWebp":"/static/logo-text-5a30e35649f9d785ef0ac83e938ef018-2e7e0.webp","srcSetWebp":"/static/logo-text-5a30e35649f9d785ef0ac83e938ef018-76658.webp 200w,\n/static/logo-text-5a30e35649f9d785ef0ac83e938ef018-dbe66.webp 400w,\n/static/logo-text-5a30e35649f9d785ef0ac83e938ef018-2e7e0.webp 500w","sizes":"(max-width: 500px) 100vw, 500px"}}},"landing":null},"layoutContext":{}}

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(218);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(110);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	var detectPassiveEvents = {
	  update: function update() {
	    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
	      var passive = false;
	      var options = Object.defineProperty({}, 'passive', {
	        get: function get() {
	          passive = true;
	        }
	      });
	      // note: have to set and remove a no-op listener instead of null
	      // (which was used previously), becasue Edge v15 throws an error
	      // when providing a null callback.
	      // https://github.com/rafrex/detect-passive-events/pull/3
	      var noop = function noop() {};
	      window.addEventListener('testPassiveEventSupport', noop, options);
	      window.removeEventListener('testPassiveEventSupport', noop, options);
	      detectPassiveEvents.hasSupport = passive;
	    }
	  }
	};
	
	detectPassiveEvents.update();
	exports.default = detectPassiveEvents;

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// ┌────────────────────────────────────────────────────────────┐ \\
	// │ Eve 0.5.4 - JavaScript Events Library                      │ \\
	// ├────────────────────────────────────────────────────────────┤ \\
	// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
	// └────────────────────────────────────────────────────────────┘ \\
	
	(function (glob) {
	    var version = "0.5.4",
	        has = "hasOwnProperty",
	        separator = /[\.\/]/,
	        comaseparator = /\s*,\s*/,
	        wildcard = "*",
	        numsort = function (a, b) {
	            return a - b;
	        },
	        current_event,
	        stop,
	        events = {n: {}},
	        firstDefined = function () {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        lastDefined = function () {
	            var i = this.length;
	            while (--i) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        objtos = Object.prototype.toString,
	        Str = String,
	        isArray = Array.isArray || function (ar) {
	            return ar instanceof Array || objtos.call(ar) == "[object Array]";
	        },
	    /*\
	     * eve
	     [ method ]
	
	     * Fires event with given `name`, given scope and other parameters.
	
	     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
	     - scope (object) context for the event handlers
	     - varargs (...) the rest of arguments will be sent to event handlers
	
	     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
	    \*/
	        eve = function (name, scope) {
	            var oldstop = stop,
	                args = Array.prototype.slice.call(arguments, 2),
	                listeners = eve.listeners(name),
	                z = 0,
	                l,
	                indexed = [],
	                queue = {},
	                out = [],
	                ce = current_event;
	            out.firstDefined = firstDefined;
	            out.lastDefined = lastDefined;
	            current_event = name;
	            stop = 0;
	            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
	                indexed.push(listeners[i].zIndex);
	                if (listeners[i].zIndex < 0) {
	                    queue[listeners[i].zIndex] = listeners[i];
	                }
	            }
	            indexed.sort(numsort);
	            while (indexed[z] < 0) {
	                l = queue[indexed[z++]];
	                out.push(l.apply(scope, args));
	                if (stop) {
	                    stop = oldstop;
	                    return out;
	                }
	            }
	            for (i = 0; i < ii; i++) {
	                l = listeners[i];
	                if ("zIndex" in l) {
	                    if (l.zIndex == indexed[z]) {
	                        out.push(l.apply(scope, args));
	                        if (stop) {
	                            break;
	                        }
	                        do {
	                            z++;
	                            l = queue[indexed[z]];
	                            l && out.push(l.apply(scope, args));
	                            if (stop) {
	                                break;
	                            }
	                        } while (l)
	                    } else {
	                        queue[l.zIndex] = l;
	                    }
	                } else {
	                    out.push(l.apply(scope, args));
	                    if (stop) {
	                        break;
	                    }
	                }
	            }
	            stop = oldstop;
	            current_event = ce;
	            return out;
	        };
	    // Undocumented. Debug only.
	    eve._events = events;
	    /*\
	     * eve.listeners
	     [ method ]
	
	     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.
	
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated
	
	     = (array) array of event handlers
	    \*/
	    eve.listeners = function (name) {
	        var names = isArray(name) ? name : name.split(separator),
	            e = events,
	            item,
	            items,
	            k,
	            i,
	            ii,
	            j,
	            jj,
	            nes,
	            es = [e],
	            out = [];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            nes = [];
	            for (j = 0, jj = es.length; j < jj; j++) {
	                e = es[j].n;
	                items = [e[names[i]], e[wildcard]];
	                k = 2;
	                while (k--) {
	                    item = items[k];
	                    if (item) {
	                        nes.push(item);
	                        out = out.concat(item.f || []);
	                    }
	                }
	            }
	            es = nes;
	        }
	        return out;
	    };
	    /*\
	     * eve.separator
	     [ method ]
	
	     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
	     * here. Be aware that if you pass a string longer than one character it will be treated as
	     * a list of characters.
	
	     - separator (string) new separator. Empty string resets to default: `.` or `/`.
	    \*/
	    eve.separator = function (sep) {
	        if (sep) {
	            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
	            sep = "[" + sep + "]";
	            separator = new RegExp(sep);
	        } else {
	            separator = /[\.\/]/;
	        }
	    };
	    /*\
	     * eve.on
	     [ method ]
	     **
	     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
	     | eve.on("*.under.*", f);
	     | eve("mouse.under.floor"); // triggers f
	     * Use @eve to trigger the listener.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     - name (array) if you don’t want to use separators, you can use array of strings
	     - f (function) event handler function
	     **
	     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment.
	     > Example:
	     | eve.on("mouse", eatIt)(2);
	     | eve.on("mouse", scream);
	     | eve.on("mouse", catchIt)(1);
	     * This will ensure that `catchIt` function will be called before `eatIt`.
	     *
	     * If you want to put your handler before non-indexed handlers, specify a negative value.
	     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
	    \*/
	    eve.on = function (name, f) {
	        if (typeof f != "function") {
	            return function () {};
	        }
	        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
	        for (var i = 0, ii = names.length; i < ii; i++) {
	            (function (name) {
	                var names = isArray(name) ? name : Str(name).split(separator),
	                    e = events,
	                    exist;
	                for (var i = 0, ii = names.length; i < ii; i++) {
	                    e = e.n;
	                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
	                }
	                e.f = e.f || [];
	                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
	                    exist = true;
	                    break;
	                }
	                !exist && e.f.push(f);
	            }(names[i]));
	        }
	        return function (zIndex) {
	            if (+zIndex == +zIndex) {
	                f.zIndex = +zIndex;
	            }
	        };
	    };
	    /*\
	     * eve.f
	     [ method ]
	     **
	     * Returns function that will fire given event with optional arguments.
	     * Arguments that will be passed to the result function will be also
	     * concated to the list of final arguments.
	     | el.onclick = eve.f("click", 1, 2);
	     | eve.on("click", function (a, b, c) {
	     |     console.log(a, b, c); // 1, 2, [event object]
	     | });
	     - event (string) event name
	     - varargs (…) and any other arguments
	     = (function) possible event handler function
	    \*/
	    eve.f = function (event) {
	        var attrs = [].slice.call(arguments, 1);
	        return function () {
	            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
	        };
	    };
	    /*\
	     * eve.stop
	     [ method ]
	     **
	     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
	    \*/
	    eve.stop = function () {
	        stop = 1;
	    };
	    /*\
	     * eve.nt
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     - subname (string) #optional subname of the event
	     **
	     = (string) name of the event, if `subname` is not specified
	     * or
	     = (boolean) `true`, if current event’s name contains `subname`
	    \*/
	    eve.nt = function (subname) {
	        var cur = isArray(current_event) ? current_event.join(".") : current_event;
	        if (subname) {
	            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
	        }
	        return cur;
	    };
	    /*\
	     * eve.nts
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     **
	     = (array) names of the event
	    \*/
	    eve.nts = function () {
	        return isArray(current_event) ? current_event : current_event.split(separator);
	    };
	    /*\
	     * eve.off
	     [ method ]
	     **
	     * Removes given function from the list of event listeners assigned to given name.
	     * If no arguments specified all the events will be cleared.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	    \*/
	    /*\
	     * eve.unbind
	     [ method ]
	     **
	     * See @eve.off
	    \*/
	    eve.off = eve.unbind = function (name, f) {
	        if (!name) {
	            eve._events = events = {n: {}};
	            return;
	        }
	        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
	        if (names.length > 1) {
	            for (var i = 0, ii = names.length; i < ii; i++) {
	                eve.off(names[i], f);
	            }
	            return;
	        }
	        names = isArray(name) ? name : Str(name).split(separator);
	        var e,
	            key,
	            splice,
	            i, ii, j, jj,
	            cur = [events],
	            inodes = [];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            for (j = 0; j < cur.length; j += splice.length - 2) {
	                splice = [j, 1];
	                e = cur[j].n;
	                if (names[i] != wildcard) {
	                    if (e[names[i]]) {
	                        splice.push(e[names[i]]);
	                        inodes.unshift({
	                            n: e,
	                            name: names[i]
	                        });
	                    }
	                } else {
	                    for (key in e) if (e[has](key)) {
	                        splice.push(e[key]);
	                        inodes.unshift({
	                            n: e,
	                            name: key
	                        });
	                    }
	                }
	                cur.splice.apply(cur, splice);
	            }
	        }
	        for (i = 0, ii = cur.length; i < ii; i++) {
	            e = cur[i];
	            while (e.n) {
	                if (f) {
	                    if (e.f) {
	                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
	                            e.f.splice(j, 1);
	                            break;
	                        }
	                        !e.f.length && delete e.f;
	                    }
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        var funcs = e.n[key].f;
	                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
	                            funcs.splice(j, 1);
	                            break;
	                        }
	                        !funcs.length && delete e.n[key].f;
	                    }
	                } else {
	                    delete e.f;
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        delete e.n[key].f;
	                    }
	                }
	                e = e.n;
	            }
	        }
	        // prune inner nodes in path
	        prune: for (i = 0, ii = inodes.length; i < ii; i++) {
	            e = inodes[i];
	            for (key in e.n[e.name].f) {
	                // not empty (has listeners)
	                continue prune;
	            }
	            for (key in e.n[e.name].n) {
	                // not empty (has children)
	                continue prune;
	            }
	            // is empty
	            delete e.n[e.name];
	        }
	    };
	    /*\
	     * eve.once
	     [ method ]
	     **
	     * Binds given event handler with a given name to only run once then unbind itself.
	     | eve.once("login", f);
	     | eve("login"); // triggers f
	     | eve("login"); // no listeners
	     * Use @eve to trigger the listener.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     = (function) same return function as @eve.on
	    \*/
	    eve.once = function (name, f) {
	        var f2 = function () {
	            eve.off(name, f2);
	            return f.apply(this, arguments);
	        };
	        return eve.on(name, f2);
	    };
	    /*\
	     * eve.version
	     [ property (string) ]
	     **
	     * Current version of the library.
	    \*/
	    eve.version = version;
	    eve.toString = function () {
	        return "You are running Eve " + version;
	    };
	    glob.eve = eve;
	    typeof module != "undefined" && module.exports ? module.exports = eve :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () { return eve; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : glob.eve = eve;
	})(typeof window != "undefined" ? window : this);


/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var BurgerIcon = (function (_Component) {
	  _inherits(BurgerIcon, _Component);
	
	  function BurgerIcon(props) {
	    _classCallCheck(this, BurgerIcon);
	
	    _get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      hover: false
	    };
	  }
	
	  _createClass(BurgerIcon, [{
	    key: 'getLineStyle',
	    value: function getLineStyle(index) {
	      return _extends({
	        position: 'absolute',
	        height: '20%',
	        left: 0,
	        right: 0,
	        top: 20 * (index * 2) + '%',
	        opacity: this.state.hover ? 0.6 : 1
	      }, this.state.hover && this.props.styles.bmBurgerBarsHover);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon = undefined;
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        fontSize: 0,
	        background: 'transparent',
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: ('bm-icon ' + (this.props.customIcon.props.className || '')).trim(),
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmIcon)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          null,
	          [0, 1, 2].map(function (bar) {
	            return _react2['default'].createElement('span', {
	              key: bar,
	              className: ('bm-burger-bars ' + _this.props.barClassName + ' ' + (_this.state.hover ? 'bm-burger-bars-hover' : '')).trim(),
	              style: _extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-burger-button ' + this.props.className).trim(),
	          style: _extends({ zIndex: 1000 }, this.props.styles.bmBurgerButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          {
	            onClick: this.props.onClick,
	            onMouseOver: function () {
	              return _this.setState({ hover: true });
	            },
	            onMouseOut: function () {
	              return _this.setState({ hover: false });
	            },
	            style: buttonStyle
	          },
	          'Open Menu'
	        )
	      );
	    }
	  }]);
	
	  return BurgerIcon;
	})(_react.Component);
	
	exports['default'] = BurgerIcon;
	
	BurgerIcon.propTypes = {
	  barClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	BurgerIcon.defaultProps = {
	  barClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  slide: __webpack_require__(429),
	  stack: __webpack_require__(430),
	  elastic: __webpack_require__(422),
	  bubble: __webpack_require__(421),
	  push: __webpack_require__(424),
	  pushRotate: __webpack_require__(425),
	  scaleDown: __webpack_require__(427),
	  scaleRotate: __webpack_require__(428),
	  fallDown: __webpack_require__(423),
	  reveal: __webpack_require__(426)
	};
	module.exports = exports['default'];

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var CrossIcon = (function (_Component) {
	  _inherits(CrossIcon, _Component);
	
	  function CrossIcon() {
	    _classCallCheck(this, CrossIcon);
	
	    _get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CrossIcon, [{
	    key: 'getCrossStyle',
	    value: function getCrossStyle(type) {
	      return {
	        position: 'absolute',
	        width: 3,
	        height: 14,
	        transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon;
	      var buttonWrapperStyle = {
	        position: 'absolute',
	        width: 24,
	        height: 24,
	        right: 8,
	        top: 8
	      };
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        fontSize: 0,
	        background: 'transparent',
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: ('bm-cross ' + (this.props.customIcon.props.className || '')).trim(),
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmCross)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          { style: { position: 'absolute', top: '6px', right: '14px' } },
	          ['before', 'after'].map(function (type, i) {
	            return _react2['default'].createElement('span', {
	              key: i,
	              className: ('bm-cross ' + _this.props.crossClassName).trim(),
	              style: _extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-cross-button ' + this.props.className).trim(),
	          style: _extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          {
	            onClick: this.props.onClick,
	            style: buttonStyle,
	            tabIndex: this.props.tabIndex
	          },
	          'Close Menu'
	        )
	      );
	    }
	  }]);
	
	  return CrossIcon;
	})(_react.Component);
	
	exports['default'] = CrossIcon;
	
	CrossIcon.propTypes = {
	  crossClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object,
	  tabIndex: _propTypes2['default'].number
	};
	
	CrossIcon.defaultProps = {
	  crossClassName: '',
	  className: '',
	  styles: {},
	  tabIndex: 0
	};
	module.exports = exports['default'];

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var styles = {
	  overlay: function overlay(isOpen) {
	    return {
	      position: 'fixed',
	      zIndex: 1000,
	      width: '100%',
	      height: '100%',
	      background: 'rgba(0, 0, 0, 0.3)',
	      opacity: isOpen ? 1 : 0,
	      MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      zIndex: 1100,
	      width: width,
	      height: '100%',
	      MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  menu: function menu() {
	    return {
	      height: '100%',
	      boxSizing: 'border-box',
	      overflow: 'auto'
	    };
	  },
	
	  itemList: function itemList() {
	    return {
	      height: '100%'
	    };
	  },
	
	  item: function item() {
	    return {
	      display: 'block'
	    };
	  }
	};
	
	exports['default'] = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _baseStyles = __webpack_require__(420);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _BurgerIcon = __webpack_require__(417);
	
	var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);
	
	var _CrossIcon = __webpack_require__(419);
	
	var _CrossIcon2 = _interopRequireDefault(_CrossIcon);
	
	exports['default'] = function (styles) {
	  var Menu = (function (_Component) {
	    _inherits(Menu, _Component);
	
	    function Menu(props) {
	      _classCallCheck(this, Menu);
	
	      _get(Object.getPrototypeOf(Menu.prototype), 'constructor', this).call(this, props);
	      this.state = {
	        isOpen: false
	      };
	
	      if (!styles) {
	        throw new Error('No styles supplied');
	      }
	    }
	
	    _createClass(Menu, [{
	      key: 'toggleMenu',
	      value: function toggleMenu() {
	        var _this = this;
	
	        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	        var isOpen = options.isOpen;
	        var noStateChange = options.noStateChange;
	
	        var newState = {
	          isOpen: typeof isOpen !== 'undefined' ? isOpen : !this.state.isOpen
	        };
	
	        this.applyWrapperStyles();
	
	        this.setState(newState, function () {
	          !noStateChange && _this.props.onStateChange(newState);
	
	          if (!_this.props.disableAutoFocus) {
	            // For accessibility reasons, ensures that when we toggle open,
	            // we focus the first menu item if one exists.
	            if (newState.isOpen) {
	              var firstItem = document.querySelector('.bm-item');
	              if (firstItem) {
	                firstItem.focus();
	              }
	            } else {
	              if (document.activeElement) {
	                document.activeElement.blur();
	              } else {
	                document.body.blur(); // Needed for IE
	              }
	            }
	          }
	
	          // Timeout ensures wrappers are cleared after animation finishes.
	          _this.timeoutId && clearTimeout(_this.timeoutId);
	          _this.timeoutId = setTimeout(function () {
	            _this.timeoutId = null;
	            if (!newState.isOpen) {
	              _this.applyWrapperStyles(false);
	            }
	          }, 500);
	        });
	      }
	
	      // Applies component-specific styles to external wrapper elements.
	    }, {
	      key: 'applyWrapperStyles',
	      value: function applyWrapperStyles() {
	        var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	        var applyClass = function applyClass(el, className) {
	          return el.classList[set ? 'add' : 'remove'](className);
	        };
	
	        if (this.props.htmlClassName) {
	          applyClass(document.querySelector('html'), this.props.htmlClassName);
	        }
	        if (this.props.bodyClassName) {
	          applyClass(document.querySelector('body'), this.props.bodyClassName);
	        }
	
	        if (styles.pageWrap && this.props.pageWrapId) {
	          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, set);
	        }
	
	        if (styles.outerContainer && this.props.outerContainerId) {
	          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, set);
	        }
	      }
	
	      // Sets or unsets styles on DOM elements outside the menu component.
	      // This is necessary for correct page interaction with some of the menus.
	      // Throws and returns if the required external elements don't exist,
	      // which means any external page animations won't be applied.
	    }, {
	      key: 'handleExternalWrapper',
	      value: function handleExternalWrapper(id, wrapperStyles, set) {
	        var wrapper = document.getElementById(id);
	
	        if (!wrapper) {
	          console.error("Element with ID '" + id + "' not found");
	          return;
	        }
	
	        var builtStyles = this.getStyle(wrapperStyles);
	
	        for (var prop in builtStyles) {
	          if (builtStyles.hasOwnProperty(prop)) {
	            wrapper.style[prop] = set ? builtStyles[prop] : '';
	          }
	        }
	
	        // Prevent any horizontal scroll.
	        // Only set overflow-x as an inline style if htmlClassName or
	        // bodyClassName is not passed in. Otherwise, it is up to the caller to
	        // decide if they want to set the overflow style in CSS using the custom
	        // class names.
	        var applyOverflow = function applyOverflow(el) {
	          return el.style['overflow-x'] = set ? 'hidden' : '';
	        };
	        if (!this.props.htmlClassName) {
	          applyOverflow(document.querySelector('html'));
	        }
	        if (!this.props.bodyClassName) {
	          applyOverflow(document.querySelector('body'));
	        }
	      }
	
	      // Builds styles incrementally for a given element.
	    }, {
	      key: 'getStyles',
	      value: function getStyles(el, index, inline) {
	        var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());
	
	        // Set base styles.
	        var output = _baseStyles2['default'][el] ? this.getStyle(_baseStyles2['default'][el]) : {};
	
	        // Add animation-specific styles.
	        if (styles[el]) {
	          output = _extends({}, output, this.getStyle(styles[el], index + 1));
	        }
	
	        // Add custom styles.
	        if (this.props.styles[propName]) {
	          output = _extends({}, output, this.props.styles[propName]);
	        }
	
	        // Add element inline styles.
	        if (inline) {
	          output = _extends({}, output, inline);
	        }
	
	        return output;
	      }
	    }, {
	      key: 'getStyle',
	      value: function getStyle(style, index) {
	        var width = this.props.width;
	
	        var formattedWidth = typeof width !== 'string' ? width + 'px' : width;
	        return style(this.state.isOpen, formattedWidth, this.props.right, index);
	      }
	    }, {
	      key: 'listenForClose',
	      value: function listenForClose(e) {
	        e = e || window.event;
	
	        // Close on ESC, unless disabled
	        if (!this.props.disableCloseOnEsc && this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'shouldDisableOverlayClick',
	      value: function shouldDisableOverlayClick() {
	        if (typeof this.props.disableOverlayClick === 'function') {
	          return this.props.disableOverlayClick();
	        } else {
	          return this.props.disableOverlayClick;
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        // Bind ESC key handler (unless custom function supplied).
	        if (this.props.customOnKeyDown) {
	          window.onkeydown = this.props.customOnKeyDown;
	        } else {
	          window.onkeydown = this.listenForClose.bind(this);
	        }
	
	        // Allow initial open state to be set by props.
	        if (this.props.isOpen) {
	          this.toggleMenu({ isOpen: true, noStateChange: true });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.onkeydown = null;
	
	        this.applyWrapperStyles(false);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps) {
	        var _this2 = this;
	
	        var wasToggled = typeof this.props.isOpen !== 'undefined' && this.props.isOpen !== this.state.isOpen && this.props.isOpen !== prevProps.isOpen;
	        if (wasToggled) {
	          this.toggleMenu();
	          // Toggling changes SVG animation requirements, so we defer these until the next componentDidUpdate
	          return;
	        }
	
	        if (styles.svg) {
	          (function () {
	            var morphShape = _reactDom2['default'].findDOMNode(_this2, 'bm-morph-shape');
	            var path = styles.svg.lib(morphShape).select('path');
	
	            if (_this2.state.isOpen) {
	              // Animate SVG path.
	              styles.svg.animate(path);
	            } else {
	              // Reset path (timeout ensures animation happens off screen).
	              setTimeout(function () {
	                path.attr('d', styles.svg.pathInitial);
	              }, 300);
	            }
	          })();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        return _react2['default'].createElement(
	          'div',
	          null,
	          !this.props.noOverlay && _react2['default'].createElement('div', {
	            className: ('bm-overlay ' + this.props.overlayClassName).trim(),
	            onClick: function () {
	              return !_this3.shouldDisableOverlayClick() && _this3.toggleMenu();
	            },
	            style: this.getStyles('overlay')
	          }),
	          _react2['default'].createElement(
	            'div',
	            {
	              id: this.props.id,
	              className: ('bm-menu-wrap ' + this.props.className).trim(),
	              style: this.getStyles('menuWrap')
	            },
	            styles.svg && _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-morph-shape ' + this.props.morphShapeClassName).trim(),
	                style: this.getStyles('morphShape')
	              },
	              _react2['default'].createElement(
	                'svg',
	                {
	                  width: '100%',
	                  height: '100%',
	                  viewBox: '0 0 100 800',
	                  preserveAspectRatio: 'none'
	                },
	                _react2['default'].createElement('path', { d: styles.svg.pathInitial })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-menu ' + this.props.menuClassName).trim(),
	                style: this.getStyles('menu')
	              },
	              _react2['default'].createElement(
	                'nav',
	                {
	                  className: ('bm-item-list ' + this.props.itemListClassName).trim(),
	                  style: this.getStyles('itemList')
	                },
	                _react2['default'].Children.map(this.props.children, function (item, index) {
	                  if (item) {
	                    var classList = ['bm-item', _this3.props.itemClassName, item.props.className].filter(function (className) {
	                      return !!className;
	                    }).join(' ');
	                    var extraProps = {
	                      key: index,
	                      className: classList,
	                      style: _this3.getStyles('item', index, item.props.style),
	                      tabIndex: _this3.state.isOpen ? 0 : -1
	                    };
	                    return _react2['default'].cloneElement(item, extraProps);
	                  }
	                })
	              )
	            ),
	            this.props.customCrossIcon !== false && _react2['default'].createElement(
	              'div',
	              { style: this.getStyles('closeButton') },
	              _react2['default'].createElement(_CrossIcon2['default'], {
	                onClick: function () {
	                  return _this3.toggleMenu();
	                },
	                styles: this.props.styles,
	                customIcon: this.props.customCrossIcon,
	                className: this.props.crossButtonClassName,
	                crossClassName: this.props.crossClassName,
	                tabIndex: this.state.isOpen ? 0 : -1
	              })
	            )
	          ),
	          this.props.customBurgerIcon !== false && _react2['default'].createElement(
	            'div',
	            { style: this.getStyles('burgerIcon') },
	            _react2['default'].createElement(_BurgerIcon2['default'], {
	              onClick: function () {
	                return _this3.toggleMenu();
	              },
	              styles: this.props.styles,
	              customIcon: this.props.customBurgerIcon,
	              className: this.props.burgerButtonClassName,
	              barClassName: this.props.burgerBarClassName
	            })
	          )
	        );
	      }
	    }]);
	
	    return Menu;
	  })(_react.Component);
	
	  Menu.propTypes = {
	    bodyClassName: _propTypes2['default'].string,
	    burgerBarClassName: _propTypes2['default'].string,
	    burgerButtonClassName: _propTypes2['default'].string,
	    className: _propTypes2['default'].string,
	    crossButtonClassName: _propTypes2['default'].string,
	    crossClassName: _propTypes2['default'].string,
	    customBurgerIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    customCrossIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    customOnKeyDown: _propTypes2['default'].func,
	    disableAutoFocus: _propTypes2['default'].bool,
	    disableCloseOnEsc: _propTypes2['default'].bool,
	    disableOverlayClick: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].func]),
	    htmlClassName: _propTypes2['default'].string,
	    id: _propTypes2['default'].string,
	    isOpen: _propTypes2['default'].bool,
	    itemClassName: _propTypes2['default'].string,
	    itemListClassName: _propTypes2['default'].string,
	    menuClassName: _propTypes2['default'].string,
	    morphShapeClassName: _propTypes2['default'].string,
	    noOverlay: _propTypes2['default'].bool,
	    onStateChange: _propTypes2['default'].func,
	    outerContainerId: styles && styles.outerContainer ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    overlayClassName: _propTypes2['default'].string,
	    pageWrapId: styles && styles.pageWrap ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    right: _propTypes2['default'].bool,
	    styles: _propTypes2['default'].object,
	    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	  };
	
	  Menu.defaultProps = {
	    bodyClassName: '',
	    burgerBarClassName: '',
	    burgerButtonClassName: '',
	    className: '',
	    crossButtonClassName: '',
	    crossClassName: '',
	    disableAutoFocus: false,
	    disableCloseOnEsc: false,
	    htmlClassName: '',
	    id: '',
	    itemClassName: '',
	    itemListClassName: '',
	    menuClassName: '',
	    morphShapeClassName: '',
	    noOverlay: false,
	    onStateChange: function onStateChange() {},
	    outerContainerId: '',
	    overlayClassName: '',
	    pageWrapId: '',
	    styles: {},
	    width: 300
	  };
	
	  return Menu;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _snapsvgImporter = __webpack_require__(165);
	
	var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);
	
	var _menuFactory = __webpack_require__(18);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  svg: {
	    lib: _snapsvgImporter2['default'],
	    pathInitial: 'M-7.312,0H0c0,0,0,113.839,0,400c0,264.506,0,400,0,400h-7.312V0z',
	    pathOpen: 'M-7.312,0H15c0,0,66,113.339,66,399.5C81,664.006,15,800,15,800H-7.312V0z;M-7.312,0H100c0,0,0,113.839,0,400c0,264.506,0,400,0,400H-7.312V0z',
	    animate: function animate(path) {
	      var pos = 0;
	      var steps = this.pathOpen.split(';');
	      var stepsTotal = steps.length;
	      var mina = window.mina;
	
	      var nextStep = function nextStep() {
	        if (pos > stepsTotal - 1) return;
	
	        path.animate({ path: steps[pos] }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function () {
	          nextStep();
	        });
	
	        pos++;
	      };
	
	      nextStep();
	    }
	  },
	
	  morphShape: function morphShape(isOpen, width, right) {
	    return {
	      position: 'absolute',
	      width: '100%',
	      height: '100%',
	      right: right ? 'inherit' : 0,
	      left: right ? 0 : 'inherit',
	      MozTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      MsTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      OTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      WebkitTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      transform: right ? 'rotateY(180deg)' : 'rotateY(0deg)'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: isOpen ? 'transform 0.4s 0s' : 'transform 0.4s'
	    };
	  },
	
	  menu: function menu(isOpen, width, right) {
	    width -= 140;
	    return {
	      position: 'fixed',
	      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  },
	
	  item: function item(isOpen, width, right, nthChild) {
	    width -= 140;
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.3s 0.4s, transform 0.3s 0.4s' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  },
	
	  closeButton: function closeButton(isOpen, width, right) {
	    width -= 140;
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _snapsvgImporter = __webpack_require__(165);
	
	var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);
	
	var _menuFactory = __webpack_require__(18);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  svg: {
	    lib: _snapsvgImporter2['default'],
	    pathInitial: 'M-1,0h101c0,0-97.833,153.603-97.833,396.167C2.167,627.579,100,800,100,800H-1V0z',
	    pathOpen: 'M-1,0h101c0,0,0-1,0,395c0,404,0,405,0,405H-1V0z',
	    animate: function animate(path) {
	      path.animate({ path: this.pathOpen }, 400, window.mina.easeinout);
	    }
	  },
	
	  morphShape: function morphShape(isOpen, width, right) {
	    return {
	      position: 'absolute',
	      width: 120,
	      height: '100%',
	      right: right ? 'inherit' : 0,
	      left: right ? 0 : 'inherit',
	      MozTransform: right ? 'rotateY(180deg)' : '',
	      MsTransform: right ? 'rotateY(180deg)' : '',
	      OTransform: right ? 'rotateY(180deg)' : '',
	      WebkitTransform: right ? 'rotateY(180deg)' : '',
	      transform: right ? 'rotateY(180deg)' : ''
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.3s'
	    };
	  },
	
	  menu: function menu(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      width: 180,
	      whiteSpace: 'nowrap',
	      boxSizing: 'border-box',
	      overflow: 'visible'
	    };
	  },
	
	  itemList: function itemList(isOpen, width, right) {
	    if (right) {
	      return {
	        position: 'relative',
	        left: '-110px',
	        width: '170%',
	        overflow: 'auto'
	      };
	    }
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      transition: isOpen ? 'all 0.3s' : 'all 0.3s 0.1s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(18);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      OTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      transform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      transition: 'all 0.5s ease-in-out'
	    };
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      perspectiveOrigin: '0% 50%',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(18);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(18);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      transformOrigin: right ? '100% 50%' : '0% 50%',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(18);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      visibility: isOpen ? 'visible' : 'hidden',
	      MozTransform: 'translate3d(0, 0, 0)',
	      MsTransform: 'translate3d(0, 0, 0)',
	      OTransform: 'translate3d(0, 0, 0)',
	      WebkitTransform: 'translate3d(0, 0, 0)',
	      transform: 'translate3d(0, 0, 0)',
	      zIndex: 1000
	    };
	  },
	
	  overlay: function overlay(isOpen, width, right) {
	    return {
	      zIndex: 1400,
	      MozTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      MsTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      OTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      WebkitTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transition: 'all 0.5s',
	      visibility: isOpen ? 'visible' : 'hidden'
	    };
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s',
	      zIndex: 1200,
	      position: 'relative'
	    };
	  },
	
	  burgerIcon: function burgerIcon(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      MsTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      OTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      WebkitTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transition: 'all 0.1s',
	      position: 'relative',
	      zIndex: 1300
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(18);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      MsTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      OTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      transform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      transformOrigin: '100%',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer() {
	    return {
	      perspective: '1500px'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(18);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(18);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(18);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0.4s cubic-bezier(0.7, 0, 0.3, 1)'
	    };
	  },
	
	  item: function item(isOpen, width, right, nthChild) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      OTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      transform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0s 0.2s cubic-bezier(0.7, 0, 0.3, 1)'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function () {
	  var Snap = undefined;
	  try {
	    Snap = __webpack_require__(549);
	  } finally {
	    return Snap;
	  }
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(60);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleUp = function FaAngleUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31 26.4q0 0.3-0.2 0.5l-1.1 1.2q-0.3 0.2-0.6 0.2t-0.5-0.2l-8.7-8.8-8.8 8.8q-0.2 0.2-0.5 0.2t-0.5-0.2l-1.2-1.2q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.2 0.6-0.2t0.5 0.2l10.4 10.4q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleUp;
	module.exports = exports['default'];

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(504);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(188);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(128);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _reactLifecyclesCompat = __webpack_require__(127);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _reactDom2.default.createPortal !== undefined;
	
	var getCreatePortal = function getCreatePortal() {
	  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      parent.removeChild(_this.node);
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var createPortal = getCreatePortal();
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = document.createElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      var prevParent = getParentElement(prevProps.parentSelector);
	      var nextParent = getParentElement(this.props.parentSelector);
	      return { prevParent: prevParent, nextParent: nextParent };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, _, snapshot) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          portalClassName = _props.portalClassName;
	
	
	      if (prevProps.portalClassName !== portalClassName) {
	        this.node.className = portalClassName;
	      }
	
	      var prevParent = snapshot.prevParent,
	          nextParent = snapshot.nextParent;
	
	      if (nextParent !== prevParent) {
	        prevParent.removeChild(this.node);
	        nextParent.appendChild(this.node);
	      }
	
	      // Stop unnecessary renders if modal is remaining closed
	      if (!prevProps.isOpen && !isOpen) return;
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = document.createElement("div");
	      }
	
	      var createPortal = getCreatePortal();
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  role: "dialog",
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  parentSelector: function parentSelector() {
	    return document.body;
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Modal);
	
	exports.default = Modal;

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(506);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(507);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(188);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(505);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(128);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus();
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	
	      if (_this.props.onAfterClose) {
	        _this.props.onAfterClose();
	      }
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.setState({ afterOpen: true });
	
	          if (_this.props.isOpen && _this.props.onAfterOpen) {
	            _this.props.onAfterOpen();
	          }
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus();
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	
	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }
	
	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.afterClose();
	      clearTimeout(this.closeTimer);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      return this.shouldBeClosed() ? null : _react2.default.createElement(
	        "div",
	        {
	          ref: this.setOverlayRef,
	          className: this.buildClassName("overlay", overlayClassName),
	          style: _extends({}, overlayStyles, this.props.style.overlay),
	          onClick: this.handleOverlayOnClick,
	          onMouseDown: this.handleOverlayOnMouseDown
	        },
	        _react2.default.createElement(
	          "div",
	          _extends({
	            ref: this.setContentRef,
	            style: _extends({}, contentStyles, this.props.style.content),
	            className: this.buildClassName("content", className),
	            tabIndex: "-1",
	            onKeyDown: this.handleKeyDown,
	            onMouseDown: this.handleContentOnMouseDown,
	            onMouseUp: this.handleContentOnMouseUp,
	            onClick: this.handleContentOnClick,
	            role: this.props.role,
	            "aria-label": this.props.contentLabel
	          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
	            "data-testid": this.props.testId
	          }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onAfterClose: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	exports.resetForTesting = resetForTesting;
	
	var _warning = __webpack_require__(204);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _safeHTMLElement = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = "length" in el ? el[0] : el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  if (!appElement && !globalElement) {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return false;
	  }
	
	  return true;
	}
	
	function hide(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).setAttribute("aria-hidden", "true");
	  }
	}
	
	function show(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).removeAttribute("aria-hidden");
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}
	
	function resetForTesting() {
	  globalElement = null;
	}

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dumpClassLists = dumpClassLists;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	function dumpClassLists() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n";
	    }
	
	    classes = document.body.className;
	
	    // eslint-disable-next-line max-len
	    buffer += "\n\ndoc.body (" + classes + "):\n";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
	    }
	
	    buffer += "\n";
	
	    // eslint-disable-next-line no-console
	    console.log(buffer);
	  }
	}
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(189);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus();
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = undefined;
	
	var _exenv = __webpack_require__(158);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(189);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === document.activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  var target;
	  if (tail === document.activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === document.activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(document.activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  // If the tabbable element does not exist,
	  // focus head/tail based on shiftKey
	  if (typeof tabbable[x] === "undefined") {
	    event.preventDefault();
	    target = shiftKey ? tail : head;
	    target.focus();
	    return;
	  }
	
	  event.preventDefault();
	
	  tabbable[x].focus();
	}
	module.exports = exports["default"];

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  // Otherwise we need to check some styles
	  var style = window.getComputedStyle(element);
	  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
	}
	module.exports = exports["default"];

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(503);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author  Milos Janda
	 * @licence MIT
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _tweenFunctions = __webpack_require__(552);
	
	var _tweenFunctions2 = _interopRequireDefault(_tweenFunctions);
	
	var _detectPassiveEvents = __webpack_require__(312);
	
	var _detectPassiveEvents2 = _interopRequireDefault(_detectPassiveEvents);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollUp = function (_React$Component) {
	    _inherits(ScrollUp, _React$Component);
	
	    function ScrollUp(props) {
	        _classCallCheck(this, ScrollUp);
	
	        // set default state
	        var _this = _possibleConstructorReturn(this, (ScrollUp.__proto__ || Object.getPrototypeOf(ScrollUp)).call(this, props));
	
	        _this.state = { show: false };
	
	        // default property `data`
	        _this.data = {
	            startValue: 0,
	            currentTime: 0, // store current time of animation
	            startTime: null,
	            rafId: null
	        };
	
	        // bind
	        _this.handleClick = _this.handleClick.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.scrollStep = _this.scrollStep.bind(_this);
	        _this.stopScrolling = _this.stopScrolling.bind(_this);
	        return _this;
	    }
	
	    _createClass(ScrollUp, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextState.show !== this.state.show;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleScroll(); // initialize state
	
	            // Add all listeners which can start scroll
	            window.addEventListener('scroll', this.handleScroll);
	            window.addEventListener("wheel", this.stopScrolling, _detectPassiveEvents2.default.hasSupport ? { passive: true } : false);
	            window.addEventListener("touchstart", this.stopScrolling, _detectPassiveEvents2.default.hasSupport ? { passive: true } : false);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // Remove all listeners which was registered
	            window.removeEventListener('scroll', this.handleScroll);
	            window.removeEventListener("wheel", this.stopScrolling, false);
	            window.removeEventListener("touchstart", this.stopScrolling, false);
	        }
	
	        /**
	         * Evaluate show/hide this component, depend on new position
	         */
	
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll() {
	            if (window.pageYOffset > this.props.showUnder) {
	                if (!this.state.show) {
	                    this.setState({ show: true });
	                }
	            } else {
	                if (this.state.show) {
	                    this.setState({ show: false });
	                }
	            }
	        }
	
	        /**
	         * Handle click on the button
	         */
	
	    }, {
	        key: 'handleClick',
	        value: function handleClick() {
	            this.stopScrolling();
	            this.data.startValue = window.pageYOffset;
	            this.data.currentTime = 0;
	            this.data.startTime = null;
	            this.data.rafId = window.requestAnimationFrame(this.scrollStep);
	        }
	
	        /**
	         * Calculate new position
	         * and scroll screen to new position or stop scrolling
	         * @param timestamp
	         */
	
	    }, {
	        key: 'scrollStep',
	        value: function scrollStep(timestamp) {
	            if (!this.data.startTime) {
	                this.data.startTime = timestamp;
	            }
	
	            this.data.currentTime = timestamp - this.data.startTime;
	
	            var position = _tweenFunctions2.default[this.props.easing](this.data.currentTime, this.data.startValue, this.props.topPosition, this.props.duration);
	
	            if (window.pageYOffset <= this.props.topPosition) {
	                this.stopScrolling();
	            } else {
	                window.scrollTo(window.pageYOffset, position);
	                this.data.rafId = window.requestAnimationFrame(this.scrollStep);
	            }
	        }
	
	        /**
	         * Stop Animation Frame
	         */
	
	    }, {
	        key: 'stopScrolling',
	        value: function stopScrolling() {
	            window.cancelAnimationFrame(this.data.rafId);
	        }
	
	        /**
	         * Render component
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var propStyle = this.props.style;
	            var element = _react2.default.createElement(
	                'div',
	                { style: propStyle, onClick: this.handleClick },
	                this.props.children
	            );
	
	            var style = (0, _objectAssign2.default)({}, ScrollUp.defaultProps.style);
	            style = (0, _objectAssign2.default)(style, propStyle);
	            style.opacity = this.state.show ? 1 : 0;
	            style.visibility = this.state.show ? 'visible' : 'hidden';
	            style.transitionProperty = 'opacity, visibility';
	
	            return _react2.default.cloneElement(element, { style: style });
	        }
	    }]);
	
	    return ScrollUp;
	}(_react2.default.Component);
	
	// Set default props
	
	
	exports.default = ScrollUp;
	ScrollUp.defaultProps = {
	    duration: 250,
	    easing: 'easeOutCubic',
	    style: {
	        position: 'fixed',
	        bottom: 50,
	        right: 30,
	        cursor: 'pointer',
	        transitionDuration: '0.2s',
	        transitionTimingFunction: 'linear',
	        transitionDelay: '0s'
	    },
	    topPosition: 0
	};
	
	// Set validation property types
	ScrollUp.propTypes = {
	    topPosition: _propTypes2.default.number,
	    showUnder: _propTypes2.default.number.isRequired, // show button under this position,
	    easing: _propTypes2.default.oneOf(['linear', 'easeInQuad', 'easeOutQuad', 'easeInOutQuad', 'easeInCubic', 'easeOutCubic', 'easeInOutCubic', 'easeInQuart', 'easeOutQuart', 'easeInOutQuart', 'easeInQuint', 'easeOutQuint', 'easeInOutQuint', 'easeInSine', 'easeOutSine', 'easeInOutSine', 'easeInExpo', 'easeOutExpo', 'easeInOutExpo', 'easeInCirc', 'easeOutCirc', 'easeInOutCirc', 'easeInElastic', 'easeOutElastic', 'easeInOutElastic', 'easeInBack', 'easeOutBack', 'easeInOutBack', 'easeInBounce', 'easeOutBounce', 'easeInOutBounce']),
	    duration: _propTypes2.default.number, // seconds
	    style: _propTypes2.default.object
	};


/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	window.eve = __webpack_require__(322)
	
	// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	var mina = (function (eve) {
	    var animations = {},
	    requestAnimFrame = window.requestAnimationFrame       ||
	                       window.webkitRequestAnimationFrame ||
	                       window.mozRequestAnimationFrame    ||
	                       window.oRequestAnimationFrame      ||
	                       window.msRequestAnimationFrame     ||
	                       function (callback) {
	                           setTimeout(callback, 16, new Date().getTime());
	                           return true;
	                       },
	    requestID,
	    isArray = Array.isArray || function (a) {
	        return a instanceof Array ||
	            Object.prototype.toString.call(a) == "[object Array]";
	    },
	    idgen = 0,
	    idprefix = "M" + (+new Date).toString(36),
	    ID = function () {
	        return idprefix + (idgen++).toString(36);
	    },
	    diff = function (a, b, A, B) {
	        if (isArray(a)) {
	            res = [];
	            for (var i = 0, ii = a.length; i < ii; i++) {
	                res[i] = diff(a[i], b, A[i], B);
	            }
	            return res;
	        }
	        var dif = (A - a) / (B - b);
	        return function (bb) {
	            return a + dif * (bb - b);
	        };
	    },
	    timer = Date.now || function () {
	        return +new Date;
	    },
	    sta = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.s;
	        }
	        var ds = a.s - val;
	        a.b += a.dur * ds;
	        a.B += a.dur * ds;
	        a.s = val;
	    },
	    speed = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.spd;
	        }
	        a.spd = val;
	    },
	    duration = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.dur;
	        }
	        a.s = a.s * val / a.dur;
	        a.dur = val;
	    },
	    stopit = function () {
	        var a = this;
	        delete animations[a.id];
	        a.update();
	        eve("mina.stop." + a.id, a);
	    },
	    pause = function () {
	        var a = this;
	        if (a.pdif) {
	            return;
	        }
	        delete animations[a.id];
	        a.update();
	        a.pdif = a.get() - a.b;
	    },
	    resume = function () {
	        var a = this;
	        if (!a.pdif) {
	            return;
	        }
	        a.b = a.get() - a.pdif;
	        delete a.pdif;
	        animations[a.id] = a;
	        frame();
	    },
	    update = function () {
	        var a = this,
	            res;
	        if (isArray(a.start)) {
	            res = [];
	            for (var j = 0, jj = a.start.length; j < jj; j++) {
	                res[j] = +a.start[j] +
	                    (a.end[j] - a.start[j]) * a.easing(a.s);
	            }
	        } else {
	            res = +a.start + (a.end - a.start) * a.easing(a.s);
	        }
	        a.set(res);
	    },
	    frame = function (timeStamp) {
	        // Manual invokation?
	        if (!timeStamp) {
	            // Frame loop stopped?
	            if (!requestID) {
	                // Start frame loop...
	                requestID = requestAnimFrame(frame);
	            }
	            return;
	        }
	        var len = 0;
	        for (var i in animations) if (animations.hasOwnProperty(i)) {
	            var a = animations[i],
	                b = a.get(),
	                res;
	            len++;
	            a.s = (b - a.b) / (a.dur / a.spd);
	            if (a.s >= 1) {
	                delete animations[i];
	                a.s = 1;
	                len--;
	                (function (a) {
	                    setTimeout(function () {
	                        eve("mina.finish." + a.id, a);
	                    });
	                }(a));
	            }
	            a.update();
	        }
	        requestID = len ? requestAnimFrame(frame) : false;
	    },
	    /*\
	     * mina
	     [ method ]
	     **
	     * Generic animation of numbers
	     **
	     - a (number) start _slave_ number
	     - A (number) end _slave_ number
	     - b (number) start _master_ number (start time in general case)
	     - B (number) end _master_ number (end time in general case)
	     - get (function) getter of _master_ number (see @mina.time)
	     - set (function) setter of _slave_ number
	     - easing (function) #optional easing function, default is @mina.linear
	     = (object) animation descriptor
	     o {
	     o         id (string) animation id,
	     o         start (number) start _slave_ number,
	     o         end (number) end _slave_ number,
	     o         b (number) start _master_ number,
	     o         s (number) animation status (0..1),
	     o         dur (number) animation duration,
	     o         spd (number) animation speed,
	     o         get (function) getter of _master_ number (see @mina.time),
	     o         set (function) setter of _slave_ number,
	     o         easing (function) easing function, default is @mina.linear,
	     o         status (function) status getter/setter,
	     o         speed (function) speed getter/setter,
	     o         duration (function) duration getter/setter,
	     o         stop (function) animation stopper
	     o         pause (function) pauses the animation
	     o         resume (function) resumes the animation
	     o         update (function) calles setter with the right value of the animation
	     o }
	    \*/
	    mina = function (a, A, b, B, get, set, easing) {
	        var anim = {
	            id: ID(),
	            start: a,
	            end: A,
	            b: b,
	            s: 0,
	            dur: B - b,
	            spd: 1,
	            get: get,
	            set: set,
	            easing: easing || mina.linear,
	            status: sta,
	            speed: speed,
	            duration: duration,
	            stop: stopit,
	            pause: pause,
	            resume: resume,
	            update: update
	        };
	        animations[anim.id] = anim;
	        var len = 0, i;
	        for (i in animations) if (animations.hasOwnProperty(i)) {
	            len++;
	            if (len == 2) {
	                break;
	            }
	        }
	        len == 1 && frame();
	        return anim;
	    };
	    /*\
	     * mina.time
	     [ method ]
	     **
	     * Returns the current time. Equivalent to:
	     | function () {
	     |     return (new Date).getTime();
	     | }
	    \*/
	    mina.time = timer;
	    /*\
	     * mina.getById
	     [ method ]
	     **
	     * Returns an animation by its id
	     - id (string) animation's id
	     = (object) See @mina
	    \*/
	    mina.getById = function (id) {
	        return animations[id] || null;
	    };
	
	    /*\
	     * mina.linear
	     [ method ]
	     **
	     * Default linear easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.linear = function (n) {
	        return n;
	    };
	    /*\
	     * mina.easeout
	     [ method ]
	     **
	     * Easeout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easeout = function (n) {
	        return Math.pow(n, 1.7);
	    };
	    /*\
	     * mina.easein
	     [ method ]
	     **
	     * Easein easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easein = function (n) {
	        return Math.pow(n, .48);
	    };
	    /*\
	     * mina.easeinout
	     [ method ]
	     **
	     * Easeinout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easeinout = function (n) {
	        if (n == 1) {
	            return 1;
	        }
	        if (n == 0) {
	            return 0;
	        }
	        var q = .48 - n / 1.04,
	            Q = Math.sqrt(.1734 + q * q),
	            x = Q - q,
	            X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1),
	            y = -Q - q,
	            Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1),
	            t = X + Y + .5;
	        return (1 - t) * 3 * t * t + t * t * t;
	    };
	    /*\
	     * mina.backin
	     [ method ]
	     **
	     * Backin easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.backin = function (n) {
	        if (n == 1) {
	            return 1;
	        }
	        var s = 1.70158;
	        return n * n * ((s + 1) * n - s);
	    };
	    /*\
	     * mina.backout
	     [ method ]
	     **
	     * Backout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.backout = function (n) {
	        if (n == 0) {
	            return 0;
	        }
	        n = n - 1;
	        var s = 1.70158;
	        return n * n * ((s + 1) * n + s) + 1;
	    };
	    /*\
	     * mina.elastic
	     [ method ]
	     **
	     * Elastic easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.elastic = function (n) {
	        if (n == !!n) {
	            return n;
	        }
	        return Math.pow(2, -10 * n) * Math.sin((n - .075) *
	            (2 * Math.PI) / .3) + 1;
	    };
	    /*\
	     * mina.bounce
	     [ method ]
	     **
	     * Bounce easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.bounce = function (n) {
	        var s = 7.5625,
	            p = 2.75,
	            l;
	        if (n < 1 / p) {
	            l = s * n * n;
	        } else {
	            if (n < 2 / p) {
	                n -= 1.5 / p;
	                l = s * n * n + .75;
	            } else {
	                if (n < 2.5 / p) {
	                    n -= 2.25 / p;
	                    l = s * n * n + .9375;
	                } else {
	                    n -= 2.625 / p;
	                    l = s * n * n + .984375;
	                }
	            }
	        }
	        return l;
	    };
	    window.mina = mina;
	    return mina;
	})(typeof eve == "undefined" ? function () {} : eve);
	
	// Copyright (c) 2013 - 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	var Snap = (function(root) {
	Snap.version = "0.5.1";
	/*\
	 * Snap
	 [ method ]
	 **
	 * Creates a drawing surface or wraps existing SVG element.
	 **
	 - width (number|string) width of surface
	 - height (number|string) height of surface
	 * or
	 - DOM (SVGElement) element to be wrapped into Snap structure
	 * or
	 - array (array) array of elements (will return set of elements)
	 * or
	 - query (string) CSS query selector
	 = (object) @Element
	\*/
	function Snap(w, h) {
	    if (w) {
	        if (w.nodeType) {
	            return wrap(w);
	        }
	        if (is(w, "array") && Snap.set) {
	            return Snap.set.apply(Snap, w);
	        }
	        if (w instanceof Element) {
	            return w;
	        }
	        if (h == null) {
	            try {
	                w = glob.doc.querySelector(String(w));
	                return wrap(w);
	            } catch (e) {
	                return null;
	            }
	        }
	    }
	    w = w == null ? "100%" : w;
	    h = h == null ? "100%" : h;
	    return new Paper(w, h);
	}
	Snap.toString = function () {
	    return "Snap v" + this.version;
	};
	Snap._ = {};
	var glob = {
	    win: root.window,
	    doc: root.window.document
	};
	Snap._.glob = glob;
	var has = "hasOwnProperty",
	    Str = String,
	    toFloat = parseFloat,
	    toInt = parseInt,
	    math = Math,
	    mmax = math.max,
	    mmin = math.min,
	    abs = math.abs,
	    pow = math.pow,
	    PI = math.PI,
	    round = math.round,
	    E = "",
	    S = " ",
	    objectToString = Object.prototype.toString,
	    ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i,
	    colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
	    bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
	    separator = Snap._.separator = /[,\s]+/,
	    whitespace = /[\s]/g,
	    commaSpaces = /[\s]*,[\s]*/,
	    hsrg = {hs: 1, rg: 1},
	    pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
	    tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
	    pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/ig,
	    idgen = 0,
	    idprefix = "S" + (+new Date).toString(36),
	    ID = function (el) {
	        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
	    },
	    xlink = "http://www.w3.org/1999/xlink",
	    xmlns = "http://www.w3.org/2000/svg",
	    hub = {},
	    /*\
	     * Snap.url
	     [ method ]
	     **
	     * Wraps path into `"url('<path>')"`.
	     - value (string) path
	     = (string) wrapped path
	    \*/
	    URL = Snap.url = function (url) {
	        return "url('#" + url + "')";
	    };
	
	function $(el, attr) {
	    if (attr) {
	        if (el == "#text") {
	            el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
	        }
	        if (el == "#comment") {
	            el = glob.doc.createComment(attr.text || attr["#text"] || "");
	        }
	        if (typeof el == "string") {
	            el = $(el);
	        }
	        if (typeof attr == "string") {
	            if (el.nodeType == 1) {
	                if (attr.substring(0, 6) == "xlink:") {
	                    return el.getAttributeNS(xlink, attr.substring(6));
	                }
	                if (attr.substring(0, 4) == "xml:") {
	                    return el.getAttributeNS(xmlns, attr.substring(4));
	                }
	                return el.getAttribute(attr);
	            } else if (attr == "text") {
	                return el.nodeValue;
	            } else {
	                return null;
	            }
	        }
	        if (el.nodeType == 1) {
	            for (var key in attr) if (attr[has](key)) {
	                var val = Str(attr[key]);
	                if (val) {
	                    if (key.substring(0, 6) == "xlink:") {
	                        el.setAttributeNS(xlink, key.substring(6), val);
	                    } else if (key.substring(0, 4) == "xml:") {
	                        el.setAttributeNS(xmlns, key.substring(4), val);
	                    } else {
	                        el.setAttribute(key, val);
	                    }
	                } else {
	                    el.removeAttribute(key);
	                }
	            }
	        } else if ("text" in attr) {
	            el.nodeValue = attr.text;
	        }
	    } else {
	        el = glob.doc.createElementNS(xmlns, el);
	    }
	    return el;
	}
	Snap._.$ = $;
	Snap._.id = ID;
	function getAttrs(el) {
	    var attrs = el.attributes,
	        name,
	        out = {};
	    for (var i = 0; i < attrs.length; i++) {
	        if (attrs[i].namespaceURI == xlink) {
	            name = "xlink:";
	        } else {
	            name = "";
	        }
	        name += attrs[i].name;
	        out[name] = attrs[i].textContent;
	    }
	    return out;
	}
	function is(o, type) {
	    type = Str.prototype.toLowerCase.call(type);
	    if (type == "finite") {
	        return isFinite(o);
	    }
	    if (type == "array" &&
	        (o instanceof Array || Array.isArray && Array.isArray(o))) {
	        return true;
	    }
	    return  type == "null" && o === null ||
	            type == typeof o && o !== null ||
	            type == "object" && o === Object(o) ||
	            objectToString.call(o).slice(8, -1).toLowerCase() == type;
	}
	/*\
	 * Snap.format
	 [ method ]
	 **
	 * Replaces construction of type `{<name>}` to the corresponding argument
	 **
	 - token (string) string to format
	 - json (object) object which properties are used as a replacement
	 = (string) formatted string
	 > Usage
	 | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
	 | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
	 |     x: 10,
	 |     y: 20,
	 |     dim: {
	 |         width: 40,
	 |         height: 50,
	 |         "negative width": -40
	 |     }
	 | }));
	\*/
	Snap.format = (function () {
	    var tokenRegex = /\{([^\}]+)\}/g,
	        objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
	        replacer = function (all, key, obj) {
	            var res = obj;
	            key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
	                name = name || quotedName;
	                if (res) {
	                    if (name in res) {
	                        res = res[name];
	                    }
	                    typeof res == "function" && isFunc && (res = res());
	                }
	            });
	            res = (res == null || res == obj ? all : res) + "";
	            return res;
	        };
	    return function (str, obj) {
	        return Str(str).replace(tokenRegex, function (all, key) {
	            return replacer(all, key, obj);
	        });
	    };
	})();
	function clone(obj) {
	    if (typeof obj == "function" || Object(obj) !== obj) {
	        return obj;
	    }
	    var res = new obj.constructor;
	    for (var key in obj) if (obj[has](key)) {
	        res[key] = clone(obj[key]);
	    }
	    return res;
	}
	Snap._.clone = clone;
	function repush(array, item) {
	    for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
	        return array.push(array.splice(i, 1)[0]);
	    }
	}
	function cacher(f, scope, postprocessor) {
	    function newf() {
	        var arg = Array.prototype.slice.call(arguments, 0),
	            args = arg.join("\u2400"),
	            cache = newf.cache = newf.cache || {},
	            count = newf.count = newf.count || [];
	        if (cache[has](args)) {
	            repush(count, args);
	            return postprocessor ? postprocessor(cache[args]) : cache[args];
	        }
	        count.length >= 1e3 && delete cache[count.shift()];
	        count.push(args);
	        cache[args] = f.apply(scope, arg);
	        return postprocessor ? postprocessor(cache[args]) : cache[args];
	    }
	    return newf;
	}
	Snap._.cacher = cacher;
	function angle(x1, y1, x2, y2, x3, y3) {
	    if (x3 == null) {
	        var x = x1 - x2,
	            y = y1 - y2;
	        if (!x && !y) {
	            return 0;
	        }
	        return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
	    } else {
	        return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
	    }
	}
	function rad(deg) {
	    return deg % 360 * PI / 180;
	}
	function deg(rad) {
	    return rad * 180 / PI % 360;
	}
	function x_y() {
	    return this.x + S + this.y;
	}
	function x_y_w_h() {
	    return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
	}
	
	/*\
	 * Snap.rad
	 [ method ]
	 **
	 * Transform angle to radians
	 - deg (number) angle in degrees
	 = (number) angle in radians
	\*/
	Snap.rad = rad;
	/*\
	 * Snap.deg
	 [ method ]
	 **
	 * Transform angle to degrees
	 - rad (number) angle in radians
	 = (number) angle in degrees
	\*/
	Snap.deg = deg;
	/*\
	 * Snap.sin
	 [ method ]
	 **
	 * Equivalent to `Math.sin()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) sin
	\*/
	Snap.sin = function (angle) {
	    return math.sin(Snap.rad(angle));
	};
	/*\
	 * Snap.tan
	 [ method ]
	 **
	 * Equivalent to `Math.tan()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) tan
	\*/
	Snap.tan = function (angle) {
	    return math.tan(Snap.rad(angle));
	};
	/*\
	 * Snap.cos
	 [ method ]
	 **
	 * Equivalent to `Math.cos()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) cos
	\*/
	Snap.cos = function (angle) {
	    return math.cos(Snap.rad(angle));
	};
	/*\
	 * Snap.asin
	 [ method ]
	 **
	 * Equivalent to `Math.asin()` only works with degrees, not radians.
	 - num (number) value
	 = (number) asin in degrees
	\*/
	Snap.asin = function (num) {
	    return Snap.deg(math.asin(num));
	};
	/*\
	 * Snap.acos
	 [ method ]
	 **
	 * Equivalent to `Math.acos()` only works with degrees, not radians.
	 - num (number) value
	 = (number) acos in degrees
	\*/
	Snap.acos = function (num) {
	    return Snap.deg(math.acos(num));
	};
	/*\
	 * Snap.atan
	 [ method ]
	 **
	 * Equivalent to `Math.atan()` only works with degrees, not radians.
	 - num (number) value
	 = (number) atan in degrees
	\*/
	Snap.atan = function (num) {
	    return Snap.deg(math.atan(num));
	};
	/*\
	 * Snap.atan2
	 [ method ]
	 **
	 * Equivalent to `Math.atan2()` only works with degrees, not radians.
	 - num (number) value
	 = (number) atan2 in degrees
	\*/
	Snap.atan2 = function (num) {
	    return Snap.deg(math.atan2(num));
	};
	/*\
	 * Snap.angle
	 [ method ]
	 **
	 * Returns an angle between two or three points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 - x3 (number) #optional x coord of third point
	 - y3 (number) #optional y coord of third point
	 = (number) angle in degrees
	\*/
	Snap.angle = angle;
	/*\
	 * Snap.len
	 [ method ]
	 **
	 * Returns distance between two points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 = (number) distance
	\*/
	Snap.len = function (x1, y1, x2, y2) {
	    return Math.sqrt(Snap.len2(x1, y1, x2, y2));
	};
	/*\
	 * Snap.len2
	 [ method ]
	 **
	 * Returns squared distance between two points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 = (number) distance
	\*/
	Snap.len2 = function (x1, y1, x2, y2) {
	    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
	};
	/*\
	 * Snap.closestPoint
	 [ method ]
	 **
	 * Returns closest point to a given one on a given path.
	 - path (Element) path element
	 - x (number) x coord of a point
	 - y (number) y coord of a point
	 = (object) in format
	 {
	    x (number) x coord of the point on the path
	    y (number) y coord of the point on the path
	    length (number) length of the path to the point
	    distance (number) distance from the given point to the path
	 }
	\*/
	// Copied from http://bl.ocks.org/mbostock/8027637
	Snap.closestPoint = function (path, x, y) {
	    function distance2(p) {
	        var dx = p.x - x,
	            dy = p.y - y;
	        return dx * dx + dy * dy;
	    }
	    var pathNode = path.node,
	        pathLength = pathNode.getTotalLength(),
	        precision = pathLength / pathNode.pathSegList.numberOfItems * .125,
	        best,
	        bestLength,
	        bestDistance = Infinity;
	
	    // linear scan for coarse approximation
	    for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
	        if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
	            best = scan;
	            bestLength = scanLength;
	            bestDistance = scanDistance;
	        }
	    }
	
	    // binary search for precise estimate
	    precision *= .5;
	    while (precision > .5) {
	        var before,
	            after,
	            beforeLength,
	            afterLength,
	            beforeDistance,
	            afterDistance;
	        if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
	            best = before;
	            bestLength = beforeLength;
	            bestDistance = beforeDistance;
	        } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
	            best = after;
	            bestLength = afterLength;
	            bestDistance = afterDistance;
	        } else {
	            precision *= .5;
	        }
	    }
	
	    best = {
	        x: best.x,
	        y: best.y,
	        length: bestLength,
	        distance: Math.sqrt(bestDistance)
	    };
	    return best;
	}
	/*\
	 * Snap.is
	 [ method ]
	 **
	 * Handy replacement for the `typeof` operator
	 - o (…) any object or primitive
	 - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
	 = (boolean) `true` if given value is of given type
	\*/
	Snap.is = is;
	/*\
	 * Snap.snapTo
	 [ method ]
	 **
	 * Snaps given value to given grid
	 - values (array|number) given array of values or step of the grid
	 - value (number) value to adjust
	 - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
	 = (number) adjusted value
	\*/
	Snap.snapTo = function (values, value, tolerance) {
	    tolerance = is(tolerance, "finite") ? tolerance : 10;
	    if (is(values, "array")) {
	        var i = values.length;
	        while (i--) if (abs(values[i] - value) <= tolerance) {
	            return values[i];
	        }
	    } else {
	        values = +values;
	        var rem = value % values;
	        if (rem < tolerance) {
	            return value - rem;
	        }
	        if (rem > values - tolerance) {
	            return value - rem + values;
	        }
	    }
	    return value;
	};
	// Colour
	/*\
	 * Snap.getRGB
	 [ method ]
	 **
	 * Parses color string as RGB object
	 - color (string) color string in one of the following formats:
	 # <ul>
	 #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
	 #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
	 #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
	 #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
	 #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
	 #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
	 #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
	 #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
	 #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
	 #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
	 #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
	 #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
	 # </ul>
	 * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••,
	 o     error (boolean) true if string can't be parsed
	 o }
	\*/
	Snap.getRGB = cacher(function (colour) {
	    if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
	        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	    }
	    if (colour == "none") {
	        return {r: -1, g: -1, b: -1, hex: "none", toString: rgbtoString};
	    }
	    !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
	    if (!colour) {
	        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	    }
	    var res,
	        red,
	        green,
	        blue,
	        opacity,
	        t,
	        values,
	        rgb = colour.match(colourRegExp);
	    if (rgb) {
	        if (rgb[2]) {
	            blue = toInt(rgb[2].substring(5), 16);
	            green = toInt(rgb[2].substring(3, 5), 16);
	            red = toInt(rgb[2].substring(1, 3), 16);
	        }
	        if (rgb[3]) {
	            blue = toInt((t = rgb[3].charAt(3)) + t, 16);
	            green = toInt((t = rgb[3].charAt(2)) + t, 16);
	            red = toInt((t = rgb[3].charAt(1)) + t, 16);
	        }
	        if (rgb[4]) {
	            values = rgb[4].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red *= 2.55);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green *= 2.55);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue *= 2.55);
	            rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	        }
	        if (rgb[5]) {
	            values = rgb[5].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red /= 100);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green /= 100);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue /= 100);
	            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	            rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	            return Snap.hsb2rgb(red, green, blue, opacity);
	        }
	        if (rgb[6]) {
	            values = rgb[6].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red /= 100);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green /= 100);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue /= 100);
	            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	            rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	            return Snap.hsl2rgb(red, green, blue, opacity);
	        }
	        red = mmin(math.round(red), 255);
	        green = mmin(math.round(green), 255);
	        blue = mmin(math.round(blue), 255);
	        opacity = mmin(mmax(opacity, 0), 1);
	        rgb = {r: red, g: green, b: blue, toString: rgbtoString};
	        rgb.hex = "#" + (16777216 | blue | green << 8 | red << 16).toString(16).slice(1);
	        rgb.opacity = is(opacity, "finite") ? opacity : 1;
	        return rgb;
	    }
	    return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	}, Snap);
	/*\
	 * Snap.hsb
	 [ method ]
	 **
	 * Converts HSB values to a hex representation of the color
	 - h (number) hue
	 - s (number) saturation
	 - b (number) value or brightness
	 = (string) hex representation of the color
	\*/
	Snap.hsb = cacher(function (h, s, b) {
	    return Snap.hsb2rgb(h, s, b).hex;
	});
	/*\
	 * Snap.hsl
	 [ method ]
	 **
	 * Converts HSL values to a hex representation of the color
	 - h (number) hue
	 - s (number) saturation
	 - l (number) luminosity
	 = (string) hex representation of the color
	\*/
	Snap.hsl = cacher(function (h, s, l) {
	    return Snap.hsl2rgb(h, s, l).hex;
	});
	/*\
	 * Snap.rgb
	 [ method ]
	 **
	 * Converts RGB values to a hex representation of the color
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (string) hex representation of the color
	\*/
	Snap.rgb = cacher(function (r, g, b, o) {
	    if (is(o, "finite")) {
	        var round = math.round;
	        return "rgba(" + [round(r), round(g), round(b), +o.toFixed(2)] + ")";
	    }
	    return "#" + (16777216 | b | g << 8 | r << 16).toString(16).slice(1);
	});
	var toHex = function (color) {
	    var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0],
	        red = "rgb(255, 0, 0)";
	    toHex = cacher(function (color) {
	        if (color.toLowerCase() == "red") {
	            return red;
	        }
	        i.style.color = red;
	        i.style.color = color;
	        var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
	        return out == red ? null : out;
	    });
	    return toHex(color);
	},
	hsbtoString = function () {
	    return "hsb(" + [this.h, this.s, this.b] + ")";
	},
	hsltoString = function () {
	    return "hsl(" + [this.h, this.s, this.l] + ")";
	},
	rgbtoString = function () {
	    return this.opacity == 1 || this.opacity == null ?
	            this.hex :
	            "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
	},
	prepareRGB = function (r, g, b) {
	    if (g == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
	        b = r.b;
	        g = r.g;
	        r = r.r;
	    }
	    if (g == null && is(r, string)) {
	        var clr = Snap.getRGB(r);
	        r = clr.r;
	        g = clr.g;
	        b = clr.b;
	    }
	    if (r > 1 || g > 1 || b > 1) {
	        r /= 255;
	        g /= 255;
	        b /= 255;
	    }
	
	    return [r, g, b];
	},
	packageRGB = function (r, g, b, o) {
	    r = math.round(r * 255);
	    g = math.round(g * 255);
	    b = math.round(b * 255);
	    var rgb = {
	        r: r,
	        g: g,
	        b: b,
	        opacity: is(o, "finite") ? o : 1,
	        hex: Snap.rgb(r, g, b),
	        toString: rgbtoString
	    };
	    is(o, "finite") && (rgb.opacity = o);
	    return rgb;
	};
	/*\
	 * Snap.color
	 [ method ]
	 **
	 * Parses the color string and returns an object featuring the color's component values
	 - clr (string) color string in one of the supported formats (see @Snap.getRGB)
	 = (object) Combined RGB/HSB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••,
	 o     error (boolean) `true` if string can't be parsed,
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     v (number) value (brightness),
	 o     l (number) lightness
	 o }
	\*/
	Snap.color = function (clr) {
	    var rgb;
	    if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
	        rgb = Snap.hsb2rgb(clr);
	        clr.r = rgb.r;
	        clr.g = rgb.g;
	        clr.b = rgb.b;
	        clr.opacity = 1;
	        clr.hex = rgb.hex;
	    } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
	        rgb = Snap.hsl2rgb(clr);
	        clr.r = rgb.r;
	        clr.g = rgb.g;
	        clr.b = rgb.b;
	        clr.opacity = 1;
	        clr.hex = rgb.hex;
	    } else {
	        if (is(clr, "string")) {
	            clr = Snap.getRGB(clr);
	        }
	        if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
	            rgb = Snap.rgb2hsl(clr);
	            clr.h = rgb.h;
	            clr.s = rgb.s;
	            clr.l = rgb.l;
	            rgb = Snap.rgb2hsb(clr);
	            clr.v = rgb.b;
	        } else {
	            clr = {hex: "none"};
	            clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
	            clr.error = 1;
	        }
	    }
	    clr.toString = rgbtoString;
	    return clr;
	};
	/*\
	 * Snap.hsb2rgb
	 [ method ]
	 **
	 * Converts HSB values to an RGB object
	 - h (number) hue
	 - s (number) saturation
	 - v (number) value or brightness
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••
	 o }
	\*/
	Snap.hsb2rgb = function (h, s, v, o) {
	    if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
	        v = h.b;
	        s = h.s;
	        o = h.o;
	        h = h.h;
	    }
	    h *= 360;
	    var R, G, B, X, C;
	    h = h % 360 / 60;
	    C = v * s;
	    X = C * (1 - abs(h % 2 - 1));
	    R = G = B = v - C;
	
	    h = ~~h;
	    R += [C, X, 0, 0, X, C][h];
	    G += [X, C, C, X, 0, 0][h];
	    B += [0, 0, X, C, C, X][h];
	    return packageRGB(R, G, B, o);
	};
	/*\
	 * Snap.hsl2rgb
	 [ method ]
	 **
	 * Converts HSL values to an RGB object
	 - h (number) hue
	 - s (number) saturation
	 - l (number) luminosity
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••
	 o }
	\*/
	Snap.hsl2rgb = function (h, s, l, o) {
	    if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
	        l = h.l;
	        s = h.s;
	        h = h.h;
	    }
	    if (h > 1 || s > 1 || l > 1) {
	        h /= 360;
	        s /= 100;
	        l /= 100;
	    }
	    h *= 360;
	    var R, G, B, X, C;
	    h = h % 360 / 60;
	    C = 2 * s * (l < .5 ? l : 1 - l);
	    X = C * (1 - abs(h % 2 - 1));
	    R = G = B = l - C / 2;
	
	    h = ~~h;
	    R += [C, X, 0, 0, X, C][h];
	    G += [X, C, C, X, 0, 0][h];
	    B += [0, 0, X, C, C, X][h];
	    return packageRGB(R, G, B, o);
	};
	/*\
	 * Snap.rgb2hsb
	 [ method ]
	 **
	 * Converts RGB values to an HSB object
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (object) HSB object in the following format:
	 o {
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     b (number) brightness
	 o }
	\*/
	Snap.rgb2hsb = function (r, g, b) {
	    b = prepareRGB(r, g, b);
	    r = b[0];
	    g = b[1];
	    b = b[2];
	
	    var H, S, V, C;
	    V = mmax(r, g, b);
	    C = V - mmin(r, g, b);
	    H = C == 0 ? null :
	        V == r ? (g - b) / C :
	        V == g ? (b - r) / C + 2 :
	                 (r - g) / C + 4;
	    H = (H + 360) % 6 * 60 / 360;
	    S = C == 0 ? 0 : C / V;
	    return {h: H, s: S, b: V, toString: hsbtoString};
	};
	/*\
	 * Snap.rgb2hsl
	 [ method ]
	 **
	 * Converts RGB values to an HSL object
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (object) HSL object in the following format:
	 o {
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     l (number) luminosity
	 o }
	\*/
	Snap.rgb2hsl = function (r, g, b) {
	    b = prepareRGB(r, g, b);
	    r = b[0];
	    g = b[1];
	    b = b[2];
	
	    var H, S, L, M, m, C;
	    M = mmax(r, g, b);
	    m = mmin(r, g, b);
	    C = M - m;
	    H = C == 0 ? null :
	        M == r ? (g - b) / C :
	        M == g ? (b - r) / C + 2 :
	                 (r - g) / C + 4;
	    H = (H + 360) % 6 * 60 / 360;
	    L = (M + m) / 2;
	    S = C == 0 ? 0 :
	         L < .5 ? C / (2 * L) :
	                  C / (2 - 2 * L);
	    return {h: H, s: S, l: L, toString: hsltoString};
	};
	
	// Transformations
	/*\
	 * Snap.parsePathString
	 [ method ]
	 **
	 * Utility method
	 **
	 * Parses given path string into an array of arrays of path segments
	 - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
	 = (array) array of segments
	\*/
	Snap.parsePathString = function (pathString) {
	    if (!pathString) {
	        return null;
	    }
	    var pth = Snap.path(pathString);
	    if (pth.arr) {
	        return Snap.path.clone(pth.arr);
	    }
	
	    var paramCounts = {a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0},
	        data = [];
	    if (is(pathString, "array") && is(pathString[0], "array")) { // rough assumption
	        data = Snap.path.clone(pathString);
	    }
	    if (!data.length) {
	        Str(pathString).replace(pathCommand, function (a, b, c) {
	            var params = [],
	                name = b.toLowerCase();
	            c.replace(pathValues, function (a, b) {
	                b && params.push(+b);
	            });
	            if (name == "m" && params.length > 2) {
	                data.push([b].concat(params.splice(0, 2)));
	                name = "l";
	                b = b == "m" ? "l" : "L";
	            }
	            if (name == "o" && params.length == 1) {
	                data.push([b, params[0]]);
	            }
	            if (name == "r") {
	                data.push([b].concat(params));
	            } else while (params.length >= paramCounts[name]) {
	                data.push([b].concat(params.splice(0, paramCounts[name])));
	                if (!paramCounts[name]) {
	                    break;
	                }
	            }
	        });
	    }
	    data.toString = Snap.path.toString;
	    pth.arr = Snap.path.clone(data);
	    return data;
	};
	/*\
	 * Snap.parseTransformString
	 [ method ]
	 **
	 * Utility method
	 **
	 * Parses given transform string into an array of transformations
	 - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
	 = (array) array of transformations
	\*/
	var parseTransformString = Snap.parseTransformString = function (TString) {
	    if (!TString) {
	        return null;
	    }
	    var paramCounts = {r: 3, s: 4, t: 2, m: 6},
	        data = [];
	    if (is(TString, "array") && is(TString[0], "array")) { // rough assumption
	        data = Snap.path.clone(TString);
	    }
	    if (!data.length) {
	        Str(TString).replace(tCommand, function (a, b, c) {
	            var params = [],
	                name = b.toLowerCase();
	            c.replace(pathValues, function (a, b) {
	                b && params.push(+b);
	            });
	            data.push([b].concat(params));
	        });
	    }
	    data.toString = Snap.path.toString;
	    return data;
	};
	function svgTransform2string(tstr) {
	    var res = [];
	    tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function (all, name, params) {
	        params = params.split(/\s*,\s*|\s+/);
	        if (name == "rotate" && params.length == 1) {
	            params.push(0, 0);
	        }
	        if (name == "scale") {
	            if (params.length > 2) {
	                params = params.slice(0, 2);
	            } else if (params.length == 2) {
	                params.push(0, 0);
	            }
	            if (params.length == 1) {
	                params.push(params[0], 0, 0);
	            }
	        }
	        if (name == "skewX") {
	            res.push(["m", 1, 0, math.tan(rad(params[0])), 1, 0, 0]);
	        } else if (name == "skewY") {
	            res.push(["m", 1, math.tan(rad(params[0])), 0, 1, 0, 0]);
	        } else {
	            res.push([name.charAt(0)].concat(params));
	        }
	        return all;
	    });
	    return res;
	}
	Snap._.svgTransform2string = svgTransform2string;
	Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
	function transform2matrix(tstr, bbox) {
	    var tdata = parseTransformString(tstr),
	        m = new Snap.Matrix;
	    if (tdata) {
	        for (var i = 0, ii = tdata.length; i < ii; i++) {
	            var t = tdata[i],
	                tlen = t.length,
	                command = Str(t[0]).toLowerCase(),
	                absolute = t[0] != command,
	                inver = absolute ? m.invert() : 0,
	                x1,
	                y1,
	                x2,
	                y2,
	                bb;
	            if (command == "t" && tlen == 2){
	                m.translate(t[1], 0);
	            } else if (command == "t" && tlen == 3) {
	                if (absolute) {
	                    x1 = inver.x(0, 0);
	                    y1 = inver.y(0, 0);
	                    x2 = inver.x(t[1], t[2]);
	                    y2 = inver.y(t[1], t[2]);
	                    m.translate(x2 - x1, y2 - y1);
	                } else {
	                    m.translate(t[1], t[2]);
	                }
	            } else if (command == "r") {
	                if (tlen == 2) {
	                    bb = bb || bbox;
	                    m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                } else if (tlen == 4) {
	                    if (absolute) {
	                        x2 = inver.x(t[2], t[3]);
	                        y2 = inver.y(t[2], t[3]);
	                        m.rotate(t[1], x2, y2);
	                    } else {
	                        m.rotate(t[1], t[2], t[3]);
	                    }
	                }
	            } else if (command == "s") {
	                if (tlen == 2 || tlen == 3) {
	                    bb = bb || bbox;
	                    m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                } else if (tlen == 4) {
	                    if (absolute) {
	                        x2 = inver.x(t[2], t[3]);
	                        y2 = inver.y(t[2], t[3]);
	                        m.scale(t[1], t[1], x2, y2);
	                    } else {
	                        m.scale(t[1], t[1], t[2], t[3]);
	                    }
	                } else if (tlen == 5) {
	                    if (absolute) {
	                        x2 = inver.x(t[3], t[4]);
	                        y2 = inver.y(t[3], t[4]);
	                        m.scale(t[1], t[2], x2, y2);
	                    } else {
	                        m.scale(t[1], t[2], t[3], t[4]);
	                    }
	                }
	            } else if (command == "m" && tlen == 7) {
	                m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
	            }
	        }
	    }
	    return m;
	}
	Snap._.transform2matrix = transform2matrix;
	Snap._unit2px = unit2px;
	var contains = glob.doc.contains || glob.doc.compareDocumentPosition ?
	    function (a, b) {
	        var adown = a.nodeType == 9 ? a.documentElement : a,
	            bup = b && b.parentNode;
	            return a == bup || !!(bup && bup.nodeType == 1 && (
	                adown.contains ?
	                    adown.contains(bup) :
	                    a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
	            ));
	    } :
	    function (a, b) {
	        if (b) {
	            while (b) {
	                b = b.parentNode;
	                if (b == a) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	function getSomeDefs(el) {
	    var p = el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) ||
	            el.node.parentNode && wrap(el.node.parentNode) ||
	            Snap.select("svg") ||
	            Snap(0, 0),
	        pdefs = p.select("defs"),
	        defs  = pdefs == null ? false : pdefs.node;
	    if (!defs) {
	        defs = make("defs", p.node).node;
	    }
	    return defs;
	}
	function getSomeSVG(el) {
	    return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
	}
	Snap._.getSomeDefs = getSomeDefs;
	Snap._.getSomeSVG = getSomeSVG;
	function unit2px(el, name, value) {
	    var svg = getSomeSVG(el).node,
	        out = {},
	        mgr = svg.querySelector(".svg---mgr");
	    if (!mgr) {
	        mgr = $("rect");
	        $(mgr, {x: -9e9, y: -9e9, width: 10, height: 10, "class": "svg---mgr", fill: "none"});
	        svg.appendChild(mgr);
	    }
	    function getW(val) {
	        if (val == null) {
	            return E;
	        }
	        if (val == +val) {
	            return val;
	        }
	        $(mgr, {width: val});
	        try {
	            return mgr.getBBox().width;
	        } catch (e) {
	            return 0;
	        }
	    }
	    function getH(val) {
	        if (val == null) {
	            return E;
	        }
	        if (val == +val) {
	            return val;
	        }
	        $(mgr, {height: val});
	        try {
	            return mgr.getBBox().height;
	        } catch (e) {
	            return 0;
	        }
	    }
	    function set(nam, f) {
	        if (name == null) {
	            out[nam] = f(el.attr(nam) || 0);
	        } else if (nam == name) {
	            out = f(value == null ? el.attr(nam) || 0 : value);
	        }
	    }
	    switch (el.type) {
	        case "rect":
	            set("rx", getW);
	            set("ry", getH);
	        case "image":
	            set("width", getW);
	            set("height", getH);
	        case "text":
	            set("x", getW);
	            set("y", getH);
	        break;
	        case "circle":
	            set("cx", getW);
	            set("cy", getH);
	            set("r", getW);
	        break;
	        case "ellipse":
	            set("cx", getW);
	            set("cy", getH);
	            set("rx", getW);
	            set("ry", getH);
	        break;
	        case "line":
	            set("x1", getW);
	            set("x2", getW);
	            set("y1", getH);
	            set("y2", getH);
	        break;
	        case "marker":
	            set("refX", getW);
	            set("markerWidth", getW);
	            set("refY", getH);
	            set("markerHeight", getH);
	        break;
	        case "radialGradient":
	            set("fx", getW);
	            set("fy", getH);
	        break;
	        case "tspan":
	            set("dx", getW);
	            set("dy", getH);
	        break;
	        default:
	            set(name, getW);
	    }
	    svg.removeChild(mgr);
	    return out;
	}
	/*\
	 * Snap.select
	 [ method ]
	 **
	 * Wraps a DOM element specified by CSS selector as @Element
	 - query (string) CSS selector of the element
	 = (Element) the current element
	\*/
	Snap.select = function (query) {
	    query = Str(query).replace(/([^\\]):/g, "$1\\:");
	    return wrap(glob.doc.querySelector(query));
	};
	/*\
	 * Snap.selectAll
	 [ method ]
	 **
	 * Wraps DOM elements specified by CSS selector as set or array of @Element
	 - query (string) CSS selector of the element
	 = (Element) the current element
	\*/
	Snap.selectAll = function (query) {
	    var nodelist = glob.doc.querySelectorAll(query),
	        set = (Snap.set || Array)();
	    for (var i = 0; i < nodelist.length; i++) {
	        set.push(wrap(nodelist[i]));
	    }
	    return set;
	};
	
	function add2group(list) {
	    if (!is(list, "array")) {
	        list = Array.prototype.slice.call(arguments, 0);
	    }
	    var i = 0,
	        j = 0,
	        node = this.node;
	    while (this[i]) delete this[i++];
	    for (i = 0; i < list.length; i++) {
	        if (list[i].type == "set") {
	            list[i].forEach(function (el) {
	                node.appendChild(el.node);
	            });
	        } else {
	            node.appendChild(list[i].node);
	        }
	    }
	    var children = node.childNodes;
	    for (i = 0; i < children.length; i++) {
	        this[j++] = wrap(children[i]);
	    }
	    return this;
	}
	// Hub garbage collector every 10s
	setInterval(function () {
	    for (var key in hub) if (hub[has](key)) {
	        var el = hub[key],
	            node = el.node;
	        if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) {
	            delete hub[key];
	        }
	    }
	}, 1e4);
	function Element(el) {
	    if (el.snap in hub) {
	        return hub[el.snap];
	    }
	    var svg;
	    try {
	        svg = el.ownerSVGElement;
	    } catch(e) {}
	    /*\
	     * Element.node
	     [ property (object) ]
	     **
	     * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
	     > Usage
	     | // draw a circle at coordinate 10,10 with radius of 10
	     | var c = paper.circle(10, 10, 10);
	     | c.node.onclick = function () {
	     |     c.attr("fill", "red");
	     | };
	    \*/
	    this.node = el;
	    if (svg) {
	        this.paper = new Paper(svg);
	    }
	    /*\
	     * Element.type
	     [ property (string) ]
	     **
	     * SVG tag name of the given element.
	    \*/
	    this.type = el.tagName || el.nodeName;
	    var id = this.id = ID(this);
	    this.anims = {};
	    this._ = {
	        transform: []
	    };
	    el.snap = id;
	    hub[id] = this;
	    if (this.type == "g") {
	        this.add = add2group;
	    }
	    if (this.type in {g: 1, mask: 1, pattern: 1, symbol: 1}) {
	        for (var method in Paper.prototype) if (Paper.prototype[has](method)) {
	            this[method] = Paper.prototype[method];
	        }
	    }
	}
	   /*\
	     * Element.attr
	     [ method ]
	     **
	     * Gets or sets given attributes of the element.
	     **
	     - params (object) contains key-value pairs of attributes you want to set
	     * or
	     - param (string) name of the attribute
	     = (Element) the current element
	     * or
	     = (string) value of attribute
	     > Usage
	     | el.attr({
	     |     fill: "#fc0",
	     |     stroke: "#000",
	     |     strokeWidth: 2, // CamelCase...
	     |     "fill-opacity": 0.5, // or dash-separated names
	     |     width: "*=2" // prefixed values
	     | });
	     | console.log(el.attr("fill")); // #fc0
	     * Prefixed values in format `"+=10"` supported. All four operations
	     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
	     * and `-`: `"+=2em"`.
	    \*/
	    Element.prototype.attr = function (params, value) {
	        var el = this,
	            node = el.node;
	        if (!params) {
	            if (node.nodeType != 1) {
	                return {
	                    text: node.nodeValue
	                };
	            }
	            var attr = node.attributes,
	                out = {};
	            for (var i = 0, ii = attr.length; i < ii; i++) {
	                out[attr[i].nodeName] = attr[i].nodeValue;
	            }
	            return out;
	        }
	        if (is(params, "string")) {
	            if (arguments.length > 1) {
	                var json = {};
	                json[params] = value;
	                params = json;
	            } else {
	                return eve("snap.util.getattr." + params, el).firstDefined();
	            }
	        }
	        for (var att in params) {
	            if (params[has](att)) {
	                eve("snap.util.attr." + att, el, params[att]);
	            }
	        }
	        return el;
	    };
	/*\
	 * Snap.parse
	 [ method ]
	 **
	 * Parses SVG fragment and converts it into a @Fragment
	 **
	 - svg (string) SVG string
	 = (Fragment) the @Fragment
	\*/
	Snap.parse = function (svg) {
	    var f = glob.doc.createDocumentFragment(),
	        full = true,
	        div = glob.doc.createElement("div");
	    svg = Str(svg);
	    if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
	        svg = "<svg>" + svg + "</svg>";
	        full = false;
	    }
	    div.innerHTML = svg;
	    svg = div.getElementsByTagName("svg")[0];
	    if (svg) {
	        if (full) {
	            f = svg;
	        } else {
	            while (svg.firstChild) {
	                f.appendChild(svg.firstChild);
	            }
	        }
	    }
	    return new Fragment(f);
	};
	function Fragment(frag) {
	    this.node = frag;
	}
	/*\
	 * Snap.fragment
	 [ method ]
	 **
	 * Creates a DOM fragment from a given list of elements or strings
	 **
	 - varargs (…) SVG string
	 = (Fragment) the @Fragment
	\*/
	Snap.fragment = function () {
	    var args = Array.prototype.slice.call(arguments, 0),
	        f = glob.doc.createDocumentFragment();
	    for (var i = 0, ii = args.length; i < ii; i++) {
	        var item = args[i];
	        if (item.node && item.node.nodeType) {
	            f.appendChild(item.node);
	        }
	        if (item.nodeType) {
	            f.appendChild(item);
	        }
	        if (typeof item == "string") {
	            f.appendChild(Snap.parse(item).node);
	        }
	    }
	    return new Fragment(f);
	};
	
	function make(name, parent) {
	    var res = $(name);
	    parent.appendChild(res);
	    var el = wrap(res);
	    return el;
	}
	function Paper(w, h) {
	    var res,
	        desc,
	        defs,
	        proto = Paper.prototype;
	    if (w && w.tagName && w.tagName.toLowerCase() == "svg") {
	        if (w.snap in hub) {
	            return hub[w.snap];
	        }
	        var doc = w.ownerDocument;
	        res = new Element(w);
	        desc = w.getElementsByTagName("desc")[0];
	        defs = w.getElementsByTagName("defs")[0];
	        if (!desc) {
	            desc = $("desc");
	            desc.appendChild(doc.createTextNode("Created with Snap"));
	            res.node.appendChild(desc);
	        }
	        if (!defs) {
	            defs = $("defs");
	            res.node.appendChild(defs);
	        }
	        res.defs = defs;
	        for (var key in proto) if (proto[has](key)) {
	            res[key] = proto[key];
	        }
	        res.paper = res.root = res;
	    } else {
	        res = make("svg", glob.doc.body);
	        $(res.node, {
	            height: h,
	            version: 1.1,
	            width: w,
	            xmlns: xmlns
	        });
	    }
	    return res;
	}
	function wrap(dom) {
	    if (!dom) {
	        return dom;
	    }
	    if (dom instanceof Element || dom instanceof Fragment) {
	        return dom;
	    }
	    if (dom.tagName && dom.tagName.toLowerCase() == "svg") {
	        return new Paper(dom);
	    }
	    if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") {
	        return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
	    }
	    return new Element(dom);
	}
	
	Snap._.make = make;
	Snap._.wrap = wrap;
	/*\
	 * Paper.el
	 [ method ]
	 **
	 * Creates an element on paper with a given name and no attributes
	 **
	 - name (string) tag name
	 - attr (object) attributes
	 = (Element) the current element
	 > Usage
	 | var c = paper.circle(10, 10, 10); // is the same as...
	 | var c = paper.el("circle").attr({
	 |     cx: 10,
	 |     cy: 10,
	 |     r: 10
	 | });
	 | // and the same as
	 | var c = paper.el("circle", {
	 |     cx: 10,
	 |     cy: 10,
	 |     r: 10
	 | });
	\*/
	Paper.prototype.el = function (name, attr) {
	    var el = make(name, this.node);
	    attr && el.attr(attr);
	    return el;
	};
	/*\
	 * Element.children
	 [ method ]
	 **
	 * Returns array of all the children of the element.
	 = (array) array of Elements
	\*/
	Element.prototype.children = function () {
	    var out = [],
	        ch = this.node.childNodes;
	    for (var i = 0, ii = ch.length; i < ii; i++) {
	        out[i] = Snap(ch[i]);
	    }
	    return out;
	};
	function jsonFiller(root, o) {
	    for (var i = 0, ii = root.length; i < ii; i++) {
	        var item = {
	                type: root[i].type,
	                attr: root[i].attr()
	            },
	            children = root[i].children();
	        o.push(item);
	        if (children.length) {
	            jsonFiller(children, item.childNodes = []);
	        }
	    }
	}
	/*\
	 * Element.toJSON
	 [ method ]
	 **
	 * Returns object representation of the given element and all its children.
	 = (object) in format
	 o {
	 o     type (string) this.type,
	 o     attr (object) attributes map,
	 o     childNodes (array) optional array of children in the same format
	 o }
	\*/
	Element.prototype.toJSON = function () {
	    var out = [];
	    jsonFiller([this], out);
	    return out[0];
	};
	// default
	eve.on("snap.util.getattr", function () {
	    var att = eve.nt();
	    att = att.substring(att.lastIndexOf(".") + 1);
	    var css = att.replace(/[A-Z]/g, function (letter) {
	        return "-" + letter.toLowerCase();
	    });
	    if (cssAttr[has](css)) {
	        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
	    } else {
	        return $(this.node, att);
	    }
	});
	var cssAttr = {
	    "alignment-baseline": 0,
	    "baseline-shift": 0,
	    "clip": 0,
	    "clip-path": 0,
	    "clip-rule": 0,
	    "color": 0,
	    "color-interpolation": 0,
	    "color-interpolation-filters": 0,
	    "color-profile": 0,
	    "color-rendering": 0,
	    "cursor": 0,
	    "direction": 0,
	    "display": 0,
	    "dominant-baseline": 0,
	    "enable-background": 0,
	    "fill": 0,
	    "fill-opacity": 0,
	    "fill-rule": 0,
	    "filter": 0,
	    "flood-color": 0,
	    "flood-opacity": 0,
	    "font": 0,
	    "font-family": 0,
	    "font-size": 0,
	    "font-size-adjust": 0,
	    "font-stretch": 0,
	    "font-style": 0,
	    "font-variant": 0,
	    "font-weight": 0,
	    "glyph-orientation-horizontal": 0,
	    "glyph-orientation-vertical": 0,
	    "image-rendering": 0,
	    "kerning": 0,
	    "letter-spacing": 0,
	    "lighting-color": 0,
	    "marker": 0,
	    "marker-end": 0,
	    "marker-mid": 0,
	    "marker-start": 0,
	    "mask": 0,
	    "opacity": 0,
	    "overflow": 0,
	    "pointer-events": 0,
	    "shape-rendering": 0,
	    "stop-color": 0,
	    "stop-opacity": 0,
	    "stroke": 0,
	    "stroke-dasharray": 0,
	    "stroke-dashoffset": 0,
	    "stroke-linecap": 0,
	    "stroke-linejoin": 0,
	    "stroke-miterlimit": 0,
	    "stroke-opacity": 0,
	    "stroke-width": 0,
	    "text-anchor": 0,
	    "text-decoration": 0,
	    "text-rendering": 0,
	    "unicode-bidi": 0,
	    "visibility": 0,
	    "word-spacing": 0,
	    "writing-mode": 0
	};
	
	eve.on("snap.util.attr", function (value) {
	    var att = eve.nt(),
	        attr = {};
	    att = att.substring(att.lastIndexOf(".") + 1);
	    attr[att] = value;
	    var style = att.replace(/-(\w)/gi, function (all, letter) {
	            return letter.toUpperCase();
	        }),
	        css = att.replace(/[A-Z]/g, function (letter) {
	            return "-" + letter.toLowerCase();
	        });
	    if (cssAttr[has](css)) {
	        this.node.style[style] = value == null ? E : value;
	    } else {
	        $(this.node, attr);
	    }
	});
	(function (proto) {}(Paper.prototype));
	
	// simple ajax
	/*\
	 * Snap.ajax
	 [ method ]
	 **
	 * Simple implementation of Ajax
	 **
	 - url (string) URL
	 - postData (object|string) data for post request
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	 * or
	 - url (string) URL
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	 = (XMLHttpRequest) the XMLHttpRequest object, just in case
	\*/
	Snap.ajax = function (url, postData, callback, scope){
	    var req = new XMLHttpRequest,
	        id = ID();
	    if (req) {
	        if (is(postData, "function")) {
	            scope = callback;
	            callback = postData;
	            postData = null;
	        } else if (is(postData, "object")) {
	            var pd = [];
	            for (var key in postData) if (postData.hasOwnProperty(key)) {
	                pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
	            }
	            postData = pd.join("&");
	        }
	        req.open(postData ? "POST" : "GET", url, true);
	        if (postData) {
	            req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	            req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	        }
	        if (callback) {
	            eve.once("snap.ajax." + id + ".0", callback);
	            eve.once("snap.ajax." + id + ".200", callback);
	            eve.once("snap.ajax." + id + ".304", callback);
	        }
	        req.onreadystatechange = function() {
	            if (req.readyState != 4) return;
	            eve("snap.ajax." + id + "." + req.status, scope, req);
	        };
	        if (req.readyState == 4) {
	            return req;
	        }
	        req.send(postData);
	        return req;
	    }
	};
	/*\
	 * Snap.load
	 [ method ]
	 **
	 * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
	 **
	 - url (string) URL
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	\*/
	Snap.load = function (url, callback, scope) {
	    Snap.ajax(url, function (req) {
	        var f = Snap.parse(req.responseText);
	        scope ? callback.call(scope, f) : callback(f);
	    });
	};
	var getOffset = function (elem) {
	    var box = elem.getBoundingClientRect(),
	        doc = elem.ownerDocument,
	        body = doc.body,
	        docElem = doc.documentElement,
	        clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0,
	        top  = box.top  + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop ) - clientTop,
	        left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
	    return {
	        y: top,
	        x: left
	    };
	};
	/*\
	 * Snap.getElementByPoint
	 [ method ]
	 **
	 * Returns you topmost element under given point.
	 **
	 = (object) Snap element object
	 - x (number) x coordinate from the top left corner of the window
	 - y (number) y coordinate from the top left corner of the window
	 > Usage
	 | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
	\*/
	Snap.getElementByPoint = function (x, y) {
	    var paper = this,
	        svg = paper.canvas,
	        target = glob.doc.elementFromPoint(x, y);
	    if (glob.win.opera && target.tagName == "svg") {
	        var so = getOffset(target),
	            sr = target.createSVGRect();
	        sr.x = x - so.x;
	        sr.y = y - so.y;
	        sr.width = sr.height = 1;
	        var hits = target.getIntersectionList(sr, null);
	        if (hits.length) {
	            target = hits[hits.length - 1];
	        }
	    }
	    if (!target) {
	        return null;
	    }
	    return wrap(target);
	};
	/*\
	 * Snap.plugin
	 [ method ]
	 **
	 * Let you write plugins. You pass in a function with five arguments, like this:
	 | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
	 |     Snap.newmethod = function () {};
	 |     Element.prototype.newmethod = function () {};
	 |     Paper.prototype.newmethod = function () {};
	 | });
	 * Inside the function you have access to all main objects (and their
	 * prototypes). This allow you to extend anything you want.
	 **
	 - f (function) your plugin body
	\*/
	Snap.plugin = function (f) {
	    f(Snap, Element, Paper, glob, Fragment);
	};
	glob.win.Snap = Snap;
	return Snap;
	}(window || this));
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        Str = String,
	        unit2px = Snap._unit2px,
	        $ = Snap._.$,
	        make = Snap._.make,
	        getSomeDefs = Snap._.getSomeDefs,
	        has = "hasOwnProperty",
	        wrap = Snap._.wrap;
	    /*\
	     * Element.getBBox
	     [ method ]
	     **
	     * Returns the bounding box descriptor for the given element
	     **
	     = (object) bounding box descriptor:
	     o {
	     o     cx: (number) x of the center,
	     o     cy: (number) x of the center,
	     o     h: (number) height,
	     o     height: (number) height,
	     o     path: (string) path command for the box,
	     o     r0: (number) radius of a circle that fully encloses the box,
	     o     r1: (number) radius of the smallest circle that can be enclosed,
	     o     r2: (number) radius of the largest circle that can be enclosed,
	     o     vb: (string) box as a viewbox command,
	     o     w: (number) width,
	     o     width: (number) width,
	     o     x2: (number) x of the right side,
	     o     x: (number) x of the left side,
	     o     y2: (number) y of the bottom edge,
	     o     y: (number) y of the top edge
	     o }
	    \*/
	    elproto.getBBox = function (isWithoutTransform) {
	        if (this.type == "tspan") {
	            return Snap._.box(this.node.getClientRects().item(0));
	        }
	        if (!Snap.Matrix || !Snap.path) {
	            return this.node.getBBox();
	        }
	        var el = this,
	            m = new Snap.Matrix;
	        if (el.removed) {
	            return Snap._.box();
	        }
	        while (el.type == "use") {
	            if (!isWithoutTransform) {
	                m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
	            }
	            if (el.original) {
	                el = el.original;
	            } else {
	                var href = el.attr("xlink:href");
	                el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
	            }
	        }
	        var _ = el._,
	            pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
	        try {
	            if (isWithoutTransform) {
	                _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
	                return Snap._.box(_.bboxwt);
	            } else {
	                el.realPath = pathfinder(el);
	                el.matrix = el.transform().localMatrix;
	                _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
	                return Snap._.box(_.bbox);
	            }
	        } catch (e) {
	            // Firefox doesn’t give you bbox of hidden element
	            return Snap._.box();
	        }
	    };
	    var propString = function () {
	        return this.string;
	    };
	    function extractTransform(el, tstr) {
	        if (tstr == null) {
	            var doReturn = true;
	            if (el.type == "linearGradient" || el.type == "radialGradient") {
	                tstr = el.node.getAttribute("gradientTransform");
	            } else if (el.type == "pattern") {
	                tstr = el.node.getAttribute("patternTransform");
	            } else {
	                tstr = el.node.getAttribute("transform");
	            }
	            if (!tstr) {
	                return new Snap.Matrix;
	            }
	            tstr = Snap._.svgTransform2string(tstr);
	        } else {
	            if (!Snap._.rgTransform.test(tstr)) {
	                tstr = Snap._.svgTransform2string(tstr);
	            } else {
	                tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
	            }
	            if (is(tstr, "array")) {
	                tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
	            }
	            el._.transform = tstr;
	        }
	        var m = Snap._.transform2matrix(tstr, el.getBBox(1));
	        if (doReturn) {
	            return m;
	        } else {
	            el.matrix = m;
	        }
	    }
	    /*\
	     * Element.transform
	     [ method ]
	     **
	     * Gets or sets transformation of the element
	     **
	     - tstr (string) transform string in Snap or SVG format
	     = (Element) the current element
	     * or
	     = (object) transformation descriptor:
	     o {
	     o     string (string) transform string,
	     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
	     o     localMatrix (Matrix) matrix of transformations applied only to the element,
	     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
	     o     global (string) global transformation as string,
	     o     local (string) local transformation as string,
	     o     toString (function) returns `string` property
	     o }
	    \*/
	    elproto.transform = function (tstr) {
	        var _ = this._;
	        if (tstr == null) {
	            var papa = this,
	                global = new Snap.Matrix(this.node.getCTM()),
	                local = extractTransform(this),
	                ms = [local],
	                m = new Snap.Matrix,
	                i,
	                localString = local.toTransformString(),
	                string = Str(local) == Str(this.matrix) ?
	                            Str(_.transform) : localString;
	            while (papa.type != "svg" && (papa = papa.parent())) {
	                ms.push(extractTransform(papa));
	            }
	            i = ms.length;
	            while (i--) {
	                m.add(ms[i]);
	            }
	            return {
	                string: string,
	                globalMatrix: global,
	                totalMatrix: m,
	                localMatrix: local,
	                diffMatrix: global.clone().add(local.invert()),
	                global: global.toTransformString(),
	                total: m.toTransformString(),
	                local: localString,
	                toString: propString
	            };
	        }
	        if (tstr instanceof Snap.Matrix) {
	            this.matrix = tstr;
	            this._.transform = tstr.toTransformString();
	        } else {
	            extractTransform(this, tstr);
	        }
	
	        if (this.node) {
	            if (this.type == "linearGradient" || this.type == "radialGradient") {
	                $(this.node, {gradientTransform: this.matrix});
	            } else if (this.type == "pattern") {
	                $(this.node, {patternTransform: this.matrix});
	            } else {
	                $(this.node, {transform: this.matrix});
	            }
	        }
	
	        return this;
	    };
	    /*\
	     * Element.parent
	     [ method ]
	     **
	     * Returns the element's parent
	     **
	     = (Element) the parent element
	    \*/
	    elproto.parent = function () {
	        return wrap(this.node.parentNode);
	    };
	    /*\
	     * Element.append
	     [ method ]
	     **
	     * Appends the given element to current one
	     **
	     - el (Element|Set) element to append
	     = (Element) the parent element
	    \*/
	    /*\
	     * Element.add
	     [ method ]
	     **
	     * See @Element.append
	    \*/
	    elproto.append = elproto.add = function (el) {
	        if (el) {
	            if (el.type == "set") {
	                var it = this;
	                el.forEach(function (el) {
	                    it.add(el);
	                });
	                return this;
	            }
	            el = wrap(el);
	            this.node.appendChild(el.node);
	            el.paper = this.paper;
	        }
	        return this;
	    };
	    /*\
	     * Element.appendTo
	     [ method ]
	     **
	     * Appends the current element to the given one
	     **
	     - el (Element) parent element to append to
	     = (Element) the child element
	    \*/
	    elproto.appendTo = function (el) {
	        if (el) {
	            el = wrap(el);
	            el.append(this);
	        }
	        return this;
	    };
	    /*\
	     * Element.prepend
	     [ method ]
	     **
	     * Prepends the given element to the current one
	     **
	     - el (Element) element to prepend
	     = (Element) the parent element
	    \*/
	    elproto.prepend = function (el) {
	        if (el) {
	            if (el.type == "set") {
	                var it = this,
	                    first;
	                el.forEach(function (el) {
	                    if (first) {
	                        first.after(el);
	                    } else {
	                        it.prepend(el);
	                    }
	                    first = el;
	                });
	                return this;
	            }
	            el = wrap(el);
	            var parent = el.parent();
	            this.node.insertBefore(el.node, this.node.firstChild);
	            this.add && this.add();
	            el.paper = this.paper;
	            this.parent() && this.parent().add();
	            parent && parent.add();
	        }
	        return this;
	    };
	    /*\
	     * Element.prependTo
	     [ method ]
	     **
	     * Prepends the current element to the given one
	     **
	     - el (Element) parent element to prepend to
	     = (Element) the child element
	    \*/
	    elproto.prependTo = function (el) {
	        el = wrap(el);
	        el.prepend(this);
	        return this;
	    };
	    /*\
	     * Element.before
	     [ method ]
	     **
	     * Inserts given element before the current one
	     **
	     - el (Element) element to insert
	     = (Element) the parent element
	    \*/
	    elproto.before = function (el) {
	        if (el.type == "set") {
	            var it = this;
	            el.forEach(function (el) {
	                var parent = el.parent();
	                it.node.parentNode.insertBefore(el.node, it.node);
	                parent && parent.add();
	            });
	            this.parent().add();
	            return this;
	        }
	        el = wrap(el);
	        var parent = el.parent();
	        this.node.parentNode.insertBefore(el.node, this.node);
	        this.parent() && this.parent().add();
	        parent && parent.add();
	        el.paper = this.paper;
	        return this;
	    };
	    /*\
	     * Element.after
	     [ method ]
	     **
	     * Inserts given element after the current one
	     **
	     - el (Element) element to insert
	     = (Element) the parent element
	    \*/
	    elproto.after = function (el) {
	        el = wrap(el);
	        var parent = el.parent();
	        if (this.node.nextSibling) {
	            this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
	        } else {
	            this.node.parentNode.appendChild(el.node);
	        }
	        this.parent() && this.parent().add();
	        parent && parent.add();
	        el.paper = this.paper;
	        return this;
	    };
	    /*\
	     * Element.insertBefore
	     [ method ]
	     **
	     * Inserts the element after the given one
	     **
	     - el (Element) element next to whom insert to
	     = (Element) the parent element
	    \*/
	    elproto.insertBefore = function (el) {
	        el = wrap(el);
	        var parent = this.parent();
	        el.node.parentNode.insertBefore(this.node, el.node);
	        this.paper = el.paper;
	        parent && parent.add();
	        el.parent() && el.parent().add();
	        return this;
	    };
	    /*\
	     * Element.insertAfter
	     [ method ]
	     **
	     * Inserts the element after the given one
	     **
	     - el (Element) element next to whom insert to
	     = (Element) the parent element
	    \*/
	    elproto.insertAfter = function (el) {
	        el = wrap(el);
	        var parent = this.parent();
	        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
	        this.paper = el.paper;
	        parent && parent.add();
	        el.parent() && el.parent().add();
	        return this;
	    };
	    /*\
	     * Element.remove
	     [ method ]
	     **
	     * Removes element from the DOM
	     = (Element) the detached element
	    \*/
	    elproto.remove = function () {
	        var parent = this.parent();
	        this.node.parentNode && this.node.parentNode.removeChild(this.node);
	        delete this.paper;
	        this.removed = true;
	        parent && parent.add();
	        return this;
	    };
	    /*\
	     * Element.select
	     [ method ]
	     **
	     * Gathers the nested @Element matching the given set of CSS selectors
	     **
	     - query (string) CSS selector
	     = (Element) result of query selection
	    \*/
	    elproto.select = function (query) {
	        return wrap(this.node.querySelector(query));
	    };
	    /*\
	     * Element.selectAll
	     [ method ]
	     **
	     * Gathers nested @Element objects matching the given set of CSS selectors
	     **
	     - query (string) CSS selector
	     = (Set|array) result of query selection
	    \*/
	    elproto.selectAll = function (query) {
	        var nodelist = this.node.querySelectorAll(query),
	            set = (Snap.set || Array)();
	        for (var i = 0; i < nodelist.length; i++) {
	            set.push(wrap(nodelist[i]));
	        }
	        return set;
	    };
	    /*\
	     * Element.asPX
	     [ method ]
	     **
	     * Returns given attribute of the element as a `px` value (not %, em, etc.)
	     **
	     - attr (string) attribute name
	     - value (string) #optional attribute value
	     = (Element) result of query selection
	    \*/
	    elproto.asPX = function (attr, value) {
	        if (value == null) {
	            value = this.attr(attr);
	        }
	        return +unit2px(this, attr, value);
	    };
	    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
	    /*\
	     * Element.use
	     [ method ]
	     **
	     * Creates a `<use>` element linked to the current element
	     **
	     = (Element) the `<use>` element
	    \*/
	    elproto.use = function () {
	        var use,
	            id = this.node.id;
	        if (!id) {
	            id = this.id;
	            $(this.node, {
	                id: id
	            });
	        }
	        if (this.type == "linearGradient" || this.type == "radialGradient" ||
	            this.type == "pattern") {
	            use = make(this.type, this.node.parentNode);
	        } else {
	            use = make("use", this.node.parentNode);
	        }
	        $(use.node, {
	            "xlink:href": "#" + id
	        });
	        use.original = this;
	        return use;
	    };
	    function fixids(el) {
	        var els = el.selectAll("*"),
	            it,
	            url = /^\s*url\(("|'|)(.*)\1\)\s*$/,
	            ids = [],
	            uses = {};
	        function urltest(it, name) {
	            var val = $(it.node, name);
	            val = val && val.match(url);
	            val = val && val[2];
	            if (val && val.charAt() == "#") {
	                val = val.substring(1);
	            } else {
	                return;
	            }
	            if (val) {
	                uses[val] = (uses[val] || []).concat(function (id) {
	                    var attr = {};
	                    attr[name] = Snap.url(id);
	                    $(it.node, attr);
	                });
	            }
	        }
	        function linktest(it) {
	            var val = $(it.node, "xlink:href");
	            if (val && val.charAt() == "#") {
	                val = val.substring(1);
	            } else {
	                return;
	            }
	            if (val) {
	                uses[val] = (uses[val] || []).concat(function (id) {
	                    it.attr("xlink:href", "#" + id);
	                });
	            }
	        }
	        for (var i = 0, ii = els.length; i < ii; i++) {
	            it = els[i];
	            urltest(it, "fill");
	            urltest(it, "stroke");
	            urltest(it, "filter");
	            urltest(it, "mask");
	            urltest(it, "clip-path");
	            linktest(it);
	            var oldid = $(it.node, "id");
	            if (oldid) {
	                $(it.node, {id: it.id});
	                ids.push({
	                    old: oldid,
	                    id: it.id
	                });
	            }
	        }
	        for (i = 0, ii = ids.length; i < ii; i++) {
	            var fs = uses[ids[i].old];
	            if (fs) {
	                for (var j = 0, jj = fs.length; j < jj; j++) {
	                    fs[j](ids[i].id);
	                }
	            }
	        }
	    }
	    /*\
	     * Element.clone
	     [ method ]
	     **
	     * Creates a clone of the element and inserts it after the element
	     **
	     = (Element) the clone
	    \*/
	    elproto.clone = function () {
	        var clone = wrap(this.node.cloneNode(true));
	        if ($(clone.node, "id")) {
	            $(clone.node, {id: clone.id});
	        }
	        fixids(clone);
	        clone.insertAfter(this);
	        return clone;
	    };
	    /*\
	     * Element.toDefs
	     [ method ]
	     **
	     * Moves element to the shared `<defs>` area
	     **
	     = (Element) the element
	    \*/
	    elproto.toDefs = function () {
	        var defs = getSomeDefs(this);
	        defs.appendChild(this.node);
	        return this;
	    };
	    /*\
	     * Element.toPattern
	     [ method ]
	     **
	     * Creates a `<pattern>` element from the current element
	     **
	     * To create a pattern you have to specify the pattern rect:
	     - x (string|number)
	     - y (string|number)
	     - width (string|number)
	     - height (string|number)
	     = (Element) the `<pattern>` element
	     * You can use pattern later on as an argument for `fill` attribute:
	     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
	     |         fill: "none",
	     |         stroke: "#bada55",
	     |         strokeWidth: 5
	     |     }).pattern(0, 0, 10, 10),
	     |     c = paper.circle(200, 200, 100);
	     | c.attr({
	     |     fill: p
	     | });
	    \*/
	    elproto.pattern = elproto.toPattern = function (x, y, width, height) {
	        var p = make("pattern", getSomeDefs(this));
	        if (x == null) {
	            x = this.getBBox();
	        }
	        if (is(x, "object") && "x" in x) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            x = x.x;
	        }
	        $(p.node, {
	            x: x,
	            y: y,
	            width: width,
	            height: height,
	            patternUnits: "userSpaceOnUse",
	            id: p.id,
	            viewBox: [x, y, width, height].join(" ")
	        });
	        p.node.appendChild(this.node);
	        return p;
	    };
	// SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
	// SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
	    /*\
	     * Element.marker
	     [ method ]
	     **
	     * Creates a `<marker>` element from the current element
	     **
	     * To create a marker you have to specify the bounding rect and reference point:
	     - x (number)
	     - y (number)
	     - width (number)
	     - height (number)
	     - refX (number)
	     - refY (number)
	     = (Element) the `<marker>` element
	     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
	    \*/
	    // TODO add usage for markers
	    elproto.marker = function (x, y, width, height, refX, refY) {
	        var p = make("marker", getSomeDefs(this));
	        if (x == null) {
	            x = this.getBBox();
	        }
	        if (is(x, "object") && "x" in x) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            refX = x.refX || x.cx;
	            refY = x.refY || x.cy;
	            x = x.x;
	        }
	        $(p.node, {
	            viewBox: [x, y, width, height].join(" "),
	            markerWidth: width,
	            markerHeight: height,
	            orient: "auto",
	            refX: refX || 0,
	            refY: refY || 0,
	            id: p.id
	        });
	        p.node.appendChild(this.node);
	        return p;
	    };
	    var eldata = {};
	    /*\
	     * Element.data
	     [ method ]
	     **
	     * Adds or retrieves given value associated with given key. (Don’t confuse
	     * with `data-` attributes)
	     *
	     * See also @Element.removeData
	     - key (string) key to store data
	     - value (any) #optional value to store
	     = (object) @Element
	     * or, if value is not specified:
	     = (any) value
	     > Usage
	     | for (var i = 0, i < 5, i++) {
	     |     paper.circle(10 + 15 * i, 10, 10)
	     |          .attr({fill: "#000"})
	     |          .data("i", i)
	     |          .click(function () {
	     |             alert(this.data("i"));
	     |          });
	     | }
	    \*/
	    elproto.data = function (key, value) {
	        var data = eldata[this.id] = eldata[this.id] || {};
	        if (arguments.length == 0){
	            eve("snap.data.get." + this.id, this, data, null);
	            return data;
	        }
	        if (arguments.length == 1) {
	            if (Snap.is(key, "object")) {
	                for (var i in key) if (key[has](i)) {
	                    this.data(i, key[i]);
	                }
	                return this;
	            }
	            eve("snap.data.get." + this.id, this, data[key], key);
	            return data[key];
	        }
	        data[key] = value;
	        eve("snap.data.set." + this.id, this, value, key);
	        return this;
	    };
	    /*\
	     * Element.removeData
	     [ method ]
	     **
	     * Removes value associated with an element by given key.
	     * If key is not provided, removes all the data of the element.
	     - key (string) #optional key
	     = (object) @Element
	    \*/
	    elproto.removeData = function (key) {
	        if (key == null) {
	            eldata[this.id] = {};
	        } else {
	            eldata[this.id] && delete eldata[this.id][key];
	        }
	        return this;
	    };
	    /*\
	     * Element.outerSVG
	     [ method ]
	     **
	     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
	     *
	     * See also @Element.innerSVG
	     = (string) SVG code for the element
	    \*/
	    /*\
	     * Element.toString
	     [ method ]
	     **
	     * See @Element.outerSVG
	    \*/
	    elproto.outerSVG = elproto.toString = toString(1);
	    /*\
	     * Element.innerSVG
	     [ method ]
	     **
	     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
	     = (string) SVG code for the element
	    \*/
	    elproto.innerSVG = toString();
	    function toString(type) {
	        return function () {
	            var res = type ? "<" + this.type : "",
	                attr = this.node.attributes,
	                chld = this.node.childNodes;
	            if (type) {
	                for (var i = 0, ii = attr.length; i < ii; i++) {
	                    res += " " + attr[i].name + '="' +
	                            attr[i].value.replace(/"/g, '\\"') + '"';
	                }
	            }
	            if (chld.length) {
	                type && (res += ">");
	                for (i = 0, ii = chld.length; i < ii; i++) {
	                    if (chld[i].nodeType == 3) {
	                        res += chld[i].nodeValue;
	                    } else if (chld[i].nodeType == 1) {
	                        res += wrap(chld[i]).toString();
	                    }
	                }
	                type && (res += "</" + this.type + ">");
	            } else {
	                type && (res += "/>");
	            }
	            return res;
	        };
	    }
	    elproto.toDataURL = function () {
	        if (window && window.btoa) {
	            var bb = this.getBBox(),
	                svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
	                x: +bb.x.toFixed(3),
	                y: +bb.y.toFixed(3),
	                width: +bb.width.toFixed(3),
	                height: +bb.height.toFixed(3),
	                contents: this.outerSVG()
	            });
	            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
	        }
	    };
	    /*\
	     * Fragment.select
	     [ method ]
	     **
	     * See @Element.select
	    \*/
	    Fragment.prototype.select = elproto.select;
	    /*\
	     * Fragment.selectAll
	     [ method ]
	     **
	     * See @Element.selectAll
	    \*/
	    Fragment.prototype.selectAll = elproto.selectAll;
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var objectToString = Object.prototype.toString,
	        Str = String,
	        math = Math,
	        E = "";
	    function Matrix(a, b, c, d, e, f) {
	        if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
	            this.a = a.a;
	            this.b = a.b;
	            this.c = a.c;
	            this.d = a.d;
	            this.e = a.e;
	            this.f = a.f;
	            return;
	        }
	        if (a != null) {
	            this.a = +a;
	            this.b = +b;
	            this.c = +c;
	            this.d = +d;
	            this.e = +e;
	            this.f = +f;
	        } else {
	            this.a = 1;
	            this.b = 0;
	            this.c = 0;
	            this.d = 1;
	            this.e = 0;
	            this.f = 0;
	        }
	    }
	    (function (matrixproto) {
	        /*\
	         * Matrix.add
	         [ method ]
	         **
	         * Adds the given matrix to existing one
	         - a (number)
	         - b (number)
	         - c (number)
	         - d (number)
	         - e (number)
	         - f (number)
	         * or
	         - matrix (object) @Matrix
	        \*/
	        matrixproto.add = function (a, b, c, d, e, f) {
	            if (a && a instanceof Matrix) {
	                return this.add(a.a, a.b, a.c, a.d, a.e, a.f);
	            }
	            var aNew = a * this.a + b * this.c,
	                bNew = a * this.b + b * this.d;
	            this.e += e * this.a + f * this.c;
	            this.f += e * this.b + f * this.d;
	            this.c = c * this.a + d * this.c;
	            this.d = c * this.b + d * this.d;
	
	            this.a = aNew;
	            this.b = bNew;
	            return this;
	        };
	        /*\
	         * Matrix.multLeft
	         [ method ]
	         **
	         * Multiplies a passed affine transform to the left: M * this.
	         - a (number)
	         - b (number)
	         - c (number)
	         - d (number)
	         - e (number)
	         - f (number)
	         * or
	         - matrix (object) @Matrix
	        \*/
	        Matrix.prototype.multLeft = function (a, b, c, d, e, f) {
	            if (a && a instanceof Matrix) {
	                return this.multLeft(a.a, a.b, a.c, a.d, a.e, a.f);
	            }
	            var aNew = a * this.a + c * this.b,
	                cNew = a * this.c + c * this.d,
	                eNew = a * this.e + c * this.f + e;
	            this.b = b * this.a + d * this.b;
	            this.d = b * this.c + d * this.d;
	            this.f = b * this.e + d * this.f + f;
	
	            this.a = aNew;
	            this.c = cNew;
	            this.e = eNew;
	            return this;
	        };
	        /*\
	         * Matrix.invert
	         [ method ]
	         **
	         * Returns an inverted version of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.invert = function () {
	            var me = this,
	                x = me.a * me.d - me.b * me.c;
	            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
	        };
	        /*\
	         * Matrix.clone
	         [ method ]
	         **
	         * Returns a copy of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.clone = function () {
	            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
	        };
	        /*\
	         * Matrix.translate
	         [ method ]
	         **
	         * Translate the matrix
	         - x (number) horizontal offset distance
	         - y (number) vertical offset distance
	        \*/
	        matrixproto.translate = function (x, y) {
	            this.e += x * this.a + y * this.c;
	            this.f += x * this.b + y * this.d;
	            return this;
	        };
	        /*\
	         * Matrix.scale
	         [ method ]
	         **
	         * Scales the matrix
	         - x (number) amount to be scaled, with `1` resulting in no change
	         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
	         - cx (number) #optional horizontal origin point from which to scale
	         - cy (number) #optional vertical origin point from which to scale
	         * Default cx, cy is the middle point of the element.
	        \*/
	        matrixproto.scale = function (x, y, cx, cy) {
	            y == null && (y = x);
	            (cx || cy) && this.translate(cx, cy);
	            this.a *= x;
	            this.b *= x;
	            this.c *= y;
	            this.d *= y;
	            (cx || cy) && this.translate(-cx, -cy);
	            return this;
	        };
	        /*\
	         * Matrix.rotate
	         [ method ]
	         **
	         * Rotates the matrix
	         - a (number) angle of rotation, in degrees
	         - x (number) horizontal origin point from which to rotate
	         - y (number) vertical origin point from which to rotate
	        \*/
	        matrixproto.rotate = function (a, x, y) {
	            a = Snap.rad(a);
	            x = x || 0;
	            y = y || 0;
	            var cos = +math.cos(a).toFixed(9),
	                sin = +math.sin(a).toFixed(9);
	            this.add(cos, sin, -sin, cos, x, y);
	            return this.add(1, 0, 0, 1, -x, -y);
	        };
	        /*\
	         * Matrix.skewX
	         [ method ]
	         **
	         * Skews the matrix along the x-axis
	         - x (number) Angle to skew along the x-axis (in degrees).
	        \*/
	        matrixproto.skewX = function (x) {
	            return this.skew(x, 0);
	        };
	        /*\
	         * Matrix.skewY
	         [ method ]
	         **
	         * Skews the matrix along the y-axis
	         - y (number) Angle to skew along the y-axis (in degrees).
	        \*/
	        matrixproto.skewY = function (y) {
	            return this.skew(0, y);
	        };
	        /*\
	         * Matrix.skew
	         [ method ]
	         **
	         * Skews the matrix
	         - y (number) Angle to skew along the y-axis (in degrees).
	         - x (number) Angle to skew along the x-axis (in degrees).
	        \*/
	        matrixproto.skew = function (x, y) {
	            x = x || 0;
	            y = y || 0;
	            x = Snap.rad(x);
	            y = Snap.rad(y);
	            var c = math.tan(x).toFixed(9);
	            var b = math.tan(y).toFixed(9);
	            return this.add(1, b, c, 1, 0, 0);
	        };
	        /*\
	         * Matrix.x
	         [ method ]
	         **
	         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
	         - x (number)
	         - y (number)
	         = (number) x
	        \*/
	        matrixproto.x = function (x, y) {
	            return x * this.a + y * this.c + this.e;
	        };
	        /*\
	         * Matrix.y
	         [ method ]
	         **
	         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
	         - x (number)
	         - y (number)
	         = (number) y
	        \*/
	        matrixproto.y = function (x, y) {
	            return x * this.b + y * this.d + this.f;
	        };
	        matrixproto.get = function (i) {
	            return +this[Str.fromCharCode(97 + i)].toFixed(4);
	        };
	        matrixproto.toString = function () {
	            return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
	        };
	        matrixproto.offset = function () {
	            return [this.e.toFixed(4), this.f.toFixed(4)];
	        };
	        function norm(a) {
	            return a[0] * a[0] + a[1] * a[1];
	        }
	        function normalize(a) {
	            var mag = math.sqrt(norm(a));
	            a[0] && (a[0] /= mag);
	            a[1] && (a[1] /= mag);
	        }
	        /*\
	         * Matrix.determinant
	         [ method ]
	         **
	         * Finds determinant of the given matrix.
	         = (number) determinant
	        \*/
	        matrixproto.determinant = function () {
	            return this.a * this.d - this.b * this.c;
	        };
	        /*\
	         * Matrix.split
	         [ method ]
	         **
	         * Splits matrix into primitive transformations
	         = (object) in format:
	         o dx (number) translation by x
	         o dy (number) translation by y
	         o scalex (number) scale by x
	         o scaley (number) scale by y
	         o shear (number) shear
	         o rotate (number) rotation in deg
	         o isSimple (boolean) could it be represented via simple transformations
	        \*/
	        matrixproto.split = function () {
	            var out = {};
	            // translation
	            out.dx = this.e;
	            out.dy = this.f;
	
	            // scale and shear
	            var row = [[this.a, this.b], [this.c, this.d]];
	            out.scalex = math.sqrt(norm(row[0]));
	            normalize(row[0]);
	
	            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
	            row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];
	
	            out.scaley = math.sqrt(norm(row[1]));
	            normalize(row[1]);
	            out.shear /= out.scaley;
	
	            if (this.determinant() < 0) {
	                out.scalex = -out.scalex;
	            }
	
	            // rotation
	            var sin = row[0][1],
	                cos = row[1][1];
	            if (cos < 0) {
	                out.rotate = Snap.deg(math.acos(cos));
	                if (sin < 0) {
	                    out.rotate = 360 - out.rotate;
	                }
	            } else {
	                out.rotate = Snap.deg(math.asin(sin));
	            }
	
	            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
	            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
	            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
	            return out;
	        };
	        /*\
	         * Matrix.toTransformString
	         [ method ]
	         **
	         * Returns transform string that represents given matrix
	         = (string) transform string
	        \*/
	        matrixproto.toTransformString = function (shorter) {
	            var s = shorter || this.split();
	            if (!+s.shear.toFixed(9)) {
	                s.scalex = +s.scalex.toFixed(4);
	                s.scaley = +s.scaley.toFixed(4);
	                s.rotate = +s.rotate.toFixed(4);
	                return  (s.dx || s.dy ? "t" + [+s.dx.toFixed(4), +s.dy.toFixed(4)] : E) +
	                        (s.rotate ? "r" + [+s.rotate.toFixed(4), 0, 0] : E) +
	                        (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E);
	            } else {
	                return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
	            }
	        };
	    })(Matrix.prototype);
	    /*\
	     * Snap.Matrix
	     [ method ]
	     **
	     * Matrix constructor, extend on your own risk.
	     * To create matrices use @Snap.matrix.
	    \*/
	    Snap.Matrix = Matrix;
	    /*\
	     * Snap.matrix
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns a matrix based on the given parameters
	     - a (number)
	     - b (number)
	     - c (number)
	     - d (number)
	     - e (number)
	     - f (number)
	     * or
	     - svgMatrix (SVGMatrix)
	     = (object) @Matrix
	    \*/
	    Snap.matrix = function (a, b, c, d, e, f) {
	        return new Matrix(a, b, c, d, e, f);
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var has = "hasOwnProperty",
	        make = Snap._.make,
	        wrap = Snap._.wrap,
	        is = Snap.is,
	        getSomeDefs = Snap._.getSomeDefs,
	        reURLValue = /^url\((['"]?)([^)]+)\1\)$/,
	        $ = Snap._.$,
	        URL = Snap.url,
	        Str = String,
	        separator = Snap._.separator,
	        E = "";
	    /*\
	     * Snap.deurl
	     [ method ]
	     **
	     * Unwraps path from `"url(<path>)"`.
	     - value (string) url path
	     = (string) unwrapped path
	    \*/
	    Snap.deurl = function (value) {
	        var res = String(value).match(reURLValue);
	        return res ? res[2] : value;
	    }
	    // Attributes event handlers
	    eve.on("snap.util.attr.mask", function (value) {
	        if (value instanceof Element || value instanceof Fragment) {
	            eve.stop();
	            if (value instanceof Fragment && value.node.childNodes.length == 1) {
	                value = value.node.firstChild;
	                getSomeDefs(this).appendChild(value);
	                value = wrap(value);
	            }
	            if (value.type == "mask") {
	                var mask = value;
	            } else {
	                mask = make("mask", getSomeDefs(this));
	                mask.node.appendChild(value.node);
	            }
	            !mask.node.id && $(mask.node, {
	                id: mask.id
	            });
	            $(this.node, {
	                mask: URL(mask.id)
	            });
	        }
	    });
	    (function (clipIt) {
	        eve.on("snap.util.attr.clip", clipIt);
	        eve.on("snap.util.attr.clip-path", clipIt);
	        eve.on("snap.util.attr.clipPath", clipIt);
	    }(function (value) {
	        if (value instanceof Element || value instanceof Fragment) {
	            eve.stop();
	            var clip,
	                node = value.node;
	            while (node) {
	                if (node.nodeName === "clipPath") {
	                    clip = new Element(node);
	                    break;
	                }
	                if (node.nodeName === "svg") {
	                    clip = undefined;
	                    break;
	                }
	                node = node.parentNode;
	            }
	            if (!clip) {
	                clip = make("clipPath", getSomeDefs(this));
	                clip.node.appendChild(value.node);
	                !clip.node.id && $(clip.node, {
	                    id: clip.id
	                });
	            }
	            $(this.node, {
	                "clip-path": URL(clip.node.id || clip.id)
	            });
	        }
	    }));
	    function fillStroke(name) {
	        return function (value) {
	            eve.stop();
	            if (value instanceof Fragment && value.node.childNodes.length == 1 &&
	                (value.node.firstChild.tagName == "radialGradient" ||
	                value.node.firstChild.tagName == "linearGradient" ||
	                value.node.firstChild.tagName == "pattern")) {
	                value = value.node.firstChild;
	                getSomeDefs(this).appendChild(value);
	                value = wrap(value);
	            }
	            if (value instanceof Element) {
	                if (value.type == "radialGradient" || value.type == "linearGradient"
	                   || value.type == "pattern") {
	                    if (!value.node.id) {
	                        $(value.node, {
	                            id: value.id
	                        });
	                    }
	                    var fill = URL(value.node.id);
	                } else {
	                    fill = value.attr(name);
	                }
	            } else {
	                fill = Snap.color(value);
	                if (fill.error) {
	                    var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
	                    if (grad) {
	                        if (!grad.node.id) {
	                            $(grad.node, {
	                                id: grad.id
	                            });
	                        }
	                        fill = URL(grad.node.id);
	                    } else {
	                        fill = value;
	                    }
	                } else {
	                    fill = Str(fill);
	                }
	            }
	            var attrs = {};
	            attrs[name] = fill;
	            $(this.node, attrs);
	            this.node.style[name] = E;
	        };
	    }
	    eve.on("snap.util.attr.fill", fillStroke("fill"));
	    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
	    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
	    eve.on("snap.util.grad.parse", function parseGrad(string) {
	        string = Str(string);
	        var tokens = string.match(gradrg);
	        if (!tokens) {
	            return null;
	        }
	        var type = tokens[1],
	            params = tokens[2],
	            stops = tokens[3];
	        params = params.split(/\s*,\s*/).map(function (el) {
	            return +el == el ? +el : el;
	        });
	        if (params.length == 1 && params[0] == 0) {
	            params = [];
	        }
	        stops = stops.split("-");
	        stops = stops.map(function (el) {
	            el = el.split(":");
	            var out = {
	                color: el[0]
	            };
	            if (el[1]) {
	                out.offset = parseFloat(el[1]);
	            }
	            return out;
	        });
	        var len = stops.length,
	            start = 0,
	            j = 0;
	        function seed(i, end) {
	            var step = (end - start) / (i - j);
	            for (var k = j; k < i; k++) {
	                stops[k].offset = +(+start + step * (k - j)).toFixed(2);
	            }
	            j = i;
	            start = end;
	        }
	        len--;
	        for (var i = 0; i < len; i++) if ("offset" in stops[i]) {
	            seed(i, stops[i].offset);
	        }
	        stops[len].offset = stops[len].offset || 100;
	        seed(len, stops[len].offset);
	        return {
	            type: type,
	            params: params,
	            stops: stops
	        };
	    });
	
	    eve.on("snap.util.attr.d", function (value) {
	        eve.stop();
	        if (is(value, "array") && is(value[0], "array")) {
	            value = Snap.path.toString.call(value);
	        }
	        value = Str(value);
	        if (value.match(/[ruo]/i)) {
	            value = Snap.path.toAbsolute(value);
	        }
	        $(this.node, {d: value});
	    })(-1);
	    eve.on("snap.util.attr.#text", function (value) {
	        eve.stop();
	        value = Str(value);
	        var txt = glob.doc.createTextNode(value);
	        while (this.node.firstChild) {
	            this.node.removeChild(this.node.firstChild);
	        }
	        this.node.appendChild(txt);
	    })(-1);
	    eve.on("snap.util.attr.path", function (value) {
	        eve.stop();
	        this.attr({d: value});
	    })(-1);
	    eve.on("snap.util.attr.class", function (value) {
	        eve.stop();
	        this.node.className.baseVal = value;
	    })(-1);
	    eve.on("snap.util.attr.viewBox", function (value) {
	        var vb;
	        if (is(value, "object") && "x" in value) {
	            vb = [value.x, value.y, value.width, value.height].join(" ");
	        } else if (is(value, "array")) {
	            vb = value.join(" ");
	        } else {
	            vb = value;
	        }
	        $(this.node, {
	            viewBox: vb
	        });
	        eve.stop();
	    })(-1);
	    eve.on("snap.util.attr.transform", function (value) {
	        this.transform(value);
	        eve.stop();
	    })(-1);
	    eve.on("snap.util.attr.r", function (value) {
	        if (this.type == "rect") {
	            eve.stop();
	            $(this.node, {
	                rx: value,
	                ry: value
	            });
	        }
	    })(-1);
	    eve.on("snap.util.attr.textpath", function (value) {
	        eve.stop();
	        if (this.type == "text") {
	            var id, tp, node;
	            if (!value && this.textPath) {
	                tp = this.textPath;
	                while (tp.node.firstChild) {
	                    this.node.appendChild(tp.node.firstChild);
	                }
	                tp.remove();
	                delete this.textPath;
	                return;
	            }
	            if (is(value, "string")) {
	                var defs = getSomeDefs(this),
	                    path = wrap(defs.parentNode).path(value);
	                defs.appendChild(path.node);
	                id = path.id;
	                path.attr({id: id});
	            } else {
	                value = wrap(value);
	                if (value instanceof Element) {
	                    id = value.attr("id");
	                    if (!id) {
	                        id = value.id;
	                        value.attr({id: id});
	                    }
	                }
	            }
	            if (id) {
	                tp = this.textPath;
	                node = this.node;
	                if (tp) {
	                    tp.attr({"xlink:href": "#" + id});
	                } else {
	                    tp = $("textPath", {
	                        "xlink:href": "#" + id
	                    });
	                    while (node.firstChild) {
	                        tp.appendChild(node.firstChild);
	                    }
	                    node.appendChild(tp);
	                    this.textPath = wrap(tp);
	                }
	            }
	        }
	    })(-1);
	    eve.on("snap.util.attr.text", function (value) {
	        if (this.type == "text") {
	            var i = 0,
	                node = this.node,
	                tuner = function (chunk) {
	                    var out = $("tspan");
	                    if (is(chunk, "array")) {
	                        for (var i = 0; i < chunk.length; i++) {
	                            out.appendChild(tuner(chunk[i]));
	                        }
	                    } else {
	                        out.appendChild(glob.doc.createTextNode(chunk));
	                    }
	                    out.normalize && out.normalize();
	                    return out;
	                };
	            while (node.firstChild) {
	                node.removeChild(node.firstChild);
	            }
	            var tuned = tuner(value);
	            while (tuned.firstChild) {
	                node.appendChild(tuned.firstChild);
	            }
	        }
	        eve.stop();
	    })(-1);
	    function setFontSize(value) {
	        eve.stop();
	        if (value == +value) {
	            value += "px";
	        }
	        this.node.style.fontSize = value;
	    }
	    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
	    eve.on("snap.util.attr.font-size", setFontSize)(-1);
	
	
	    eve.on("snap.util.getattr.transform", function () {
	        eve.stop();
	        return this.transform();
	    })(-1);
	    eve.on("snap.util.getattr.textpath", function () {
	        eve.stop();
	        return this.textPath;
	    })(-1);
	    // Markers
	    (function () {
	        function getter(end) {
	            return function () {
	                eve.stop();
	                var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
	                if (style == "none") {
	                    return style;
	                } else {
	                    return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
	                }
	            };
	        }
	        function setter(end) {
	            return function (value) {
	                eve.stop();
	                var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
	                if (value == "" || !value) {
	                    this.node.style[name] = "none";
	                    return;
	                }
	                if (value.type == "marker") {
	                    var id = value.node.id;
	                    if (!id) {
	                        $(value.node, {id: value.id});
	                    }
	                    this.node.style[name] = URL(id);
	                    return;
	                }
	            };
	        }
	        eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
	        eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
	        eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
	        eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
	        eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
	        eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
	        eve.on("snap.util.attr.marker-end", setter("end"))(-1);
	        eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
	        eve.on("snap.util.attr.marker-start", setter("start"))(-1);
	        eve.on("snap.util.attr.markerStart", setter("start"))(-1);
	        eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
	        eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
	    }());
	    eve.on("snap.util.getattr.r", function () {
	        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
	            eve.stop();
	            return $(this.node, "rx");
	        }
	    })(-1);
	    function textExtract(node) {
	        var out = [];
	        var children = node.childNodes;
	        for (var i = 0, ii = children.length; i < ii; i++) {
	            var chi = children[i];
	            if (chi.nodeType == 3) {
	                out.push(chi.nodeValue);
	            }
	            if (chi.tagName == "tspan") {
	                if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) {
	                    out.push(chi.firstChild.nodeValue);
	                } else {
	                    out.push(textExtract(chi));
	                }
	            }
	        }
	        return out;
	    }
	    eve.on("snap.util.getattr.text", function () {
	        if (this.type == "text" || this.type == "tspan") {
	            eve.stop();
	            var out = textExtract(this.node);
	            return out.length == 1 ? out[0] : out;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.#text", function () {
	        return this.node.textContent;
	    })(-1);
	    eve.on("snap.util.getattr.fill", function (internal) {
	        if (internal) {
	            return;
	        }
	        eve.stop();
	        var value = eve("snap.util.getattr.fill", this, true).firstDefined();
	        return Snap(Snap.deurl(value)) || value;
	    })(-1);
	    eve.on("snap.util.getattr.stroke", function (internal) {
	        if (internal) {
	            return;
	        }
	        eve.stop();
	        var value = eve("snap.util.getattr.stroke", this, true).firstDefined();
	        return Snap(Snap.deurl(value)) || value;
	    })(-1);
	    eve.on("snap.util.getattr.viewBox", function () {
	        eve.stop();
	        var vb = $(this.node, "viewBox");
	        if (vb) {
	            vb = vb.split(separator);
	            return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
	        } else {
	            return;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.points", function () {
	        var p = $(this.node, "points");
	        eve.stop();
	        if (p) {
	            return p.split(separator);
	        } else {
	            return;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.path", function () {
	        var p = $(this.node, "d");
	        eve.stop();
	        return p;
	    })(-1);
	    eve.on("snap.util.getattr.class", function () {
	        return this.node.className.baseVal;
	    })(-1);
	    function getFontSize() {
	        eve.stop();
	        return this.node.style.fontSize;
	    }
	    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
	    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
	});
	
	// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var rgNotSpace = /\S+/g,
	        rgBadSpace = /[\t\r\n\f]/g,
	        rgTrim = /(^\s+|\s+$)/g,
	        Str = String,
	        elproto = Element.prototype;
	    /*\
	     * Element.addClass
	     [ method ]
	     **
	     * Adds given class name or list of class names to the element.
	     - value (string) class name or space separated list of class names
	     **
	     = (Element) original element.
	    \*/
	    elproto.addClass = function (value) {
	        var classes = Str(value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	
	        if (classes.length) {
	            j = 0;
	            while (clazz = classes[j++]) {
	                pos = curClasses.indexOf(clazz);
	                if (!~pos) {
	                    curClasses.push(clazz);
	                }
	            }
	
	            finalValue = curClasses.join(" ");
	            if (className != finalValue) {
	                elem.className.baseVal = finalValue;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.removeClass
	     [ method ]
	     **
	     * Removes given class name or list of class names from the element.
	     - value (string) class name or space separated list of class names
	     **
	     = (Element) original element.
	    \*/
	    elproto.removeClass = function (value) {
	        var classes = Str(value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	        if (curClasses.length) {
	            j = 0;
	            while (clazz = classes[j++]) {
	                pos = curClasses.indexOf(clazz);
	                if (~pos) {
	                    curClasses.splice(pos, 1);
	                }
	            }
	
	            finalValue = curClasses.join(" ");
	            if (className != finalValue) {
	                elem.className.baseVal = finalValue;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.hasClass
	     [ method ]
	     **
	     * Checks if the element has a given class name in the list of class names applied to it.
	     - value (string) class name
	     **
	     = (boolean) `true` if the element has given class
	    \*/
	    elproto.hasClass = function (value) {
	        var elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [];
	        return !!~curClasses.indexOf(value);
	    };
	    /*\
	     * Element.toggleClass
	     [ method ]
	     **
	     * Add or remove one or more classes from the element, depending on either
	     * the class’s presence or the value of the `flag` argument.
	     - value (string) class name or space separated list of class names
	     - flag (boolean) value to determine whether the class should be added or removed
	     **
	     = (Element) original element.
	    \*/
	    elproto.toggleClass = function (value, flag) {
	        if (flag != null) {
	            if (flag) {
	                return this.addClass(value);
	            } else {
	                return this.removeClass(value);
	            }
	        }
	        var classes = (value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	        j = 0;
	        while (clazz = classes[j++]) {
	            pos = curClasses.indexOf(clazz);
	            if (~pos) {
	                curClasses.splice(pos, 1);
	            } else {
	                curClasses.push(clazz);
	            }
	        }
	
	        finalValue = curClasses.join(" ");
	        if (className != finalValue) {
	            elem.className.baseVal = finalValue;
	        }
	        return this;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var operators = {
	            "+": function (x, y) {
	                    return x + y;
	                },
	            "-": function (x, y) {
	                    return x - y;
	                },
	            "/": function (x, y) {
	                    return x / y;
	                },
	            "*": function (x, y) {
	                    return x * y;
	                }
	        },
	        Str = String,
	        reUnit = /[a-z]+$/i,
	        reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
	    function getNumber(val) {
	        return val;
	    }
	    function getUnit(unit) {
	        return function (val) {
	            return +val.toFixed(3) + unit;
	        };
	    }
	    eve.on("snap.util.attr", function (val) {
	        var plus = Str(val).match(reAddon);
	        if (plus) {
	            var evnt = eve.nt(),
	                name = evnt.substring(evnt.lastIndexOf(".") + 1),
	                a = this.attr(name),
	                atr = {};
	            eve.stop();
	            var unit = plus[3] || "",
	                aUnit = a.match(reUnit),
	                op = operators[plus[1]];
	            if (aUnit && aUnit == unit) {
	                val = op(parseFloat(a), +plus[2]);
	            } else {
	                a = this.asPX(name);
	                val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
	            }
	            if (isNaN(a) || isNaN(val)) {
	                return;
	            }
	            atr[name] = val;
	            this.attr(atr);
	        }
	    })(-10);
	    eve.on("snap.util.equal", function (name, b) {
	        var A, B, a = Str(this.attr(name) || ""),
	            el = this,
	            bplus = Str(b).match(reAddon);
	        if (bplus) {
	            eve.stop();
	            var unit = bplus[3] || "",
	                aUnit = a.match(reUnit),
	                op = operators[bplus[1]];
	            if (aUnit && aUnit == unit) {
	                return {
	                    from: parseFloat(a),
	                    to: op(parseFloat(a), +bplus[2]),
	                    f: getUnit(aUnit)
	                };
	            } else {
	                a = this.asPX(name);
	                return {
	                    from: a,
	                    to: op(a, this.asPX(name, bplus[2] + unit)),
	                    f: getNumber
	                };
	            }
	        }
	    })(-10);
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var proto = Paper.prototype,
	        is = Snap.is;
	    /*\
	     * Paper.rect
	     [ method ]
	     *
	     * Draws a rectangle
	     **
	     - x (number) x coordinate of the top left corner
	     - y (number) y coordinate of the top left corner
	     - width (number) width
	     - height (number) height
	     - rx (number) #optional horizontal radius for rounded corners, default is 0
	     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
	     = (object) the `rect` element
	     **
	     > Usage
	     | // regular rectangle
	     | var c = paper.rect(10, 10, 50, 50);
	     | // rectangle with rounded corners
	     | var c = paper.rect(40, 40, 50, 50, 10);
	    \*/
	    proto.rect = function (x, y, w, h, rx, ry) {
	        var attr;
	        if (ry == null) {
	            ry = rx;
	        }
	        if (is(x, "object") && x == "[object Object]") {
	            attr = x;
	        } else if (x != null) {
	            attr = {
	                x: x,
	                y: y,
	                width: w,
	                height: h
	            };
	            if (rx != null) {
	                attr.rx = rx;
	                attr.ry = ry;
	            }
	        }
	        return this.el("rect", attr);
	    };
	    /*\
	     * Paper.circle
	     [ method ]
	     **
	     * Draws a circle
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - r (number) radius
	     = (object) the `circle` element
	     **
	     > Usage
	     | var c = paper.circle(50, 50, 40);
	    \*/
	    proto.circle = function (cx, cy, r) {
	        var attr;
	        if (is(cx, "object") && cx == "[object Object]") {
	            attr = cx;
	        } else if (cx != null) {
	            attr = {
	                cx: cx,
	                cy: cy,
	                r: r
	            };
	        }
	        return this.el("circle", attr);
	    };
	
	    var preload = (function () {
	        function onerror() {
	            this.parentNode.removeChild(this);
	        }
	        return function (src, f) {
	            var img = glob.doc.createElement("img"),
	                body = glob.doc.body;
	            img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
	            img.onload = function () {
	                f.call(img);
	                img.onload = img.onerror = null;
	                body.removeChild(img);
	            };
	            img.onerror = onerror;
	            body.appendChild(img);
	            img.src = src;
	        };
	    }());
	
	    /*\
	     * Paper.image
	     [ method ]
	     **
	     * Places an image on the surface
	     **
	     - src (string) URI of the source image
	     - x (number) x offset position
	     - y (number) y offset position
	     - width (number) width of the image
	     - height (number) height of the image
	     = (object) the `image` element
	     * or
	     = (object) Snap element object with type `image`
	     **
	     > Usage
	     | var c = paper.image("apple.png", 10, 10, 80, 80);
	    \*/
	    proto.image = function (src, x, y, width, height) {
	        var el = this.el("image");
	        if (is(src, "object") && "src" in src) {
	            el.attr(src);
	        } else if (src != null) {
	            var set = {
	                "xlink:href": src,
	                preserveAspectRatio: "none"
	            };
	            if (x != null && y != null) {
	                set.x = x;
	                set.y = y;
	            }
	            if (width != null && height != null) {
	                set.width = width;
	                set.height = height;
	            } else {
	                preload(src, function () {
	                    Snap._.$(el.node, {
	                        width: this.offsetWidth,
	                        height: this.offsetHeight
	                    });
	                });
	            }
	            Snap._.$(el.node, set);
	        }
	        return el;
	    };
	    /*\
	     * Paper.ellipse
	     [ method ]
	     **
	     * Draws an ellipse
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - rx (number) horizontal radius
	     - ry (number) vertical radius
	     = (object) the `ellipse` element
	     **
	     > Usage
	     | var c = paper.ellipse(50, 50, 40, 20);
	    \*/
	    proto.ellipse = function (cx, cy, rx, ry) {
	        var attr;
	        if (is(cx, "object") && cx == "[object Object]") {
	            attr = cx;
	        } else if (cx != null) {
	            attr ={
	                cx: cx,
	                cy: cy,
	                rx: rx,
	                ry: ry
	            };
	        }
	        return this.el("ellipse", attr);
	    };
	    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
	    /*\
	     * Paper.path
	     [ method ]
	     **
	     * Creates a `<path>` element using the given string as the path's definition
	     - pathString (string) #optional path string in SVG format
	     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
	     | "M10,20L30,40"
	     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
	     *
	     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
	     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
	     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
	     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
	     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
	     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
	     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
	     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
	     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
	     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
	     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
	     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
	     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
	     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
	     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
	     > Usage
	     | var c = paper.path("M10 10L90 90");
	     | // draw a diagonal line:
	     | // move to 10,10, line to 90,90
	    \*/
	    proto.path = function (d) {
	        var attr;
	        if (is(d, "object") && !is(d, "array")) {
	            attr = d;
	        } else if (d) {
	            attr = {d: d};
	        }
	        return this.el("path", attr);
	    };
	    /*\
	     * Paper.g
	     [ method ]
	     **
	     * Creates a group element
	     **
	     - varargs (…) #optional elements to nest within the group
	     = (object) the `g` element
	     **
	     > Usage
	     | var c1 = paper.circle(),
	     |     c2 = paper.rect(),
	     |     g = paper.g(c2, c1); // note that the order of elements is different
	     * or
	     | var c1 = paper.circle(),
	     |     c2 = paper.rect(),
	     |     g = paper.g();
	     | g.add(c2, c1);
	    \*/
	    /*\
	     * Paper.group
	     [ method ]
	     **
	     * See @Paper.g
	    \*/
	    proto.group = proto.g = function (first) {
	        var attr,
	            el = this.el("g");
	        if (arguments.length == 1 && first && !first.type) {
	            el.attr(first);
	        } else if (arguments.length) {
	            el.add(Array.prototype.slice.call(arguments, 0));
	        }
	        return el;
	    };
	    /*\
	     * Paper.svg
	     [ method ]
	     **
	     * Creates a nested SVG element.
	     - x (number) @optional X of the element
	     - y (number) @optional Y of the element
	     - width (number) @optional width of the element
	     - height (number) @optional height of the element
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     **
	     = (object) the `svg` element
	     **
	    \*/
	    proto.svg = function (x, y, width, height, vbx, vby, vbw, vbh) {
	        var attrs = {};
	        if (is(x, "object") && y == null) {
	            attrs = x;
	        } else {
	            if (x != null) {
	                attrs.x = x;
	            }
	            if (y != null) {
	                attrs.y = y;
	            }
	            if (width != null) {
	                attrs.width = width;
	            }
	            if (height != null) {
	                attrs.height = height;
	            }
	            if (vbx != null && vby != null && vbw != null && vbh != null) {
	                attrs.viewBox = [vbx, vby, vbw, vbh];
	            }
	        }
	        return this.el("svg", attrs);
	    };
	    /*\
	     * Paper.mask
	     [ method ]
	     **
	     * Equivalent in behaviour to @Paper.g, except it’s a mask.
	     **
	     = (object) the `mask` element
	     **
	    \*/
	    proto.mask = function (first) {
	        var attr,
	            el = this.el("mask");
	        if (arguments.length == 1 && first && !first.type) {
	            el.attr(first);
	        } else if (arguments.length) {
	            el.add(Array.prototype.slice.call(arguments, 0));
	        }
	        return el;
	    };
	    /*\
	     * Paper.ptrn
	     [ method ]
	     **
	     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
	     - x (number) @optional X of the element
	     - y (number) @optional Y of the element
	     - width (number) @optional width of the element
	     - height (number) @optional height of the element
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     **
	     = (object) the `pattern` element
	     **
	    \*/
	    proto.ptrn = function (x, y, width, height, vx, vy, vw, vh) {
	        if (is(x, "object")) {
	            var attr = x;
	        } else {
	            attr = {patternUnits: "userSpaceOnUse"};
	            if (x) {
	                attr.x = x;
	            }
	            if (y) {
	                attr.y = y;
	            }
	            if (width != null) {
	                attr.width = width;
	            }
	            if (height != null) {
	                attr.height = height;
	            }
	            if (vx != null && vy != null && vw != null && vh != null) {
	                attr.viewBox = [vx, vy, vw, vh];
	            } else {
	                attr.viewBox = [x || 0, y || 0, width || 0, height || 0];
	            }
	        }
	        return this.el("pattern", attr);
	    };
	    /*\
	     * Paper.use
	     [ method ]
	     **
	     * Creates a <use> element.
	     - id (string) @optional id of element to link
	     * or
	     - id (Element) @optional element to link
	     **
	     = (object) the `use` element
	     **
	    \*/
	    proto.use = function (id) {
	        if (id != null) {
	            if (id instanceof Element) {
	                if (!id.attr("id")) {
	                    id.attr({id: Snap._.id(id)});
	                }
	                id = id.attr("id");
	            }
	            if (String(id).charAt() == "#") {
	                id = id.substring(1);
	            }
	            return this.el("use", {"xlink:href": "#" + id});
	        } else {
	            return Element.prototype.use.call(this);
	        }
	    };
	    /*\
	     * Paper.symbol
	     [ method ]
	     **
	     * Creates a <symbol> element.
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     = (object) the `symbol` element
	     **
	    \*/
	    proto.symbol = function (vx, vy, vw, vh) {
	        var attr = {};
	        if (vx != null && vy != null && vw != null && vh != null) {
	            attr.viewBox = [vx, vy, vw, vh];
	        }
	
	        return this.el("symbol", attr);
	    };
	    /*\
	     * Paper.text
	     [ method ]
	     **
	     * Draws a text string
	     **
	     - x (number) x coordinate position
	     - y (number) y coordinate position
	     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
	     = (object) the `text` element
	     **
	     > Usage
	     | var t1 = paper.text(50, 50, "Snap");
	     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
	     | // Text path usage
	     | t1.attr({textpath: "M10,10L100,100"});
	     | // or
	     | var pth = paper.path("M10,10L100,100");
	     | t1.attr({textpath: pth});
	    \*/
	    proto.text = function (x, y, text) {
	        var attr = {};
	        if (is(x, "object")) {
	            attr = x;
	        } else if (x != null) {
	            attr = {
	                x: x,
	                y: y,
	                text: text || ""
	            };
	        }
	        return this.el("text", attr);
	    };
	    /*\
	     * Paper.line
	     [ method ]
	     **
	     * Draws a line
	     **
	     - x1 (number) x coordinate position of the start
	     - y1 (number) y coordinate position of the start
	     - x2 (number) x coordinate position of the end
	     - y2 (number) y coordinate position of the end
	     = (object) the `line` element
	     **
	     > Usage
	     | var t1 = paper.line(50, 50, 100, 100);
	    \*/
	    proto.line = function (x1, y1, x2, y2) {
	        var attr = {};
	        if (is(x1, "object")) {
	            attr = x1;
	        } else if (x1 != null) {
	            attr = {
	                x1: x1,
	                x2: x2,
	                y1: y1,
	                y2: y2
	            };
	        }
	        return this.el("line", attr);
	    };
	    /*\
	     * Paper.polyline
	     [ method ]
	     **
	     * Draws a polyline
	     **
	     - points (array) array of points
	     * or
	     - varargs (…) points
	     = (object) the `polyline` element
	     **
	     > Usage
	     | var p1 = paper.polyline([10, 10, 100, 100]);
	     | var p2 = paper.polyline(10, 10, 100, 100);
	    \*/
	    proto.polyline = function (points) {
	        if (arguments.length > 1) {
	            points = Array.prototype.slice.call(arguments, 0);
	        }
	        var attr = {};
	        if (is(points, "object") && !is(points, "array")) {
	            attr = points;
	        } else if (points != null) {
	            attr = {points: points};
	        }
	        return this.el("polyline", attr);
	    };
	    /*\
	     * Paper.polygon
	     [ method ]
	     **
	     * Draws a polygon. See @Paper.polyline
	    \*/
	    proto.polygon = function (points) {
	        if (arguments.length > 1) {
	            points = Array.prototype.slice.call(arguments, 0);
	        }
	        var attr = {};
	        if (is(points, "object") && !is(points, "array")) {
	            attr = points;
	        } else if (points != null) {
	            attr = {points: points};
	        }
	        return this.el("polygon", attr);
	    };
	    // gradients
	    (function () {
	        var $ = Snap._.$;
	        // gradients' helpers
	        /*\
	         * Element.stops
	         [ method ]
	         **
	         * Only for gradients!
	         * Returns array of gradient stops elements.
	         = (array) the stops array.
	        \*/
	        function Gstops() {
	            return this.selectAll("stop");
	        }
	        /*\
	         * Element.addStop
	         [ method ]
	         **
	         * Only for gradients!
	         * Adds another stop to the gradient.
	         - color (string) stops color
	         - offset (number) stops offset 0..100
	         = (object) gradient element
	        \*/
	        function GaddStop(color, offset) {
	            var stop = $("stop"),
	                attr = {
	                    offset: +offset + "%"
	                };
	            color = Snap.color(color);
	            attr["stop-color"] = color.hex;
	            if (color.opacity < 1) {
	                attr["stop-opacity"] = color.opacity;
	            }
	            $(stop, attr);
	            var stops = this.stops(),
	                inserted;
	            for (var i = 0; i < stops.length; i++) {
	                var stopOffset = parseFloat(stops[i].attr("offset"));
	                if (stopOffset > offset) {
	                    this.node.insertBefore(stop, stops[i].node);
	                    inserted = true;
	                    break;
	                }
	            }
	            if (!inserted) {
	                this.node.appendChild(stop);
	            }
	            return this;
	        }
	        function GgetBBox() {
	            if (this.type == "linearGradient") {
	                var x1 = $(this.node, "x1") || 0,
	                    x2 = $(this.node, "x2") || 1,
	                    y1 = $(this.node, "y1") || 0,
	                    y2 = $(this.node, "y2") || 0;
	                return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
	            } else {
	                var cx = this.node.cx || .5,
	                    cy = this.node.cy || .5,
	                    r = this.node.r || 0;
	                return Snap._.box(cx - r, cy - r, r * 2, r * 2);
	            }
	        }
	        /*\
	         * Element.setStops
	         [ method ]
	         **
	         * Only for gradients!
	         * Updates stops of the gradient based on passed gradient descriptor. See @Ppaer.gradient
	         - str (string) gradient descriptor part after `()`.
	         = (object) gradient element
	         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
	         | g.setStops("#fff-#000-#f00-#fc0");
	        \*/
	        function GsetStops(str) {
	            var grad = str,
	                stops = this.stops();
	            if (typeof str == "string") {
	                grad = eve("snap.util.grad.parse", null, "l(0,0,0,1)" + str).firstDefined().stops;
	            }
	            if (!Snap.is(grad, "array")) {
	                return;
	            }
	            for (var i = 0; i < stops.length; i++) {
	                if (grad[i]) {
	                    var color = Snap.color(grad[i].color),
	                        attr = {"offset": grad[i].offset + "%"};
	                    attr["stop-color"] = color.hex;
	                    if (color.opacity < 1) {
	                        attr["stop-opacity"] = color.opacity;
	                    }
	                    stops[i].attr(attr);
	                } else {
	                    stops[i].remove();
	                }
	            }
	            for (i = stops.length; i < grad.length; i++) {
	                this.addStop(grad[i].color, grad[i].offset);
	            }
	            return this;
	        }
	        function gradient(defs, str) {
	            var grad = eve("snap.util.grad.parse", null, str).firstDefined(),
	                el;
	            if (!grad) {
	                return null;
	            }
	            grad.params.unshift(defs);
	            if (grad.type.toLowerCase() == "l") {
	                el = gradientLinear.apply(0, grad.params);
	            } else {
	                el = gradientRadial.apply(0, grad.params);
	            }
	            if (grad.type != grad.type.toLowerCase()) {
	                $(el.node, {
	                    gradientUnits: "userSpaceOnUse"
	                });
	            }
	            var stops = grad.stops,
	                len = stops.length;
	            for (var i = 0; i < len; i++) {
	                var stop = stops[i];
	                el.addStop(stop.color, stop.offset);
	            }
	            return el;
	        }
	        function gradientLinear(defs, x1, y1, x2, y2) {
	            var el = Snap._.make("linearGradient", defs);
	            el.stops = Gstops;
	            el.addStop = GaddStop;
	            el.getBBox = GgetBBox;
	            el.setStops = GsetStops;
	            if (x1 != null) {
	                $(el.node, {
	                    x1: x1,
	                    y1: y1,
	                    x2: x2,
	                    y2: y2
	                });
	            }
	            return el;
	        }
	        function gradientRadial(defs, cx, cy, r, fx, fy) {
	            var el = Snap._.make("radialGradient", defs);
	            el.stops = Gstops;
	            el.addStop = GaddStop;
	            el.getBBox = GgetBBox;
	            if (cx != null) {
	                $(el.node, {
	                    cx: cx,
	                    cy: cy,
	                    r: r
	                });
	            }
	            if (fx != null && fy != null) {
	                $(el.node, {
	                    fx: fx,
	                    fy: fy
	                });
	            }
	            return el;
	        }
	        /*\
	         * Paper.gradient
	         [ method ]
	         **
	         * Creates a gradient element
	         **
	         - gradient (string) gradient descriptor
	         > Gradient Descriptor
	         * The gradient descriptor is an expression formatted as
	         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
	         * either linear or radial.  The uppercase `L` or `R` letters
	         * indicate absolute coordinates offset from the SVG surface.
	         * Lowercase `l` or `r` letters indicate coordinates
	         * calculated relative to the element to which the gradient is
	         * applied.  Coordinates specify a linear gradient vector as
	         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
	         * `r` and optional `fx`, `fy` specifying a focal point away
	         * from the center of the circle. Specify `<colors>` as a list
	         * of dash-separated CSS color values.  Each color may be
	         * followed by a custom offset value, separated with a colon
	         * character.
	         > Examples
	         * Linear gradient, relative from top-left corner to bottom-right
	         * corner, from black through red to white:
	         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
	         * Linear gradient, absolute from (0, 0) to (100, 100), from black
	         * through red at 25% to white:
	         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
	         * Radial gradient, relative from the center of the element with radius
	         * half the width, from black to white:
	         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
	         * To apply the gradient:
	         | paper.circle(50, 50, 40).attr({
	         |     fill: g
	         | });
	         = (object) the `gradient` element
	        \*/
	        proto.gradient = function (str) {
	            return gradient(this.defs, str);
	        };
	        proto.gradientLinear = function (x1, y1, x2, y2) {
	            return gradientLinear(this.defs, x1, y1, x2, y2);
	        };
	        proto.gradientRadial = function (cx, cy, r, fx, fy) {
	            return gradientRadial(this.defs, cx, cy, r, fx, fy);
	        };
	        /*\
	         * Paper.toString
	         [ method ]
	         **
	         * Returns SVG code for the @Paper
	         = (string) SVG code for the @Paper
	        \*/
	        proto.toString = function () {
	            var doc = this.node.ownerDocument,
	                f = doc.createDocumentFragment(),
	                d = doc.createElement("div"),
	                svg = this.node.cloneNode(true),
	                res;
	            f.appendChild(d);
	            d.appendChild(svg);
	            Snap._.$(svg, {xmlns: "http://www.w3.org/2000/svg"});
	            res = d.innerHTML;
	            f.removeChild(f.firstChild);
	            return res;
	        };
	        /*\
	         * Paper.toDataURL
	         [ method ]
	         **
	         * Returns SVG code for the @Paper as Data URI string.
	         = (string) Data URI string
	        \*/
	        proto.toDataURL = function () {
	            if (window && window.btoa) {
	                return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
	            }
	        };
	        /*\
	         * Paper.clear
	         [ method ]
	         **
	         * Removes all child nodes of the paper, except <defs>.
	        \*/
	        proto.clear = function () {
	            var node = this.node.firstChild,
	                next;
	            while (node) {
	                next = node.nextSibling;
	                if (node.tagName != "defs") {
	                    node.parentNode.removeChild(node);
	                } else {
	                    proto.clear.call({node: node});
	                }
	                node = next;
	            }
	        };
	    }());
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        clone = Snap._.clone,
	        has = "hasOwnProperty",
	        p2s = /,?([a-z]),?/gi,
	        toFloat = parseFloat,
	        math = Math,
	        PI = math.PI,
	        mmin = math.min,
	        mmax = math.max,
	        pow = math.pow,
	        abs = math.abs;
	    function paths(ps) {
	        var p = paths.ps = paths.ps || {};
	        if (p[ps]) {
	            p[ps].sleep = 100;
	        } else {
	            p[ps] = {
	                sleep: 100
	            };
	        }
	        setTimeout(function () {
	            for (var key in p) if (p[has](key) && key != ps) {
	                p[key].sleep--;
	                !p[key].sleep && delete p[key];
	            }
	        });
	        return p[ps];
	    }
	    function box(x, y, width, height) {
	        if (x == null) {
	            x = y = width = height = 0;
	        }
	        if (y == null) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            x = x.x;
	        }
	        return {
	            x: x,
	            y: y,
	            width: width,
	            w: width,
	            height: height,
	            h: height,
	            x2: x + width,
	            y2: y + height,
	            cx: x + width / 2,
	            cy: y + height / 2,
	            r1: math.min(width, height) / 2,
	            r2: math.max(width, height) / 2,
	            r0: math.sqrt(width * width + height * height) / 2,
	            path: rectPath(x, y, width, height),
	            vb: [x, y, width, height].join(" ")
	        };
	    }
	    function toString() {
	        return this.join(",").replace(p2s, "$1");
	    }
	    function pathClone(pathArray) {
	        var res = clone(pathArray);
	        res.toString = toString;
	        return res;
	    }
	    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
	        if (length == null) {
	            return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
	        } else {
	            return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y,
	                getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
	        }
	    }
	    function getLengthFactory(istotal, subpath) {
	        function O(val) {
	            return +(+val).toFixed(3);
	        }
	        return Snap._.cacher(function (path, length, onlystart) {
	            if (path instanceof Element) {
	                path = path.attr("d");
	            }
	            path = path2curve(path);
	            var x, y, p, l, sp = "", subpaths = {}, point,
	                len = 0;
	            for (var i = 0, ii = path.length; i < ii; i++) {
	                p = path[i];
	                if (p[0] == "M") {
	                    x = +p[1];
	                    y = +p[2];
	                } else {
	                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                    if (len + l > length) {
	                        if (subpath && !subpaths.start) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            sp += [
	                                "C" + O(point.start.x),
	                                O(point.start.y),
	                                O(point.m.x),
	                                O(point.m.y),
	                                O(point.x),
	                                O(point.y)
	                            ];
	                            if (onlystart) {return sp;}
	                            subpaths.start = sp;
	                            sp = [
	                                "M" + O(point.x),
	                                O(point.y) + "C" + O(point.n.x),
	                                O(point.n.y),
	                                O(point.end.x),
	                                O(point.end.y),
	                                O(p[5]),
	                                O(p[6])
	                            ].join();
	                            len += l;
	                            x = +p[5];
	                            y = +p[6];
	                            continue;
	                        }
	                        if (!istotal && !subpath) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            return point;
	                        }
	                    }
	                    len += l;
	                    x = +p[5];
	                    y = +p[6];
	                }
	                sp += p.shift() + p;
	            }
	            subpaths.end = sp;
	            point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
	            return point;
	        }, null, Snap._.clone);
	    }
	    var getTotalLength = getLengthFactory(1),
	        getPointAtLength = getLengthFactory(),
	        getSubpathsAtLength = getLengthFactory(0, 1);
	    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	        var t1 = 1 - t,
	            t13 = pow(t1, 3),
	            t12 = pow(t1, 2),
	            t2 = t * t,
	            t3 = t2 * t,
	            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
	            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
	            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
	            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
	            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
	            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
	            ax = t1 * p1x + t * c1x,
	            ay = t1 * p1y + t * c1y,
	            cx = t1 * c2x + t * p2x,
	            cy = t1 * c2y + t * p2y,
	            alpha = 90 - math.atan2(mx - nx, my - ny) * 180 / PI;
	        // (mx > nx || my < ny) && (alpha += 180);
	        return {
	            x: x,
	            y: y,
	            m: {x: mx, y: my},
	            n: {x: nx, y: ny},
	            start: {x: ax, y: ay},
	            end: {x: cx, y: cy},
	            alpha: alpha
	        };
	    }
	    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
	        if (!Snap.is(p1x, "array")) {
	            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
	        }
	        var bbox = curveDim.apply(null, p1x);
	        return box(
	            bbox.min.x,
	            bbox.min.y,
	            bbox.max.x - bbox.min.x,
	            bbox.max.y - bbox.min.y
	        );
	    }
	    function isPointInsideBBox(bbox, x, y) {
	        return  x >= bbox.x &&
	                x <= bbox.x + bbox.width &&
	                y >= bbox.y &&
	                y <= bbox.y + bbox.height;
	    }
	    function isBBoxIntersect(bbox1, bbox2) {
	        bbox1 = box(bbox1);
	        bbox2 = box(bbox2);
	        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y)
	            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y)
	            || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2)
	            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2)
	            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y)
	            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y)
	            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2)
	            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2)
	            || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x
	                || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x)
	            && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y
	                || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
	    }
	    function base3(t, p1, p2, p3, p4) {
	        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
	            t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
	        return t * t2 - 3 * p1 + 3 * p2;
	    }
	    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
	        if (z == null) {
	            z = 1;
	        }
	        z = z > 1 ? 1 : z < 0 ? 0 : z;
	        var z2 = z / 2,
	            n = 12,
	            Tvalues = [-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],
	            Cvalues = [0.2491,0.2491,0.2335,0.2335,0.2032,0.2032,0.1601,0.1601,0.1069,0.1069,0.0472,0.0472],
	            sum = 0;
	        for (var i = 0; i < n; i++) {
	            var ct = z2 * Tvalues[i] + z2,
	                xbase = base3(ct, x1, x2, x3, x4),
	                ybase = base3(ct, y1, y2, y3, y4),
	                comb = xbase * xbase + ybase * ybase;
	            sum += Cvalues[i] * math.sqrt(comb);
	        }
	        return z2 * sum;
	    }
	    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
	        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
	            return;
	        }
	        var t = 1,
	            step = t / 2,
	            t2 = t - step,
	            l,
	            e = .01;
	        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        while (abs(l - ll) > e) {
	            step /= 2;
	            t2 += (l < ll ? 1 : -1) * step;
	            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        }
	        return t2;
	    }
	    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
	        if (
	            mmax(x1, x2) < mmin(x3, x4) ||
	            mmin(x1, x2) > mmax(x3, x4) ||
	            mmax(y1, y2) < mmin(y3, y4) ||
	            mmin(y1, y2) > mmax(y3, y4)
	        ) {
	            return;
	        }
	        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
	            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
	            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
	
	        if (!denominator) {
	            return;
	        }
	        var px = nx / denominator,
	            py = ny / denominator,
	            px2 = +px.toFixed(2),
	            py2 = +py.toFixed(2);
	        if (
	            px2 < +mmin(x1, x2).toFixed(2) ||
	            px2 > +mmax(x1, x2).toFixed(2) ||
	            px2 < +mmin(x3, x4).toFixed(2) ||
	            px2 > +mmax(x3, x4).toFixed(2) ||
	            py2 < +mmin(y1, y2).toFixed(2) ||
	            py2 > +mmax(y1, y2).toFixed(2) ||
	            py2 < +mmin(y3, y4).toFixed(2) ||
	            py2 > +mmax(y3, y4).toFixed(2)
	        ) {
	            return;
	        }
	        return {x: px, y: py};
	    }
	    function inter(bez1, bez2) {
	        return interHelper(bez1, bez2);
	    }
	    function interCount(bez1, bez2) {
	        return interHelper(bez1, bez2, 1);
	    }
	    function interHelper(bez1, bez2, justCount) {
	        var bbox1 = bezierBBox(bez1),
	            bbox2 = bezierBBox(bez2);
	        if (!isBBoxIntersect(bbox1, bbox2)) {
	            return justCount ? 0 : [];
	        }
	        var l1 = bezlen.apply(0, bez1),
	            l2 = bezlen.apply(0, bez2),
	            n1 = ~~(l1 / 8),
	            n2 = ~~(l2 / 8),
	            dots1 = [],
	            dots2 = [],
	            xy = {},
	            res = justCount ? 0 : [];
	        for (var i = 0; i < n1 + 1; i++) {
	            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
	            dots1.push({x: p.x, y: p.y, t: i / n1});
	        }
	        for (i = 0; i < n2 + 1; i++) {
	            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
	            dots2.push({x: p.x, y: p.y, t: i / n2});
	        }
	        for (i = 0; i < n1; i++) {
	            for (var j = 0; j < n2; j++) {
	                var di = dots1[i],
	                    di1 = dots1[i + 1],
	                    dj = dots2[j],
	                    dj1 = dots2[j + 1],
	                    ci = abs(di1.x - di.x) < .001 ? "y" : "x",
	                    cj = abs(dj1.x - dj.x) < .001 ? "y" : "x",
	                    is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
	                if (is) {
	                    if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
	                        continue;
	                    }
	                    xy[is.x.toFixed(4)] = is.y.toFixed(4);
	                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
	                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
	                    if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
	                        if (justCount) {
	                            res++;
	                        } else {
	                            res.push({
	                                x: is.x,
	                                y: is.y,
	                                t1: t1,
	                                t2: t2
	                            });
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    function pathIntersection(path1, path2) {
	        return interPathHelper(path1, path2);
	    }
	    function pathIntersectionNumber(path1, path2) {
	        return interPathHelper(path1, path2, 1);
	    }
	    function interPathHelper(path1, path2, justCount) {
	        path1 = path2curve(path1);
	        path2 = path2curve(path2);
	        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2,
	            res = justCount ? 0 : [];
	        for (var i = 0, ii = path1.length; i < ii; i++) {
	            var pi = path1[i];
	            if (pi[0] == "M") {
	                x1 = x1m = pi[1];
	                y1 = y1m = pi[2];
	            } else {
	                if (pi[0] == "C") {
	                    bez1 = [x1, y1].concat(pi.slice(1));
	                    x1 = bez1[6];
	                    y1 = bez1[7];
	                } else {
	                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
	                    x1 = x1m;
	                    y1 = y1m;
	                }
	                for (var j = 0, jj = path2.length; j < jj; j++) {
	                    var pj = path2[j];
	                    if (pj[0] == "M") {
	                        x2 = x2m = pj[1];
	                        y2 = y2m = pj[2];
	                    } else {
	                        if (pj[0] == "C") {
	                            bez2 = [x2, y2].concat(pj.slice(1));
	                            x2 = bez2[6];
	                            y2 = bez2[7];
	                        } else {
	                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
	                            x2 = x2m;
	                            y2 = y2m;
	                        }
	                        var intr = interHelper(bez1, bez2, justCount);
	                        if (justCount) {
	                            res += intr;
	                        } else {
	                            for (var k = 0, kk = intr.length; k < kk; k++) {
	                                intr[k].segment1 = i;
	                                intr[k].segment2 = j;
	                                intr[k].bez1 = bez1;
	                                intr[k].bez2 = bez2;
	                            }
	                            res = res.concat(intr);
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    function isPointInsidePath(path, x, y) {
	        var bbox = pathBBox(path);
	        return isPointInsideBBox(bbox, x, y) &&
	               interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
	    }
	    function pathBBox(path) {
	        var pth = paths(path);
	        if (pth.bbox) {
	            return clone(pth.bbox);
	        }
	        if (!path) {
	            return box();
	        }
	        path = path2curve(path);
	        var x = 0,
	            y = 0,
	            X = [],
	            Y = [],
	            p;
	        for (var i = 0, ii = path.length; i < ii; i++) {
	            p = path[i];
	            if (p[0] == "M") {
	                x = p[1];
	                y = p[2];
	                X.push(x);
	                Y.push(y);
	            } else {
	                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                X = X.concat(dim.min.x, dim.max.x);
	                Y = Y.concat(dim.min.y, dim.max.y);
	                x = p[5];
	                y = p[6];
	            }
	        }
	        var xmin = mmin.apply(0, X),
	            ymin = mmin.apply(0, Y),
	            xmax = mmax.apply(0, X),
	            ymax = mmax.apply(0, Y),
	            bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
	        pth.bbox = clone(bb);
	        return bb;
	    }
	    function rectPath(x, y, w, h, r) {
	        if (r) {
	            return [
	                ["M", +x + +r, y],
	                ["l", w - r * 2, 0],
	                ["a", r, r, 0, 0, 1, r, r],
	                ["l", 0, h - r * 2],
	                ["a", r, r, 0, 0, 1, -r, r],
	                ["l", r * 2 - w, 0],
	                ["a", r, r, 0, 0, 1, -r, -r],
	                ["l", 0, r * 2 - h],
	                ["a", r, r, 0, 0, 1, r, -r],
	                ["z"]
	            ];
	        }
	        var res = [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
	        res.toString = toString;
	        return res;
	    }
	    function ellipsePath(x, y, rx, ry, a) {
	        if (a == null && ry == null) {
	            ry = rx;
	        }
	        x = +x;
	        y = +y;
	        rx = +rx;
	        ry = +ry;
	        if (a != null) {
	            var rad = Math.PI / 180,
	                x1 = x + rx * Math.cos(-ry * rad),
	                x2 = x + rx * Math.cos(-a * rad),
	                y1 = y + rx * Math.sin(-ry * rad),
	                y2 = y + rx * Math.sin(-a * rad),
	                res = [["M", x1, y1], ["A", rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
	        } else {
	            res = [
	                ["M", x, y],
	                ["m", 0, -ry],
	                ["a", rx, ry, 0, 1, 1, 0, 2 * ry],
	                ["a", rx, ry, 0, 1, 1, 0, -2 * ry],
	                ["z"]
	            ];
	        }
	        res.toString = toString;
	        return res;
	    }
	    var unit2px = Snap._unit2px,
	        getPath = {
	        path: function (el) {
	            return el.attr("path");
	        },
	        circle: function (el) {
	            var attr = unit2px(el);
	            return ellipsePath(attr.cx, attr.cy, attr.r);
	        },
	        ellipse: function (el) {
	            var attr = unit2px(el);
	            return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
	        },
	        rect: function (el) {
	            var attr = unit2px(el);
	            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
	        },
	        image: function (el) {
	            var attr = unit2px(el);
	            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
	        },
	        line: function (el) {
	            return "M" + [el.attr("x1") || 0, el.attr("y1") || 0, el.attr("x2"), el.attr("y2")];
	        },
	        polyline: function (el) {
	            return "M" + el.attr("points");
	        },
	        polygon: function (el) {
	            return "M" + el.attr("points") + "z";
	        },
	        deflt: function (el) {
	            var bbox = el.node.getBBox();
	            return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
	        }
	    };
	    function pathToRelative(pathArray) {
	        var pth = paths(pathArray),
	            lowerCase = String.prototype.toLowerCase;
	        if (pth.rel) {
	            return pathClone(pth.rel);
	        }
	        if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) {
	            pathArray = Snap.parsePathString(pathArray);
	        }
	        var res = [],
	            x = 0,
	            y = 0,
	            mx = 0,
	            my = 0,
	            start = 0;
	        if (pathArray[0][0] == "M") {
	            x = pathArray[0][1];
	            y = pathArray[0][2];
	            mx = x;
	            my = y;
	            start++;
	            res.push(["M", x, y]);
	        }
	        for (var i = start, ii = pathArray.length; i < ii; i++) {
	            var r = res[i] = [],
	                pa = pathArray[i];
	            if (pa[0] != lowerCase.call(pa[0])) {
	                r[0] = lowerCase.call(pa[0]);
	                switch (r[0]) {
	                    case "a":
	                        r[1] = pa[1];
	                        r[2] = pa[2];
	                        r[3] = pa[3];
	                        r[4] = pa[4];
	                        r[5] = pa[5];
	                        r[6] = +(pa[6] - x).toFixed(3);
	                        r[7] = +(pa[7] - y).toFixed(3);
	                        break;
	                    case "v":
	                        r[1] = +(pa[1] - y).toFixed(3);
	                        break;
	                    case "m":
	                        mx = pa[1];
	                        my = pa[2];
	                    default:
	                        for (var j = 1, jj = pa.length; j < jj; j++) {
	                            r[j] = +(pa[j] - (j % 2 ? x : y)).toFixed(3);
	                        }
	                }
	            } else {
	                r = res[i] = [];
	                if (pa[0] == "m") {
	                    mx = pa[1] + x;
	                    my = pa[2] + y;
	                }
	                for (var k = 0, kk = pa.length; k < kk; k++) {
	                    res[i][k] = pa[k];
	                }
	            }
	            var len = res[i].length;
	            switch (res[i][0]) {
	                case "z":
	                    x = mx;
	                    y = my;
	                    break;
	                case "h":
	                    x += +res[i][len - 1];
	                    break;
	                case "v":
	                    y += +res[i][len - 1];
	                    break;
	                default:
	                    x += +res[i][len - 2];
	                    y += +res[i][len - 1];
	            }
	        }
	        res.toString = toString;
	        pth.rel = pathClone(res);
	        return res;
	    }
	    function pathToAbsolute(pathArray) {
	        var pth = paths(pathArray);
	        if (pth.abs) {
	            return pathClone(pth.abs);
	        }
	        if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) { // rough assumption
	            pathArray = Snap.parsePathString(pathArray);
	        }
	        if (!pathArray || !pathArray.length) {
	            return [["M", 0, 0]];
	        }
	        var res = [],
	            x = 0,
	            y = 0,
	            mx = 0,
	            my = 0,
	            start = 0,
	            pa0;
	        if (pathArray[0][0] == "M") {
	            x = +pathArray[0][1];
	            y = +pathArray[0][2];
	            mx = x;
	            my = y;
	            start++;
	            res[0] = ["M", x, y];
	        }
	        var crz = pathArray.length == 3 &&
	            pathArray[0][0] == "M" &&
	            pathArray[1][0].toUpperCase() == "R" &&
	            pathArray[2][0].toUpperCase() == "Z";
	        for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
	            res.push(r = []);
	            pa = pathArray[i];
	            pa0 = pa[0];
	            if (pa0 != pa0.toUpperCase()) {
	                r[0] = pa0.toUpperCase();
	                switch (r[0]) {
	                    case "A":
	                        r[1] = pa[1];
	                        r[2] = pa[2];
	                        r[3] = pa[3];
	                        r[4] = pa[4];
	                        r[5] = pa[5];
	                        r[6] = +pa[6] + x;
	                        r[7] = +pa[7] + y;
	                        break;
	                    case "V":
	                        r[1] = +pa[1] + y;
	                        break;
	                    case "H":
	                        r[1] = +pa[1] + x;
	                        break;
	                    case "R":
	                        var dots = [x, y].concat(pa.slice(1));
	                        for (var j = 2, jj = dots.length; j < jj; j++) {
	                            dots[j] = +dots[j] + x;
	                            dots[++j] = +dots[j] + y;
	                        }
	                        res.pop();
	                        res = res.concat(catmullRom2bezier(dots, crz));
	                        break;
	                    case "O":
	                        res.pop();
	                        dots = ellipsePath(x, y, pa[1], pa[2]);
	                        dots.push(dots[0]);
	                        res = res.concat(dots);
	                        break;
	                    case "U":
	                        res.pop();
	                        res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
	                        r = ["U"].concat(res[res.length - 1].slice(-2));
	                        break;
	                    case "M":
	                        mx = +pa[1] + x;
	                        my = +pa[2] + y;
	                    default:
	                        for (j = 1, jj = pa.length; j < jj; j++) {
	                            r[j] = +pa[j] + (j % 2 ? x : y);
	                        }
	                }
	            } else if (pa0 == "R") {
	                dots = [x, y].concat(pa.slice(1));
	                res.pop();
	                res = res.concat(catmullRom2bezier(dots, crz));
	                r = ["R"].concat(pa.slice(-2));
	            } else if (pa0 == "O") {
	                res.pop();
	                dots = ellipsePath(x, y, pa[1], pa[2]);
	                dots.push(dots[0]);
	                res = res.concat(dots);
	            } else if (pa0 == "U") {
	                res.pop();
	                res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
	                r = ["U"].concat(res[res.length - 1].slice(-2));
	            } else {
	                for (var k = 0, kk = pa.length; k < kk; k++) {
	                    r[k] = pa[k];
	                }
	            }
	            pa0 = pa0.toUpperCase();
	            if (pa0 != "O") {
	                switch (r[0]) {
	                    case "Z":
	                        x = +mx;
	                        y = +my;
	                        break;
	                    case "H":
	                        x = r[1];
	                        break;
	                    case "V":
	                        y = r[1];
	                        break;
	                    case "M":
	                        mx = r[r.length - 2];
	                        my = r[r.length - 1];
	                    default:
	                        x = r[r.length - 2];
	                        y = r[r.length - 1];
	                }
	            }
	        }
	        res.toString = toString;
	        pth.abs = pathClone(res);
	        return res;
	    }
	    function l2c(x1, y1, x2, y2) {
	        return [x1, y1, x2, y2, x2, y2];
	    }
	    function q2c(x1, y1, ax, ay, x2, y2) {
	        var _13 = 1 / 3,
	            _23 = 2 / 3;
	        return [
	                _13 * x1 + _23 * ax,
	                _13 * y1 + _23 * ay,
	                _13 * x2 + _23 * ax,
	                _13 * y2 + _23 * ay,
	                x2,
	                y2
	            ];
	    }
	    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
	        // for more information of where this math came from visit:
	        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
	        var _120 = PI * 120 / 180,
	            rad = PI / 180 * (+angle || 0),
	            res = [],
	            xy,
	            rotate = Snap._.cacher(function (x, y, rad) {
	                var X = x * math.cos(rad) - y * math.sin(rad),
	                    Y = x * math.sin(rad) + y * math.cos(rad);
	                return {x: X, y: Y};
	            });
	        if (!rx || !ry) {
	            return [x1, y1, x2, y2, x2, y2];
	        }
	        if (!recursive) {
	            xy = rotate(x1, y1, -rad);
	            x1 = xy.x;
	            y1 = xy.y;
	            xy = rotate(x2, y2, -rad);
	            x2 = xy.x;
	            y2 = xy.y;
	            var cos = math.cos(PI / 180 * angle),
	                sin = math.sin(PI / 180 * angle),
	                x = (x1 - x2) / 2,
	                y = (y1 - y2) / 2;
	            var h = x * x / (rx * rx) + y * y / (ry * ry);
	            if (h > 1) {
	                h = math.sqrt(h);
	                rx = h * rx;
	                ry = h * ry;
	            }
	            var rx2 = rx * rx,
	                ry2 = ry * ry,
	                k = (large_arc_flag == sweep_flag ? -1 : 1) *
	                    math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
	                cx = k * rx * y / ry + (x1 + x2) / 2,
	                cy = k * -ry * x / rx + (y1 + y2) / 2,
	                f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
	                f2 = math.asin(((y2 - cy) / ry).toFixed(9));
	
	            f1 = x1 < cx ? PI - f1 : f1;
	            f2 = x2 < cx ? PI - f2 : f2;
	            f1 < 0 && (f1 = PI * 2 + f1);
	            f2 < 0 && (f2 = PI * 2 + f2);
	            if (sweep_flag && f1 > f2) {
	                f1 = f1 - PI * 2;
	            }
	            if (!sweep_flag && f2 > f1) {
	                f2 = f2 - PI * 2;
	            }
	        } else {
	            f1 = recursive[0];
	            f2 = recursive[1];
	            cx = recursive[2];
	            cy = recursive[3];
	        }
	        var df = f2 - f1;
	        if (abs(df) > _120) {
	            var f2old = f2,
	                x2old = x2,
	                y2old = y2;
	            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
	            x2 = cx + rx * math.cos(f2);
	            y2 = cy + ry * math.sin(f2);
	            res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
	        }
	        df = f2 - f1;
	        var c1 = math.cos(f1),
	            s1 = math.sin(f1),
	            c2 = math.cos(f2),
	            s2 = math.sin(f2),
	            t = math.tan(df / 4),
	            hx = 4 / 3 * rx * t,
	            hy = 4 / 3 * ry * t,
	            m1 = [x1, y1],
	            m2 = [x1 + hx * s1, y1 - hy * c1],
	            m3 = [x2 + hx * s2, y2 - hy * c2],
	            m4 = [x2, y2];
	        m2[0] = 2 * m1[0] - m2[0];
	        m2[1] = 2 * m1[1] - m2[1];
	        if (recursive) {
	            return [m2, m3, m4].concat(res);
	        } else {
	            res = [m2, m3, m4].concat(res).join().split(",");
	            var newres = [];
	            for (var i = 0, ii = res.length; i < ii; i++) {
	                newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
	            }
	            return newres;
	        }
	    }
	    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	        var t1 = 1 - t;
	        return {
	            x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
	            y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
	        };
	    }
	
	    // Returns bounding box of cubic bezier curve.
	    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
	    // Original version: NISHIO Hirokazu
	    // Modifications: https://github.com/timo22345
	    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
	        var tvalues = [],
	            bounds = [[], []],
	            a, b, c, t, t1, t2, b2ac, sqrtb2ac;
	        for (var i = 0; i < 2; ++i) {
	            if (i == 0) {
	                b = 6 * x0 - 12 * x1 + 6 * x2;
	                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
	                c = 3 * x1 - 3 * x0;
	            } else {
	                b = 6 * y0 - 12 * y1 + 6 * y2;
	                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
	                c = 3 * y1 - 3 * y0;
	            }
	            if (abs(a) < 1e-12) {
	                if (abs(b) < 1e-12) {
	                    continue;
	                }
	                t = -c / b;
	                if (0 < t && t < 1) {
	                    tvalues.push(t);
	                }
	                continue;
	            }
	            b2ac = b * b - 4 * c * a;
	            sqrtb2ac = math.sqrt(b2ac);
	            if (b2ac < 0) {
	                continue;
	            }
	            t1 = (-b + sqrtb2ac) / (2 * a);
	            if (0 < t1 && t1 < 1) {
	                tvalues.push(t1);
	            }
	            t2 = (-b - sqrtb2ac) / (2 * a);
	            if (0 < t2 && t2 < 1) {
	                tvalues.push(t2);
	            }
	        }
	
	        var x, y, j = tvalues.length,
	            jlen = j,
	            mt;
	        while (j--) {
	            t = tvalues[j];
	            mt = 1 - t;
	            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
	            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
	        }
	
	        bounds[0][jlen] = x0;
	        bounds[1][jlen] = y0;
	        bounds[0][jlen + 1] = x3;
	        bounds[1][jlen + 1] = y3;
	        bounds[0].length = bounds[1].length = jlen + 2;
	
	
	        return {
	          min: {x: mmin.apply(0, bounds[0]), y: mmin.apply(0, bounds[1])},
	          max: {x: mmax.apply(0, bounds[0]), y: mmax.apply(0, bounds[1])}
	        };
	    }
	
	    function path2curve(path, path2) {
	        var pth = !path2 && paths(path);
	        if (!path2 && pth.curve) {
	            return pathClone(pth.curve);
	        }
	        var p = pathToAbsolute(path),
	            p2 = path2 && pathToAbsolute(path2),
	            attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	            attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	            processPath = function (path, d, pcom) {
	                var nx, ny;
	                if (!path) {
	                    return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
	                }
	                !(path[0] in {T: 1, Q: 1}) && (d.qx = d.qy = null);
	                switch (path[0]) {
	                    case "M":
	                        d.X = path[1];
	                        d.Y = path[2];
	                        break;
	                    case "A":
	                        path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
	                        break;
	                    case "S":
	                        if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
	                            nx = d.x * 2 - d.bx;          // And reflect the previous
	                            ny = d.y * 2 - d.by;          // command's control point relative to the current point.
	                        }
	                        else {                            // or some else or nothing
	                            nx = d.x;
	                            ny = d.y;
	                        }
	                        path = ["C", nx, ny].concat(path.slice(1));
	                        break;
	                    case "T":
	                        if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
	                            d.qx = d.x * 2 - d.qx;        // And make a reflection similar
	                            d.qy = d.y * 2 - d.qy;        // to case "S".
	                        }
	                        else {                            // or something else or nothing
	                            d.qx = d.x;
	                            d.qy = d.y;
	                        }
	                        path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
	                        break;
	                    case "Q":
	                        d.qx = path[1];
	                        d.qy = path[2];
	                        path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
	                        break;
	                    case "L":
	                        path = ["C"].concat(l2c(d.x, d.y, path[1], path[2]));
	                        break;
	                    case "H":
	                        path = ["C"].concat(l2c(d.x, d.y, path[1], d.y));
	                        break;
	                    case "V":
	                        path = ["C"].concat(l2c(d.x, d.y, d.x, path[1]));
	                        break;
	                    case "Z":
	                        path = ["C"].concat(l2c(d.x, d.y, d.X, d.Y));
	                        break;
	                }
	                return path;
	            },
	            fixArc = function (pp, i) {
	                if (pp[i].length > 7) {
	                    pp[i].shift();
	                    var pi = pp[i];
	                    while (pi.length) {
	                        pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
	                        p2 && (pcoms2[i] = "A"); // the same as above
	                        pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
	                    }
	                    pp.splice(i, 1);
	                    ii = mmax(p.length, p2 && p2.length || 0);
	                }
	            },
	            fixM = function (path1, path2, a1, a2, i) {
	                if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
	                    path2.splice(i, 0, ["M", a2.x, a2.y]);
	                    a1.bx = 0;
	                    a1.by = 0;
	                    a1.x = path1[i][1];
	                    a1.y = path1[i][2];
	                    ii = mmax(p.length, p2 && p2.length || 0);
	                }
	            },
	            pcoms1 = [], // path commands of original path p
	            pcoms2 = [], // path commands of original path p2
	            pfirst = "", // temporary holder for original path command
	            pcom = ""; // holder for previous path command of original path
	        for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
	            p[i] && (pfirst = p[i][0]); // save current path command
	
	            if (pfirst != "C") // C is not saved yet, because it may be result of conversion
	            {
	                pcoms1[i] = pfirst; // Save current path command
	                i && ( pcom = pcoms1[i - 1]); // Get previous path command pcom
	            }
	            p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath
	
	            if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
	            // which may produce multiple C:s
	            // so we have to make sure that C is also C in original path
	
	            fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1
	
	            if (p2) { // the same procedures is done to p2
	                p2[i] && (pfirst = p2[i][0]);
	                if (pfirst != "C") {
	                    pcoms2[i] = pfirst;
	                    i && (pcom = pcoms2[i - 1]);
	                }
	                p2[i] = processPath(p2[i], attrs2, pcom);
	
	                if (pcoms2[i] != "A" && pfirst == "C") {
	                    pcoms2[i] = "C";
	                }
	
	                fixArc(p2, i);
	            }
	            fixM(p, p2, attrs, attrs2, i);
	            fixM(p2, p, attrs2, attrs, i);
	            var seg = p[i],
	                seg2 = p2 && p2[i],
	                seglen = seg.length,
	                seg2len = p2 && seg2.length;
	            attrs.x = seg[seglen - 2];
	            attrs.y = seg[seglen - 1];
	            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
	            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
	            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
	            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
	            attrs2.x = p2 && seg2[seg2len - 2];
	            attrs2.y = p2 && seg2[seg2len - 1];
	        }
	        if (!p2) {
	            pth.curve = pathClone(p);
	        }
	        return p2 ? [p, p2] : p;
	    }
	    function mapPath(path, matrix) {
	        if (!matrix) {
	            return path;
	        }
	        var x, y, i, j, ii, jj, pathi;
	        path = path2curve(path);
	        for (i = 0, ii = path.length; i < ii; i++) {
	            pathi = path[i];
	            for (j = 1, jj = pathi.length; j < jj; j += 2) {
	                x = matrix.x(pathi[j], pathi[j + 1]);
	                y = matrix.y(pathi[j], pathi[j + 1]);
	                pathi[j] = x;
	                pathi[j + 1] = y;
	            }
	        }
	        return path;
	    }
	
	    // http://schepers.cc/getting-to-the-point
	    function catmullRom2bezier(crp, z) {
	        var d = [];
	        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
	            var p = [
	                        {x: +crp[i - 2], y: +crp[i - 1]},
	                        {x: +crp[i],     y: +crp[i + 1]},
	                        {x: +crp[i + 2], y: +crp[i + 3]},
	                        {x: +crp[i + 4], y: +crp[i + 5]}
	                    ];
	            if (z) {
	                if (!i) {
	                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
	                } else if (iLen - 4 == i) {
	                    p[3] = {x: +crp[0], y: +crp[1]};
	                } else if (iLen - 2 == i) {
	                    p[2] = {x: +crp[0], y: +crp[1]};
	                    p[3] = {x: +crp[2], y: +crp[3]};
	                }
	            } else {
	                if (iLen - 4 == i) {
	                    p[3] = p[2];
	                } else if (!i) {
	                    p[0] = {x: +crp[i], y: +crp[i + 1]};
	                }
	            }
	            d.push(["C",
	                  (-p[0].x + 6 * p[1].x + p[2].x) / 6,
	                  (-p[0].y + 6 * p[1].y + p[2].y) / 6,
	                  (p[1].x + 6 * p[2].x - p[3].x) / 6,
	                  (p[1].y + 6*p[2].y - p[3].y) / 6,
	                  p[2].x,
	                  p[2].y
	            ]);
	        }
	
	        return d;
	    }
	
	    // export
	    Snap.path = paths;
	
	    /*\
	     * Snap.path.getTotalLength
	     [ method ]
	     **
	     * Returns the length of the given path in pixels
	     **
	     - path (string) SVG path string
	     **
	     = (number) length
	    \*/
	    Snap.path.getTotalLength = getTotalLength;
	    /*\
	     * Snap.path.getPointAtLength
	     [ method ]
	     **
	     * Returns the coordinates of the point located at the given length along the given path
	     **
	     - path (string) SVG path string
	     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate,
	     o     y: (number) y coordinate,
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    Snap.path.getPointAtLength = getPointAtLength;
	    /*\
	     * Snap.path.getSubpath
	     [ method ]
	     **
	     * Returns the subpath of a given path between given start and end lengths
	     **
	     - path (string) SVG path string
	     - from (number) length, in pixels, from the start of the path to the start of the segment
	     - to (number) length, in pixels, from the start of the path to the end of the segment
	     **
	     = (string) path string definition for the segment
	    \*/
	    Snap.path.getSubpath = function (path, from, to) {
	        if (this.getTotalLength(path) - to < 1e-6) {
	            return getSubpathsAtLength(path, from).end;
	        }
	        var a = getSubpathsAtLength(path, to, 1);
	        return from ? getSubpathsAtLength(a, from).end : a;
	    };
	    /*\
	     * Element.getTotalLength
	     [ method ]
	     **
	     * Returns the length of the path in pixels (only works for `path` elements)
	     = (number) length
	    \*/
	    elproto.getTotalLength = function () {
	        if (this.node.getTotalLength) {
	            return this.node.getTotalLength();
	        }
	    };
	    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
	    /*\
	     * Element.getPointAtLength
	     [ method ]
	     **
	     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
	     **
	     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate,
	     o     y: (number) y coordinate,
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    elproto.getPointAtLength = function (length) {
	        return getPointAtLength(this.attr("d"), length);
	    };
	    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
	    /*\
	     * Element.getSubpath
	     [ method ]
	     **
	     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
	     **
	     - from (number) length, in pixels, from the start of the path to the start of the segment
	     - to (number) length, in pixels, from the start of the path to the end of the segment
	     **
	     = (string) path string definition for the segment
	    \*/
	    elproto.getSubpath = function (from, to) {
	        return Snap.path.getSubpath(this.attr("d"), from, to);
	    };
	    Snap._.box = box;
	    /*\
	     * Snap.path.findDotsAtSegment
	     [ method ]
	     **
	     * Utility method
	     **
	     * Finds dot coordinates on the given cubic beziér curve at the given t
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     - t (number) position on the curve (0..1)
	     = (object) point information in format:
	     o {
	     o     x: (number) x coordinate of the point,
	     o     y: (number) y coordinate of the point,
	     o     m: {
	     o         x: (number) x coordinate of the left anchor,
	     o         y: (number) y coordinate of the left anchor
	     o     },
	     o     n: {
	     o         x: (number) x coordinate of the right anchor,
	     o         y: (number) y coordinate of the right anchor
	     o     },
	     o     start: {
	     o         x: (number) x coordinate of the start of the curve,
	     o         y: (number) y coordinate of the start of the curve
	     o     },
	     o     end: {
	     o         x: (number) x coordinate of the end of the curve,
	     o         y: (number) y coordinate of the end of the curve
	     o     },
	     o     alpha: (number) angle of the curve derivative at the point
	     o }
	    \*/
	    Snap.path.findDotsAtSegment = findDotsAtSegment;
	    /*\
	     * Snap.path.bezierBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns the bounding box of a given cubic beziér curve
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     * or
	     - bez (array) array of six points for beziér curve
	     = (object) bounding box
	     o {
	     o     x: (number) x coordinate of the left top point of the box,
	     o     y: (number) y coordinate of the left top point of the box,
	     o     x2: (number) x coordinate of the right bottom point of the box,
	     o     y2: (number) y coordinate of the right bottom point of the box,
	     o     width: (number) width of the box,
	     o     height: (number) height of the box
	     o }
	    \*/
	    Snap.path.bezierBBox = bezierBBox;
	    /*\
	     * Snap.path.isPointInsideBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside bounding box
	     - bbox (string) bounding box
	     - x (string) x coordinate of the point
	     - y (string) y coordinate of the point
	     = (boolean) `true` if point is inside
	    \*/
	    Snap.path.isPointInsideBBox = isPointInsideBBox;
	    Snap.closest = function (x, y, X, Y) {
	        var r = 100,
	            b = box(x - r / 2, y - r / 2, r, r),
	            inside = [],
	            getter = X[0].hasOwnProperty("x") ? function (i) {
	                return {
	                    x: X[i].x,
	                    y: X[i].y
	                };
	            } : function (i) {
	                return {
	                    x: X[i],
	                    y: Y[i]
	                };
	            },
	            found = 0;
	        while (r <= 1e6 && !found) {
	            for (var i = 0, ii = X.length; i < ii; i++) {
	                var xy = getter(i);
	                if (isPointInsideBBox(b, xy.x, xy.y)) {
	                    found++;
	                    inside.push(xy);
	                    break;
	                }
	            }
	            if (!found) {
	                r *= 2;
	                b = box(x - r / 2, y - r / 2, r, r)
	            }
	        }
	        if (r == 1e6) {
	            return;
	        }
	        var len = Infinity,
	            res;
	        for (i = 0, ii = inside.length; i < ii; i++) {
	            var l = Snap.len(x, y, inside[i].x, inside[i].y);
	            if (len > l) {
	                len = l;
	                inside[i].len = l;
	                res = inside[i];
	            }
	        }
	        return res;
	    };
	    /*\
	     * Snap.path.isBBoxIntersect
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if two bounding boxes intersect
	     - bbox1 (string) first bounding box
	     - bbox2 (string) second bounding box
	     = (boolean) `true` if bounding boxes intersect
	    \*/
	    Snap.path.isBBoxIntersect = isBBoxIntersect;
	    /*\
	     * Snap.path.intersection
	     [ method ]
	     **
	     * Utility method
	     **
	     * Finds intersections of two paths
	     - path1 (string) path string
	     - path2 (string) path string
	     = (array) dots of intersection
	     o [
	     o     {
	     o         x: (number) x coordinate of the point,
	     o         y: (number) y coordinate of the point,
	     o         t1: (number) t value for segment of path1,
	     o         t2: (number) t value for segment of path2,
	     o         segment1: (number) order number for segment of path1,
	     o         segment2: (number) order number for segment of path2,
	     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
	     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
	     o     }
	     o ]
	    \*/
	    Snap.path.intersection = pathIntersection;
	    Snap.path.intersectionNumber = pathIntersectionNumber;
	    /*\
	     * Snap.path.isPointInside
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside a given closed path.
	     *
	     * Note: fill mode doesn’t affect the result of this method.
	     - path (string) path string
	     - x (number) x of the point
	     - y (number) y of the point
	     = (boolean) `true` if point is inside the path
	    \*/
	    Snap.path.isPointInside = isPointInsidePath;
	    /*\
	     * Snap.path.getBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns the bounding box of a given path
	     - path (string) path string
	     = (object) bounding box
	     o {
	     o     x: (number) x coordinate of the left top point of the box,
	     o     y: (number) y coordinate of the left top point of the box,
	     o     x2: (number) x coordinate of the right bottom point of the box,
	     o     y2: (number) y coordinate of the right bottom point of the box,
	     o     width: (number) width of the box,
	     o     height: (number) height of the box
	     o }
	    \*/
	    Snap.path.getBBox = pathBBox;
	    Snap.path.get = getPath;
	    /*\
	     * Snap.path.toRelative
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path coordinates into relative values
	     - path (string) path string
	     = (array) path string
	    \*/
	    Snap.path.toRelative = pathToRelative;
	    /*\
	     * Snap.path.toAbsolute
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path coordinates into absolute values
	     - path (string) path string
	     = (array) path string
	    \*/
	    Snap.path.toAbsolute = pathToAbsolute;
	    /*\
	     * Snap.path.toCubic
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path to a new path where all segments are cubic beziér curves
	     - pathString (string|array) path string or array of segments
	     = (array) array of segments
	    \*/
	    Snap.path.toCubic = path2curve;
	    /*\
	     * Snap.path.map
	     [ method ]
	     **
	     * Transform the path string with the given matrix
	     - path (string) path string
	     - matrix (object) see @Matrix
	     = (string) transformed path string
	    \*/
	    Snap.path.map = mapPath;
	    Snap.path.toString = toString;
	    Snap.path.clone = pathClone;
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var mmax = Math.max,
	        mmin = Math.min;
	
	    // Set
	    var Set = function (items) {
	        this.items = [];
		this.bindings = {};
	        this.length = 0;
	        this.type = "set";
	        if (items) {
	            for (var i = 0, ii = items.length; i < ii; i++) {
	                if (items[i]) {
	                    this[this.items.length] = this.items[this.items.length] = items[i];
	                    this.length++;
	                }
	            }
	        }
	    },
	    setproto = Set.prototype;
	    /*\
	     * Set.push
	     [ method ]
	     **
	     * Adds each argument to the current set
	     = (object) original element
	    \*/
	    setproto.push = function () {
	        var item,
	            len;
	        for (var i = 0, ii = arguments.length; i < ii; i++) {
	            item = arguments[i];
	            if (item) {
	                len = this.items.length;
	                this[len] = this.items[len] = item;
	                this.length++;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.pop
	     [ method ]
	     **
	     * Removes last element and returns it
	     = (object) element
	    \*/
	    setproto.pop = function () {
	        this.length && delete this[this.length--];
	        return this.items.pop();
	    };
	    /*\
	     * Set.forEach
	     [ method ]
	     **
	     * Executes given function for each element in the set
	     *
	     * If the function returns `false`, the loop stops running.
	     **
	     - callback (function) function to run
	     - thisArg (object) context object for the callback
	     = (object) Set object
	    \*/
	    setproto.forEach = function (callback, thisArg) {
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            if (callback.call(thisArg, this.items[i], i) === false) {
	                return this;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.animate
	     [ method ]
	     **
	     * Animates each element in set in sync.
	     *
	     **
	     - attrs (object) key-value pairs of destination attributes
	     - duration (number) duration of the animation in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function that executes when the animation ends
	     * or
	     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
	     > Usage
	     | // animate all elements in set to radius 10
	     | set.animate({r: 10}, 500, mina.easein);
	     | // or
	     | // animate first element to radius 10, but second to radius 20 and in different time
	     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
	     = (Element) the current element
	    \*/
	    setproto.animate = function (attrs, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        if (attrs instanceof Snap._.Animation) {
	            callback = attrs.callback;
	            easing = attrs.easing;
	            ms = easing.dur;
	            attrs = attrs.attr;
	        }
	        var args = arguments;
	        if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) {
	            var each = true;
	        }
	        var begin,
	            handler = function () {
	                if (begin) {
	                    this.b = begin;
	                } else {
	                    begin = this.b;
	                }
	            },
	            cb = 0,
	            set = this,
	            callbacker = callback && function () {
	                if (++cb == set.length) {
	                    callback.call(this);
	                }
	            };
	        return this.forEach(function (el, i) {
	            eve.once("snap.animcreated." + el.id, handler);
	            if (each) {
	                args[i] && el.animate.apply(el, args[i]);
	            } else {
	                el.animate(attrs, ms, easing, callbacker);
	            }
	        });
	    };
	    /*\
	     * Set.remove
	     [ method ]
	     **
	     * Removes all children of the set.
	     *
	     = (object) Set object
	    \*/
	    setproto.remove = function () {
	        while (this.length) {
	            this.pop().remove();
	        }
	        return this;
	    };
	    /*\
	     * Set.bind
	     [ method ]
	     **
	     * Specifies how to handle a specific attribute when applied
	     * to a set.
	     *
	     **
	     - attr (string) attribute name
	     - callback (function) function to run
	     * or
	     - attr (string) attribute name
	     - element (Element) specific element in the set to apply the attribute to
	     * or
	     - attr (string) attribute name
	     - element (Element) specific element in the set to apply the attribute to
	     - eattr (string) attribute on the element to bind the attribute to
	     = (object) Set object
	    \*/
	    setproto.bind = function (attr, a, b) {
	        var data = {};
	        if (typeof a == "function") {
	            this.bindings[attr] = a;
	        } else {
	            var aname = b || attr;
	            this.bindings[attr] = function (v) {
	                data[aname] = v;
	                a.attr(data);
	            };
	        }
	        return this;
	    };
	    /*\
	     * Set.attr
	     [ method ]
	     **
	     * Equivalent of @Element.attr.
	     = (object) Set object
	    \*/
	    setproto.attr = function (value) {
	        var unbound = {};
	        for (var k in value) {
	            if (this.bindings[k]) {
	                this.bindings[k](value[k]);
	            } else {
	                unbound[k] = value[k];
	            }
	        }
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            this.items[i].attr(unbound);
	        }
	        return this;
	    };
	    /*\
	     * Set.clear
	     [ method ]
	     **
	     * Removes all elements from the set
	    \*/
	    setproto.clear = function () {
	        while (this.length) {
	            this.pop();
	        }
	    };
	    /*\
	     * Set.splice
	     [ method ]
	     **
	     * Removes range of elements from the set
	     **
	     - index (number) position of the deletion
	     - count (number) number of element to remove
	     - insertion… (object) #optional elements to insert
	     = (object) set elements that were deleted
	    \*/
	    setproto.splice = function (index, count, insertion) {
	        index = index < 0 ? mmax(this.length + index, 0) : index;
	        count = mmax(0, mmin(this.length - index, count));
	        var tail = [],
	            todel = [],
	            args = [],
	            i;
	        for (i = 2; i < arguments.length; i++) {
	            args.push(arguments[i]);
	        }
	        for (i = 0; i < count; i++) {
	            todel.push(this[index + i]);
	        }
	        for (; i < this.length - index; i++) {
	            tail.push(this[index + i]);
	        }
	        var arglen = args.length;
	        for (i = 0; i < arglen + tail.length; i++) {
	            this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
	        }
	        i = this.items.length = this.length -= count - arglen;
	        while (this[i]) {
	            delete this[i++];
	        }
	        return new Set(todel);
	    };
	    /*\
	     * Set.exclude
	     [ method ]
	     **
	     * Removes given element from the set
	     **
	     - element (object) element to remove
	     = (boolean) `true` if object was found and removed from the set
	    \*/
	    setproto.exclude = function (el) {
	        for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
	            this.splice(i, 1);
	            return true;
	        }
	        return false;
	    };
	    /*\
	     * Set.insertAfter
	     [ method ]
	     **
	     * Inserts set elements after given element.
	     **
	     - element (object) set will be inserted after this element
	     = (object) Set object
	    \*/
	    setproto.insertAfter = function (el) {
	        var i = this.items.length;
	        while (i--) {
	            this.items[i].insertAfter(el);
	        }
	        return this;
	    };
	    /*\
	     * Set.getBBox
	     [ method ]
	     **
	     * Union of all bboxes of the set. See @Element.getBBox.
	     = (object) bounding box descriptor. See @Element.getBBox.
	    \*/
	    setproto.getBBox = function () {
	        var x = [],
	            y = [],
	            x2 = [],
	            y2 = [];
	        for (var i = this.items.length; i--;) if (!this.items[i].removed) {
	            var box = this.items[i].getBBox();
	            x.push(box.x);
	            y.push(box.y);
	            x2.push(box.x + box.width);
	            y2.push(box.y + box.height);
	        }
	        x = mmin.apply(0, x);
	        y = mmin.apply(0, y);
	        x2 = mmax.apply(0, x2);
	        y2 = mmax.apply(0, y2);
	        return {
	            x: x,
	            y: y,
	            x2: x2,
	            y2: y2,
	            width: x2 - x,
	            height: y2 - y,
	            cx: x + (x2 - x) / 2,
	            cy: y + (y2 - y) / 2
	        };
	    };
	    /*\
	     * Set.insertAfter
	     [ method ]
	     **
	     * Creates a clone of the set.
	     **
	     = (object) New Set object
	    \*/
	    setproto.clone = function (s) {
	        s = new Set;
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            s.push(this.items[i].clone());
	        }
	        return s;
	    };
	    setproto.toString = function () {
	        return "Snap\u2018s set";
	    };
	    setproto.type = "set";
	    // export
	    /*\
	     * Snap.Set
	     [ property ]
	     **
	     * Set constructor.
	    \*/
	    Snap.Set = Set;
	    /*\
	     * Snap.set
	     [ method ]
	     **
	     * Creates a set and fills it with list of arguments.
	     **
	     = (object) New Set object
	     | var r = paper.rect(0, 0, 10, 10),
	     |     s1 = Snap.set(), // empty set
	     |     s2 = Snap.set(r, paper.circle(100, 100, 20)); // prefilled set
	    \*/
	    Snap.set = function () {
	        var set = new Set;
	        if (arguments.length) {
	            set.push.apply(set, Array.prototype.slice.call(arguments, 0));
	        }
	        return set;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var names = {},
	        reUnit = /[%a-z]+$/i,
	        Str = String;
	    names.stroke = names.fill = "colour";
	    function getEmpty(item) {
	        var l = item[0];
	        switch (l.toLowerCase()) {
	            case "t": return [l, 0, 0];
	            case "m": return [l, 1, 0, 0, 1, 0, 0];
	            case "r": if (item.length == 4) {
	                return [l, 0, item[2], item[3]];
	            } else {
	                return [l, 0];
	            }
	            case "s": if (item.length == 5) {
	                return [l, 1, 1, item[3], item[4]];
	            } else if (item.length == 3) {
	                return [l, 1, 1];
	            } else {
	                return [l, 1];
	            }
	        }
	    }
	    function equaliseTransform(t1, t2, getBBox) {
	        t1 = t1 || new Snap.Matrix;
	        t2 = t2 || new Snap.Matrix;
	        t1 = Snap.parseTransformString(t1.toTransformString()) || [];
	        t2 = Snap.parseTransformString(t2.toTransformString()) || [];
	        var maxlength = Math.max(t1.length, t2.length),
	            from = [],
	            to = [],
	            i = 0, j, jj,
	            tt1, tt2;
	        for (; i < maxlength; i++) {
	            tt1 = t1[i] || getEmpty(t2[i]);
	            tt2 = t2[i] || getEmpty(tt1);
	            if (tt1[0] != tt2[0] ||
	                tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3]) ||
	                tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4])
	                ) {
	                    t1 = Snap._.transform2matrix(t1, getBBox());
	                    t2 = Snap._.transform2matrix(t2, getBBox());
	                    from = [["m", t1.a, t1.b, t1.c, t1.d, t1.e, t1.f]];
	                    to = [["m", t2.a, t2.b, t2.c, t2.d, t2.e, t2.f]];
	                    break;
	            }
	            from[i] = [];
	            to[i] = [];
	            for (j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++) {
	                j in tt1 && (from[i][j] = tt1[j]);
	                j in tt2 && (to[i][j] = tt2[j]);
	            }
	        }
	        return {
	            from: path2array(from),
	            to: path2array(to),
	            f: getPath(from)
	        };
	    }
	    function getNumber(val) {
	        return val;
	    }
	    function getUnit(unit) {
	        return function (val) {
	            return +val.toFixed(3) + unit;
	        };
	    }
	    function getViewBox(val) {
	        return val.join(" ");
	    }
	    function getColour(clr) {
	        return Snap.rgb(clr[0], clr[1], clr[2], clr[3]);
	    }
	    function getPath(path) {
	        var k = 0, i, ii, j, jj, out, a, b = [];
	        for (i = 0, ii = path.length; i < ii; i++) {
	            out = "[";
	            a = ['"' + path[i][0] + '"'];
	            for (j = 1, jj = path[i].length; j < jj; j++) {
	                a[j] = "val[" + k++ + "]";
	            }
	            out += a + "]";
	            b[i] = out;
	        }
	        return Function("val", "return Snap.path.toString.call([" + b + "])");
	    }
	    function path2array(path) {
	        var out = [];
	        for (var i = 0, ii = path.length; i < ii; i++) {
	            for (var j = 1, jj = path[i].length; j < jj; j++) {
	                out.push(path[i][j]);
	            }
	        }
	        return out;
	    }
	    function isNumeric(obj) {
	        return isFinite(obj);
	    }
	    function arrayEqual(arr1, arr2) {
	        if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) {
	            return false;
	        }
	        return arr1.toString() == arr2.toString();
	    }
	    Element.prototype.equal = function (name, b) {
	        return eve("snap.util.equal", this, name, b).firstDefined();
	    };
	    eve.on("snap.util.equal", function (name, b) {
	        var A, B, a = Str(this.attr(name) || ""),
	            el = this;
	        if (names[name] == "colour") {
	            A = Snap.color(a);
	            B = Snap.color(b);
	            return {
	                from: [A.r, A.g, A.b, A.opacity],
	                to: [B.r, B.g, B.b, B.opacity],
	                f: getColour
	            };
	        }
	        if (name == "viewBox") {
	            A = this.attr(name).vb.split(" ").map(Number);
	            B = b.split(" ").map(Number);
	            return {
	                from: A,
	                to: B,
	                f: getViewBox
	            };
	        }
	        if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
	            if (typeof b == "string") {
	                b = Str(b).replace(/\.{3}|\u2026/g, a);
	            }
	            a = this.matrix;
	            if (!Snap._.rgTransform.test(b)) {
	                b = Snap._.transform2matrix(Snap._.svgTransform2string(b), this.getBBox());
	            } else {
	                b = Snap._.transform2matrix(b, this.getBBox());
	            }
	            return equaliseTransform(a, b, function () {
	                return el.getBBox(1);
	            });
	        }
	        if (name == "d" || name == "path") {
	            A = Snap.path.toCubic(a, b);
	            return {
	                from: path2array(A[0]),
	                to: path2array(A[1]),
	                f: getPath(A[0])
	            };
	        }
	        if (name == "points") {
	            A = Str(a).split(Snap._.separator);
	            B = Str(b).split(Snap._.separator);
	            return {
	                from: A,
	                to: B,
	                f: function (val) { return val; }
	            };
	        }
	        if (isNumeric(a) && isNumeric(b)) {
	            return {
	                from: parseFloat(a),
	                to: parseFloat(b),
	                f: getNumber
	            };
	        }
	        var aUnit = a.match(reUnit),
	            bUnit = Str(b).match(reUnit);
	        if (aUnit && arrayEqual(aUnit, bUnit)) {
	            return {
	                from: parseFloat(a),
	                to: parseFloat(b),
	                f: getUnit(aUnit)
	            };
	        } else {
	            return {
	                from: this.asPX(name),
	                to: this.asPX(name, b),
	                f: getNumber
	            };
	        }
	    });
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	// 
	// http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	    has = "hasOwnProperty",
	    supportsTouch = "createTouch" in glob.doc,
	    events = [
	        "click", "dblclick", "mousedown", "mousemove", "mouseout",
	        "mouseover", "mouseup", "touchstart", "touchmove", "touchend",
	        "touchcancel"
	    ],
	    touchMap = {
	        mousedown: "touchstart",
	        mousemove: "touchmove",
	        mouseup: "touchend"
	    },
	    getScroll = function (xy, el) {
	        var name = xy == "y" ? "scrollTop" : "scrollLeft",
	            doc = el && el.node ? el.node.ownerDocument : glob.doc;
	        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
	    },
	    preventDefault = function () {
	        this.returnValue = false;
	    },
	    preventTouch = function () {
	        return this.originalEvent.preventDefault();
	    },
	    stopPropagation = function () {
	        this.cancelBubble = true;
	    },
	    stopTouch = function () {
	        return this.originalEvent.stopPropagation();
	    },
	    addEvent = function (obj, type, fn, element) {
	        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type,
	            f = function (e) {
	                var scrollY = getScroll("y", element),
	                    scrollX = getScroll("x", element);
	                if (supportsTouch && touchMap[has](type)) {
	                    for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
	                        if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
	                            var olde = e;
	                            e = e.targetTouches[i];
	                            e.originalEvent = olde;
	                            e.preventDefault = preventTouch;
	                            e.stopPropagation = stopTouch;
	                            break;
	                        }
	                    }
	                }
	                var x = e.clientX + scrollX,
	                    y = e.clientY + scrollY;
	                return fn.call(element, e, x, y);
	            };
	
	        if (type !== realName) {
	            obj.addEventListener(type, f, false);
	        }
	
	        obj.addEventListener(realName, f, false);
	
	        return function () {
	            if (type !== realName) {
	                obj.removeEventListener(type, f, false);
	            }
	
	            obj.removeEventListener(realName, f, false);
	            return true;
	        };
	    },
	    drag = [],
	    dragMove = function (e) {
	        var x = e.clientX,
	            y = e.clientY,
	            scrollY = getScroll("y"),
	            scrollX = getScroll("x"),
	            dragi,
	            j = drag.length;
	        while (j--) {
	            dragi = drag[j];
	            if (supportsTouch) {
	                var i = e.touches && e.touches.length,
	                    touch;
	                while (i--) {
	                    touch = e.touches[i];
	                    if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
	                        x = touch.clientX;
	                        y = touch.clientY;
	                        (e.originalEvent ? e.originalEvent : e).preventDefault();
	                        break;
	                    }
	                }
	            } else {
	                e.preventDefault();
	            }
	            var node = dragi.el.node,
	                o,
	                next = node.nextSibling,
	                parent = node.parentNode,
	                display = node.style.display;
	            // glob.win.opera && parent.removeChild(node);
	            // node.style.display = "none";
	            // o = dragi.el.paper.getElementByPoint(x, y);
	            // node.style.display = display;
	            // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
	            // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
	            x += scrollX;
	            y += scrollY;
	            eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
	        }
	    },
	    dragUp = function (e) {
	        Snap.unmousemove(dragMove).unmouseup(dragUp);
	        var i = drag.length,
	            dragi;
	        while (i--) {
	            dragi = drag[i];
	            dragi.el._drag = {};
	            eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
	            eve.off("snap.drag.*." + dragi.el.id);
	        }
	        drag = [];
	    };
	    /*\
	     * Element.click
	     [ method ]
	     **
	     * Adds a click event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unclick
	     [ method ]
	     **
	     * Removes a click event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.dblclick
	     [ method ]
	     **
	     * Adds a double click event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.undblclick
	     [ method ]
	     **
	     * Removes a double click event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mousedown
	     [ method ]
	     **
	     * Adds a mousedown event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousedown
	     [ method ]
	     **
	     * Removes a mousedown event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mousemove
	     [ method ]
	     **
	     * Adds a mousemove event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousemove
	     [ method ]
	     **
	     * Removes a mousemove event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseout
	     [ method ]
	     **
	     * Adds a mouseout event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseout
	     [ method ]
	     **
	     * Removes a mouseout event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseover
	     [ method ]
	     **
	     * Adds a mouseover event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseover
	     [ method ]
	     **
	     * Removes a mouseover event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseup
	     [ method ]
	     **
	     * Adds a mouseup event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseup
	     [ method ]
	     **
	     * Removes a mouseup event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchstart
	     [ method ]
	     **
	     * Adds a touchstart event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchstart
	     [ method ]
	     **
	     * Removes a touchstart event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchmove
	     [ method ]
	     **
	     * Adds a touchmove event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchmove
	     [ method ]
	     **
	     * Removes a touchmove event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchend
	     [ method ]
	     **
	     * Adds a touchend event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchend
	     [ method ]
	     **
	     * Removes a touchend event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchcancel
	     [ method ]
	     **
	     * Adds a touchcancel event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchcancel
	     [ method ]
	     **
	     * Removes a touchcancel event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    for (var i = events.length; i--;) {
	        (function (eventName) {
	            Snap[eventName] = elproto[eventName] = function (fn, scope) {
	                if (Snap.is(fn, "function")) {
	                    this.events = this.events || [];
	                    this.events.push({
	                        name: eventName,
	                        f: fn,
	                        unbind: addEvent(this.node || document, eventName, fn, scope || this)
	                    });
	                } else {
	                    for (var i = 0, ii = this.events.length; i < ii; i++) if (this.events[i].name == eventName) {
	                        try {
	                            this.events[i].f.call(this);
	                        } catch (e) {}
	                    }
	                }
	                return this;
	            };
	            Snap["un" + eventName] =
	            elproto["un" + eventName] = function (fn) {
	                var events = this.events || [],
	                    l = events.length;
	                while (l--) if (events[l].name == eventName &&
	                               (events[l].f == fn || !fn)) {
	                    events[l].unbind();
	                    events.splice(l, 1);
	                    !events.length && delete this.events;
	                    return this;
	                }
	                return this;
	            };
	        })(events[i]);
	    }
	    /*\
	     * Element.hover
	     [ method ]
	     **
	     * Adds hover event handlers to the element
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     - icontext (object) #optional context for hover in handler
	     - ocontext (object) #optional context for hover out handler
	     = (object) @Element
	    \*/
	    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
	        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
	    };
	    /*\
	     * Element.unhover
	     [ method ]
	     **
	     * Removes hover event handlers from the element
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     = (object) @Element
	    \*/
	    elproto.unhover = function (f_in, f_out) {
	        return this.unmouseover(f_in).unmouseout(f_out);
	    };
	    var draggable = [];
	    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
	    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
	    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
	    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
	    /*\
	     * Element.drag
	     [ method ]
	     **
	     * Adds event handlers for an element's drag gesture
	     **
	     - onmove (function) handler for moving
	     - onstart (function) handler for drag start
	     - onend (function) handler for drag end
	     - mcontext (object) #optional context for moving handler
	     - scontext (object) #optional context for drag start handler
	     - econtext (object) #optional context for drag end handler
	     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start, 
	     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element 
	     * `drag.over.<id>` fires as well.
	     *
	     * Start event and start handler are called in specified context or in context of the element with following parameters:
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * Move event and move handler are called in specified context or in context of the element with following parameters:
	     o dx (number) shift by x from the start point
	     o dy (number) shift by y from the start point
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * End event and end handler are called in specified context or in context of the element with following parameters:
	     o event (object) DOM event object
	     = (object) @Element
	    \*/
	    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
	        var el = this;
	        if (!arguments.length) {
	            var origTransform;
	            return el.drag(function (dx, dy) {
	                this.attr({
	                    transform: origTransform + (origTransform ? "T" : "t") + [dx, dy]
	                });
	            }, function () {
	                origTransform = this.transform().local;
	            });
	        }
	        function start(e, x, y) {
	            (e.originalEvent || e).preventDefault();
	            el._drag.x = x;
	            el._drag.y = y;
	            el._drag.id = e.identifier;
	            !drag.length && Snap.mousemove(dragMove).mouseup(dragUp);
	            drag.push({el: el, move_scope: move_scope, start_scope: start_scope, end_scope: end_scope});
	            onstart && eve.on("snap.drag.start." + el.id, onstart);
	            onmove && eve.on("snap.drag.move." + el.id, onmove);
	            onend && eve.on("snap.drag.end." + el.id, onend);
	            eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
	        }
	        function init(e, x, y) {
	            eve("snap.draginit." + el.id, el, e, x, y);
	        }
	        eve.on("snap.draginit." + el.id, start);
	        el._drag = {};
	        draggable.push({el: el, start: start, init: init});
	        el.mousedown(init);
	        return el;
	    };
	    /*
	     * Element.onDragOver
	     [ method ]
	     **
	     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
	     - f (function) handler for event, first argument would be the element you are dragging over
	    \*/
	    // elproto.onDragOver = function (f) {
	    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
	    // };
	    /*\
	     * Element.undrag
	     [ method ]
	     **
	     * Removes all drag event handlers from the given element
	    \*/
	    elproto.undrag = function () {
	        var i = draggable.length;
	        while (i--) if (draggable[i].el == this) {
	            this.unmousedown(draggable[i].init);
	            draggable.splice(i, 1);
	            eve.unbind("snap.drag.*." + this.id);
	            eve.unbind("snap.draginit." + this.id);
	        }
	        !draggable.length && Snap.unmousemove(dragMove).unmouseup(dragUp);
	        return this;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	        pproto = Paper.prototype,
	        rgurl = /^\s*url\((.+)\)/,
	        Str = String,
	        $ = Snap._.$;
	    Snap.filter = {};
	    /*\
	     * Paper.filter
	     [ method ]
	     **
	     * Creates a `<filter>` element
	     **
	     - filstr (string) SVG fragment of filter provided as a string
	     = (object) @Element
	     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
	     > Usage
	     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    pproto.filter = function (filstr) {
	        var paper = this;
	        if (paper.type != "svg") {
	            paper = paper.paper;
	        }
	        var f = Snap.parse(Str(filstr)),
	            id = Snap._.id(),
	            width = paper.node.offsetWidth,
	            height = paper.node.offsetHeight,
	            filter = $("filter");
	        $(filter, {
	            id: id,
	            filterUnits: "userSpaceOnUse"
	        });
	        filter.appendChild(f.node);
	        paper.defs.appendChild(filter);
	        return new Element(filter);
	    };
	
	    eve.on("snap.util.getattr.filter", function () {
	        eve.stop();
	        var p = $(this.node, "filter");
	        if (p) {
	            var match = Str(p).match(rgurl);
	            return match && Snap.select(match[1]);
	        }
	    });
	    eve.on("snap.util.attr.filter", function (value) {
	        if (value instanceof Element && value.type == "filter") {
	            eve.stop();
	            var id = value.node.id;
	            if (!id) {
	                $(value.node, {id: value.id});
	                id = value.id;
	            }
	            $(this.node, {
	                filter: Snap.url(id)
	            });
	        }
	        if (!value || value == "none") {
	            eve.stop();
	            this.node.removeAttribute("filter");
	        }
	    });
	    /*\
	     * Snap.filter.blur
	     [ method ]
	     **
	     * Returns an SVG markup string for the blur filter
	     **
	     - x (number) amount of horizontal blur, in pixels
	     - y (number) #optional amount of vertical blur, in pixels
	     = (string) filter representation
	     > Usage
	     | var f = paper.filter(Snap.filter.blur(5, 10)),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    Snap.filter.blur = function (x, y) {
	        if (x == null) {
	            x = 2;
	        }
	        var def = y == null ? x : [x, y];
	        return Snap.format('\<feGaussianBlur stdDeviation="{def}"/>', {
	            def: def
	        });
	    };
	    Snap.filter.blur.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.shadow
	     [ method ]
	     **
	     * Returns an SVG markup string for the shadow filter
	     **
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - blur (number) #optional amount of blur
	     - color (string) #optional color of the shadow
	     - opacity (number) #optional `0..1` opacity of the shadow
	     * or
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - color (string) #optional color of the shadow
	     - opacity (number) #optional `0..1` opacity of the shadow
	     * which makes blur default to `4`. Or
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - opacity (number) #optional `0..1` opacity of the shadow
	     = (string) filter representation
	     > Usage
	     | var f = paper.filter(Snap.filter.shadow(0, 2, .3)),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    Snap.filter.shadow = function (dx, dy, blur, color, opacity) {
	        if (opacity == null) {
	            if (color == null) {
	                opacity = blur;
	                blur = 4;
	                color = "#000";
	            } else {
	                opacity = color;
	                color = blur;
	                blur = 4;
	            }
	        }
	        if (blur == null) {
	            blur = 4;
	        }
	        if (opacity == null) {
	            opacity = 1;
	        }
	        if (dx == null) {
	            dx = 0;
	            dy = 2;
	        }
	        if (dy == null) {
	            dy = dx;
	        }
	        color = Snap.color(color);
	        return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
	            color: color,
	            dx: dx,
	            dy: dy,
	            blur: blur,
	            opacity: opacity
	        });
	    };
	    Snap.filter.shadow.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.grayscale
	     [ method ]
	     **
	     * Returns an SVG markup string for the grayscale filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.grayscale = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
	            a: 0.2126 + 0.7874 * (1 - amount),
	            b: 0.7152 - 0.7152 * (1 - amount),
	            c: 0.0722 - 0.0722 * (1 - amount),
	            d: 0.2126 - 0.2126 * (1 - amount),
	            e: 0.7152 + 0.2848 * (1 - amount),
	            f: 0.0722 - 0.0722 * (1 - amount),
	            g: 0.2126 - 0.2126 * (1 - amount),
	            h: 0.0722 + 0.9278 * (1 - amount)
	        });
	    };
	    Snap.filter.grayscale.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.sepia
	     [ method ]
	     **
	     * Returns an SVG markup string for the sepia filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.sepia = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
	            a: 0.393 + 0.607 * (1 - amount),
	            b: 0.769 - 0.769 * (1 - amount),
	            c: 0.189 - 0.189 * (1 - amount),
	            d: 0.349 - 0.349 * (1 - amount),
	            e: 0.686 + 0.314 * (1 - amount),
	            f: 0.168 - 0.168 * (1 - amount),
	            g: 0.272 - 0.272 * (1 - amount),
	            h: 0.534 - 0.534 * (1 - amount),
	            i: 0.131 + 0.869 * (1 - amount)
	        });
	    };
	    Snap.filter.sepia.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.saturate
	     [ method ]
	     **
	     * Returns an SVG markup string for the saturate filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.saturate = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
	            amount: 1 - amount
	        });
	    };
	    Snap.filter.saturate.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.hueRotate
	     [ method ]
	     **
	     * Returns an SVG markup string for the hue-rotate filter
	     **
	     - angle (number) angle of rotation
	     = (string) filter representation
	    \*/
	    Snap.filter.hueRotate = function (angle) {
	        angle = angle || 0;
	        return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
	            angle: angle
	        });
	    };
	    Snap.filter.hueRotate.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.invert
	     [ method ]
	     **
	     * Returns an SVG markup string for the invert filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.invert = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	//        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
	        return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
	            amount: amount,
	            amount2: 1 - amount
	        });
	    };
	    Snap.filter.invert.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.brightness
	     [ method ]
	     **
	     * Returns an SVG markup string for the brightness filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.brightness = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
	            amount: amount
	        });
	    };
	    Snap.filter.brightness.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.contrast
	     [ method ]
	     **
	     * Returns an SVG markup string for the contrast filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.contrast = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
	            amount: amount,
	            amount2: .5 - amount / 2
	        });
	    };
	    Snap.filter.contrast.toString = function () {
	        return this();
	    };
	});
	
	// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var box = Snap._.box,
	        is = Snap.is,
	        firstLetter = /^[^a-z]*([tbmlrc])/i,
	        toString = function () {
	            return "T" + this.dx + "," + this.dy;
	        };
	    /*\
	     * Element.getAlign
	     [ method ]
	     **
	     * Returns shift needed to align the element relatively to given element.
	     * If no elements specified, parent `<svg>` container will be used.
	     - el (object) @optional alignment element
	     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
	     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
	     > Usage
	     | el.transform(el.getAlign(el2, "top"));
	     * or
	     | var dy = el.getAlign(el2, "top").dy;
	    \*/
	    Element.prototype.getAlign = function (el, way) {
	        if (way == null && is(el, "string")) {
	            way = el;
	            el = null;
	        }
	        el = el || this.paper;
	        var bx = el.getBBox ? el.getBBox() : box(el),
	            bb = this.getBBox(),
	            out = {};
	        way = way && way.match(firstLetter);
	        way = way ? way[1].toLowerCase() : "c";
	        switch (way) {
	            case "t":
	                out.dx = 0;
	                out.dy = bx.y - bb.y;
	            break;
	            case "b":
	                out.dx = 0;
	                out.dy = bx.y2 - bb.y2;
	            break;
	            case "m":
	                out.dx = 0;
	                out.dy = bx.cy - bb.cy;
	            break;
	            case "l":
	                out.dx = bx.x - bb.x;
	                out.dy = 0;
	            break;
	            case "r":
	                out.dx = bx.x2 - bb.x2;
	                out.dy = 0;
	            break;
	            default:
	                out.dx = bx.cx - bb.cx;
	                out.dy = 0;
	            break;
	        }
	        out.toString = toString;
	        return out;
	    };
	    /*\
	     * Element.align
	     [ method ]
	     **
	     * Aligns the element relatively to given one via transformation.
	     * If no elements specified, parent `<svg>` container will be used.
	     - el (object) @optional alignment element
	     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
	     = (object) this element
	     > Usage
	     | el.align(el2, "top");
	     * or
	     | el.align("middle");
	    \*/
	    Element.prototype.align = function (el, way) {
	        return this.transform("..." + this.getAlign(el, way));
	    };
	});
	
	// Copyright (c) 2016 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        Str = String,
	        has = "hasOwnProperty";
	    function slice(from, to, f) {
	        return function (arr) {
	            var res = arr.slice(from, to);
	            if (res.length == 1) {
	                res = res[0];
	            }
	            return f ? f(res) : res;
	        };
	    }
	    var Animation = function (attr, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        this.attr = attr;
	        this.dur = ms;
	        easing && (this.easing = easing);
	        callback && (this.callback = callback);
	    };
	    Snap._.Animation = Animation;
	    /*\
	     * Snap.animation
	     [ method ]
	     **
	     * Creates an animation object
	     **
	     - attr (object) attributes of final destination
	     - duration (number) duration of the animation, in milliseconds
	     - easing (function) #optional one of easing functions of @mina or custom one
	     - callback (function) #optional callback function that fires when animation ends
	     = (object) animation object
	    \*/
	    Snap.animation = function (attr, ms, easing, callback) {
	        return new Animation(attr, ms, easing, callback);
	    };
	    /*\
	     * Element.inAnim
	     [ method ]
	     **
	     * Returns a set of animations that may be able to manipulate the current element
	     **
	     = (object) in format:
	     o {
	     o     anim (object) animation object,
	     o     mina (object) @mina object,
	     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
	     o     status (function) gets or sets the status of the animation,
	     o     stop (function) stops the animation
	     o }
	    \*/
	    elproto.inAnim = function () {
	        var el = this,
	            res = [];
	        for (var id in el.anims) if (el.anims[has](id)) {
	            (function (a) {
	                res.push({
	                    anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
	                    mina: a,
	                    curStatus: a.status(),
	                    status: function (val) {
	                        return a.status(val);
	                    },
	                    stop: function () {
	                        a.stop();
	                    }
	                });
	            }(el.anims[id]));
	        }
	        return res;
	    };
	    /*\
	     * Snap.animate
	     [ method ]
	     **
	     * Runs generic animation of one number into another with a caring function
	     **
	     - from (number|array) number or array of numbers
	     - to (number|array) number or array of numbers
	     - setter (function) caring function that accepts one number argument
	     - duration (number) duration, in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function to execute when animation ends
	     = (object) animation object in @mina format
	     o {
	     o     id (string) animation id, consider it read-only,
	     o     duration (function) gets or sets the duration of the animation,
	     o     easing (function) easing,
	     o     speed (function) gets or sets the speed of the animation,
	     o     status (function) gets or sets the status of the animation,
	     o     stop (function) stops the animation
	     o }
	     | var rect = Snap().rect(0, 0, 10, 10);
	     | Snap.animate(0, 10, function (val) {
	     |     rect.attr({
	     |         x: val
	     |     });
	     | }, 1000);
	     | // in given context is equivalent to
	     | rect.animate({x: 10}, 1000);
	    \*/
	    Snap.animate = function (from, to, setter, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        var now = mina.time(),
	            anim = mina(from, to, now, now + ms, mina.time, setter, easing);
	        callback && eve.once("mina.finish." + anim.id, callback);
	        return anim;
	    };
	    /*\
	     * Element.stop
	     [ method ]
	     **
	     * Stops all the animations for the current element
	     **
	     = (Element) the current element
	    \*/
	    elproto.stop = function () {
	        var anims = this.inAnim();
	        for (var i = 0, ii = anims.length; i < ii; i++) {
	            anims[i].stop();
	        }
	        return this;
	    };
	    /*\
	     * Element.animate
	     [ method ]
	     **
	     * Animates the given attributes of the element
	     **
	     - attrs (object) key-value pairs of destination attributes
	     - duration (number) duration of the animation in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function that executes when the animation ends
	     = (Element) the current element
	    \*/
	    elproto.animate = function (attrs, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        if (attrs instanceof Animation) {
	            callback = attrs.callback;
	            easing = attrs.easing;
	            ms = attrs.dur;
	            attrs = attrs.attr;
	        }
	        var fkeys = [], tkeys = [], keys = {}, from, to, f, eq,
	            el = this;
	        for (var key in attrs) if (attrs[has](key)) {
	            if (el.equal) {
	                eq = el.equal(key, Str(attrs[key]));
	                from = eq.from;
	                to = eq.to;
	                f = eq.f;
	            } else {
	                from = +el.attr(key);
	                to = +attrs[key];
	            }
	            var len = is(from, "array") ? from.length : 1;
	            keys[key] = slice(fkeys.length, fkeys.length + len, f);
	            fkeys = fkeys.concat(from);
	            tkeys = tkeys.concat(to);
	        }
	        var now = mina.time(),
	            anim = mina(fkeys, tkeys, now, now + ms, mina.time, function (val) {
	                var attr = {};
	                for (var key in keys) if (keys[has](key)) {
	                    attr[key] = keys[key](val);
	                }
	                el.attr(attr);
	            }, easing);
	        el.anims[anim.id] = anim;
	        anim._attrs = attrs;
	        anim._callback = callback;
	        eve("snap.animcreated." + el.id, anim);
	        eve.once("mina.finish." + anim.id, function () {
	            eve.off("mina.*." + anim.id);
	            delete el.anims[anim.id];
	            callback && callback.call(el);
	        });
	        eve.once("mina.stop." + anim.id, function () {
	            eve.off("mina.*." + anim.id);
	            delete el.anims[anim.id];
	        });
	        return el;
	    };
	});
	
	// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    // Colours are from https://www.materialui.co
	    var red         = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000",
	        pink        = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162",
	        purple      = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF",
	        deeppurple  = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA",
	        indigo      = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE",
	        blue        = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF",
	        lightblue   = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA",
	        cyan        = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4",
	        teal        = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5",
	        green       = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853",
	        lightgreen  = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17",
	        lime        = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00",
	        yellow      = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600",
	        amber       = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00",
	        orange      = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00",
	        deeporange  = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00",
	        brown       = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723",
	        grey        = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121",
	        bluegrey    = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
	    /*\
	     * Snap.mui
	     [ property ]
	     **
	     * Contain Material UI colours.
	     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.mui.deeppurple, stroke: Snap.mui.amber[600]});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.mui = {};
	    /*\
	     * Snap.flat
	     [ property ]
	     **
	     * Contain Flat UI colours.
	     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.flat.carrot, stroke: Snap.flat.wetasphalt});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.flat = {};
	    function saveColor(colors) {
	        colors = colors.split(/(?=#)/);
	        var color = new String(colors[5]);
	        color[50] = colors[0];
	        color[100] = colors[1];
	        color[200] = colors[2];
	        color[300] = colors[3];
	        color[400] = colors[4];
	        color[500] = colors[5];
	        color[600] = colors[6];
	        color[700] = colors[7];
	        color[800] = colors[8];
	        color[900] = colors[9];
	        if (colors[10]) {
	            color.A100 = colors[10];
	            color.A200 = colors[11];
	            color.A400 = colors[12];
	            color.A700 = colors[13];
	        }
	        return color;
	    }
	    Snap.mui.red = saveColor(red);
	    Snap.mui.pink = saveColor(pink);
	    Snap.mui.purple = saveColor(purple);
	    Snap.mui.deeppurple = saveColor(deeppurple);
	    Snap.mui.indigo = saveColor(indigo);
	    Snap.mui.blue = saveColor(blue);
	    Snap.mui.lightblue = saveColor(lightblue);
	    Snap.mui.cyan = saveColor(cyan);
	    Snap.mui.teal = saveColor(teal);
	    Snap.mui.green = saveColor(green);
	    Snap.mui.lightgreen = saveColor(lightgreen);
	    Snap.mui.lime = saveColor(lime);
	    Snap.mui.yellow = saveColor(yellow);
	    Snap.mui.amber = saveColor(amber);
	    Snap.mui.orange = saveColor(orange);
	    Snap.mui.deeporange = saveColor(deeporange);
	    Snap.mui.brown = saveColor(brown);
	    Snap.mui.grey = saveColor(grey);
	    Snap.mui.bluegrey = saveColor(bluegrey);
	    Snap.flat.turquoise = "#1abc9c";
	    Snap.flat.greensea = "#16a085";
	    Snap.flat.sunflower = "#f1c40f";
	    Snap.flat.orange = "#f39c12";
	    Snap.flat.emerland = "#2ecc71";
	    Snap.flat.nephritis = "#27ae60";
	    Snap.flat.carrot = "#e67e22";
	    Snap.flat.pumpkin = "#d35400";
	    Snap.flat.peterriver = "#3498db";
	    Snap.flat.belizehole = "#2980b9";
	    Snap.flat.alizarin = "#e74c3c";
	    Snap.flat.pomegranate = "#c0392b";
	    Snap.flat.amethyst = "#9b59b6";
	    Snap.flat.wisteria = "#8e44ad";
	    Snap.flat.clouds = "#ecf0f1";
	    Snap.flat.silver = "#bdc3c7";
	    Snap.flat.wetasphalt = "#34495e";
	    Snap.flat.midnightblue = "#2c3e50";
	    Snap.flat.concrete = "#95a5a6";
	    Snap.flat.asbestos = "#7f8c8d";
	    /*\
	     * Snap.importMUIColors
	     [ method ]
	     **
	     * Imports Material UI colours into global object.
	     | Snap.importMUIColors();
	     | Snap().rect(0, 0, 10, 10).attr({fill: deeppurple, stroke: amber[600]});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.importMUIColors = function () {
	        for (var color in Snap.mui) {
	            if (Snap.mui.hasOwnProperty(color)) {
	                window[color] = Snap.mui[color];
	            }
	        }
	    };
	});
	
	module.exports = Snap


/***/ }),

/***/ 552:
/***/ (function(module, exports) {

	'use strict';
	
	// t: current time, b: beginning value, _c: final value, d: total duration
	var tweenFunctions = {
	  linear: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * t / d + b;
	  },
	  easeInQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t + b;
	  },
	  easeOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (t /= d) * (t - 2) + b;
	  },
	  easeInOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t + b;
	    } else {
	      return -c / 2 * ((--t) * (t - 2) - 1) + b;
	    }
	  },
	  easeInCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t + b;
	  },
	  easeOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t + 1) + b;
	  },
	  easeInOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t + 2) + b;
	    }
	  },
	  easeInQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t + b;
	  },
	  easeOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	  },
	  easeInOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t + b;
	    } else {
	      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	    }
	  },
	  easeInQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t * t + b;
	  },
	  easeOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	  },
	  easeInOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	    }
	  },
	  easeInSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	  },
	  easeOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sin(t / d * (Math.PI / 2)) + b;
	  },
	  easeInOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	  },
	  easeInExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	  },
	  easeOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	  },
	  easeInOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    if (t === 0) {
	      return b;
	    }
	    if (t === d) {
	      return b + c;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
	    } else {
	      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	    }
	  },
	  easeInCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	  },
	  easeOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	  },
	  easeInOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
	    } else {
	      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	    }
	  },
	  easeInElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d) === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	  },
	  easeOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d) === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	  },
	  easeInOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d / 2) === 2) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * (0.3 * 1.5);
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    if (t < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	    } else {
	      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
	    }
	  },
	  easeInBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * (t /= d) * t * ((s + 1) * t - s) + b;
	  },
	  easeOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	  },
	  easeInOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	    }
	  },
	  easeInBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    v = tweenFunctions.easeOutBounce(d - t, 0, c, d);
	    return c - v + b;
	  },
	  easeOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d) < 1 / 2.75) {
	      return c * (7.5625 * t * t) + b;
	    } else if (t < 2 / 2.75) {
	      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
	    } else if (t < 2.5 / 2.75) {
	      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
	    } else {
	      return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
	    }
	  },
	  easeInOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    if (t < d / 2) {
	      v = tweenFunctions.easeInBounce(t * 2, 0, c, d);
	      return v * 0.5 + b;
	    } else {
	      v = tweenFunctions.easeOutBounce(t * 2 - d, 0, c, d);
	      return v * 0.5 + c * 0.5 + b;
	    }
	  }
	};
	
	module.exports = tweenFunctions;


/***/ }),

/***/ 331:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(508);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _gatsbyLink = __webpack_require__(40);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(323);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	__webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      showModal: false
	    };
	    _this.handleOpenModal = _this.handleOpenModal.bind(_this);
	    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
	    return _this;
	  }
	
	  Footer.prototype.handleOpenModal = function handleOpenModal() {
	    this.setState({ showModal: true });
	  };
	
	  Footer.prototype.handleCloseModal = function handleCloseModal() {
	    this.setState({ showModal: false });
	  };
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _indexModule2.default.wrapper },
	      _react2.default.createElement(
	        'nav',
	        { className: _indexModule2.default.list },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: _indexModule2.default.link,
	            activeClassName: 'menu-active',
	            to: '/about/',
	            style: { width: 'fit-content', marginRight: '1rem' } },
	          'About'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: _indexModule2.default.link,
	            activeClassName: 'menu-active',
	            to: '/contact/',
	            style: { width: 'fit-content', marginLeft: '1rem' } },
	          'Contact'
	        )
	      ),
	      _react2.default.createElement(
	        'small',
	        null,
	        '\xA92019 Holzauge Fotografie -\xA0',
	        _react2.default.createElement(
	          'a',
	          { onClick: this.handleOpenModal },
	          'Datenschutzerkl\xE4rung'
	        )
	      ),
	      _react2.default.createElement(
	        _reactModal2.default,
	        {
	          isOpen: this.state.showModal,
	          contentLabel: 'Datenschutzerkl\xE4rung',
	          ariaHideApp: false },
	        _react2.default.createElement(
	          'h4',
	          { style: { textAlign: 'center' } },
	          'Datenschutzerkl\xE4rung'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Diese Datenschutzerkl\xE4rung kl\xE4rt Sie \xFCber die Art, den Umfang und Zweck der Verarbeitung von personenbezogenen Daten dieser Webseite. Im Hinblick auf die verwendeten Begrifflichkeiten, wie z.B. \u201EVerarbeitung\u201C oder \u201EVerantwortlicher\u201C verweisen wir auf die Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO).'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            'Verantwortlicher Webseite'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Achim Hilker'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'K\xF6ln'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'mail@achimhilker.com'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            'Verantwortlicher Inhalt'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Dennis Hundt'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Frechen'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'info@holzauge-fotografie.de'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Generell ist zu sagen, dass Daten allein zur technischen analyse der Webseite gesammelt werden und in keinster Weise f\xFCr andere Zwecke benutzt/korreliert werden.'
	        ),
	        _react2.default.createElement(
	          'h4',
	          { style: { textAlign: 'center' } },
	          'Erhebung von Zugriffsdaten und Logfiles'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '- Wir erheben auf Grundlage unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO Daten \xFCber jeden Zugriff auf den Server, auf dem sich dieser Dienst befindet (sogenannte Serverlogfiles). Zu den Zugriffsdaten geh\xF6ren Name der abgerufenen Webseite, Datei, Datum und Uhrzeit des Abrufs, \xFCbertragene Datenmenge, Meldung \xFCber erfolgreichen Abruf, Browsertyp nebst Version, das Betriebssystem des Nutzers, Referrer URL (die zuvor besuchte Seite), IP-Adresse und der anfragende Provider.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '- Logfile-Informationen werden aus Sicherheitsgr\xFCnden (z.B. zur Aufkl\xE4rung von Missbrauchs- oder Betrugshandlungen) f\xFCr die Dauer von maximal 7 Tagen gespeichert und danach gel\xF6scht. Daten, deren weitere Aufbewahrung zu Beweiszwecken erforderlich ist, sind bis zur endg\xFCltigen Kl\xE4rung des jeweiligen Vorfalls von der L\xF6schung ausgenommen.'
	        ),
	        _react2.default.createElement(
	          'h4',
	          { style: { textAlign: 'center' } },
	          'Google Universal Analytics'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '- Wir setzen Google Analytics in der Ausgestaltung als \u201EUniversal-Analytics\u201C ein. \u201EUniversal Analytics\u201C bezeichnet ein Verfahren von Google Analytics, bei dem die Nutzeranalyse auf Grundlage einer pseudonymen Nutzer-ID erfolgt und damit ein pseudonymes Profil des Nutzers mit Informationen aus der Nutzung verschiedener Ger\xE4ten erstellt wird (sog. \u201ECross-Device-Tracking\u201C).'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modalclose' },
	          _react2.default.createElement(
	            'a',
	            { onClick: this.handleCloseModal },
	            _react2.default.createElement(
	              'h4',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Schlie\xDFen'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-Footer----index-module---wrapper---15J7S","list":"src-components-Footer----index-module---list---2IXhR"};

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(40);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(75);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _indexModule = __webpack_require__(325);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(data) {
	  return _react2.default.createElement(
	    'div',
	    { className: _indexModule2.default.logo },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/editorial' },
	      _react2.default.createElement(_gatsbyImage2.default, { className: _indexModule2.default.img, sizes: data.data.logo.childImageSharp.sizes, alt: 'Logo' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _indexModule2.default.imgtext },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/editorial' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.data.logotext.childImageSharp.sizes, alt: 'Logo' })
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"logo":"src-components-Logo----index-module---logo---rMc3D","img":"src-components-Logo----index-module---img---2A2Ws","imgtext":"src-components-Logo----index-module---imgtext---1fD3f"};

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(40);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(326);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	__webpack_require__(332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuDesk = function MenuDesk() {
	  return _react2.default.createElement(
	    'nav',
	    { className: _indexModule2.default.wrapper },
	    _react2.default.createElement(
	      'ul',
	      { className: _indexModule2.default.list },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'item', activeClassName: 'current', to: '/editorial/' },
	        'Editorial'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'item', activeClassName: 'current', to: '/portrait/' },
	        'Portrait'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'item', activeClassName: 'current', to: '/travel/' },
	        'Travel'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'item', activeClassName: 'current', to: '/freiearbeit/' },
	        'freie Arbeit'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'item', activeClassName: 'current', to: '/reportage/' },
	        'Reportage'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'item', activeClassName: 'current', to: '/wedding/' },
	        'Wedding'
	      ),
	      _react2.default.createElement('span', { className: 'line' })
	    )
	  );
	};
	
	exports.default = MenuDesk;
	module.exports = exports['default'];

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-MenuDesk----index-module---wrapper---4FNux","list":"src-components-MenuDesk----index-module---list---1sPJZ"};

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(40);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactBurgerMenu = __webpack_require__(418);
	
	__webpack_require__(333);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var menuicon = __webpack_require__(553);
	
	var MenuMobile = function (_React$Component) {
	  _inherits(MenuMobile, _React$Component);
	
	  function MenuMobile(props) {
	    _classCallCheck(this, MenuMobile);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      menuOpen: false
	    };
	    return _this;
	  }
	
	  MenuMobile.prototype.handleStateChange = function handleStateChange(state) {
	    this.setState({ menuOpen: state.isOpen });
	  };
	
	  MenuMobile.prototype.closeMenu = function closeMenu() {
	    this.setState({ menuOpen: false });
	    console.log(this);
	  };
	
	  MenuMobile.prototype.toggleMenu = function toggleMenu() {
	    this.setState({ menuOpen: !this.state.menuOpen });
	  };
	
	  MenuMobile.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactBurgerMenu.stack,
	      { right: true, width: '100px', customBurgerIcon: _react2.default.createElement('img', { src: menuicon }) },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          className: 'menu-item',
	          to: { pathname: '/editorial/', state: { isOpen: false } },
	          activeClassName: 'mobile-menu-active',
	          style: { marginBottom: '0.5em', width: 'auto', display: 'inline-block' } },
	        'Editorial'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          className: 'menu-item',
	          to: { pathname: '/portrait/', state: { menuOpen: false } },
	          activeClassName: 'mobile-menu-active',
	          style: { marginBottom: '0.5em', width: 'auto', display: 'inline-block' } },
	        'Portrait'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          className: 'menu-item',
	          to: { pathname: '/travel/', state: { menuOpen: false } },
	          activeClassName: 'mobile-menu-active',
	          style: { marginBottom: '0.5em', width: 'auto', display: 'inline-block' } },
	        'Travel'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          className: 'menu-item',
	          to: { pathname: '/freiearbeit/', state: { menuOpen: false } },
	          activeClassName: 'mobile-menu-active',
	          style: { marginBottom: '0.5em', width: 'auto', display: 'inline-block' } },
	        'freie Arbeit'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          className: 'menu-item',
	          to: { pathname: '/reportage/', state: { menuOpen: false } },
	          activeClassName: 'mobile-menu-active',
	          style: { marginBottom: '0.5em', width: 'auto', display: 'inline-block' } },
	        'Reportage'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          className: 'menu-item',
	          to: { pathname: '/wedding/', state: { menuOpen: false } },
	          activeClassName: 'mobile-menu-active',
	          style: { marginBottom: '0.5em', width: 'auto', display: 'inline-block' } },
	        'Wedding'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          className: 'menu-item',
	          to: { pathname: '/about/', state: { menuOpen: false } },
	          activeClassName: 'mobile-menu-active',
	          style: { marginBottom: '0.5em', width: 'auto', display: 'inline-block' } },
	        'About'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          className: 'menu-item',
	          to: { pathname: '/contact/', state: { menuOpen: false } },
	          activeClassName: 'mobile-menu-active',
	          style: { marginBottom: '0.5em', width: 'auto', display: 'inline-block' } },
	        'Contact'
	      )
	    );
	  };
	
	  return MenuMobile;
	}(_react2.default.Component);
	
	exports.default = MenuMobile;
	module.exports = exports['default'];

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Logo = __webpack_require__(215);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Footer = __webpack_require__(214);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _MenuMobile = __webpack_require__(217);
	
	var _MenuMobile2 = _interopRequireDefault(_MenuMobile);
	
	var _MenuDesk = __webpack_require__(216);
	
	var _MenuDesk2 = _interopRequireDefault(_MenuDesk);
	
	var _SEO = __webpack_require__(9);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _angleUp = __webpack_require__(497);
	
	var _angleUp2 = _interopRequireDefault(_angleUp);
	
	var _reactScrollUp = __webpack_require__(526);
	
	var _reactScrollUp2 = _interopRequireDefault(_reactScrollUp);
	
	var _index = __webpack_require__(335);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data,
	      location = _ref.location,
	      history = _ref.history;
	
	  var windowWidth = 1000;
	  typeof window !== 'undefined' && (windowWidth = window.innerWidth);
	  var isHome = false;
	  if (location.pathname === '' + ("/")) {
	    return children({ data: data, location: location, history: history });
	  } else {
	    return _react2.default.createElement(
	      'div',
	      { className: 'grid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        _react2.default.createElement(_Logo2.default, { data: data }),
	        windowWidth < 700 && _react2.default.createElement(_MenuMobile2.default, null),
	        windowWidth > 700 && _react2.default.createElement(_MenuDesk2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'main' },
	        children({ data: data, location: location, history: history })
	      ),
	      _react2.default.createElement(_Footer2.default, null),
	      _react2.default.createElement(
	        _reactScrollUp2.default,
	        { showUnder: 160, style: { right: 20 } },
	        _react2.default.createElement(_angleUp2.default, { style: { fontSize: '1.8rem' } })
	      )
	    );
	  }
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-d97c3db890fba2c2c5eb.js